
 (() => { // webpackBootstrap
   	var __webpack_modules__ = ({

	 876:
	 ((module) => {

	  "use strict";


	  module.exports = function(el, onOver, onOut) {
		var x, y, pX, pY;
		var mouseOver = false;
		var focused = false;
		var h = {},
			state = 0,
			timer = 0;

		var options = {
		  sensitivity: 7,
		  interval: 100,
		  timeout: 0,
		  handleFocus: false
		};

		function delay(el, e) {
		  if (timer) timer = clearTimeout(timer);
		  state = 0;
		  return focused ? undefined : onOut.call(el, e);
		}

		function tracker(e) {
		  x = e.clientX;
		  y = e.clientY;
		}

		function compare(el, e) {
		  if (timer) timer = clearTimeout(timer);
		  if ((Math.abs(pX - x) + Math.abs(pY - y)) < options.sensitivity) {
			state = 1;
			return focused ? undefined : onOver.call(el, e);
		  } else {
			pX = x;
			pY = y;
			timer = setTimeout(function() {
			  compare(el, e);
			}, options.interval);
		  }
		}

		// Public methods
		h.options = function(opt) {
		  var focusOptionChanged = opt.handleFocus !== options.handleFocus;
		  options = Object.assign({}, options, opt);
		  if (focusOptionChanged) {
			options.handleFocus ? addFocus() : removeFocus();
		  }
		  return h;
		};

		function dispatchOver(e) {
		  mouseOver = true;
		  if (timer) timer = clearTimeout(timer);
		  el.removeEventListener('mousemove', tracker, false);

		  if (state !== 1) {
			pX = e.clientX;
			pY = e.clientY;

			el.addEventListener('mousemove', tracker, false);

			timer = setTimeout(function() {
			  compare(el, e);
			}, options.interval);
		  }

		  return this;
		}

		function dispatchOut(e) {
		  mouseOver = false;
		  if (timer) timer = clearTimeout(timer);
		  el.removeEventListener('mousemove', tracker, false);

		  if (state === 1) {
			timer = setTimeout(function() {
			  delay(el, e);
			}, options.timeout);
		  }

		  return this;
		}

		function dispatchFocus(e) {
		  if (!mouseOver) {
			focused = true;
			onOver.call(el, e);
		  }
		}

		function dispatchBlur(e) {
		  if (!mouseOver && focused) {
			focused = false;
			onOut.call(el, e);
		  }
		}

		function addFocus() {
		  el.addEventListener('focus', dispatchFocus, false);
		  el.addEventListener('blur', dispatchBlur, false);
		}

		function removeFocus() {
		  el.removeEventListener('focus', dispatchFocus, false);
		  el.removeEventListener('blur', dispatchBlur, false);
		}

		h.remove = function() {
		  if (!el) return;
		  el.removeEventListener('mouseover', dispatchOver, false);
		  el.removeEventListener('mouseout', dispatchOut, false);
		  removeFocus();
		};

		if (el) {
		  el.addEventListener('mouseover', dispatchOver, false);
		  el.addEventListener('mouseout', dispatchOut, false);
		}

		return h;
	  };


	   }),

	 630:
	 (function(module, exports) {

	  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
		if (true) {
		  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
			  __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				  (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		  __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else { var mod; }
	  })(this, function (module, exports) {
		'use strict';

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});

		var _class, _temp;

		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		  }
		}

		var _createClass = function () {
		  function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
			  var descriptor = props[i];
			  descriptor.enumerable = descriptor.enumerable || false;
			  descriptor.configurable = true;
			  if ("value" in descriptor) descriptor.writable = true;
			  Object.defineProperty(target, descriptor.key, descriptor);
			}
		  }

		  return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		  };
		}();

		function isIn(needle, haystack) {
		  return haystack.indexOf(needle) >= 0;
		}

		function extend(custom, defaults) {
		  for (var key in defaults) {
			if (custom[key] == null) {
			  var value = defaults[key];
			  custom[key] = value;
			}
		  }
		  return custom;
		}

		function isMobile(agent) {
		  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent)
		  );
		}

		function createEvent(event) {
		  var bubble = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
		  var cancel = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
		  var detail = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

		  var customEvent = void 0;
		  if (document.createEvent != null) {
			// W3C DOM
			customEvent = document.createEvent('CustomEvent');
			customEvent.initCustomEvent(event, bubble, cancel, detail);
		  } else if (document.createEventObject != null) {
			// IE DOM < 9
			customEvent = document.createEventObject();
			customEvent.eventType = event;
		  } else {
			customEvent.eventName = event;
		  }

		  return customEvent;
		}

		function emitEvent(elem, event) {
		  if (elem.dispatchEvent != null) {
			// W3C DOM
			elem.dispatchEvent(event);
		  } else if (event in (elem != null)) {
			elem[event]();
		  } else if ('on' + event in (elem != null)) {
			elem['on' + event]();
		  }
		}

		function addEvent(elem, event, fn) {
		  if (elem.addEventListener != null) {
			// W3C DOM
			elem.addEventListener(event, fn, false);
		  } else if (elem.attachEvent != null) {
			// IE DOM
			elem.attachEvent('on' + event, fn);
		  } else {
			// fallback
			elem[event] = fn;
		  }
		}

		function removeEvent(elem, event, fn) {
		  if (elem.removeEventListener != null) {
			// W3C DOM
			elem.removeEventListener(event, fn, false);
		  } else if (elem.detachEvent != null) {
			// IE DOM
			elem.detachEvent('on' + event, fn);
		  } else {
			// fallback
			delete elem[event];
		  }
		}

		function getInnerHeight() {
		  if ('innerHeight' in window) {
			return window.innerHeight;
		  }

		  return document.documentElement.clientHeight;
		}

		// Minimalistic WeakMap shim, just in case.
		var WeakMap = window.WeakMap || window.MozWeakMap || function () {
		  function WeakMap() {
			_classCallCheck(this, WeakMap);

			this.keys = [];
			this.values = [];
		  }

		  _createClass(WeakMap, [{
			key: 'get',
			value: function get(key) {
			  for (var i = 0; i < this.keys.length; i++) {
				var item = this.keys[i];
				if (item === key) {
				  return this.values[i];
				}
			  }
			  return undefined;
			}
		  }, {
			key: 'set',
			value: function set(key, value) {
			  for (var i = 0; i < this.keys.length; i++) {
				var item = this.keys[i];
				if (item === key) {
				  this.values[i] = value;
				  return this;
				}
			  }
			  this.keys.push(key);
			  this.values.push(value);
			  return this;
			}
		  }]);

		  return WeakMap;
		}();

		// Dummy MutationObserver, to avoid raising exceptions.
		var MutationObserver = window.MutationObserver || window.WebkitMutationObserver || window.MozMutationObserver || (_temp = _class = function () {
		  function MutationObserver() {
			_classCallCheck(this, MutationObserver);

			if (typeof console !== 'undefined' && console !== null) {
			  console.warn('MutationObserver is not supported by your browser.');
			  console.warn('WOW.js cannot detect dom mutations, please call .sync() after loading new content.');
			}
		  }

		  _createClass(MutationObserver, [{
			key: 'observe',
			value: function observe() {}
		  }]);

		  return MutationObserver;
		}(), _class.notSupported = true, _temp);

		// getComputedStyle shim, from http://stackoverflow.com/a/21797294
		var getComputedStyle = window.getComputedStyle || function getComputedStyle(el) {
		  var getComputedStyleRX = /(\-([a-z]){1})/g;
		  return {
			getPropertyValue: function getPropertyValue(prop) {
			  if (prop === 'float') {
				prop = 'styleFloat';
			  }
			  if (getComputedStyleRX.test(prop)) {
				prop.replace(getComputedStyleRX, function (_, _char) {
				  return _char.toUpperCase();
				});
			  }
			  var currentStyle = el.currentStyle;

			  return (currentStyle != null ? currentStyle[prop] : void 0) || null;
			}
		  };
		};

		var WOW = function () {
		  function WOW() {
			var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

			_classCallCheck(this, WOW);

			this.defaults = {
			  boxClass: 'wow',
			  animateClass: 'animated',
			  offset: 0,
			  mobile: true,
			  live: true,
			  callback: null,
			  scrollContainer: null
			};

			this.animate = function animateFactory() {
			  if ('requestAnimationFrame' in window) {
				return function (callback) {
				  return window.requestAnimationFrame(callback);
				};
			  }
			  return function (callback) {
				return callback();
			  };
			}();

			this.vendors = ['moz', 'webkit'];

			this.start = this.start.bind(this);
			this.resetAnimation = this.resetAnimation.bind(this);
			this.scrollHandler = this.scrollHandler.bind(this);
			this.scrollCallback = this.scrollCallback.bind(this);
			this.scrolled = true;
			this.config = extend(options, this.defaults);
			if (options.scrollContainer != null) {
			  this.config.scrollContainer = document.querySelector(options.scrollContainer);
			}
			// Map of elements to animation names:
			this.animationNameCache = new WeakMap();
			this.wowEvent = createEvent(this.config.boxClass);
		  }

		  _createClass(WOW, [{
			key: 'init',
			value: function init() {
			  this.element = window.document.documentElement;
			  if (isIn(document.readyState, ['interactive', 'complete'])) {
				this.start();
			  } else {
				addEvent(document, 'DOMContentLoaded', this.start);
			  }
			  this.finished = [];
			}
		  }, {
			key: 'start',
			value: function start() {
			  var _this = this;

			  this.stopped = false;
			  this.boxes = [].slice.call(this.element.querySelectorAll('.' + this.config.boxClass));
			  this.all = this.boxes.slice(0);
			  if (this.boxes.length) {
				if (this.disabled()) {
				  this.resetStyle();
				} else {
				  for (var i = 0; i < this.boxes.length; i++) {
					var box = this.boxes[i];
					this.applyStyle(box, true);
				  }
				}
			  }
			  if (!this.disabled()) {
				addEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
				addEvent(window, 'resize', this.scrollHandler);
				this.interval = setInterval(this.scrollCallback, 50);
			  }
			  if (this.config.live) {
				var mut = new MutationObserver(function (records) {
				  for (var j = 0; j < records.length; j++) {
					var record = records[j];
					for (var k = 0; k < record.addedNodes.length; k++) {
					  var node = record.addedNodes[k];
					  _this.doSync(node);
					}
				  }
				  return undefined;
				});
				mut.observe(document.body, {
				  childList: true,
				  subtree: true
				});
			  }
			}
		  }, {
			key: 'stop',
			value: function stop() {
			  this.stopped = true;
			  removeEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
			  removeEvent(window, 'resize', this.scrollHandler);
			  if (this.interval != null) {
				clearInterval(this.interval);
			  }
			}
		  }, {
			key: 'sync',
			value: function sync() {
			  if (MutationObserver.notSupported) {
				this.doSync(this.element);
			  }
			}
		  }, {
			key: 'doSync',
			value: function doSync(element) {
			  if (typeof element === 'undefined' || element === null) {
				element = this.element;
			  }
			  if (element.nodeType !== 1) {
				return;
			  }
			  element = element.parentNode || element;
			  var iterable = element.querySelectorAll('.' + this.config.boxClass);
			  for (var i = 0; i < iterable.length; i++) {
				var box = iterable[i];
				if (!isIn(box, this.all)) {
				  this.boxes.push(box);
				  this.all.push(box);
				  if (this.stopped || this.disabled()) {
					this.resetStyle();
				  } else {
					this.applyStyle(box, true);
				  }
				  this.scrolled = true;
				}
			  }
			}
		  }, {
			key: 'show',
			value: function show(box) {
			  this.applyStyle(box);
			  box.className = box.className + ' ' + this.config.animateClass;
			  if (this.config.callback != null) {
				this.config.callback(box);
			  }
			  emitEvent(box, this.wowEvent);

			  addEvent(box, 'animationend', this.resetAnimation);
			  addEvent(box, 'oanimationend', this.resetAnimation);
			  addEvent(box, 'webkitAnimationEnd', this.resetAnimation);
			  addEvent(box, 'MSAnimationEnd', this.resetAnimation);

			  return box;
			}
		  }, {
			key: 'applyStyle',
			value: function applyStyle(box, hidden) {
			  var _this2 = this;

			  var duration = box.getAttribute('data-wow-duration');
			  var delay = box.getAttribute('data-wow-delay');
			  var iteration = box.getAttribute('data-wow-iteration');

			  return this.animate(function () {
				return _this2.customStyle(box, hidden, duration, delay, iteration);
			  });
			}
		  }, {
			key: 'resetStyle',
			value: function resetStyle() {
			  for (var i = 0; i < this.boxes.length; i++) {
				var box = this.boxes[i];
				box.style.visibility = 'visible';
			  }
			  return undefined;
			}
		  }, {
			key: 'resetAnimation',
			value: function resetAnimation(event) {
			  if (event.type.toLowerCase().indexOf('animationend') >= 0) {
				var target = event.target || event.srcElement;
				target.className = target.className.replace(this.config.animateClass, '').trim();
			  }
			}
		  }, {
			key: 'customStyle',
			value: function customStyle(box, hidden, duration, delay, iteration) {
			  if (hidden) {
				this.cacheAnimationName(box);
			  }
			  box.style.visibility = hidden ? 'hidden' : 'visible';

			  if (duration) {
				this.vendorSet(box.style, { animationDuration: duration });
			  }
			  if (delay) {
				this.vendorSet(box.style, { animationDelay: delay });
			  }
			  if (iteration) {
				this.vendorSet(box.style, { animationIterationCount: iteration });
			  }
			  this.vendorSet(box.style, { animationName: hidden ? 'none' : this.cachedAnimationName(box) });

			  return box;
			}
		  }, {
			key: 'vendorSet',
			value: function vendorSet(elem, properties) {
			  for (var name in properties) {
				if (properties.hasOwnProperty(name)) {
				  var value = properties[name];
				  elem['' + name] = value;
				  for (var i = 0; i < this.vendors.length; i++) {
					var vendor = this.vendors[i];
					elem['' + vendor + name.charAt(0).toUpperCase() + name.substr(1)] = value;
				  }
				}
			  }
			}
		  }, {
			key: 'vendorCSS',
			value: function vendorCSS(elem, property) {
			  var style = getComputedStyle(elem);
			  var result = style.getPropertyCSSValue(property);
			  for (var i = 0; i < this.vendors.length; i++) {
				var vendor = this.vendors[i];
				result = result || style.getPropertyCSSValue('-' + vendor + '-' + property);
			  }
			  return result;
			}
		  }, {
			key: 'animationName',
			value: function animationName(box) {
			  var aName = void 0;
			  try {
				aName = this.vendorCSS(box, 'animation-name').cssText;
			  } catch (error) {
				// Opera, fall back to plain property value
				aName = getComputedStyle(box).getPropertyValue('animation-name');
			  }

			  if (aName === 'none') {
				return ''; // SVG/Firefox, unable to get animation name?
			  }

			  return aName;
			}
		  }, {
			key: 'cacheAnimationName',
			value: function cacheAnimationName(box) {
			  // https://bugzilla.mozilla.org/show_bug.cgi?id=921834
			  // box.dataset is not supported for SVG elements in Firefox
			  return this.animationNameCache.set(box, this.animationName(box));
			}
		  }, {
			key: 'cachedAnimationName',
			value: function cachedAnimationName(box) {
			  return this.animationNameCache.get(box);
			}
		  }, {
			key: 'scrollHandler',
			value: function scrollHandler() {
			  this.scrolled = true;
			}
		  }, {
			key: 'scrollCallback',
			value: function scrollCallback() {
			  if (this.scrolled) {
				this.scrolled = false;
				var results = [];
				for (var i = 0; i < this.boxes.length; i++) {
				  var box = this.boxes[i];
				  if (box) {
					if (this.isVisible(box)) {
					  this.show(box);
					  continue;
					}
					results.push(box);
				  }
				}
				this.boxes = results;
				if (!this.boxes.length && !this.config.live) {
				  this.stop();
				}
			  }
			}
		  }, {
			key: 'offsetTop',
			value: function offsetTop(element) {
			  // SVG elements don't have an offsetTop in Firefox.
			  // This will use their nearest parent that has an offsetTop.
			  // Also, using ('offsetTop' of element) causes an exception in Firefox.
			  while (element.offsetTop === undefined) {
				element = element.parentNode;
			  }
			  var top = element.offsetTop;
			  while (element.offsetParent) {
				element = element.offsetParent;
				top += element.offsetTop;
			  }
			  return top;
			}
		  }, {
			key: 'isVisible',
			value: function isVisible(box) {
			  var offset = box.getAttribute('data-wow-offset') || this.config.offset;
			  var viewTop = this.config.scrollContainer && this.config.scrollContainer.scrollTop || window.pageYOffset;
			  var viewBottom = viewTop + Math.min(this.element.clientHeight, getInnerHeight()) - offset;
			  var top = this.offsetTop(box);
			  var bottom = top + box.clientHeight;

			  return top <= viewBottom && bottom >= viewTop;
			}
		  }, {
			key: 'disabled',
			value: function disabled() {
			  return !this.config.mobile && isMobile(navigator.userAgent);
			}
		  }]);

		  return WOW;
		}();

		exports.default = WOW;
		module.exports = exports['default'];
	  });


	   })

	 	});
  /************************************************************************/
   	// The module cache
   	var __webpack_module_cache__ = {};

   	// The require function
   	function __webpack_require__(moduleId) {
	 		// Check if module is in cache
	 		var cachedModule = __webpack_module_cache__[moduleId];
	 		if (cachedModule !== undefined) {
	   			return cachedModule.exports;
	   		}
	 		// Create a new module (and put it into the cache)
	 		var module = __webpack_module_cache__[moduleId] = {
	   			// no module.id needed
	   			// no module.loaded needed
	   			exports: {}
	   		};

	 		// Execute the module function
	 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	 		// Return the exports of the module
	 		return module.exports;
	 	}

  /************************************************************************/
   	/* webpack/runtime/compat get default export */
   	(() => {
	 		// getDefaultExport function for compatibility with non-harmony modules
	 		__webpack_require__.n = (module) => {
	   			var getter = module && module.__esModule ?
		   				() => (module['default']) :
		   				() => (module);
	   			__webpack_require__.d(getter, { a: getter });
	   			return getter;
	   		};
	 	})();

   	/* webpack/runtime/define property getters */
   	(() => {
	 		// define getter functions for harmony exports
	 		__webpack_require__.d = (exports, definition) => {
	   			for(var key in definition) {
		 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
		   					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
		   				}
		 			}
	   		};
	 	})();

   	/* webpack/runtime/global */
   	(() => {
	 		__webpack_require__.g = (function() {
	   			if (typeof globalThis === 'object') return globalThis;
	   			try {
		 				return this || new Function('return this')();
		 			} catch (e) {
		 				if (typeof window === 'object') return window;
		 			}
	   		})();
	 	})();

   	/* webpack/runtime/hasOwnProperty shorthand */
   	(() => {
	 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
	 	})();

  /************************************************************************/
  var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
	"use strict";

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
	var jquery = window.jQuery;
	var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./node_modules/wow.js/dist/wow.js
	var wow = __webpack_require__(630);
	var wow_default = /*#__PURE__*/__webpack_require__.n(wow);

	/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
	/*  */

	var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
	function isUndef (v) {
	  return v === undefined || v === null
	}

	function isDef (v) {
	  return v !== undefined && v !== null
	}

	function isTrue (v) {
	  return v === true
	}

	function isFalse (v) {
	  return v === false
	}

	/**
	 * Check if value is primitive.
	 */
	function isPrimitive (value) {
	  return (
		  typeof value === 'string' ||
		  typeof value === 'number' ||
		  // $flow-disable-line
		  typeof value === 'symbol' ||
		  typeof value === 'boolean'
	  )
	}

	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}

	/**
	 * Get the raw type string of a value, e.g., [object Object].
	 */
	var _toString = Object.prototype.toString;

	function toRawType (value) {
	  return _toString.call(value).slice(8, -1)
	}

	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject (obj) {
	  return _toString.call(obj) === '[object Object]'
	}

	function isRegExp (v) {
	  return _toString.call(v) === '[object RegExp]'
	}

	/**
	 * Check if val is a valid array index.
	 */
	function isValidArrayIndex (val) {
	  var n = parseFloat(String(val));
	  return n >= 0 && Math.floor(n) === n && isFinite(val)
	}

	function isPromise (val) {
	  return (
		  isDef(val) &&
		  typeof val.then === 'function' &&
		  typeof val.catch === 'function'
	  )
	}

	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function vue_esm_toString (val) {
	  return val == null
		  ? ''
		  : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
			  ? JSON.stringify(val, null, 2)
			  : String(val)
	}

	/**
	 * Convert an input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}

	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
		str,
		expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
		map[list[i]] = true;
	  }
	  return expectsLowerCase
		  ? function (val) { return map[val.toLowerCase()]; }
		  : function (val) { return map[val]; }
	}

	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);

	/**
	 * Check if an attribute is a reserved attribute.
	 */
	var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

	/**
	 * Remove an item from an array.
	 */
	function remove (arr, item) {
	  if (arr.length) {
		var index = arr.indexOf(item);
		if (index > -1) {
		  return arr.splice(index, 1)
		}
	  }
	}

	/**
	 * Check whether an object has the property.
	 */
	var vue_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return vue_esm_hasOwnProperty.call(obj, key)
	}

	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
		var hit = cache[str];
		return hit || (cache[str] = fn(str))
	  })
	}

	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});

	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});

	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /\B([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str.replace(hyphenateRE, '-$1').toLowerCase()
	});

	/**
	 * Simple bind polyfill for environments that do not support it,
	 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
	 * since native bind is now performant enough in most browsers.
	 * But removing it would mean breaking code that was able to run in
	 * PhantomJS 1.x, so this must be kept for backward compatibility.
	 */

	/* istanbul ignore next */
	function polyfillBind (fn, ctx) {
	  function boundFn (a) {
		var l = arguments.length;
		return l
			? l > 1
				? fn.apply(ctx, arguments)
				: fn.call(ctx, a)
			: fn.call(ctx)
	  }

	  boundFn._length = fn.length;
	  return boundFn
	}

	function nativeBind (fn, ctx) {
	  return fn.bind(ctx)
	}

	var bind = Function.prototype.bind
		? nativeBind
		: polyfillBind;

	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
		ret[i] = list[i + start];
	  }
	  return ret
	}

	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
		to[key] = _from[key];
	  }
	  return to
	}

	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
		if (arr[i]) {
		  extend(res, arr[i]);
		}
	  }
	  return res
	}

	/* eslint-disable no-unused-vars */

	/**
	 * Perform no operation.
	 * Stubbing args to make Flow happy without leaving useless transpiled code
	 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
	 */
	function noop (a, b, c) {}

	/**
	 * Always return false.
	 */
	var no = function (a, b, c) { return false; };

	/* eslint-enable no-unused-vars */

	/**
	 * Return the same value.
	 */
	var identity = function (_) { return _; };

	/**
	 * Generate a string containing static keys from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
		return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}

	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  if (a === b) { return true }
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
		try {
		  var isArrayA = Array.isArray(a);
		  var isArrayB = Array.isArray(b);
		  if (isArrayA && isArrayB) {
			return a.length === b.length && a.every(function (e, i) {
			  return looseEqual(e, b[i])
			})
		  } else if (a instanceof Date && b instanceof Date) {
			return a.getTime() === b.getTime()
		  } else if (!isArrayA && !isArrayB) {
			var keysA = Object.keys(a);
			var keysB = Object.keys(b);
			return keysA.length === keysB.length && keysA.every(function (key) {
			  return looseEqual(a[key], b[key])
			})
		  } else {
			/* istanbul ignore next */
			return false
		  }
		} catch (e) {
		  /* istanbul ignore next */
		  return false
		}
	  } else if (!isObjectA && !isObjectB) {
		return String(a) === String(b)
	  } else {
		return false
	  }
	}

	/**
	 * Return the first index at which a loosely equal value can be
	 * found in the array (if value is a plain object, the array must
	 * contain an object of the same shape), or -1 if it is not present.
	 */
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
		if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}

	/**
	 * Ensure a function is called only once.
	 */
	function once (fn) {
	  var called = false;
	  return function () {
		if (!called) {
		  called = true;
		  fn.apply(this, arguments);
		}
	  }
	}

	var SSR_ATTR = 'data-server-rendered';

	var ASSET_TYPES = [
	  'component',
	  'directive',
	  'filter'
	];

	var LIFECYCLE_HOOKS = [
	  'beforeCreate',
	  'created',
	  'beforeMount',
	  'mounted',
	  'beforeUpdate',
	  'updated',
	  'beforeDestroy',
	  'destroyed',
	  'activated',
	  'deactivated',
	  'errorCaptured',
	  'serverPrefetch'
	];

	/*  */



	var config = ({
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  // $flow-disable-line
	  optionMergeStrategies: Object.create(null),

	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,

	  /**
	   * Show production mode tip message on boot?
	   */
	  productionTip: "production" !== 'production',

	  /**
	   * Whether to enable devtools
	   */
	  devtools: "production" !== 'production',

	  /**
	   * Whether to record perf
	   */
	  performance: false,

	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,

	  /**
	   * Warn handler for watcher warns
	   */
	  warnHandler: null,

	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],

	  /**
	   * Custom user key aliases for v-on
	   */
	  // $flow-disable-line
	  keyCodes: Object.create(null),

	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,

	  /**
	   * Check if an attribute is reserved so that it cannot be used as a component
	   * prop. This is platform-dependent and may be overwritten.
	   */
	  isReservedAttr: no,

	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,

	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,

	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,

	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,

	  /**
	   * Perform updates asynchronously. Intended to be used by Vue Test Utils
	   * This will significantly reduce performance if set to false.
	   */
	  async: true,

	  /**
	   * Exposed for legacy reasons
	   */
	  _lifecycleHooks: LIFECYCLE_HOOKS
	});

	/*  */

	/**
	 * unicode letters used for parsing html tags, component names and property paths.
	 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
	 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
	 */
	var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}

	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
		value: val,
		enumerable: !!enumerable,
		writable: true,
		configurable: true
	  });
	}

	/**
	 * Parse simple path.
	 */
	var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
	function parsePath (path) {
	  if (bailRE.test(path)) {
		return
	  }
	  var segments = path.split('.');
	  return function (obj) {
		for (var i = 0; i < segments.length; i++) {
		  if (!obj) { return }
		  obj = obj[segments[i]];
		}
		return obj
	  }
	}

	/*  */

// can we use __proto__?
	var hasProto = '__proto__' in {};

// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
	var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
	var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
	var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
	var isPhantomJS = UA && /phantomjs/.test(UA);
	var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
	var nativeWatch = ({}).watch;

	var supportsPassive = false;
	if (inBrowser) {
	  try {
		var opts = {};
		Object.defineProperty(opts, 'passive', ({
		  get: function get () {
			/* istanbul ignore next */
			supportsPassive = true;
		  }
		})); // https://github.com/facebook/flow/issues/285
		window.addEventListener('test-passive', null, opts);
	  } catch (e) {}
	}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
		/* istanbul ignore if */
		if (!inBrowser && !inWeex && typeof __webpack_require__.g !== 'undefined') {
		  // detect presence of vue-server-renderer and avoid
		  // Webpack shimming the process
		  _isServer = __webpack_require__.g['process'] && __webpack_require__.g['process'].env.VUE_ENV === 'server';
		} else {
		  _isServer = false;
		}
	  }
	  return _isServer
	};

// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

	/* istanbul ignore next */
	function isNative (Ctor) {
	  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
	}

	var hasSymbol =
		typeof Symbol !== 'undefined' && isNative(Symbol) &&
		typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

	var _Set;
	/* istanbul ignore if */ // $flow-disable-line
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = /*@__PURE__*/(function () {
		function Set () {
		  this.set = Object.create(null);
		}
		Set.prototype.has = function has (key) {
		  return this.set[key] === true
		};
		Set.prototype.add = function add (key) {
		  this.set[key] = true;
		};
		Set.prototype.clear = function clear () {
		  this.set = Object.create(null);
		};

		return Set;
	  }());
	}

	/*  */

	var warn = noop;
	var tip = (/* unused pure expression or super */ null && (noop));
	var generateComponentTrace = ((/* unused pure expression or super */ null && (noop))); // work around flow check
	var formatComponentName = ((/* unused pure expression or super */ null && (noop)));

	if (false) { var repeat, classify, classifyRE, hasConsole; }

	/*  */

	var uid = 0;

	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid++;
	  this.subs = [];
	};

	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};

	Dep.prototype.removeSub = function removeSub (sub) {
	  remove(this.subs, sub);
	};

	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
		Dep.target.addDep(this);
	  }
	};

	Dep.prototype.notify = function notify () {
	  // stabilize the subscriber list first
	  var subs = this.subs.slice();
	  if (false) {}
	  for (var i = 0, l = subs.length; i < l; i++) {
		subs[i].update();
	  }
	};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
	Dep.target = null;
	var targetStack = [];

	function pushTarget (target) {
	  targetStack.push(target);
	  Dep.target = target;
	}

	function popTarget () {
	  targetStack.pop();
	  Dep.target = targetStack[targetStack.length - 1];
	}

	/*  */

	var VNode = function VNode (
		tag,
		data,
		children,
		text,
		elm,
		context,
		componentOptions,
		asyncFactory
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.fnContext = undefined;
	  this.fnOptions = undefined;
	  this.fnScopeId = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	  this.asyncFactory = asyncFactory;
	  this.asyncMeta = undefined;
	  this.isAsyncPlaceholder = false;
	};

	var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};

	Object.defineProperties( VNode.prototype, prototypeAccessors );

	var createEmptyVNode = function (text) {
	  if ( text === void 0 ) text = '';

	  var node = new VNode();
	  node.text = text;
	  node.isComment = true;
	  return node
	};

	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
		  vnode.tag,
		  vnode.data,
		  // #7975
		  // clone children array to avoid mutating original in case of cloning
		  // a child.
		  vnode.children && vnode.children.slice(),
		  vnode.text,
		  vnode.elm,
		  vnode.context,
		  vnode.componentOptions,
		  vnode.asyncFactory
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isComment = vnode.isComment;
	  cloned.fnContext = vnode.fnContext;
	  cloned.fnOptions = vnode.fnOptions;
	  cloned.fnScopeId = vnode.fnScopeId;
	  cloned.asyncMeta = vnode.asyncMeta;
	  cloned.isCloned = true;
	  return cloned
	}

	/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);

	var methodsToPatch = [
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	];

	/**
	 * Intercept mutating methods and emit events
	 */
	methodsToPatch.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];

		var result = original.apply(this, args);
		var ob = this.__ob__;
		var inserted;
		switch (method) {
		  case 'push':
		  case 'unshift':
			inserted = args;
			break
		  case 'splice':
			inserted = args.slice(2);
			break
		}
		if (inserted) { ob.observeArray(inserted); }
		// notify change
		ob.dep.notify();
		return result
	  });
	});

	/*  */

	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

	/**
	 * In some cases we may want to disable observation inside a component's
	 * update computation.
	 */
	var shouldObserve = true;

	function toggleObserving (value) {
	  shouldObserve = value;
	}

	/**
	 * Observer class that is attached to each observed
	 * object. Once attached, the observer converts the target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatch updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
		if (hasProto) {
		  protoAugment(value, arrayMethods);
		} else {
		  copyAugment(value, arrayMethods, arrayKeys);
		}
		this.observeArray(value);
	  } else {
		this.walk(value);
	  }
	};

	/**
	 * Walk through all properties and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
		defineReactive$$1(obj, keys[i]);
	  }
	};

	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
		observe(items[i]);
	  }
	};

// helpers

	/**
	 * Augment a target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}

	/**
	 * Augment a target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
		var key = keys[i];
		def(target, key, src[key]);
	  }
	}

	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value) || value instanceof VNode) {
		return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
		ob = value.__ob__;
	  } else if (
		  shouldObserve &&
		  !isServerRendering() &&
		  (Array.isArray(value) || isPlainObject(value)) &&
		  Object.isExtensible(value) &&
		  !value._isVue
	  ) {
		ob = new Observer(value);
	  }
	  if (asRootData && ob) {
		ob.vmCount++;
	  }
	  return ob
	}

	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive$$1 (
		obj,
		key,
		val,
		customSetter,
		shallow
	) {
	  var dep = new Dep();

	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
		return
	  }

	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	  if ((!getter || setter) && arguments.length === 2) {
		val = obj[key];
	  }

	  var childOb = !shallow && observe(val);
	  Object.defineProperty(obj, key, {
		enumerable: true,
		configurable: true,
		get: function reactiveGetter () {
		  var value = getter ? getter.call(obj) : val;
		  if (Dep.target) {
			dep.depend();
			if (childOb) {
			  childOb.dep.depend();
			  if (Array.isArray(value)) {
				dependArray(value);
			  }
			}
		  }
		  return value
		},
		set: function reactiveSetter (newVal) {
		  var value = getter ? getter.call(obj) : val;
		  /* eslint-disable no-self-compare */
		  if (newVal === value || (newVal !== newVal && value !== value)) {
			return
		  }
		  /* eslint-enable no-self-compare */
		  if (false) {}
		  // #7981: for accessor properties without setter
		  if (getter && !setter) { return }
		  if (setter) {
			setter.call(obj, newVal);
		  } else {
			val = newVal;
		  }
		  childOb = !shallow && observe(newVal);
		  dep.notify();
		}
	  });
	}

	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set (target, key, val) {
	  if (false
	  ) {}
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
		target.length = Math.max(target.length, key);
		target.splice(key, 1, val);
		return val
	  }
	  if (key in target && !(key in Object.prototype)) {
		target[key] = val;
		return val
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
		false && 0;
		return val
	  }
	  if (!ob) {
		target[key] = val;
		return val
	  }
	  defineReactive$$1(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}

	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (target, key) {
	  if (false
	  ) {}
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
		target.splice(key, 1);
		return
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
		false && 0;
		return
	  }
	  if (!hasOwn(target, key)) {
		return
	  }
	  delete target[key];
	  if (!ob) {
		return
	  }
	  ob.dep.notify();
	}

	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
		e = value[i];
		e && e.__ob__ && e.__ob__.dep.depend();
		if (Array.isArray(e)) {
		  dependArray(e);
		}
	  }
	}

	/*  */

	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;

	/**
	 * Options with restrictions
	 */
	if (false) {}

	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;

	  var keys = hasSymbol
		  ? Reflect.ownKeys(from)
		  : Object.keys(from);

	  for (var i = 0; i < keys.length; i++) {
		key = keys[i];
		// in case the object is already observed...
		if (key === '__ob__') { continue }
		toVal = to[key];
		fromVal = from[key];
		if (!hasOwn(to, key)) {
		  set(to, key, fromVal);
		} else if (
			toVal !== fromVal &&
			isPlainObject(toVal) &&
			isPlainObject(fromVal)
		) {
		  mergeData(toVal, fromVal);
		}
	  }
	  return to
	}

	/**
	 * Data
	 */
	function mergeDataOrFn (
		parentVal,
		childVal,
		vm
	) {
	  if (!vm) {
		// in a Vue.extend merge, both should be functions
		if (!childVal) {
		  return parentVal
		}
		if (!parentVal) {
		  return childVal
		}
		// when parentVal & childVal are both present,
		// we need to return a function that returns the
		// merged result of both functions... no need to
		// check if parentVal is a function here because
		// it has to be a function to pass previous merges.
		return function mergedDataFn () {
		  return mergeData(
			  typeof childVal === 'function' ? childVal.call(this, this) : childVal,
			  typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
		  )
		}
	  } else {
		return function mergedInstanceDataFn () {
		  // instance merge
		  var instanceData = typeof childVal === 'function'
			  ? childVal.call(vm, vm)
			  : childVal;
		  var defaultData = typeof parentVal === 'function'
			  ? parentVal.call(vm, vm)
			  : parentVal;
		  if (instanceData) {
			return mergeData(instanceData, defaultData)
		  } else {
			return defaultData
		  }
		}
	  }
	}

	strats.data = function (
		parentVal,
		childVal,
		vm
	) {
	  if (!vm) {
		if (childVal && typeof childVal !== 'function') {
		  false && 0;

		  return parentVal
		}
		return mergeDataOrFn(parentVal, childVal)
	  }

	  return mergeDataOrFn(parentVal, childVal, vm)
	};

	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeHook (
		parentVal,
		childVal
	) {
	  var res = childVal
		  ? parentVal
			  ? parentVal.concat(childVal)
			  : Array.isArray(childVal)
				  ? childVal
				  : [childVal]
		  : parentVal;
	  return res
		  ? dedupeHooks(res)
		  : res
	}

	function dedupeHooks (hooks) {
	  var res = [];
	  for (var i = 0; i < hooks.length; i++) {
		if (res.indexOf(hooks[i]) === -1) {
		  res.push(hooks[i]);
		}
	  }
	  return res
	}

	LIFECYCLE_HOOKS.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});

	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (
		parentVal,
		childVal,
		vm,
		key
	) {
	  var res = Object.create(parentVal || null);
	  if (childVal) {
		false && 0;
		return extend(res, childVal)
	  } else {
		return res
	  }
	}

	ASSET_TYPES.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});

	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (
		parentVal,
		childVal,
		vm,
		key
	) {
	  // work around Firefox's Object.prototype.watch...
	  if (parentVal === nativeWatch) { parentVal = undefined; }
	  if (childVal === nativeWatch) { childVal = undefined; }
	  /* istanbul ignore if */
	  if (!childVal) { return Object.create(parentVal || null) }
	  if (false) {}
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key$1 in childVal) {
		var parent = ret[key$1];
		var child = childVal[key$1];
		if (parent && !Array.isArray(parent)) {
		  parent = [parent];
		}
		ret[key$1] = parent
			? parent.concat(child)
			: Array.isArray(child) ? child : [child];
	  }
	  return ret
	};

	/**
	 * Other object hashes.
	 */
	strats.props =
		strats.methods =
			strats.inject =
				strats.computed = function (
					parentVal,
					childVal,
					vm,
					key
				) {
				  if (childVal && "production" !== 'production') {}
				  if (!parentVal) { return childVal }
				  var ret = Object.create(null);
				  extend(ret, parentVal);
				  if (childVal) { extend(ret, childVal); }
				  return ret
				};
	strats.provide = mergeDataOrFn;

	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
		  ? parentVal
		  : childVal
	};

	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
		validateComponentName(key);
	  }
	}

	function validateComponentName (name) {
	  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
		warn(
			'Invalid component name: "' + name + '". Component names ' +
			'should conform to valid custom element name in html5 specification.'
		);
	  }
	  if (isBuiltInTag(name) || config.isReservedTag(name)) {
		warn(
			'Do not use built-in or reserved HTML elements as component ' +
			'id: ' + name
		);
	  }
	}

	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options, vm) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
		i = props.length;
		while (i--) {
		  val = props[i];
		  if (typeof val === 'string') {
			name = camelize(val);
			res[name] = { type: null };
		  } else if (false) {}
		}
	  } else if (isPlainObject(props)) {
		for (var key in props) {
		  val = props[key];
		  name = camelize(key);
		  res[name] = isPlainObject(val)
			  ? val
			  : { type: val };
		}
	  } else if (false) {}
	  options.props = res;
	}

	/**
	 * Normalize all injections into Object-based format
	 */
	function normalizeInject (options, vm) {
	  var inject = options.inject;
	  if (!inject) { return }
	  var normalized = options.inject = {};
	  if (Array.isArray(inject)) {
		for (var i = 0; i < inject.length; i++) {
		  normalized[inject[i]] = { from: inject[i] };
		}
	  } else if (isPlainObject(inject)) {
		for (var key in inject) {
		  var val = inject[key];
		  normalized[key] = isPlainObject(val)
			  ? extend({ from: key }, val)
			  : { from: val };
		}
	  } else if (false) {}
	}

	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
		for (var key in dirs) {
		  var def$$1 = dirs[key];
		  if (typeof def$$1 === 'function') {
			dirs[key] = { bind: def$$1, update: def$$1 };
		  }
		}
	  }
	}

	function assertObjectType (name, value, vm) {
	  if (!isPlainObject(value)) {
		warn(
			"Invalid value for option \"" + name + "\": expected an Object, " +
			"but got " + (toRawType(value)) + ".",
			vm
		);
	  }
	}

	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
		parent,
		child,
		vm
	) {
	  if (false) {}

	  if (typeof child === 'function') {
		child = child.options;
	  }

	  normalizeProps(child, vm);
	  normalizeInject(child, vm);
	  normalizeDirectives(child);

	  // Apply extends and mixins on the child options,
	  // but only if it is a raw options object that isn't
	  // the result of another mergeOptions call.
	  // Only merged options has the _base property.
	  if (!child._base) {
		if (child.extends) {
		  parent = mergeOptions(parent, child.extends, vm);
		}
		if (child.mixins) {
		  for (var i = 0, l = child.mixins.length; i < l; i++) {
			parent = mergeOptions(parent, child.mixins[i], vm);
		  }
		}
	  }

	  var options = {};
	  var key;
	  for (key in parent) {
		mergeField(key);
	  }
	  for (key in child) {
		if (!hasOwn(parent, key)) {
		  mergeField(key);
		}
	  }
	  function mergeField (key) {
		var strat = strats[key] || defaultStrat;
		options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}

	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
		options,
		type,
		id,
		warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
		return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if (false) {}
	  return res
	}

	/*  */



	function validateProp (
		key,
		propOptions,
		propsData,
		vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // boolean casting
	  var booleanIndex = getTypeIndex(Boolean, prop.type);
	  if (booleanIndex > -1) {
		if (absent && !hasOwn(prop, 'default')) {
		  value = false;
		} else if (value === '' || value === hyphenate(key)) {
		  // only cast empty string / same name to boolean if
		  // boolean has higher priority
		  var stringIndex = getTypeIndex(String, prop.type);
		  if (stringIndex < 0 || booleanIndex < stringIndex) {
			value = true;
		  }
		}
	  }
	  // check default value
	  if (value === undefined) {
		value = getPropDefaultValue(vm, prop, key);
		// since the default value is a fresh copy,
		// make sure to observe it.
		var prevShouldObserve = shouldObserve;
		toggleObserving(true);
		observe(value);
		toggleObserving(prevShouldObserve);
	  }
	  if (
		  false
	  ) {}
	  return value
	}

	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
		return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (false) {}
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
		  vm.$options.propsData[key] === undefined &&
		  vm._props[key] !== undefined
	  ) {
		return vm._props[key]
	  }
	  // call factory function for non-Function types
	  // a value is Function if its prototype is function even across different execution context
	  return typeof def === 'function' && getType(prop.type) !== 'Function'
		  ? def.call(vm)
		  : def
	}

	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
		prop,
		name,
		value,
		vm,
		absent
	) {
	  if (prop.required && absent) {
		warn(
			'Missing required prop: "' + name + '"',
			vm
		);
		return
	  }
	  if (value == null && !prop.required) {
		return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
		if (!Array.isArray(type)) {
		  type = [type];
		}
		for (var i = 0; i < type.length && !valid; i++) {
		  var assertedType = assertType(value, type[i], vm);
		  expectedTypes.push(assertedType.expectedType || '');
		  valid = assertedType.valid;
		}
	  }

	  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
	  if (!valid && haveExpectedTypes) {
		warn(
			getInvalidTypeMessage(name, value, expectedTypes),
			vm
		);
		return
	  }
	  var validator = prop.validator;
	  if (validator) {
		if (!validator(value)) {
		  warn(
			  'Invalid prop: custom validator check failed for prop "' + name + '".',
			  vm
		  );
		}
	  }
	}

	var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

	function assertType (value, type, vm) {
	  var valid;
	  var expectedType = getType(type);
	  if (simpleCheckRE.test(expectedType)) {
		var t = typeof value;
		valid = t === expectedType.toLowerCase();
		// for primitive wrapper objects
		if (!valid && t === 'object') {
		  valid = value instanceof type;
		}
	  } else if (expectedType === 'Object') {
		valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
		valid = Array.isArray(value);
	  } else {
		try {
		  valid = value instanceof type;
		} catch (e) {
		  warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
		  valid = false;
		}
	  }
	  return {
		valid: valid,
		expectedType: expectedType
	  }
	}

	var functionTypeCheckRE = /^\s*function (\w+)/;

	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(functionTypeCheckRE);
	  return match ? match[1] : ''
	}

	function isSameType (a, b) {
	  return getType(a) === getType(b)
	}

	function getTypeIndex (type, expectedTypes) {
	  if (!Array.isArray(expectedTypes)) {
		return isSameType(expectedTypes, type) ? 0 : -1
	  }
	  for (var i = 0, len = expectedTypes.length; i < len; i++) {
		if (isSameType(expectedTypes[i], type)) {
		  return i
		}
	  }
	  return -1
	}

	function getInvalidTypeMessage (name, value, expectedTypes) {
	  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
		  " Expected " + (expectedTypes.map(capitalize).join(', '));
	  var expectedType = expectedTypes[0];
	  var receivedType = toRawType(value);
	  // check if we need to specify expected value
	  if (
		  expectedTypes.length === 1 &&
		  isExplicable(expectedType) &&
		  isExplicable(typeof value) &&
		  !isBoolean(expectedType, receivedType)
	  ) {
		message += " with value " + (styleValue(value, expectedType));
	  }
	  message += ", got " + receivedType + " ";
	  // check if we need to specify received value
	  if (isExplicable(receivedType)) {
		message += "with value " + (styleValue(value, receivedType)) + ".";
	  }
	  return message
	}

	function styleValue (value, type) {
	  if (type === 'String') {
		return ("\"" + value + "\"")
	  } else if (type === 'Number') {
		return ("" + (Number(value)))
	  } else {
		return ("" + value)
	  }
	}

	var EXPLICABLE_TYPES = (/* unused pure expression or super */ null && (['string', 'number', 'boolean']));
	function isExplicable (value) {
	  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
	}

	function isBoolean () {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
	}

	/*  */

	function handleError (err, vm, info) {
	  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
	  // See: https://github.com/vuejs/vuex/issues/1505
	  pushTarget();
	  try {
		if (vm) {
		  var cur = vm;
		  while ((cur = cur.$parent)) {
			var hooks = cur.$options.errorCaptured;
			if (hooks) {
			  for (var i = 0; i < hooks.length; i++) {
				try {
				  var capture = hooks[i].call(cur, err, vm, info) === false;
				  if (capture) { return }
				} catch (e) {
				  globalHandleError(e, cur, 'errorCaptured hook');
				}
			  }
			}
		  }
		}
		globalHandleError(err, vm, info);
	  } finally {
		popTarget();
	  }
	}

	function invokeWithErrorHandling (
		handler,
		context,
		args,
		vm,
		info
	) {
	  var res;
	  try {
		res = args ? handler.apply(context, args) : handler.call(context);
		if (res && !res._isVue && isPromise(res) && !res._handled) {
		  res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
		  // issue #9511
		  // avoid catch triggering multiple times when nested calls
		  res._handled = true;
		}
	  } catch (e) {
		handleError(e, vm, info);
	  }
	  return res
	}

	function globalHandleError (err, vm, info) {
	  if (config.errorHandler) {
		try {
		  return config.errorHandler.call(null, err, vm, info)
		} catch (e) {
		  // if the user intentionally throws the original error in the handler,
		  // do not log it twice
		  if (e !== err) {
			logError(e, null, 'config.errorHandler');
		  }
		}
	  }
	  logError(err, vm, info);
	}

	function logError (err, vm, info) {
	  if (false) {}
	  /* istanbul ignore else */
	  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
		console.error(err);
	  } else {
		throw err
	  }
	}

	/*  */

	var isUsingMicroTask = false;

	var callbacks = [];
	var pending = false;

	function flushCallbacks () {
	  pending = false;
	  var copies = callbacks.slice(0);
	  callbacks.length = 0;
	  for (var i = 0; i < copies.length; i++) {
		copies[i]();
	  }
	}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
	var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
	/* istanbul ignore next, $flow-disable-line */
	if (typeof Promise !== 'undefined' && isNative(Promise)) {
	  var p = Promise.resolve();
	  timerFunc = function () {
		p.then(flushCallbacks);
		// In problematic UIWebViews, Promise.then doesn't completely break, but
		// it can get stuck in a weird state where callbacks are pushed into the
		// microtask queue but the queue isn't being flushed, until the browser
		// needs to do some other work, e.g. handle a timer. Therefore we can
		// "force" the microtask queue to be flushed by adding an empty timer.
		if (isIOS) { setTimeout(noop); }
	  };
	  isUsingMicroTask = true;
	} else if (!isIE && typeof MutationObserver !== 'undefined' && (
		isNative(MutationObserver) ||
		// PhantomJS and iOS 7.x
		MutationObserver.toString() === '[object MutationObserverConstructor]'
	)) {
	  // Use MutationObserver where native Promise is not available,
	  // e.g. PhantomJS, iOS7, Android 4.4
	  // (#6466 MutationObserver is unreliable in IE11)
	  var counter = 1;
	  var observer = new MutationObserver(flushCallbacks);
	  var textNode = document.createTextNode(String(counter));
	  observer.observe(textNode, {
		characterData: true
	  });
	  timerFunc = function () {
		counter = (counter + 1) % 2;
		textNode.data = String(counter);
	  };
	  isUsingMicroTask = true;
	} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
	  // Fallback to setImmediate.
	  // Technically it leverages the (macro) task queue,
	  // but it is still a better choice than setTimeout.
	  timerFunc = function () {
		setImmediate(flushCallbacks);
	  };
	} else {
	  // Fallback to setTimeout.
	  timerFunc = function () {
		setTimeout(flushCallbacks, 0);
	  };
	}

	function nextTick (cb, ctx) {
	  var _resolve;
	  callbacks.push(function () {
		if (cb) {
		  try {
			cb.call(ctx);
		  } catch (e) {
			handleError(e, ctx, 'nextTick');
		  }
		} else if (_resolve) {
		  _resolve(ctx);
		}
	  });
	  if (!pending) {
		pending = true;
		timerFunc();
	  }
	  // $flow-disable-line
	  if (!cb && typeof Promise !== 'undefined') {
		return new Promise(function (resolve) {
		  _resolve = resolve;
		})
	  }
	}

	/*  */

	var mark;
	var measure;

	if (false) { var perf; }

	/* not type checking this file because flow doesn't play well with Proxy */

	var initProxy;

	if (false) { var getHandler, hasHandler, isBuiltInModifier, hasProxy, warnReservedPrefix, warnNonPresent, allowedGlobals; }

	/*  */

	var seenObjects = new _Set();

	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	function traverse (val) {
	  _traverse(val, seenObjects);
	  seenObjects.clear();
	}

	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
		return
	  }
	  if (val.__ob__) {
		var depId = val.__ob__.dep.id;
		if (seen.has(depId)) {
		  return
		}
		seen.add(depId);
	  }
	  if (isA) {
		i = val.length;
		while (i--) { _traverse(val[i], seen); }
	  } else {
		keys = Object.keys(val);
		i = keys.length;
		while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}

	/*  */

	var normalizeEvent = cached(function (name) {
	  var passive = name.charAt(0) === '&';
	  name = passive ? name.slice(1) : name;
	  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once$$1 ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
		name: name,
		once: once$$1,
		capture: capture,
		passive: passive
	  }
	});

	function createFnInvoker (fns, vm) {
	  function invoker () {
		var arguments$1 = arguments;

		var fns = invoker.fns;
		if (Array.isArray(fns)) {
		  var cloned = fns.slice();
		  for (var i = 0; i < cloned.length; i++) {
			invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
		  }
		} else {
		  // return handler return value for single handlers
		  return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
		}
	  }
	  invoker.fns = fns;
	  return invoker
	}

	function updateListeners (
		on,
		oldOn,
		add,
		remove$$1,
		createOnceHandler,
		vm
	) {
	  var name, def$$1, cur, old, event;
	  for (name in on) {
		def$$1 = cur = on[name];
		old = oldOn[name];
		event = normalizeEvent(name);
		if (isUndef(cur)) {
		  false && 0;
		} else if (isUndef(old)) {
		  if (isUndef(cur.fns)) {
			cur = on[name] = createFnInvoker(cur, vm);
		  }
		  if (isTrue(event.once)) {
			cur = on[name] = createOnceHandler(event.name, cur, event.capture);
		  }
		  add(event.name, cur, event.capture, event.passive, event.params);
		} else if (cur !== old) {
		  old.fns = cur;
		  on[name] = old;
		}
	  }
	  for (name in oldOn) {
		if (isUndef(on[name])) {
		  event = normalizeEvent(name);
		  remove$$1(event.name, oldOn[name], event.capture);
		}
	  }
	}

	/*  */

	function mergeVNodeHook (def, hookKey, hook) {
	  if (def instanceof VNode) {
		def = def.data.hook || (def.data.hook = {});
	  }
	  var invoker;
	  var oldHook = def[hookKey];

	  function wrappedHook () {
		hook.apply(this, arguments);
		// important: remove merged hook to ensure it's called only once
		// and prevent memory leak
		remove(invoker.fns, wrappedHook);
	  }

	  if (isUndef(oldHook)) {
		// no existing hook
		invoker = createFnInvoker([wrappedHook]);
	  } else {
		/* istanbul ignore if */
		if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
		  // already a merged invoker
		  invoker = oldHook;
		  invoker.fns.push(wrappedHook);
		} else {
		  // existing plain hook
		  invoker = createFnInvoker([oldHook, wrappedHook]);
		}
	  }

	  invoker.merged = true;
	  def[hookKey] = invoker;
	}

	/*  */

	function extractPropsFromVNodeData (
		data,
		Ctor,
		tag
	) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (isUndef(propOptions)) {
		return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  if (isDef(attrs) || isDef(props)) {
		for (var key in propOptions) {
		  var altKey = hyphenate(key);
		  if (false) { var keyInLowerCase; }
		  checkProp(res, props, key, altKey, true) ||
		  checkProp(res, attrs, key, altKey, false);
		}
	  }
	  return res
	}

	function checkProp (
		res,
		hash,
		key,
		altKey,
		preserve
	) {
	  if (isDef(hash)) {
		if (hasOwn(hash, key)) {
		  res[key] = hash[key];
		  if (!preserve) {
			delete hash[key];
		  }
		  return true
		} else if (hasOwn(hash, altKey)) {
		  res[key] = hash[altKey];
		  if (!preserve) {
			delete hash[altKey];
		  }
		  return true
		}
	  }
	  return false
	}

	/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
		if (Array.isArray(children[i])) {
		  return Array.prototype.concat.apply([], children)
		}
	  }
	  return children
	}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
		  ? [createTextVNode(children)]
		  : Array.isArray(children)
			  ? normalizeArrayChildren(children)
			  : undefined
	}

	function isTextNode (node) {
	  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
	}

	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, lastIndex, last;
	  for (i = 0; i < children.length; i++) {
		c = children[i];
		if (isUndef(c) || typeof c === 'boolean') { continue }
		lastIndex = res.length - 1;
		last = res[lastIndex];
		//  nested
		if (Array.isArray(c)) {
		  if (c.length > 0) {
			c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
			// merge adjacent text nodes
			if (isTextNode(c[0]) && isTextNode(last)) {
			  res[lastIndex] = createTextVNode(last.text + (c[0]).text);
			  c.shift();
			}
			res.push.apply(res, c);
		  }
		} else if (isPrimitive(c)) {
		  if (isTextNode(last)) {
			// merge adjacent text nodes
			// this is necessary for SSR hydration because text nodes are
			// essentially merged when rendered to HTML strings
			res[lastIndex] = createTextVNode(last.text + c);
		  } else if (c !== '') {
			// convert primitive to vnode
			res.push(createTextVNode(c));
		  }
		} else {
		  if (isTextNode(c) && isTextNode(last)) {
			// merge adjacent text nodes
			res[lastIndex] = createTextVNode(last.text + c.text);
		  } else {
			// default key for nested array children (likely generated by v-for)
			if (isTrue(children._isVList) &&
				isDef(c.tag) &&
				isUndef(c.key) &&
				isDef(nestedIndex)) {
			  c.key = "__vlist" + nestedIndex + "_" + i + "__";
			}
			res.push(c);
		  }
		}
	  }
	  return res
	}

	/*  */

	function initProvide (vm) {
	  var provide = vm.$options.provide;
	  if (provide) {
		vm._provided = typeof provide === 'function'
			? provide.call(vm)
			: provide;
	  }
	}

	function initInjections (vm) {
	  var result = resolveInject(vm.$options.inject, vm);
	  if (result) {
		toggleObserving(false);
		Object.keys(result).forEach(function (key) {
		  /* istanbul ignore else */
		  if (false) {} else {
			defineReactive$$1(vm, key, result[key]);
		  }
		});
		toggleObserving(true);
	  }
	}

	function resolveInject (inject, vm) {
	  if (inject) {
		// inject is :any because flow is not smart enough to figure out cached
		var result = Object.create(null);
		var keys = hasSymbol
			? Reflect.ownKeys(inject)
			: Object.keys(inject);

		for (var i = 0; i < keys.length; i++) {
		  var key = keys[i];
		  // #6574 in case the inject object is observed...
		  if (key === '__ob__') { continue }
		  var provideKey = inject[key].from;
		  var source = vm;
		  while (source) {
			if (source._provided && hasOwn(source._provided, provideKey)) {
			  result[key] = source._provided[provideKey];
			  break
			}
			source = source.$parent;
		  }
		  if (!source) {
			if ('default' in inject[key]) {
			  var provideDefault = inject[key].default;
			  result[key] = typeof provideDefault === 'function'
				  ? provideDefault.call(vm)
				  : provideDefault;
			} else if (false) {}
		  }
		}
		return result
	  }
	}

	/*  */



	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots (
		children,
		context
	) {
	  if (!children || !children.length) {
		return {}
	  }
	  var slots = {};
	  for (var i = 0, l = children.length; i < l; i++) {
		var child = children[i];
		var data = child.data;
		// remove slot attribute if the node is resolved as a Vue slot node
		if (data && data.attrs && data.attrs.slot) {
		  delete data.attrs.slot;
		}
		// named slots should only be respected if the vnode was rendered in the
		// same context.
		if ((child.context === context || child.fnContext === context) &&
			data && data.slot != null
		) {
		  var name = data.slot;
		  var slot = (slots[name] || (slots[name] = []));
		  if (child.tag === 'template') {
			slot.push.apply(slot, child.children || []);
		  } else {
			slot.push(child);
		  }
		} else {
		  (slots.default || (slots.default = [])).push(child);
		}
	  }
	  // ignore slots that contains only whitespace
	  for (var name$1 in slots) {
		if (slots[name$1].every(isWhitespace)) {
		  delete slots[name$1];
		}
	  }
	  return slots
	}

	function isWhitespace (node) {
	  return (node.isComment && !node.asyncFactory) || node.text === ' '
	}

	/*  */

	function isAsyncPlaceholder (node) {
	  return node.isComment && node.asyncFactory
	}

	/*  */

	function normalizeScopedSlots (
		slots,
		normalSlots,
		prevSlots
	) {
	  var res;
	  var hasNormalSlots = Object.keys(normalSlots).length > 0;
	  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
	  var key = slots && slots.$key;
	  if (!slots) {
		res = {};
	  } else if (slots._normalized) {
		// fast path 1: child component re-render only, parent did not change
		return slots._normalized
	  } else if (
		  isStable &&
		  prevSlots &&
		  prevSlots !== emptyObject &&
		  key === prevSlots.$key &&
		  !hasNormalSlots &&
		  !prevSlots.$hasNormal
	  ) {
		// fast path 2: stable scoped slots w/ no normal slots to proxy,
		// only need to normalize once
		return prevSlots
	  } else {
		res = {};
		for (var key$1 in slots) {
		  if (slots[key$1] && key$1[0] !== '$') {
			res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
		  }
		}
	  }
	  // expose normal slots on scopedSlots
	  for (var key$2 in normalSlots) {
		if (!(key$2 in res)) {
		  res[key$2] = proxyNormalSlot(normalSlots, key$2);
		}
	  }
	  // avoriaz seems to mock a non-extensible $scopedSlots object
	  // and when that is passed down this would cause an error
	  if (slots && Object.isExtensible(slots)) {
		(slots)._normalized = res;
	  }
	  def(res, '$stable', isStable);
	  def(res, '$key', key);
	  def(res, '$hasNormal', hasNormalSlots);
	  return res
	}

	function normalizeScopedSlot(normalSlots, key, fn) {
	  var normalized = function () {
		var res = arguments.length ? fn.apply(null, arguments) : fn({});
		res = res && typeof res === 'object' && !Array.isArray(res)
			? [res] // single vnode
			: normalizeChildren(res);
		var vnode = res && res[0];
		return res && (
			!vnode ||
			(res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
		) ? undefined
			: res
	  };
	  // this is a slot using the new v-slot syntax without scope. although it is
	  // compiled as a scoped slot, render fn users would expect it to be present
	  // on this.$slots because the usage is semantically a normal slot.
	  if (fn.proxy) {
		Object.defineProperty(normalSlots, key, {
		  get: normalized,
		  enumerable: true,
		  configurable: true
		});
	  }
	  return normalized
	}

	function proxyNormalSlot(slots, key) {
	  return function () { return slots[key]; }
	}

	/*  */

	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList (
		val,
		render
	) {
	  var ret, i, l, keys, key;
	  if (Array.isArray(val) || typeof val === 'string') {
		ret = new Array(val.length);
		for (i = 0, l = val.length; i < l; i++) {
		  ret[i] = render(val[i], i);
		}
	  } else if (typeof val === 'number') {
		ret = new Array(val);
		for (i = 0; i < val; i++) {
		  ret[i] = render(i + 1, i);
		}
	  } else if (isObject(val)) {
		if (hasSymbol && val[Symbol.iterator]) {
		  ret = [];
		  var iterator = val[Symbol.iterator]();
		  var result = iterator.next();
		  while (!result.done) {
			ret.push(render(result.value, ret.length));
			result = iterator.next();
		  }
		} else {
		  keys = Object.keys(val);
		  ret = new Array(keys.length);
		  for (i = 0, l = keys.length; i < l; i++) {
			key = keys[i];
			ret[i] = render(val[key], key, i);
		  }
		}
	  }
	  if (!isDef(ret)) {
		ret = [];
	  }
	  (ret)._isVList = true;
	  return ret
	}

	/*  */

	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot (
		name,
		fallbackRender,
		props,
		bindObject
	) {
	  var scopedSlotFn = this.$scopedSlots[name];
	  var nodes;
	  if (scopedSlotFn) {
		// scoped slot
		props = props || {};
		if (bindObject) {
		  if (false) {}
		  props = extend(extend({}, bindObject), props);
		}
		nodes =
			scopedSlotFn(props) ||
			(typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
	  } else {
		nodes =
			this.$slots[name] ||
			(typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
	  }

	  var target = props && props.slot;
	  if (target) {
		return this.$createElement('template', { slot: target }, nodes)
	  } else {
		return nodes
	  }
	}

	/*  */

	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter (id) {
	  return resolveAsset(this.$options, 'filters', id, true) || identity
	}

	/*  */

	function isKeyNotMatch (expect, actual) {
	  if (Array.isArray(expect)) {
		return expect.indexOf(actual) === -1
	  } else {
		return expect !== actual
	  }
	}

	/**
	 * Runtime helper for checking keyCodes from config.
	 * exposed as Vue.prototype._k
	 * passing in eventKeyName as last argument separately for backwards compat
	 */
	function checkKeyCodes (
		eventKeyCode,
		key,
		builtInKeyCode,
		eventKeyName,
		builtInKeyName
	) {
	  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
	  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
		return isKeyNotMatch(builtInKeyName, eventKeyName)
	  } else if (mappedKeyCode) {
		return isKeyNotMatch(mappedKeyCode, eventKeyCode)
	  } else if (eventKeyName) {
		return hyphenate(eventKeyName) !== key
	  }
	  return eventKeyCode === undefined
	}

	/*  */

	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps (
		data,
		tag,
		value,
		asProp,
		isSync
	) {
	  if (value) {
		if (!isObject(value)) {
		  false && 0;
		} else {
		  if (Array.isArray(value)) {
			value = toObject(value);
		  }
		  var hash;
		  var loop = function ( key ) {
			if (
				key === 'class' ||
				key === 'style' ||
				isReservedAttribute(key)
			) {
			  hash = data;
			} else {
			  var type = data.attrs && data.attrs.type;
			  hash = asProp || config.mustUseProp(tag, type, key)
				  ? data.domProps || (data.domProps = {})
				  : data.attrs || (data.attrs = {});
			}
			var camelizedKey = camelize(key);
			var hyphenatedKey = hyphenate(key);
			if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
			  hash[key] = value[key];

			  if (isSync) {
				var on = data.on || (data.on = {});
				on[("update:" + key)] = function ($event) {
				  value[key] = $event;
				};
			  }
			}
		  };

		  for (var key in value) loop( key );
		}
	  }
	  return data
	}

	/*  */

	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic (
		index,
		isInFor
	) {
	  var cached = this._staticTrees || (this._staticTrees = []);
	  var tree = cached[index];
	  // if has already-rendered static tree and not inside v-for,
	  // we can reuse the same tree.
	  if (tree && !isInFor) {
		return tree
	  }
	  // otherwise, render a fresh tree.
	  tree = cached[index] = this.$options.staticRenderFns[index].call(
		  this._renderProxy,
		  null,
		  this // for render fns generated for functional component templates
	  );
	  markStatic(tree, ("__static__" + index), false);
	  return tree
	}

	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce (
		tree,
		index,
		key
	) {
	  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	  return tree
	}

	function markStatic (
		tree,
		key,
		isOnce
	) {
	  if (Array.isArray(tree)) {
		for (var i = 0; i < tree.length; i++) {
		  if (tree[i] && typeof tree[i] !== 'string') {
			markStaticNode(tree[i], (key + "_" + i), isOnce);
		  }
		}
	  } else {
		markStaticNode(tree, key, isOnce);
	  }
	}

	function markStaticNode (node, key, isOnce) {
	  node.isStatic = true;
	  node.key = key;
	  node.isOnce = isOnce;
	}

	/*  */

	function bindObjectListeners (data, value) {
	  if (value) {
		if (!isPlainObject(value)) {
		  false && 0;
		} else {
		  var on = data.on = data.on ? extend({}, data.on) : {};
		  for (var key in value) {
			var existing = on[key];
			var ours = value[key];
			on[key] = existing ? [].concat(existing, ours) : ours;
		  }
		}
	  }
	  return data
	}

	/*  */

	function resolveScopedSlots (
		fns, // see flow/vnode
		res,
		// the following are added in 2.6
		hasDynamicKeys,
		contentHashKey
	) {
	  res = res || { $stable: !hasDynamicKeys };
	  for (var i = 0; i < fns.length; i++) {
		var slot = fns[i];
		if (Array.isArray(slot)) {
		  resolveScopedSlots(slot, res, hasDynamicKeys);
		} else if (slot) {
		  // marker for reverse proxying v-slot without scope on this.$slots
		  if (slot.proxy) {
			slot.fn.proxy = true;
		  }
		  res[slot.key] = slot.fn;
		}
	  }
	  if (contentHashKey) {
		(res).$key = contentHashKey;
	  }
	  return res
	}

	/*  */

	function bindDynamicKeys (baseObj, values) {
	  for (var i = 0; i < values.length; i += 2) {
		var key = values[i];
		if (typeof key === 'string' && key) {
		  baseObj[values[i]] = values[i + 1];
		} else if (false) {}
	  }
	  return baseObj
	}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
	function prependModifier (value, symbol) {
	  return typeof value === 'string' ? symbol + value : value
	}

	/*  */

	function installRenderHelpers (target) {
	  target._o = markOnce;
	  target._n = toNumber;
	  target._s = vue_esm_toString;
	  target._l = renderList;
	  target._t = renderSlot;
	  target._q = looseEqual;
	  target._i = looseIndexOf;
	  target._m = renderStatic;
	  target._f = resolveFilter;
	  target._k = checkKeyCodes;
	  target._b = bindObjectProps;
	  target._v = createTextVNode;
	  target._e = createEmptyVNode;
	  target._u = resolveScopedSlots;
	  target._g = bindObjectListeners;
	  target._d = bindDynamicKeys;
	  target._p = prependModifier;
	}

	/*  */

	function FunctionalRenderContext (
		data,
		props,
		children,
		parent,
		Ctor
	) {
	  var this$1 = this;

	  var options = Ctor.options;
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var contextVm;
	  if (hasOwn(parent, '_uid')) {
		contextVm = Object.create(parent);
		// $flow-disable-line
		contextVm._original = parent;
	  } else {
		// the context vm passed in is a functional context as well.
		// in this case we want to make sure we are able to get a hold to the
		// real context instance.
		contextVm = parent;
		// $flow-disable-line
		parent = parent._original;
	  }
	  var isCompiled = isTrue(options._compiled);
	  var needNormalization = !isCompiled;

	  this.data = data;
	  this.props = props;
	  this.children = children;
	  this.parent = parent;
	  this.listeners = data.on || emptyObject;
	  this.injections = resolveInject(options.inject, parent);
	  this.slots = function () {
		if (!this$1.$slots) {
		  normalizeScopedSlots(
			  data.scopedSlots,
			  this$1.$slots = resolveSlots(children, parent)
		  );
		}
		return this$1.$slots
	  };

	  Object.defineProperty(this, 'scopedSlots', ({
		enumerable: true,
		get: function get () {
		  return normalizeScopedSlots(data.scopedSlots, this.slots())
		}
	  }));

	  // support for compiled functional template
	  if (isCompiled) {
		// exposing $options for renderStatic()
		this.$options = options;
		// pre-resolve slots for renderSlot()
		this.$slots = this.slots();
		this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
	  }

	  if (options._scopeId) {
		this._c = function (a, b, c, d) {
		  var vnode = createElement(contextVm, a, b, c, d, needNormalization);
		  if (vnode && !Array.isArray(vnode)) {
			vnode.fnScopeId = options._scopeId;
			vnode.fnContext = parent;
		  }
		  return vnode
		};
	  } else {
		this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
	  }
	}

	installRenderHelpers(FunctionalRenderContext.prototype);

	function createFunctionalComponent (
		Ctor,
		propsData,
		data,
		contextVm,
		children
	) {
	  var options = Ctor.options;
	  var props = {};
	  var propOptions = options.props;
	  if (isDef(propOptions)) {
		for (var key in propOptions) {
		  props[key] = validateProp(key, propOptions, propsData || emptyObject);
		}
	  } else {
		if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
		if (isDef(data.props)) { mergeProps(props, data.props); }
	  }

	  var renderContext = new FunctionalRenderContext(
		  data,
		  props,
		  children,
		  contextVm,
		  Ctor
	  );

	  var vnode = options.render.call(null, renderContext._c, renderContext);

	  if (vnode instanceof VNode) {
		return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
	  } else if (Array.isArray(vnode)) {
		var vnodes = normalizeChildren(vnode) || [];
		var res = new Array(vnodes.length);
		for (var i = 0; i < vnodes.length; i++) {
		  res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
		}
		return res
	  }
	}

	function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
	  // #7817 clone node before setting fnContext, otherwise if the node is reused
	  // (e.g. it was from a cached normal slot) the fnContext causes named slots
	  // that should not be matched to match.
	  var clone = cloneVNode(vnode);
	  clone.fnContext = contextVm;
	  clone.fnOptions = options;
	  if (false) {}
	  if (data.slot) {
		(clone.data || (clone.data = {})).slot = data.slot;
	  }
	  return clone
	}

	function mergeProps (to, from) {
	  for (var key in from) {
		to[camelize(key)] = from[key];
	  }
	}

	/*  */

	/*  */

	/*  */

	/*  */

// inline hooks to be invoked on component VNodes during patch
	var componentVNodeHooks = {
	  init: function init (vnode, hydrating) {
		if (
			vnode.componentInstance &&
			!vnode.componentInstance._isDestroyed &&
			vnode.data.keepAlive
		) {
		  // kept-alive components, treat as a patch
		  var mountedNode = vnode; // work around flow
		  componentVNodeHooks.prepatch(mountedNode, mountedNode);
		} else {
		  var child = vnode.componentInstance = createComponentInstanceForVnode(
			  vnode,
			  activeInstance
		  );
		  child.$mount(hydrating ? vnode.elm : undefined, hydrating);
		}
	  },

	  prepatch: function prepatch (oldVnode, vnode) {
		var options = vnode.componentOptions;
		var child = vnode.componentInstance = oldVnode.componentInstance;
		updateChildComponent(
			child,
			options.propsData, // updated props
			options.listeners, // updated listeners
			vnode, // new parent vnode
			options.children // new children
		);
	  },

	  insert: function insert (vnode) {
		var context = vnode.context;
		var componentInstance = vnode.componentInstance;
		if (!componentInstance._isMounted) {
		  componentInstance._isMounted = true;
		  callHook(componentInstance, 'mounted');
		}
		if (vnode.data.keepAlive) {
		  if (context._isMounted) {
			// vue-router#1212
			// During updates, a kept-alive component's child components may
			// change, so directly walking the tree here may call activated hooks
			// on incorrect children. Instead we push them into a queue which will
			// be processed after the whole patch process ended.
			queueActivatedComponent(componentInstance);
		  } else {
			activateChildComponent(componentInstance, true /* direct */);
		  }
		}
	  },

	  destroy: function destroy (vnode) {
		var componentInstance = vnode.componentInstance;
		if (!componentInstance._isDestroyed) {
		  if (!vnode.data.keepAlive) {
			componentInstance.$destroy();
		  } else {
			deactivateChildComponent(componentInstance, true /* direct */);
		  }
		}
	  }
	};

	var hooksToMerge = Object.keys(componentVNodeHooks);

	function createComponent (
		Ctor,
		data,
		context,
		children,
		tag
	) {
	  if (isUndef(Ctor)) {
		return
	  }

	  var baseCtor = context.$options._base;

	  // plain options object: turn it into a constructor
	  if (isObject(Ctor)) {
		Ctor = baseCtor.extend(Ctor);
	  }

	  // if at this stage it's not a constructor or an async component factory,
	  // reject.
	  if (typeof Ctor !== 'function') {
		if (false) {}
		return
	  }

	  // async component
	  var asyncFactory;
	  if (isUndef(Ctor.cid)) {
		asyncFactory = Ctor;
		Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
		if (Ctor === undefined) {
		  // return a placeholder node for async component, which is rendered
		  // as a comment node but preserves all the raw information for the node.
		  // the information will be used for async server-rendering and hydration.
		  return createAsyncPlaceholder(
			  asyncFactory,
			  data,
			  context,
			  children,
			  tag
		  )
		}
	  }

	  data = data || {};

	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);

	  // transform component v-model data into props & events
	  if (isDef(data.model)) {
		transformModel(Ctor.options, data);
	  }

	  // extract props
	  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

	  // functional component
	  if (isTrue(Ctor.options.functional)) {
		return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }

	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  // so it gets processed during parent component patch.
	  data.on = data.nativeOn;

	  if (isTrue(Ctor.options.abstract)) {
		// abstract components do not keep anything
		// other than props & listeners & slot

		// work around flow
		var slot = data.slot;
		data = {};
		if (slot) {
		  data.slot = slot;
		}
	  }

	  // install component management hooks onto the placeholder node
	  installComponentHooks(data);

	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
		  ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
		  data, undefined, undefined, undefined, context,
		  { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
		  asyncFactory
	  );

	  return vnode
	}

	function createComponentInstanceForVnode (
		// we know it's MountedComponentVNode but flow doesn't
		vnode,
		// activeInstance in lifecycle state
		parent
	) {
	  var options = {
		_isComponent: true,
		_parentVnode: vnode,
		parent: parent
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (isDef(inlineTemplate)) {
		options.render = inlineTemplate.render;
		options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnode.componentOptions.Ctor(options)
	}

	function installComponentHooks (data) {
	  var hooks = data.hook || (data.hook = {});
	  for (var i = 0; i < hooksToMerge.length; i++) {
		var key = hooksToMerge[i];
		var existing = hooks[key];
		var toMerge = componentVNodeHooks[key];
		if (existing !== toMerge && !(existing && existing._merged)) {
		  hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
		}
	  }
	}

	function mergeHook$1 (f1, f2) {
	  var merged = function (a, b) {
		// flow complains about extra args which is why we use any
		f1(a, b);
		f2(a, b);
	  };
	  merged._merged = true;
	  return merged
	}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
	function transformModel (options, data) {
	  var prop = (options.model && options.model.prop) || 'value';
	  var event = (options.model && options.model.event) || 'input'
	  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
	  var on = data.on || (data.on = {});
	  var existing = on[event];
	  var callback = data.model.callback;
	  if (isDef(existing)) {
		if (
			Array.isArray(existing)
				? existing.indexOf(callback) === -1
				: existing !== callback
		) {
		  on[event] = [callback].concat(existing);
		}
	  } else {
		on[event] = callback;
	  }
	}

	/*  */

	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
	function createElement (
		context,
		tag,
		data,
		children,
		normalizationType,
		alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
		normalizationType = children;
		children = data;
		data = undefined;
	  }
	  if (isTrue(alwaysNormalize)) {
		normalizationType = ALWAYS_NORMALIZE;
	  }
	  return _createElement(context, tag, data, children, normalizationType)
	}

	function _createElement (
		context,
		tag,
		data,
		children,
		normalizationType
	) {
	  if (isDef(data) && isDef((data).__ob__)) {
		false && 0;
		return createEmptyVNode()
	  }
	  // object syntax in v-bind
	  if (isDef(data) && isDef(data.is)) {
		tag = data.is;
	  }
	  if (!tag) {
		// in case of component :is set to falsy value
		return createEmptyVNode()
	  }
	  // warn against non-primitive key
	  if (false
	  ) {}
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
		  typeof children[0] === 'function'
	  ) {
		data = data || {};
		data.scopedSlots = { default: children[0] };
		children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
		children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
		children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
		var Ctor;
		ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
		if (config.isReservedTag(tag)) {
		  // platform built-in elements
		  if (false) {}
		  vnode = new VNode(
			  config.parsePlatformTagName(tag), data, children,
			  undefined, undefined, context
		  );
		} else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
		  // component
		  vnode = createComponent(Ctor, data, context, children, tag);
		} else {
		  // unknown or unlisted namespaced elements
		  // check at runtime because it may get assigned a namespace when its
		  // parent normalizes children
		  vnode = new VNode(
			  tag, data, children,
			  undefined, undefined, context
		  );
		}
	  } else {
		// direct component options / constructor
		vnode = createComponent(tag, data, context, children);
	  }
	  if (Array.isArray(vnode)) {
		return vnode
	  } else if (isDef(vnode)) {
		if (isDef(ns)) { applyNS(vnode, ns); }
		if (isDef(data)) { registerDeepBindings(data); }
		return vnode
	  } else {
		return createEmptyVNode()
	  }
	}

	function applyNS (vnode, ns, force) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
		// use default namespace inside foreignObject
		ns = undefined;
		force = true;
	  }
	  if (isDef(vnode.children)) {
		for (var i = 0, l = vnode.children.length; i < l; i++) {
		  var child = vnode.children[i];
		  if (isDef(child.tag) && (
			  isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
			applyNS(child, ns, force);
		  }
		}
	  }
	}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
	function registerDeepBindings (data) {
	  if (isObject(data.style)) {
		traverse(data.style);
	  }
	  if (isObject(data.class)) {
		traverse(data.class);
	  }
	}

	/*  */

	function initRender (vm) {
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null; // v-once cached trees
	  var options = vm.$options;
	  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(options._renderChildren, renderContext);
	  vm.$scopedSlots = emptyObject;
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

	  // $attrs & $listeners are exposed for easier HOC creation.
	  // they need to be reactive so that HOCs using them are always updated
	  var parentData = parentVnode && parentVnode.data;

	  /* istanbul ignore else */
	  if (false) {} else {
		defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
		defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
	  }
	}

	var currentRenderingInstance = null;

	function renderMixin (Vue) {
	  // install runtime convenience helpers
	  installRenderHelpers(Vue.prototype);

	  Vue.prototype.$nextTick = function (fn) {
		return nextTick(fn, this)
	  };

	  Vue.prototype._render = function () {
		var vm = this;
		var ref = vm.$options;
		var render = ref.render;
		var _parentVnode = ref._parentVnode;

		if (_parentVnode) {
		  vm.$scopedSlots = normalizeScopedSlots(
			  _parentVnode.data.scopedSlots,
			  vm.$slots,
			  vm.$scopedSlots
		  );
		}

		// set parent vnode. this allows render functions to have access
		// to the data on the placeholder node.
		vm.$vnode = _parentVnode;
		// render self
		var vnode;
		try {
		  // There's no need to maintain a stack because all render fns are called
		  // separately from one another. Nested component's render fns are called
		  // when parent component is patched.
		  currentRenderingInstance = vm;
		  vnode = render.call(vm._renderProxy, vm.$createElement);
		} catch (e) {
		  handleError(e, vm, "render");
		  // return error render result,
		  // or previous vnode to prevent render error causing blank component
		  /* istanbul ignore else */
		  if (false) {} else {
			vnode = vm._vnode;
		  }
		} finally {
		  currentRenderingInstance = null;
		}
		// if the returned array contains only a single node, allow it
		if (Array.isArray(vnode) && vnode.length === 1) {
		  vnode = vnode[0];
		}
		// return empty vnode in case the render function errored out
		if (!(vnode instanceof VNode)) {
		  if (false) {}
		  vnode = createEmptyVNode();
		}
		// set parent
		vnode.parent = _parentVnode;
		return vnode
	  };
	}

	/*  */

	function ensureCtor (comp, base) {
	  if (
		  comp.__esModule ||
		  (hasSymbol && comp[Symbol.toStringTag] === 'Module')
	  ) {
		comp = comp.default;
	  }
	  return isObject(comp)
		  ? base.extend(comp)
		  : comp
	}

	function createAsyncPlaceholder (
		factory,
		data,
		context,
		children,
		tag
	) {
	  var node = createEmptyVNode();
	  node.asyncFactory = factory;
	  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
	  return node
	}

	function resolveAsyncComponent (
		factory,
		baseCtor
	) {
	  if (isTrue(factory.error) && isDef(factory.errorComp)) {
		return factory.errorComp
	  }

	  if (isDef(factory.resolved)) {
		return factory.resolved
	  }

	  var owner = currentRenderingInstance;
	  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
		// already pending
		factory.owners.push(owner);
	  }

	  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
		return factory.loadingComp
	  }

	  if (owner && !isDef(factory.owners)) {
		var owners = factory.owners = [owner];
		var sync = true;
		var timerLoading = null;
		var timerTimeout = null

		;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

		var forceRender = function (renderCompleted) {
		  for (var i = 0, l = owners.length; i < l; i++) {
			(owners[i]).$forceUpdate();
		  }

		  if (renderCompleted) {
			owners.length = 0;
			if (timerLoading !== null) {
			  clearTimeout(timerLoading);
			  timerLoading = null;
			}
			if (timerTimeout !== null) {
			  clearTimeout(timerTimeout);
			  timerTimeout = null;
			}
		  }
		};

		var resolve = once(function (res) {
		  // cache resolved
		  factory.resolved = ensureCtor(res, baseCtor);
		  // invoke callbacks only if this is not a synchronous resolve
		  // (async resolves are shimmed as synchronous during SSR)
		  if (!sync) {
			forceRender(true);
		  } else {
			owners.length = 0;
		  }
		});

		var reject = once(function (reason) {
		  false && 0;
		  if (isDef(factory.errorComp)) {
			factory.error = true;
			forceRender(true);
		  }
		});

		var res = factory(resolve, reject);

		if (isObject(res)) {
		  if (isPromise(res)) {
			// () => Promise
			if (isUndef(factory.resolved)) {
			  res.then(resolve, reject);
			}
		  } else if (isPromise(res.component)) {
			res.component.then(resolve, reject);

			if (isDef(res.error)) {
			  factory.errorComp = ensureCtor(res.error, baseCtor);
			}

			if (isDef(res.loading)) {
			  factory.loadingComp = ensureCtor(res.loading, baseCtor);
			  if (res.delay === 0) {
				factory.loading = true;
			  } else {
				timerLoading = setTimeout(function () {
				  timerLoading = null;
				  if (isUndef(factory.resolved) && isUndef(factory.error)) {
					factory.loading = true;
					forceRender(false);
				  }
				}, res.delay || 200);
			  }
			}

			if (isDef(res.timeout)) {
			  timerTimeout = setTimeout(function () {
				timerTimeout = null;
				if (isUndef(factory.resolved)) {
				  reject(
					  false
						  ? (0)
						  : null
				  );
				}
			  }, res.timeout);
			}
		  }
		}

		sync = false;
		// return in case resolved synchronously
		return factory.loading
			? factory.loadingComp
			: factory.resolved
	  }
	}

	/*  */

	function getFirstComponentChild (children) {
	  if (Array.isArray(children)) {
		for (var i = 0; i < children.length; i++) {
		  var c = children[i];
		  if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
			return c
		  }
		}
	  }
	}

	/*  */

	/*  */

	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
		updateComponentListeners(vm, listeners);
	  }
	}

	var target;

	function add (event, fn) {
	  target.$on(event, fn);
	}

	function remove$1 (event, fn) {
	  target.$off(event, fn);
	}

	function createOnceHandler (event, fn) {
	  var _target = target;
	  return function onceHandler () {
		var res = fn.apply(null, arguments);
		if (res !== null) {
		  _target.$off(event, onceHandler);
		}
	  }
	}

	function updateComponentListeners (
		vm,
		listeners,
		oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
	  target = undefined;
	}

	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
		var vm = this;
		if (Array.isArray(event)) {
		  for (var i = 0, l = event.length; i < l; i++) {
			vm.$on(event[i], fn);
		  }
		} else {
		  (vm._events[event] || (vm._events[event] = [])).push(fn);
		  // optimize hook:event cost by using a boolean flag marked at registration
		  // instead of a hash lookup
		  if (hookRE.test(event)) {
			vm._hasHookEvent = true;
		  }
		}
		return vm
	  };

	  Vue.prototype.$once = function (event, fn) {
		var vm = this;
		function on () {
		  vm.$off(event, on);
		  fn.apply(vm, arguments);
		}
		on.fn = fn;
		vm.$on(event, on);
		return vm
	  };

	  Vue.prototype.$off = function (event, fn) {
		var vm = this;
		// all
		if (!arguments.length) {
		  vm._events = Object.create(null);
		  return vm
		}
		// array of events
		if (Array.isArray(event)) {
		  for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
			vm.$off(event[i$1], fn);
		  }
		  return vm
		}
		// specific event
		var cbs = vm._events[event];
		if (!cbs) {
		  return vm
		}
		if (!fn) {
		  vm._events[event] = null;
		  return vm
		}
		// specific handler
		var cb;
		var i = cbs.length;
		while (i--) {
		  cb = cbs[i];
		  if (cb === fn || cb.fn === fn) {
			cbs.splice(i, 1);
			break
		  }
		}
		return vm
	  };

	  Vue.prototype.$emit = function (event) {
		var vm = this;
		if (false) { var lowerCaseEvent; }
		var cbs = vm._events[event];
		if (cbs) {
		  cbs = cbs.length > 1 ? toArray(cbs) : cbs;
		  var args = toArray(arguments, 1);
		  var info = "event handler for \"" + event + "\"";
		  for (var i = 0, l = cbs.length; i < l; i++) {
			invokeWithErrorHandling(cbs[i], vm, args, vm, info);
		  }
		}
		return vm
	  };
	}

	/*  */

	var activeInstance = null;
	var isUpdatingChildComponent = false;

	function setActiveInstance(vm) {
	  var prevActiveInstance = activeInstance;
	  activeInstance = vm;
	  return function () {
		activeInstance = prevActiveInstance;
	  }
	}

	function initLifecycle (vm) {
	  var options = vm.$options;

	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
		while (parent.$options.abstract && parent.$parent) {
		  parent = parent.$parent;
		}
		parent.$children.push(vm);
	  }

	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;

	  vm.$children = [];
	  vm.$refs = {};

	  vm._watcher = null;
	  vm._inactive = null;
	  vm._directInactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}

	function lifecycleMixin (Vue) {
	  Vue.prototype._update = function (vnode, hydrating) {
		var vm = this;
		var prevEl = vm.$el;
		var prevVnode = vm._vnode;
		var restoreActiveInstance = setActiveInstance(vm);
		vm._vnode = vnode;
		// Vue.prototype.__patch__ is injected in entry points
		// based on the rendering backend used.
		if (!prevVnode) {
		  // initial render
		  vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
		} else {
		  // updates
		  vm.$el = vm.__patch__(prevVnode, vnode);
		}
		restoreActiveInstance();
		// update __vue__ reference
		if (prevEl) {
		  prevEl.__vue__ = null;
		}
		if (vm.$el) {
		  vm.$el.__vue__ = vm;
		}
		// if parent is an HOC, update its $el as well
		if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
		  vm.$parent.$el = vm.$el;
		}
		// updated hook is called by the scheduler to ensure that children are
		// updated in a parent's updated hook.
	  };

	  Vue.prototype.$forceUpdate = function () {
		var vm = this;
		if (vm._watcher) {
		  vm._watcher.update();
		}
	  };

	  Vue.prototype.$destroy = function () {
		var vm = this;
		if (vm._isBeingDestroyed) {
		  return
		}
		callHook(vm, 'beforeDestroy');
		vm._isBeingDestroyed = true;
		// remove self from parent
		var parent = vm.$parent;
		if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
		  remove(parent.$children, vm);
		}
		// teardown watchers
		if (vm._watcher) {
		  vm._watcher.teardown();
		}
		var i = vm._watchers.length;
		while (i--) {
		  vm._watchers[i].teardown();
		}
		// remove reference from data ob
		// frozen object may not have observer.
		if (vm._data.__ob__) {
		  vm._data.__ob__.vmCount--;
		}
		// call the last hook...
		vm._isDestroyed = true;
		// invoke destroy hooks on current rendered tree
		vm.__patch__(vm._vnode, null);
		// fire destroyed hook
		callHook(vm, 'destroyed');
		// turn off all instance listeners.
		vm.$off();
		// remove __vue__ reference
		if (vm.$el) {
		  vm.$el.__vue__ = null;
		}
		// release circular reference (#6759)
		if (vm.$vnode) {
		  vm.$vnode.parent = null;
		}
	  };
	}

	function mountComponent (
		vm,
		el,
		hydrating
	) {
	  vm.$el = el;
	  if (!vm.$options.render) {
		vm.$options.render = createEmptyVNode;
		if (false) {}
	  }
	  callHook(vm, 'beforeMount');

	  var updateComponent;
	  /* istanbul ignore if */
	  if (false) {} else {
		updateComponent = function () {
		  vm._update(vm._render(), hydrating);
		};
	  }

	  // we set this to vm._watcher inside the watcher's constructor
	  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
	  // component's mounted hook), which relies on vm._watcher being already defined
	  new Watcher(vm, updateComponent, noop, {
		before: function before () {
		  if (vm._isMounted && !vm._isDestroyed) {
			callHook(vm, 'beforeUpdate');
		  }
		}
	  }, true /* isRenderWatcher */);
	  hydrating = false;

	  // manually mounted instance, call mounted on self
	  // mounted is called for render-created child components in its inserted hook
	  if (vm.$vnode == null) {
		vm._isMounted = true;
		callHook(vm, 'mounted');
	  }
	  return vm
	}

	function updateChildComponent (
		vm,
		propsData,
		listeners,
		parentVnode,
		renderChildren
	) {
	  if (false) {}

	  // determine whether component has slot children
	  // we need to do this before overwriting $options._renderChildren.

	  // check if there are dynamic scopedSlots (hand-written or compiled but with
	  // dynamic slot names). Static scoped slots compiled from template has the
	  // "$stable" marker.
	  var newScopedSlots = parentVnode.data.scopedSlots;
	  var oldScopedSlots = vm.$scopedSlots;
	  var hasDynamicScopedSlot = !!(
		  (newScopedSlots && !newScopedSlots.$stable) ||
		  (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
		  (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
		  (!newScopedSlots && vm.$scopedSlots.$key)
	  );

	  // Any static slot children from the parent may have changed during parent's
	  // update. Dynamic scoped slots may also have changed. In such cases, a forced
	  // update is necessary to ensure correctness.
	  var needsForceUpdate = !!(
		  renderChildren ||               // has new static slots
		  vm.$options._renderChildren ||  // has old static slots
		  hasDynamicScopedSlot
	  );

	  vm.$options._parentVnode = parentVnode;
	  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

	  if (vm._vnode) { // update child tree's parent
		vm._vnode.parent = parentVnode;
	  }
	  vm.$options._renderChildren = renderChildren;

	  // update $attrs and $listeners hash
	  // these are also reactive so they may trigger child update if the child
	  // used them during render
	  vm.$attrs = parentVnode.data.attrs || emptyObject;
	  vm.$listeners = listeners || emptyObject;

	  // update props
	  if (propsData && vm.$options.props) {
		toggleObserving(false);
		var props = vm._props;
		var propKeys = vm.$options._propKeys || [];
		for (var i = 0; i < propKeys.length; i++) {
		  var key = propKeys[i];
		  var propOptions = vm.$options.props; // wtf flow?
		  props[key] = validateProp(key, propOptions, propsData, vm);
		}
		toggleObserving(true);
		// keep a copy of raw propsData
		vm.$options.propsData = propsData;
	  }

	  // update listeners
	  listeners = listeners || emptyObject;
	  var oldListeners = vm.$options._parentListeners;
	  vm.$options._parentListeners = listeners;
	  updateComponentListeners(vm, listeners, oldListeners);

	  // resolve slots + force update if has children
	  if (needsForceUpdate) {
		vm.$slots = resolveSlots(renderChildren, parentVnode.context);
		vm.$forceUpdate();
	  }

	  if (false) {}
	}

	function isInInactiveTree (vm) {
	  while (vm && (vm = vm.$parent)) {
		if (vm._inactive) { return true }
	  }
	  return false
	}

	function activateChildComponent (vm, direct) {
	  if (direct) {
		vm._directInactive = false;
		if (isInInactiveTree(vm)) {
		  return
		}
	  } else if (vm._directInactive) {
		return
	  }
	  if (vm._inactive || vm._inactive === null) {
		vm._inactive = false;
		for (var i = 0; i < vm.$children.length; i++) {
		  activateChildComponent(vm.$children[i]);
		}
		callHook(vm, 'activated');
	  }
	}

	function deactivateChildComponent (vm, direct) {
	  if (direct) {
		vm._directInactive = true;
		if (isInInactiveTree(vm)) {
		  return
		}
	  }
	  if (!vm._inactive) {
		vm._inactive = true;
		for (var i = 0; i < vm.$children.length; i++) {
		  deactivateChildComponent(vm.$children[i]);
		}
		callHook(vm, 'deactivated');
	  }
	}

	function callHook (vm, hook) {
	  // #7573 disable dep collection when invoking lifecycle hooks
	  pushTarget();
	  var handlers = vm.$options[hook];
	  var info = hook + " hook";
	  if (handlers) {
		for (var i = 0, j = handlers.length; i < j; i++) {
		  invokeWithErrorHandling(handlers[i], vm, null, vm, info);
		}
	  }
	  if (vm._hasHookEvent) {
		vm.$emit('hook:' + hook);
	  }
	  popTarget();
	}

	/*  */

	var MAX_UPDATE_COUNT = 100;

	var queue = [];
	var activatedChildren = [];
	var has = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;

	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  index = queue.length = activatedChildren.length = 0;
	  has = {};
	  if (false) {}
	  waiting = flushing = false;
	}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
	var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
	var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
	if (inBrowser && !isIE) {
	  var vue_esm_performance = window.performance;
	  if (
		  vue_esm_performance &&
		  typeof vue_esm_performance.now === 'function' &&
		  getNow() > document.createEvent('Event').timeStamp
	  ) {
		// if the event timestamp, although evaluated AFTER the Date.now(), is
		// smaller than it, it means the event is using a hi-res timestamp,
		// and we need to use the hi-res version for event listener timestamps as
		// well.
		getNow = function () { return vue_esm_performance.now(); };
	  }
	}

	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  currentFlushTimestamp = getNow();
	  flushing = true;
	  var watcher, id;

	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });

	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
		watcher = queue[index];
		if (watcher.before) {
		  watcher.before();
		}
		id = watcher.id;
		has[id] = null;
		watcher.run();
		// in dev build, check and stop circular updates.
		if (false) {}
	  }

	  // keep copies of post queues before resetting state
	  var activatedQueue = activatedChildren.slice();
	  var updatedQueue = queue.slice();

	  resetSchedulerState();

	  // call component updated and activated hooks
	  callActivatedHooks(activatedQueue);
	  callUpdatedHooks(updatedQueue);

	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
		devtools.emit('flush');
	  }
	}

	function callUpdatedHooks (queue) {
	  var i = queue.length;
	  while (i--) {
		var watcher = queue[i];
		var vm = watcher.vm;
		if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
		  callHook(vm, 'updated');
		}
	  }
	}

	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent (vm) {
	  // setting _inactive to false here so that a render function can
	  // rely on checking whether it's in an inactive tree (e.g. router-view)
	  vm._inactive = false;
	  activatedChildren.push(vm);
	}

	function callActivatedHooks (queue) {
	  for (var i = 0; i < queue.length; i++) {
		queue[i]._inactive = true;
		activateChildComponent(queue[i], true /* true */);
	  }
	}

	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
		has[id] = true;
		if (!flushing) {
		  queue.push(watcher);
		} else {
		  // if already flushing, splice the watcher based on its id
		  // if already past its id, it will be run next immediately.
		  var i = queue.length - 1;
		  while (i > index && queue[i].id > watcher.id) {
			i--;
		  }
		  queue.splice(i + 1, 0, watcher);
		}
		// queue the flush
		if (!waiting) {
		  waiting = true;

		  if (false) {}
		  nextTick(flushSchedulerQueue);
		}
	  }
	}

	/*  */



	var uid$2 = 0;

	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
		vm,
		expOrFn,
		cb,
		options,
		isRenderWatcher
	) {
	  this.vm = vm;
	  if (isRenderWatcher) {
		vm._watcher = this;
	  }
	  vm._watchers.push(this);
	  // options
	  if (options) {
		this.deep = !!options.deep;
		this.user = !!options.user;
		this.lazy = !!options.lazy;
		this.sync = !!options.sync;
		this.before = options.before;
	  } else {
		this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression =  false
		  ? 0
		  : '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
		this.getter = expOrFn;
	  } else {
		this.getter = parsePath(expOrFn);
		if (!this.getter) {
		  this.getter = noop;
		  false && 0;
		}
	  }
	  this.value = this.lazy
		  ? undefined
		  : this.get();
	};

	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value;
	  var vm = this.vm;
	  try {
		value = this.getter.call(vm, vm);
	  } catch (e) {
		if (this.user) {
		  handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
		} else {
		  throw e
		}
	  } finally {
		// "touch" every property so they are all tracked as
		// dependencies for deep watching
		if (this.deep) {
		  traverse(value);
		}
		popTarget();
		this.cleanupDeps();
	  }
	  return value
	};

	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
		this.newDepIds.add(id);
		this.newDeps.push(dep);
		if (!this.depIds.has(id)) {
		  dep.addSub(this);
		}
	  }
	};

	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	  var i = this.deps.length;
	  while (i--) {
		var dep = this.deps[i];
		if (!this.newDepIds.has(dep.id)) {
		  dep.removeSub(this);
		}
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};

	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
		this.dirty = true;
	  } else if (this.sync) {
		this.run();
	  } else {
		queueWatcher(this);
	  }
	};

	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
		var value = this.get();
		if (
			value !== this.value ||
			// Deep watchers and watchers on Object/Arrays should fire even
			// when the value is the same, because the value may
			// have mutated.
			isObject(value) ||
			this.deep
		) {
		  // set new value
		  var oldValue = this.value;
		  this.value = value;
		  if (this.user) {
			var info = "callback for watcher \"" + (this.expression) + "\"";
			invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
		  } else {
			this.cb.call(this.vm, value, oldValue);
		  }
		}
	  }
	};

	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};

	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	  var i = this.deps.length;
	  while (i--) {
		this.deps[i].depend();
	  }
	};

	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	  if (this.active) {
		// remove self from vm's watcher list
		// this is a somewhat expensive operation so we skip it
		// if the vm is being destroyed.
		if (!this.vm._isBeingDestroyed) {
		  remove(this.vm._watchers, this);
		}
		var i = this.deps.length;
		while (i--) {
		  this.deps[i].removeSub(this);
		}
		this.active = false;
	  }
	};

	/*  */

	var sharedPropertyDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};

	function proxy (target, sourceKey, key) {
	  sharedPropertyDefinition.get = function proxyGetter () {
		return this[sourceKey][key]
	  };
	  sharedPropertyDefinition.set = function proxySetter (val) {
		this[sourceKey][key] = val;
	  };
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}

	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
		initData(vm);
	  } else {
		observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch && opts.watch !== nativeWatch) {
		initWatch(vm, opts.watch);
	  }
	}

	function initProps (vm, propsOptions) {
	  var propsData = vm.$options.propsData || {};
	  var props = vm._props = {};
	  // cache prop keys so that future props updates can iterate using Array
	  // instead of dynamic object key enumeration.
	  var keys = vm.$options._propKeys = [];
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  if (!isRoot) {
		toggleObserving(false);
	  }
	  var loop = function ( key ) {
		keys.push(key);
		var value = validateProp(key, propsOptions, propsData, vm);
		/* istanbul ignore else */
		if (false) { var hyphenatedKey; } else {
		  defineReactive$$1(props, key, value);
		}
		// static props are already proxied on the component's prototype
		// during Vue.extend(). We only need to proxy props defined at
		// instantiation here.
		if (!(key in vm)) {
		  proxy(vm, "_props", key);
		}
	  };

	  for (var key in propsOptions) loop( key );
	  toggleObserving(true);
	}

	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
		  ? getData(data, vm)
		  : data || {};
	  if (!isPlainObject(data)) {
		data = {};
		false && 0;
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var methods = vm.$options.methods;
	  var i = keys.length;
	  while (i--) {
		var key = keys[i];
		if (false) {}
		if (props && hasOwn(props, key)) {
		  false && 0;
		} else if (!isReserved(key)) {
		  proxy(vm, "_data", key);
		}
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}

	function getData (data, vm) {
	  // #7573 disable dep collection when invoking data getters
	  pushTarget();
	  try {
		return data.call(vm, vm)
	  } catch (e) {
		handleError(e, vm, "data()");
		return {}
	  } finally {
		popTarget();
	  }
	}

	var computedWatcherOptions = { lazy: true };

	function initComputed (vm, computed) {
	  // $flow-disable-line
	  var watchers = vm._computedWatchers = Object.create(null);
	  // computed properties are just getters during SSR
	  var isSSR = isServerRendering();

	  for (var key in computed) {
		var userDef = computed[key];
		var getter = typeof userDef === 'function' ? userDef : userDef.get;
		if (false) {}

		if (!isSSR) {
		  // create internal watcher for the computed property.
		  watchers[key] = new Watcher(
			  vm,
			  getter || noop,
			  noop,
			  computedWatcherOptions
		  );
		}

		// component-defined computed properties are already defined on the
		// component prototype. We only need to define computed properties defined
		// at instantiation here.
		if (!(key in vm)) {
		  defineComputed(vm, key, userDef);
		} else if (false) {}
	  }
	}

	function defineComputed (
		target,
		key,
		userDef
	) {
	  var shouldCache = !isServerRendering();
	  if (typeof userDef === 'function') {
		sharedPropertyDefinition.get = shouldCache
			? createComputedGetter(key)
			: createGetterInvoker(userDef);
		sharedPropertyDefinition.set = noop;
	  } else {
		sharedPropertyDefinition.get = userDef.get
			? shouldCache && userDef.cache !== false
				? createComputedGetter(key)
				: createGetterInvoker(userDef.get)
			: noop;
		sharedPropertyDefinition.set = userDef.set || noop;
	  }
	  if (false) {}
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}

	function createComputedGetter (key) {
	  return function computedGetter () {
		var watcher = this._computedWatchers && this._computedWatchers[key];
		if (watcher) {
		  if (watcher.dirty) {
			watcher.evaluate();
		  }
		  if (Dep.target) {
			watcher.depend();
		  }
		  return watcher.value
		}
	  }
	}

	function createGetterInvoker(fn) {
	  return function computedGetter () {
		return fn.call(this, this)
	  }
	}

	function initMethods (vm, methods) {
	  var props = vm.$options.props;
	  for (var key in methods) {
		if (false) {}
		vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
	  }
	}

	function initWatch (vm, watch) {
	  for (var key in watch) {
		var handler = watch[key];
		if (Array.isArray(handler)) {
		  for (var i = 0; i < handler.length; i++) {
			createWatcher(vm, key, handler[i]);
		  }
		} else {
		  createWatcher(vm, key, handler);
		}
	  }
	}

	function createWatcher (
		vm,
		expOrFn,
		handler,
		options
	) {
	  if (isPlainObject(handler)) {
		options = handler;
		handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
		handler = vm[handler];
	  }
	  return vm.$watch(expOrFn, handler, options)
	}

	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () { return this._data };
	  var propsDef = {};
	  propsDef.get = function () { return this._props };
	  if (false) {}
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	  Object.defineProperty(Vue.prototype, '$props', propsDef);

	  Vue.prototype.$set = set;
	  Vue.prototype.$delete = del;

	  Vue.prototype.$watch = function (
		  expOrFn,
		  cb,
		  options
	  ) {
		var vm = this;
		if (isPlainObject(cb)) {
		  return createWatcher(vm, expOrFn, cb, options)
		}
		options = options || {};
		options.user = true;
		var watcher = new Watcher(vm, expOrFn, cb, options);
		if (options.immediate) {
		  var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
		  pushTarget();
		  invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
		  popTarget();
		}
		return function unwatchFn () {
		  watcher.teardown();
		}
	  };
	}

	/*  */

	var uid$3 = 0;

	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
		var vm = this;
		// a uid
		vm._uid = uid$3++;

		var startTag, endTag;
		/* istanbul ignore if */
		if (false) {}

		// a flag to avoid this being observed
		vm._isVue = true;
		// merge options
		if (options && options._isComponent) {
		  // optimize internal component instantiation
		  // since dynamic options merging is pretty slow, and none of the
		  // internal component options needs special treatment.
		  initInternalComponent(vm, options);
		} else {
		  vm.$options = mergeOptions(
			  resolveConstructorOptions(vm.constructor),
			  options || {},
			  vm
		  );
		}
		/* istanbul ignore else */
		if (false) {} else {
		  vm._renderProxy = vm;
		}
		// expose real self
		vm._self = vm;
		initLifecycle(vm);
		initEvents(vm);
		initRender(vm);
		callHook(vm, 'beforeCreate');
		initInjections(vm); // resolve injections before data/props
		initState(vm);
		initProvide(vm); // resolve provide after data/props
		callHook(vm, 'created');

		/* istanbul ignore if */
		if (false) {}

		if (vm.$options.el) {
		  vm.$mount(vm.$options.el);
		}
	  };
	}

	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  var parentVnode = options._parentVnode;
	  opts.parent = options.parent;
	  opts._parentVnode = parentVnode;

	  var vnodeComponentOptions = parentVnode.componentOptions;
	  opts.propsData = vnodeComponentOptions.propsData;
	  opts._parentListeners = vnodeComponentOptions.listeners;
	  opts._renderChildren = vnodeComponentOptions.children;
	  opts._componentTag = vnodeComponentOptions.tag;

	  if (options.render) {
		opts.render = options.render;
		opts.staticRenderFns = options.staticRenderFns;
	  }
	}

	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
		var superOptions = resolveConstructorOptions(Ctor.super);
		var cachedSuperOptions = Ctor.superOptions;
		if (superOptions !== cachedSuperOptions) {
		  // super option changed,
		  // need to resolve new options.
		  Ctor.superOptions = superOptions;
		  // check if there are any late-modified/attached options (#4976)
		  var modifiedOptions = resolveModifiedOptions(Ctor);
		  // update base extend options
		  if (modifiedOptions) {
			extend(Ctor.extendOptions, modifiedOptions);
		  }
		  options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
		  if (options.name) {
			options.components[options.name] = Ctor;
		  }
		}
	  }
	  return options
	}

	function resolveModifiedOptions (Ctor) {
	  var modified;
	  var latest = Ctor.options;
	  var sealed = Ctor.sealedOptions;
	  for (var key in latest) {
		if (latest[key] !== sealed[key]) {
		  if (!modified) { modified = {}; }
		  modified[key] = latest[key];
		}
	  }
	  return modified
	}

	function vue_esm_Vue (options) {
	  if (false
	  ) {}
	  this._init(options);
	}

	initMixin(vue_esm_Vue);
	stateMixin(vue_esm_Vue);
	eventsMixin(vue_esm_Vue);
	lifecycleMixin(vue_esm_Vue);
	renderMixin(vue_esm_Vue);

	/*  */

	function initUse (Vue) {
	  Vue.use = function (plugin) {
		var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
		if (installedPlugins.indexOf(plugin) > -1) {
		  return this
		}

		// additional parameters
		var args = toArray(arguments, 1);
		args.unshift(this);
		if (typeof plugin.install === 'function') {
		  plugin.install.apply(plugin, args);
		} else if (typeof plugin === 'function') {
		  plugin.apply(null, args);
		}
		installedPlugins.push(plugin);
		return this
	  };
	}

	/*  */

	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
		this.options = mergeOptions(this.options, mixin);
		return this
	  };
	}

	/*  */

	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;

	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
		extendOptions = extendOptions || {};
		var Super = this;
		var SuperId = Super.cid;
		var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
		if (cachedCtors[SuperId]) {
		  return cachedCtors[SuperId]
		}

		var name = extendOptions.name || Super.options.name;
		if (false) {}

		var Sub = function VueComponent (options) {
		  this._init(options);
		};
		Sub.prototype = Object.create(Super.prototype);
		Sub.prototype.constructor = Sub;
		Sub.cid = cid++;
		Sub.options = mergeOptions(
			Super.options,
			extendOptions
		);
		Sub['super'] = Super;

		// For props and computed properties, we define the proxy getters on
		// the Vue instances at extension time, on the extended prototype. This
		// avoids Object.defineProperty calls for each instance created.
		if (Sub.options.props) {
		  initProps$1(Sub);
		}
		if (Sub.options.computed) {
		  initComputed$1(Sub);
		}

		// allow further extension/mixin/plugin usage
		Sub.extend = Super.extend;
		Sub.mixin = Super.mixin;
		Sub.use = Super.use;

		// create asset registers, so extended classes
		// can have their private assets too.
		ASSET_TYPES.forEach(function (type) {
		  Sub[type] = Super[type];
		});
		// enable recursive self-lookup
		if (name) {
		  Sub.options.components[name] = Sub;
		}

		// keep a reference to the super options at extension time.
		// later at instantiation we can check if Super's options have
		// been updated.
		Sub.superOptions = Super.options;
		Sub.extendOptions = extendOptions;
		Sub.sealedOptions = extend({}, Sub.options);

		// cache constructor
		cachedCtors[SuperId] = Sub;
		return Sub
	  };
	}

	function initProps$1 (Comp) {
	  var props = Comp.options.props;
	  for (var key in props) {
		proxy(Comp.prototype, "_props", key);
	  }
	}

	function initComputed$1 (Comp) {
	  var computed = Comp.options.computed;
	  for (var key in computed) {
		defineComputed(Comp.prototype, key, computed[key]);
	  }
	}

	/*  */

	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  ASSET_TYPES.forEach(function (type) {
		Vue[type] = function (
			id,
			definition
		) {
		  if (!definition) {
			return this.options[type + 's'][id]
		  } else {
			/* istanbul ignore if */
			if (false) {}
			if (type === 'component' && isPlainObject(definition)) {
			  definition.name = definition.name || id;
			  definition = this.options._base.extend(definition);
			}
			if (type === 'directive' && typeof definition === 'function') {
			  definition = { bind: definition, update: definition };
			}
			this.options[type + 's'][id] = definition;
			return definition
		  }
		};
	  });
	}

	/*  */





	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}

	function matches (pattern, name) {
	  if (Array.isArray(pattern)) {
		return pattern.indexOf(name) > -1
	  } else if (typeof pattern === 'string') {
		return pattern.split(',').indexOf(name) > -1
	  } else if (isRegExp(pattern)) {
		return pattern.test(name)
	  }
	  /* istanbul ignore next */
	  return false
	}

	function pruneCache (keepAliveInstance, filter) {
	  var cache = keepAliveInstance.cache;
	  var keys = keepAliveInstance.keys;
	  var _vnode = keepAliveInstance._vnode;
	  for (var key in cache) {
		var entry = cache[key];
		if (entry) {
		  var name = entry.name;
		  if (name && !filter(name)) {
			pruneCacheEntry(cache, key, keys, _vnode);
		  }
		}
	  }
	}

	function pruneCacheEntry (
		cache,
		key,
		keys,
		current
	) {
	  var entry = cache[key];
	  if (entry && (!current || entry.tag !== current.tag)) {
		entry.componentInstance.$destroy();
	  }
	  cache[key] = null;
	  remove(keys, key);
	}

	var patternTypes = [String, RegExp, Array];

	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,

	  props: {
		include: patternTypes,
		exclude: patternTypes,
		max: [String, Number]
	  },

	  methods: {
		cacheVNode: function cacheVNode() {
		  var ref = this;
		  var cache = ref.cache;
		  var keys = ref.keys;
		  var vnodeToCache = ref.vnodeToCache;
		  var keyToCache = ref.keyToCache;
		  if (vnodeToCache) {
			var tag = vnodeToCache.tag;
			var componentInstance = vnodeToCache.componentInstance;
			var componentOptions = vnodeToCache.componentOptions;
			cache[keyToCache] = {
			  name: getComponentName(componentOptions),
			  tag: tag,
			  componentInstance: componentInstance,
			};
			keys.push(keyToCache);
			// prune oldest entry
			if (this.max && keys.length > parseInt(this.max)) {
			  pruneCacheEntry(cache, keys[0], keys, this._vnode);
			}
			this.vnodeToCache = null;
		  }
		}
	  },

	  created: function created () {
		this.cache = Object.create(null);
		this.keys = [];
	  },

	  destroyed: function destroyed () {
		for (var key in this.cache) {
		  pruneCacheEntry(this.cache, key, this.keys);
		}
	  },

	  mounted: function mounted () {
		var this$1 = this;

		this.cacheVNode();
		this.$watch('include', function (val) {
		  pruneCache(this$1, function (name) { return matches(val, name); });
		});
		this.$watch('exclude', function (val) {
		  pruneCache(this$1, function (name) { return !matches(val, name); });
		});
	  },

	  updated: function updated () {
		this.cacheVNode();
	  },

	  render: function render () {
		var slot = this.$slots.default;
		var vnode = getFirstComponentChild(slot);
		var componentOptions = vnode && vnode.componentOptions;
		if (componentOptions) {
		  // check pattern
		  var name = getComponentName(componentOptions);
		  var ref = this;
		  var include = ref.include;
		  var exclude = ref.exclude;
		  if (
			  // not included
			  (include && (!name || !matches(include, name))) ||
			  // excluded
			  (exclude && name && matches(exclude, name))
		  ) {
			return vnode
		  }

		  var ref$1 = this;
		  var cache = ref$1.cache;
		  var keys = ref$1.keys;
		  var key = vnode.key == null
			  // same constructor may get registered as different local components
			  // so cid alone is not enough (#3269)
			  ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
			  : vnode.key;
		  if (cache[key]) {
			vnode.componentInstance = cache[key].componentInstance;
			// make current key freshest
			remove(keys, key);
			keys.push(key);
		  } else {
			// delay setting the cache until update
			this.vnodeToCache = vnode;
			this.keyToCache = key;
		  }

		  vnode.data.keepAlive = true;
		}
		return vnode || (slot && slot[0])
	  }
	};

	var builtInComponents = {
	  KeepAlive: KeepAlive
	};

	/*  */

	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  if (false) {}
	  Object.defineProperty(Vue, 'config', configDef);

	  // exposed util methods.
	  // NOTE: these are not considered part of the public API - avoid relying on
	  // them unless you are aware of the risk.
	  Vue.util = {
		warn: warn,
		extend: extend,
		mergeOptions: mergeOptions,
		defineReactive: defineReactive$$1
	  };

	  Vue.set = set;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;

	  // 2.6 explicit observable API
	  Vue.observable = function (obj) {
		observe(obj);
		return obj
	  };

	  Vue.options = Object.create(null);
	  ASSET_TYPES.forEach(function (type) {
		Vue.options[type + 's'] = Object.create(null);
	  });

	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;

	  extend(Vue.options.components, builtInComponents);

	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}

	initGlobalAPI(vue_esm_Vue);

	Object.defineProperty(vue_esm_Vue.prototype, '$isServer', {
	  get: isServerRendering
	});

	Object.defineProperty(vue_esm_Vue.prototype, '$ssrContext', {
	  get: function get () {
		/* istanbul ignore next */
		return this.$vnode && this.$vnode.ssrContext
	  }
	});

// expose FunctionalRenderContext for ssr runtime helper installation
	Object.defineProperty(vue_esm_Vue, 'FunctionalRenderContext', {
	  value: FunctionalRenderContext
	});

	vue_esm_Vue.version = '2.6.14';

	/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
	var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select,progress');
	var mustUseProp = function (tag, type, attr) {
	  return (
		  (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
		  (attr === 'selected' && tag === 'option') ||
		  (attr === 'checked' && tag === 'input') ||
		  (attr === 'muted' && tag === 'video')
	  )
	};

	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

	var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

	var convertEnumeratedValue = function (key, value) {
	  return isFalsyAttrValue(value) || value === 'false'
		  ? 'false'
		  // allow arbitrary string value for contenteditable
		  : key === 'contenteditable' && isValidContentEditableValue(value)
			  ? value
			  : 'true'
	};

	var isBooleanAttr = makeMap(
		'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
		'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
		'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
		'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
		'required,reversed,scoped,seamless,selected,sortable,' +
		'truespeed,typemustmatch,visible'
	);

	var xlinkNS = 'http://www.w3.org/1999/xlink';

	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};

	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};

	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};

	/*  */

	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (isDef(childNode.componentInstance)) {
		childNode = childNode.componentInstance._vnode;
		if (childNode && childNode.data) {
		  data = mergeClassData(childNode.data, data);
		}
	  }
	  while (isDef(parentNode = parentNode.parent)) {
		if (parentNode && parentNode.data) {
		  data = mergeClassData(data, parentNode.data);
		}
	  }
	  return renderClass(data.staticClass, data.class)
	}

	function mergeClassData (child, parent) {
	  return {
		staticClass: concat(child.staticClass, parent.staticClass),
		class: isDef(child.class)
			? [child.class, parent.class]
			: parent.class
	  }
	}

	function renderClass (
		staticClass,
		dynamicClass
	) {
	  if (isDef(staticClass) || isDef(dynamicClass)) {
		return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}

	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}

	function stringifyClass (value) {
	  if (Array.isArray(value)) {
		return stringifyArray(value)
	  }
	  if (isObject(value)) {
		return stringifyObject(value)
	  }
	  if (typeof value === 'string') {
		return value
	  }
	  /* istanbul ignore next */
	  return ''
	}

	function stringifyArray (value) {
	  var res = '';
	  var stringified;
	  for (var i = 0, l = value.length; i < l; i++) {
		if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
		  if (res) { res += ' '; }
		  res += stringified;
		}
	  }
	  return res
	}

	function stringifyObject (value) {
	  var res = '';
	  for (var key in value) {
		if (value[key]) {
		  if (res) { res += ' '; }
		  res += key;
		}
	  }
	  return res
	}

	/*  */

	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};

	var isHTMLTag = makeMap(
		'html,body,base,head,link,meta,style,title,' +
		'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
		'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
		'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
		's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
		'embed,object,param,source,canvas,script,noscript,del,ins,' +
		'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
		'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
		'output,progress,select,textarea,' +
		'details,dialog,menu,menuitem,summary,' +
		'content,element,shadow,template,blockquote,iframe,tfoot'
	);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
	var isSVG = makeMap(
		'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
		'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
		'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
		true
	);

	var isPreTag = function (tag) { return tag === 'pre'; };

	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};

	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
		return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
		return 'math'
	  }
	}

	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
		return true
	  }
	  if (isReservedTag(tag)) {
		return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
		return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
		// http://stackoverflow.com/a/28210364/1070244
		return (unknownElementCache[tag] = (
			el.constructor === window.HTMLUnknownElement ||
			el.constructor === window.HTMLElement
		))
	  } else {
		return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}

	var isTextInputType = makeMap('text,number,password,search,email,tel,url');

	/*  */

	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
		var selected = document.querySelector(el);
		if (!selected) {
		  false && 0;
		  return document.createElement('div')
		}
		return selected
	  } else {
		return el
	  }
	}

	/*  */

	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
		return elm
	  }
	  // false or null will remove the attribute but undefined will not
	  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
		elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}

	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}

	function createTextNode (text) {
	  return document.createTextNode(text)
	}

	function createComment (text) {
	  return document.createComment(text)
	}

	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}

	function removeChild (node, child) {
	  node.removeChild(child);
	}

	function appendChild (node, child) {
	  node.appendChild(child);
	}

	function parentNode (node) {
	  return node.parentNode
	}

	function nextSibling (node) {
	  return node.nextSibling
	}

	function tagName (node) {
	  return node.tagName
	}

	function setTextContent (node, text) {
	  node.textContent = text;
	}

	function setStyleScope (node, scopeId) {
	  node.setAttribute(scopeId, '');
	}

	var nodeOps = /*#__PURE__*/Object.freeze({
	  createElement: createElement$1,
	  createElementNS: createElementNS,
	  createTextNode: createTextNode,
	  createComment: createComment,
	  insertBefore: insertBefore,
	  removeChild: removeChild,
	  appendChild: appendChild,
	  parentNode: parentNode,
	  nextSibling: nextSibling,
	  tagName: tagName,
	  setTextContent: setTextContent,
	  setStyleScope: setStyleScope
	});

	/*  */

	var ref = {
	  create: function create (_, vnode) {
		registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
		if (oldVnode.data.ref !== vnode.data.ref) {
		  registerRef(oldVnode, true);
		  registerRef(vnode);
		}
	  },
	  destroy: function destroy (vnode) {
		registerRef(vnode, true);
	  }
	};

	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!isDef(key)) { return }

	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
		if (Array.isArray(refs[key])) {
		  remove(refs[key], ref);
		} else if (refs[key] === ref) {
		  refs[key] = undefined;
		}
	  } else {
		if (vnode.data.refInFor) {
		  if (!Array.isArray(refs[key])) {
			refs[key] = [ref];
		  } else if (refs[key].indexOf(ref) < 0) {
			// $flow-disable-line
			refs[key].push(ref);
		  }
		} else {
		  refs[key] = ref;
		}
	  }
	}

	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */

	var emptyNode = new VNode('', {}, []);

	var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

	function sameVnode (a, b) {
	  return (
		  a.key === b.key &&
		  a.asyncFactory === b.asyncFactory && (
			  (
				  a.tag === b.tag &&
				  a.isComment === b.isComment &&
				  isDef(a.data) === isDef(b.data) &&
				  sameInputType(a, b)
			  ) || (
				  isTrue(a.isAsyncPlaceholder) &&
				  isUndef(b.asyncFactory.error)
			  )
		  )
	  )
	}

	function sameInputType (a, b) {
	  if (a.tag !== 'input') { return true }
	  var i;
	  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
	  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
	  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
	}

	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
		key = children[i].key;
		if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}

	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};

	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;

	  for (i = 0; i < hooks.length; ++i) {
		cbs[hooks[i]] = [];
		for (j = 0; j < modules.length; ++j) {
		  if (isDef(modules[j][hooks[i]])) {
			cbs[hooks[i]].push(modules[j][hooks[i]]);
		  }
		}
	  }

	  function emptyNodeAt (elm) {
		return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }

	  function createRmCb (childElm, listeners) {
		function remove$$1 () {
		  if (--remove$$1.listeners === 0) {
			removeNode(childElm);
		  }
		}
		remove$$1.listeners = listeners;
		return remove$$1
	  }

	  function removeNode (el) {
		var parent = nodeOps.parentNode(el);
		// element may have already been removed due to v-html / v-text
		if (isDef(parent)) {
		  nodeOps.removeChild(parent, el);
		}
	  }

	  function isUnknownElement$$1 (vnode, inVPre) {
		return (
			!inVPre &&
			!vnode.ns &&
			!(
				config.ignoredElements.length &&
				config.ignoredElements.some(function (ignore) {
				  return isRegExp(ignore)
					  ? ignore.test(vnode.tag)
					  : ignore === vnode.tag
				})
			) &&
			config.isUnknownElement(vnode.tag)
		)
	  }

	  var creatingElmInVPre = 0;

	  function createElm (
		  vnode,
		  insertedVnodeQueue,
		  parentElm,
		  refElm,
		  nested,
		  ownerArray,
		  index
	  ) {
		if (isDef(vnode.elm) && isDef(ownerArray)) {
		  // This vnode was used in a previous render!
		  // now it's used as a new node, overwriting its elm would cause
		  // potential patch errors down the road when it's used as an insertion
		  // reference node. Instead, we clone the node on-demand before creating
		  // associated DOM element for it.
		  vnode = ownerArray[index] = cloneVNode(vnode);
		}

		vnode.isRootInsert = !nested; // for transition enter check
		if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
		  return
		}

		var data = vnode.data;
		var children = vnode.children;
		var tag = vnode.tag;
		if (isDef(tag)) {
		  if (false) {}

		  vnode.elm = vnode.ns
			  ? nodeOps.createElementNS(vnode.ns, tag)
			  : nodeOps.createElement(tag, vnode);
		  setScope(vnode);

		  /* istanbul ignore if */
		  {
			createChildren(vnode, children, insertedVnodeQueue);
			if (isDef(data)) {
			  invokeCreateHooks(vnode, insertedVnodeQueue);
			}
			insert(parentElm, vnode.elm, refElm);
		  }

		  if (false) {}
		} else if (isTrue(vnode.isComment)) {
		  vnode.elm = nodeOps.createComment(vnode.text);
		  insert(parentElm, vnode.elm, refElm);
		} else {
		  vnode.elm = nodeOps.createTextNode(vnode.text);
		  insert(parentElm, vnode.elm, refElm);
		}
	  }

	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
		var i = vnode.data;
		if (isDef(i)) {
		  var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
		  if (isDef(i = i.hook) && isDef(i = i.init)) {
			i(vnode, false /* hydrating */);
		  }
		  // after calling the init hook, if the vnode is a child component
		  // it should've created a child instance and mounted it. the child
		  // component also has set the placeholder vnode's elm.
		  // in that case we can just return the element and be done.
		  if (isDef(vnode.componentInstance)) {
			initComponent(vnode, insertedVnodeQueue);
			insert(parentElm, vnode.elm, refElm);
			if (isTrue(isReactivated)) {
			  reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
			}
			return true
		  }
		}
	  }

	  function initComponent (vnode, insertedVnodeQueue) {
		if (isDef(vnode.data.pendingInsert)) {
		  insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
		  vnode.data.pendingInsert = null;
		}
		vnode.elm = vnode.componentInstance.$el;
		if (isPatchable(vnode)) {
		  invokeCreateHooks(vnode, insertedVnodeQueue);
		  setScope(vnode);
		} else {
		  // empty component root.
		  // skip all element-related modules except for ref (#3455)
		  registerRef(vnode);
		  // make sure to invoke the insert hook
		  insertedVnodeQueue.push(vnode);
		}
	  }

	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
		var i;
		// hack for #4339: a reactivated component with inner transition
		// does not trigger because the inner node's created hooks are not called
		// again. It's not ideal to involve module-specific logic in here but
		// there doesn't seem to be a better way to do it.
		var innerNode = vnode;
		while (innerNode.componentInstance) {
		  innerNode = innerNode.componentInstance._vnode;
		  if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
			for (i = 0; i < cbs.activate.length; ++i) {
			  cbs.activate[i](emptyNode, innerNode);
			}
			insertedVnodeQueue.push(innerNode);
			break
		  }
		}
		// unlike a newly created component,
		// a reactivated keep-alive component doesn't insert itself
		insert(parentElm, vnode.elm, refElm);
	  }

	  function insert (parent, elm, ref$$1) {
		if (isDef(parent)) {
		  if (isDef(ref$$1)) {
			if (nodeOps.parentNode(ref$$1) === parent) {
			  nodeOps.insertBefore(parent, elm, ref$$1);
			}
		  } else {
			nodeOps.appendChild(parent, elm);
		  }
		}
	  }

	  function createChildren (vnode, children, insertedVnodeQueue) {
		if (Array.isArray(children)) {
		  if (false) {}
		  for (var i = 0; i < children.length; ++i) {
			createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
		  }
		} else if (isPrimitive(vnode.text)) {
		  nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
		}
	  }

	  function isPatchable (vnode) {
		while (vnode.componentInstance) {
		  vnode = vnode.componentInstance._vnode;
		}
		return isDef(vnode.tag)
	  }

	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
		for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
		  cbs.create[i$1](emptyNode, vnode);
		}
		i = vnode.data.hook; // Reuse variable
		if (isDef(i)) {
		  if (isDef(i.create)) { i.create(emptyNode, vnode); }
		  if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
		}
	  }

	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
		var i;
		if (isDef(i = vnode.fnScopeId)) {
		  nodeOps.setStyleScope(vnode.elm, i);
		} else {
		  var ancestor = vnode;
		  while (ancestor) {
			if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
			  nodeOps.setStyleScope(vnode.elm, i);
			}
			ancestor = ancestor.parent;
		  }
		}
		// for slot content they should also get the scopeId from the host instance.
		if (isDef(i = activeInstance) &&
			i !== vnode.context &&
			i !== vnode.fnContext &&
			isDef(i = i.$options._scopeId)
		) {
		  nodeOps.setStyleScope(vnode.elm, i);
		}
	  }

	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
		for (; startIdx <= endIdx; ++startIdx) {
		  createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
		}
	  }

	  function invokeDestroyHook (vnode) {
		var i, j;
		var data = vnode.data;
		if (isDef(data)) {
		  if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
		  for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
		}
		if (isDef(i = vnode.children)) {
		  for (j = 0; j < vnode.children.length; ++j) {
			invokeDestroyHook(vnode.children[j]);
		  }
		}
	  }

	  function removeVnodes (vnodes, startIdx, endIdx) {
		for (; startIdx <= endIdx; ++startIdx) {
		  var ch = vnodes[startIdx];
		  if (isDef(ch)) {
			if (isDef(ch.tag)) {
			  removeAndInvokeRemoveHook(ch);
			  invokeDestroyHook(ch);
			} else { // Text node
			  removeNode(ch.elm);
			}
		  }
		}
	  }

	  function removeAndInvokeRemoveHook (vnode, rm) {
		if (isDef(rm) || isDef(vnode.data)) {
		  var i;
		  var listeners = cbs.remove.length + 1;
		  if (isDef(rm)) {
			// we have a recursively passed down rm callback
			// increase the listeners count
			rm.listeners += listeners;
		  } else {
			// directly removing
			rm = createRmCb(vnode.elm, listeners);
		  }
		  // recursively invoke hooks on child component root node
		  if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
			removeAndInvokeRemoveHook(i, rm);
		  }
		  for (i = 0; i < cbs.remove.length; ++i) {
			cbs.remove[i](vnode, rm);
		  }
		  if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
			i(vnode, rm);
		  } else {
			rm();
		  }
		} else {
		  removeNode(vnode.elm);
		}
	  }

	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
		var oldStartIdx = 0;
		var newStartIdx = 0;
		var oldEndIdx = oldCh.length - 1;
		var oldStartVnode = oldCh[0];
		var oldEndVnode = oldCh[oldEndIdx];
		var newEndIdx = newCh.length - 1;
		var newStartVnode = newCh[0];
		var newEndVnode = newCh[newEndIdx];
		var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

		// removeOnly is a special flag used only by <transition-group>
		// to ensure removed elements stay in correct relative positions
		// during leaving transitions
		var canMove = !removeOnly;

		if (false) {}

		while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
		  if (isUndef(oldStartVnode)) {
			oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
		  } else if (isUndef(oldEndVnode)) {
			oldEndVnode = oldCh[--oldEndIdx];
		  } else if (sameVnode(oldStartVnode, newStartVnode)) {
			patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
			oldStartVnode = oldCh[++oldStartIdx];
			newStartVnode = newCh[++newStartIdx];
		  } else if (sameVnode(oldEndVnode, newEndVnode)) {
			patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
			oldEndVnode = oldCh[--oldEndIdx];
			newEndVnode = newCh[--newEndIdx];
		  } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
			patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
			canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
			oldStartVnode = oldCh[++oldStartIdx];
			newEndVnode = newCh[--newEndIdx];
		  } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
			patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
			canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
			oldEndVnode = oldCh[--oldEndIdx];
			newStartVnode = newCh[++newStartIdx];
		  } else {
			if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
			idxInOld = isDef(newStartVnode.key)
				? oldKeyToIdx[newStartVnode.key]
				: findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
			if (isUndef(idxInOld)) { // New element
			  createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
			} else {
			  vnodeToMove = oldCh[idxInOld];
			  if (sameVnode(vnodeToMove, newStartVnode)) {
				patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
				oldCh[idxInOld] = undefined;
				canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
			  } else {
				// same key but different element. treat as new element
				createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
			  }
			}
			newStartVnode = newCh[++newStartIdx];
		  }
		}
		if (oldStartIdx > oldEndIdx) {
		  refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
		  addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
		} else if (newStartIdx > newEndIdx) {
		  removeVnodes(oldCh, oldStartIdx, oldEndIdx);
		}
	  }

	  function checkDuplicateKeys (children) {
		var seenKeys = {};
		for (var i = 0; i < children.length; i++) {
		  var vnode = children[i];
		  var key = vnode.key;
		  if (isDef(key)) {
			if (seenKeys[key]) {
			  warn(
				  ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
				  vnode.context
			  );
			} else {
			  seenKeys[key] = true;
			}
		  }
		}
	  }

	  function findIdxInOld (node, oldCh, start, end) {
		for (var i = start; i < end; i++) {
		  var c = oldCh[i];
		  if (isDef(c) && sameVnode(node, c)) { return i }
		}
	  }

	  function patchVnode (
		  oldVnode,
		  vnode,
		  insertedVnodeQueue,
		  ownerArray,
		  index,
		  removeOnly
	  ) {
		if (oldVnode === vnode) {
		  return
		}

		if (isDef(vnode.elm) && isDef(ownerArray)) {
		  // clone reused vnode
		  vnode = ownerArray[index] = cloneVNode(vnode);
		}

		var elm = vnode.elm = oldVnode.elm;

		if (isTrue(oldVnode.isAsyncPlaceholder)) {
		  if (isDef(vnode.asyncFactory.resolved)) {
			hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
		  } else {
			vnode.isAsyncPlaceholder = true;
		  }
		  return
		}

		// reuse element for static trees.
		// note we only do this if the vnode is cloned -
		// if the new node is not cloned it means the render functions have been
		// reset by the hot-reload-api and we need to do a proper re-render.
		if (isTrue(vnode.isStatic) &&
			isTrue(oldVnode.isStatic) &&
			vnode.key === oldVnode.key &&
			(isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
		) {
		  vnode.componentInstance = oldVnode.componentInstance;
		  return
		}

		var i;
		var data = vnode.data;
		if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
		  i(oldVnode, vnode);
		}

		var oldCh = oldVnode.children;
		var ch = vnode.children;
		if (isDef(data) && isPatchable(vnode)) {
		  for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
		  if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
		}
		if (isUndef(vnode.text)) {
		  if (isDef(oldCh) && isDef(ch)) {
			if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
		  } else if (isDef(ch)) {
			if (false) {}
			if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
			addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
		  } else if (isDef(oldCh)) {
			removeVnodes(oldCh, 0, oldCh.length - 1);
		  } else if (isDef(oldVnode.text)) {
			nodeOps.setTextContent(elm, '');
		  }
		} else if (oldVnode.text !== vnode.text) {
		  nodeOps.setTextContent(elm, vnode.text);
		}
		if (isDef(data)) {
		  if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
		}
	  }

	  function invokeInsertHook (vnode, queue, initial) {
		// delay insert hooks for component root nodes, invoke them after the
		// element is really inserted
		if (isTrue(initial) && isDef(vnode.parent)) {
		  vnode.parent.data.pendingInsert = queue;
		} else {
		  for (var i = 0; i < queue.length; ++i) {
			queue[i].data.hook.insert(queue[i]);
		  }
		}
	  }

	  var hydrationBailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  // Note: style is excluded because it relies on initial clone for future
	  // deep updates (#7063).
	  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
		var i;
		var tag = vnode.tag;
		var data = vnode.data;
		var children = vnode.children;
		inVPre = inVPre || (data && data.pre);
		vnode.elm = elm;

		if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
		  vnode.isAsyncPlaceholder = true;
		  return true
		}
		// assert node match
		if (false) {}
		if (isDef(data)) {
		  if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
		  if (isDef(i = vnode.componentInstance)) {
			// child component. it should have hydrated its own tree.
			initComponent(vnode, insertedVnodeQueue);
			return true
		  }
		}
		if (isDef(tag)) {
		  if (isDef(children)) {
			// empty element, allow client to pick up and populate children
			if (!elm.hasChildNodes()) {
			  createChildren(vnode, children, insertedVnodeQueue);
			} else {
			  // v-html and domProps: innerHTML
			  if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
				if (i !== elm.innerHTML) {
				  /* istanbul ignore if */
				  if (false
				  ) {}
				  return false
				}
			  } else {
				// iterate and compare children lists
				var childrenMatch = true;
				var childNode = elm.firstChild;
				for (var i$1 = 0; i$1 < children.length; i$1++) {
				  if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
					childrenMatch = false;
					break
				  }
				  childNode = childNode.nextSibling;
				}
				// if childNode is not null, it means the actual childNodes list is
				// longer than the virtual children list.
				if (!childrenMatch || childNode) {
				  /* istanbul ignore if */
				  if (false
				  ) {}
				  return false
				}
			  }
			}
		  }
		  if (isDef(data)) {
			var fullInvoke = false;
			for (var key in data) {
			  if (!isRenderedModule(key)) {
				fullInvoke = true;
				invokeCreateHooks(vnode, insertedVnodeQueue);
				break
			  }
			}
			if (!fullInvoke && data['class']) {
			  // ensure collecting deps for deep class bindings for future updates
			  traverse(data['class']);
			}
		  }
		} else if (elm.data !== vnode.text) {
		  elm.data = vnode.text;
		}
		return true
	  }

	  function assertNodeMatch (node, vnode, inVPre) {
		if (isDef(vnode.tag)) {
		  return vnode.tag.indexOf('vue-component') === 0 || (
			  !isUnknownElement$$1(vnode, inVPre) &&
			  vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
		  )
		} else {
		  return node.nodeType === (vnode.isComment ? 8 : 3)
		}
	  }

	  return function patch (oldVnode, vnode, hydrating, removeOnly) {
		if (isUndef(vnode)) {
		  if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
		  return
		}

		var isInitialPatch = false;
		var insertedVnodeQueue = [];

		if (isUndef(oldVnode)) {
		  // empty mount (likely as component), create new root element
		  isInitialPatch = true;
		  createElm(vnode, insertedVnodeQueue);
		} else {
		  var isRealElement = isDef(oldVnode.nodeType);
		  if (!isRealElement && sameVnode(oldVnode, vnode)) {
			// patch existing root node
			patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
		  } else {
			if (isRealElement) {
			  // mounting to a real element
			  // check if this is server-rendered content and if we can perform
			  // a successful hydration.
			  if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
				oldVnode.removeAttribute(SSR_ATTR);
				hydrating = true;
			  }
			  if (isTrue(hydrating)) {
				if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
				  invokeInsertHook(vnode, insertedVnodeQueue, true);
				  return oldVnode
				} else if (false) {}
			  }
			  // either not server-rendered, or hydration failed.
			  // create an empty node and replace it
			  oldVnode = emptyNodeAt(oldVnode);
			}

			// replacing existing element
			var oldElm = oldVnode.elm;
			var parentElm = nodeOps.parentNode(oldElm);

			// create new node
			createElm(
				vnode,
				insertedVnodeQueue,
				// extremely rare edge case: do not insert if old element is in a
				// leaving transition. Only happens when combining transition +
				// keep-alive + HOCs. (#4590)
				oldElm._leaveCb ? null : parentElm,
				nodeOps.nextSibling(oldElm)
			);

			// update parent placeholder node element, recursively
			if (isDef(vnode.parent)) {
			  var ancestor = vnode.parent;
			  var patchable = isPatchable(vnode);
			  while (ancestor) {
				for (var i = 0; i < cbs.destroy.length; ++i) {
				  cbs.destroy[i](ancestor);
				}
				ancestor.elm = vnode.elm;
				if (patchable) {
				  for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
					cbs.create[i$1](emptyNode, ancestor);
				  }
				  // #6513
				  // invoke insert hooks that may have been merged by create hooks.
				  // e.g. for directives that uses the "inserted" hook.
				  var insert = ancestor.data.hook.insert;
				  if (insert.merged) {
					// start at index 1 to avoid re-invoking component mounted hook
					for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
					  insert.fns[i$2]();
					}
				  }
				} else {
				  registerRef(ancestor);
				}
				ancestor = ancestor.parent;
			  }
			}

			// destroy old node
			if (isDef(parentElm)) {
			  removeVnodes([oldVnode], 0, 0);
			} else if (isDef(oldVnode.tag)) {
			  invokeDestroyHook(oldVnode);
			}
		  }
		}

		invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
		return vnode.elm
	  }
	}

	/*  */

	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
		updateDirectives(vnode, emptyNode);
	  }
	};

	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
		_update(oldVnode, vnode);
	  }
	}

	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];

	  var key, oldDir, dir;
	  for (key in newDirs) {
		oldDir = oldDirs[key];
		dir = newDirs[key];
		if (!oldDir) {
		  // new directive, bind
		  callHook$1(dir, 'bind', vnode, oldVnode);
		  if (dir.def && dir.def.inserted) {
			dirsWithInsert.push(dir);
		  }
		} else {
		  // existing directive, update
		  dir.oldValue = oldDir.value;
		  dir.oldArg = oldDir.arg;
		  callHook$1(dir, 'update', vnode, oldVnode);
		  if (dir.def && dir.def.componentUpdated) {
			dirsWithPostpatch.push(dir);
		  }
		}
	  }

	  if (dirsWithInsert.length) {
		var callInsert = function () {
		  for (var i = 0; i < dirsWithInsert.length; i++) {
			callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
		  }
		};
		if (isCreate) {
		  mergeVNodeHook(vnode, 'insert', callInsert);
		} else {
		  callInsert();
		}
	  }

	  if (dirsWithPostpatch.length) {
		mergeVNodeHook(vnode, 'postpatch', function () {
		  for (var i = 0; i < dirsWithPostpatch.length; i++) {
			callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
		  }
		});
	  }

	  if (!isCreate) {
		for (key in oldDirs) {
		  if (!newDirs[key]) {
			// no longer present, unbind
			callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
		  }
		}
	  }
	}

	var emptyModifiers = Object.create(null);

	function normalizeDirectives$1 (
		dirs,
		vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
		// $flow-disable-line
		return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
		dir = dirs[i];
		if (!dir.modifiers) {
		  // $flow-disable-line
		  dir.modifiers = emptyModifiers;
		}
		res[getRawDirName(dir)] = dir;
		dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  // $flow-disable-line
	  return res
	}

	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}

	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
		try {
		  fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
		} catch (e) {
		  handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
		}
	  }
	}

	var baseModules = [
	  ref,
	  directives
	];

	/*  */

	function updateAttrs (oldVnode, vnode) {
	  var opts = vnode.componentOptions;
	  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
		return
	  }
	  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
		return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(attrs.__ob__)) {
		attrs = vnode.data.attrs = extend({}, attrs);
	  }

	  for (key in attrs) {
		cur = attrs[key];
		old = oldAttrs[key];
		if (old !== cur) {
		  setAttr(elm, key, cur, vnode.data.pre);
		}
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  // #6666: IE/Edge forces progress value down to 1 before setting a max
	  /* istanbul ignore if */
	  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
		setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
		if (isUndef(attrs[key])) {
		  if (isXlink(key)) {
			elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
		  } else if (!isEnumeratedAttr(key)) {
			elm.removeAttribute(key);
		  }
		}
	  }
	}

	function setAttr (el, key, value, isInPre) {
	  if (isInPre || el.tagName.indexOf('-') > -1) {
		baseSetAttr(el, key, value);
	  } else if (isBooleanAttr(key)) {
		// set attribute for blank value
		// e.g. <option disabled>Select one</option>
		if (isFalsyAttrValue(value)) {
		  el.removeAttribute(key);
		} else {
		  // technically allowfullscreen is a boolean attribute for <iframe>,
		  // but Flash expects a value of "true" when used on <embed> tag
		  value = key === 'allowfullscreen' && el.tagName === 'EMBED'
			  ? 'true'
			  : key;
		  el.setAttribute(key, value);
		}
	  } else if (isEnumeratedAttr(key)) {
		el.setAttribute(key, convertEnumeratedValue(key, value));
	  } else if (isXlink(key)) {
		if (isFalsyAttrValue(value)) {
		  el.removeAttributeNS(xlinkNS, getXlinkProp(key));
		} else {
		  el.setAttributeNS(xlinkNS, key, value);
		}
	  } else {
		baseSetAttr(el, key, value);
	  }
	}

	function baseSetAttr (el, key, value) {
	  if (isFalsyAttrValue(value)) {
		el.removeAttribute(key);
	  } else {
		// #7138: IE10 & 11 fires input event when setting placeholder on
		// <textarea>... block the first input event and remove the blocker
		// immediately.
		/* istanbul ignore if */
		if (
			isIE && !isIE9 &&
			el.tagName === 'TEXTAREA' &&
			key === 'placeholder' && value !== '' && !el.__ieph
		) {
		  var blocker = function (e) {
			e.stopImmediatePropagation();
			el.removeEventListener('input', blocker);
		  };
		  el.addEventListener('input', blocker);
		  // $flow-disable-line
		  el.__ieph = true; /* IE placeholder patched */
		}
		el.setAttribute(key, value);
	  }
	}

	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};

	/*  */

	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (
		  isUndef(data.staticClass) &&
		  isUndef(data.class) && (
			  isUndef(oldData) || (
				  isUndef(oldData.staticClass) &&
				  isUndef(oldData.class)
			  )
		  )
	  ) {
		return
	  }

	  var cls = genClassForVnode(vnode);

	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (isDef(transitionClass)) {
		cls = concat(cls, stringifyClass(transitionClass));
	  }

	  // set the class
	  if (cls !== el._prevClass) {
		el.setAttribute('class', cls);
		el._prevClass = cls;
	  }
	}

	var klass = {
	  create: updateClass,
	  update: updateClass
	};

	/*  */

	var validDivisionCharRE = /[\w).+\-_$\]]/;

	function parseFilters (exp) {
	  var inSingle = false;
	  var inDouble = false;
	  var inTemplateString = false;
	  var inRegex = false;
	  var curly = 0;
	  var square = 0;
	  var paren = 0;
	  var lastFilterIndex = 0;
	  var c, prev, i, expression, filters;

	  for (i = 0; i < exp.length; i++) {
		prev = c;
		c = exp.charCodeAt(i);
		if (inSingle) {
		  if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
		} else if (inDouble) {
		  if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
		} else if (inTemplateString) {
		  if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
		} else if (inRegex) {
		  if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
		} else if (
			c === 0x7C && // pipe
			exp.charCodeAt(i + 1) !== 0x7C &&
			exp.charCodeAt(i - 1) !== 0x7C &&
			!curly && !square && !paren
		) {
		  if (expression === undefined) {
			// first filter, end of expression
			lastFilterIndex = i + 1;
			expression = exp.slice(0, i).trim();
		  } else {
			pushFilter();
		  }
		} else {
		  switch (c) {
			case 0x22: inDouble = true; break         // "
			case 0x27: inSingle = true; break         // '
			case 0x60: inTemplateString = true; break // `
			case 0x28: paren++; break                 // (
			case 0x29: paren--; break                 // )
			case 0x5B: square++; break                // [
			case 0x5D: square--; break                // ]
			case 0x7B: curly++; break                 // {
			case 0x7D: curly--; break                 // }
		  }
		  if (c === 0x2f) { // /
			var j = i - 1;
			var p = (void 0);
			// find first non-whitespace prev char
			for (; j >= 0; j--) {
			  p = exp.charAt(j);
			  if (p !== ' ') { break }
			}
			if (!p || !validDivisionCharRE.test(p)) {
			  inRegex = true;
			}
		  }
		}
	  }

	  if (expression === undefined) {
		expression = exp.slice(0, i).trim();
	  } else if (lastFilterIndex !== 0) {
		pushFilter();
	  }

	  function pushFilter () {
		(filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
		lastFilterIndex = i + 1;
	  }

	  if (filters) {
		for (i = 0; i < filters.length; i++) {
		  expression = wrapFilter(expression, filters[i]);
		}
	  }

	  return expression
	}

	function wrapFilter (exp, filter) {
	  var i = filter.indexOf('(');
	  if (i < 0) {
		// _f: resolveFilter
		return ("_f(\"" + filter + "\")(" + exp + ")")
	  } else {
		var name = filter.slice(0, i);
		var args = filter.slice(i + 1);
		return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
	  }
	}

	/*  */



	/* eslint-disable no-unused-vars */
	function baseWarn (msg, range) {
	  console.error(("[Vue compiler]: " + msg));
	}
	/* eslint-enable no-unused-vars */

	function pluckModuleFunction (
		modules,
		key
	) {
	  return modules
		  ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
		  : []
	}

	function addProp (el, name, value, range, dynamic) {
	  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
	  el.plain = false;
	}

	function addAttr (el, name, value, range, dynamic) {
	  var attrs = dynamic
		  ? (el.dynamicAttrs || (el.dynamicAttrs = []))
		  : (el.attrs || (el.attrs = []));
	  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
	  el.plain = false;
	}

// add a raw attr (use this in preTransforms)
	function addRawAttr (el, name, value, range) {
	  el.attrsMap[name] = value;
	  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
	}

	function addDirective (
		el,
		name,
		rawName,
		value,
		arg,
		isDynamicArg,
		modifiers,
		range
	) {
	  (el.directives || (el.directives = [])).push(rangeSetItem({
		name: name,
		rawName: rawName,
		value: value,
		arg: arg,
		isDynamicArg: isDynamicArg,
		modifiers: modifiers
	  }, range));
	  el.plain = false;
	}

	function prependModifierMarker (symbol, name, dynamic) {
	  return dynamic
		  ? ("_p(" + name + ",\"" + symbol + "\")")
		  : symbol + name // mark the event as captured
	}

	function addHandler (
		el,
		name,
		value,
		modifiers,
		important,
		warn,
		range,
		dynamic
	) {
	  modifiers = modifiers || emptyObject;
	  // warn prevent and passive modifier
	  /* istanbul ignore if */
	  if (
		  false
	  ) {}

	  // normalize click.right and click.middle since they don't actually fire
	  // this is technically browser-specific, but at least for now browsers are
	  // the only target envs that have right/middle clicks.
	  if (modifiers.right) {
		if (dynamic) {
		  name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
		} else if (name === 'click') {
		  name = 'contextmenu';
		  delete modifiers.right;
		}
	  } else if (modifiers.middle) {
		if (dynamic) {
		  name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
		} else if (name === 'click') {
		  name = 'mouseup';
		}
	  }

	  // check capture modifier
	  if (modifiers.capture) {
		delete modifiers.capture;
		name = prependModifierMarker('!', name, dynamic);
	  }
	  if (modifiers.once) {
		delete modifiers.once;
		name = prependModifierMarker('~', name, dynamic);
	  }
	  /* istanbul ignore if */
	  if (modifiers.passive) {
		delete modifiers.passive;
		name = prependModifierMarker('&', name, dynamic);
	  }

	  var events;
	  if (modifiers.native) {
		delete modifiers.native;
		events = el.nativeEvents || (el.nativeEvents = {});
	  } else {
		events = el.events || (el.events = {});
	  }

	  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
	  if (modifiers !== emptyObject) {
		newHandler.modifiers = modifiers;
	  }

	  var handlers = events[name];
	  /* istanbul ignore if */
	  if (Array.isArray(handlers)) {
		important ? handlers.unshift(newHandler) : handlers.push(newHandler);
	  } else if (handlers) {
		events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
	  } else {
		events[name] = newHandler;
	  }

	  el.plain = false;
	}

	function getRawBindingAttr (
		el,
		name
	) {
	  return el.rawAttrsMap[':' + name] ||
		  el.rawAttrsMap['v-bind:' + name] ||
		  el.rawAttrsMap[name]
	}

	function getBindingAttr (
		el,
		name,
		getStatic
	) {
	  var dynamicValue =
		  getAndRemoveAttr(el, ':' + name) ||
		  getAndRemoveAttr(el, 'v-bind:' + name);
	  if (dynamicValue != null) {
		return parseFilters(dynamicValue)
	  } else if (getStatic !== false) {
		var staticValue = getAndRemoveAttr(el, name);
		if (staticValue != null) {
		  return JSON.stringify(staticValue)
		}
	  }
	}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
	function getAndRemoveAttr (
		el,
		name,
		removeFromMap
	) {
	  var val;
	  if ((val = el.attrsMap[name]) != null) {
		var list = el.attrsList;
		for (var i = 0, l = list.length; i < l; i++) {
		  if (list[i].name === name) {
			list.splice(i, 1);
			break
		  }
		}
	  }
	  if (removeFromMap) {
		delete el.attrsMap[name];
	  }
	  return val
	}

	function getAndRemoveAttrByRegex (
		el,
		name
	) {
	  var list = el.attrsList;
	  for (var i = 0, l = list.length; i < l; i++) {
		var attr = list[i];
		if (name.test(attr.name)) {
		  list.splice(i, 1);
		  return attr
		}
	  }
	}

	function rangeSetItem (
		item,
		range
	) {
	  if (range) {
		if (range.start != null) {
		  item.start = range.start;
		}
		if (range.end != null) {
		  item.end = range.end;
		}
	  }
	  return item
	}

	/*  */

	/**
	 * Cross-platform code generation for component v-model
	 */
	function genComponentModel (
		el,
		value,
		modifiers
	) {
	  var ref = modifiers || {};
	  var number = ref.number;
	  var trim = ref.trim;

	  var baseValueExpression = '$$v';
	  var valueExpression = baseValueExpression;
	  if (trim) {
		valueExpression =
			"(typeof " + baseValueExpression + " === 'string'" +
			"? " + baseValueExpression + ".trim()" +
			": " + baseValueExpression + ")";
	  }
	  if (number) {
		valueExpression = "_n(" + valueExpression + ")";
	  }
	  var assignment = genAssignmentCode(value, valueExpression);

	  el.model = {
		value: ("(" + value + ")"),
		expression: JSON.stringify(value),
		callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
	  };
	}

	/**
	 * Cross-platform codegen helper for generating v-model value assignment code.
	 */
	function genAssignmentCode (
		value,
		assignment
	) {
	  var res = parseModel(value);
	  if (res.key === null) {
		return (value + "=" + assignment)
	  } else {
		return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
	  }
	}

	/**
	 * Parse a v-model expression into a base path and a final key segment.
	 * Handles both dot-path and possible square brackets.
	 *
	 * Possible cases:
	 *
	 * - test
	 * - test[key]
	 * - test[test1[key]]
	 * - test["a"][key]
	 * - xxx.test[a[a].test1[key]]
	 * - test.xxx.a["asa"][test1[key]]
	 *
	 */

	var len, str, chr, index$1, expressionPos, expressionEndPos;



	function parseModel (val) {
	  // Fix https://github.com/vuejs/vue/pull/7730
	  // allow v-model="obj.val " (trailing whitespace)
	  val = val.trim();
	  len = val.length;

	  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
		index$1 = val.lastIndexOf('.');
		if (index$1 > -1) {
		  return {
			exp: val.slice(0, index$1),
			key: '"' + val.slice(index$1 + 1) + '"'
		  }
		} else {
		  return {
			exp: val,
			key: null
		  }
		}
	  }

	  str = val;
	  index$1 = expressionPos = expressionEndPos = 0;

	  while (!eof()) {
		chr = next();
		/* istanbul ignore if */
		if (isStringStart(chr)) {
		  parseString(chr);
		} else if (chr === 0x5B) {
		  parseBracket(chr);
		}
	  }

	  return {
		exp: val.slice(0, expressionPos),
		key: val.slice(expressionPos + 1, expressionEndPos)
	  }
	}

	function next () {
	  return str.charCodeAt(++index$1)
	}

	function eof () {
	  return index$1 >= len
	}

	function isStringStart (chr) {
	  return chr === 0x22 || chr === 0x27
	}

	function parseBracket (chr) {
	  var inBracket = 1;
	  expressionPos = index$1;
	  while (!eof()) {
		chr = next();
		if (isStringStart(chr)) {
		  parseString(chr);
		  continue
		}
		if (chr === 0x5B) { inBracket++; }
		if (chr === 0x5D) { inBracket--; }
		if (inBracket === 0) {
		  expressionEndPos = index$1;
		  break
		}
	  }
	}

	function parseString (chr) {
	  var stringQuote = chr;
	  while (!eof()) {
		chr = next();
		if (chr === stringQuote) {
		  break
		}
	  }
	}

	/*  */

	var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
	var RANGE_TOKEN = '__r';
	var CHECKBOX_RADIO_TOKEN = '__c';

	function model (
		el,
		dir,
		_warn
	) {
	  warn$1 = _warn;
	  var value = dir.value;
	  var modifiers = dir.modifiers;
	  var tag = el.tag;
	  var type = el.attrsMap.type;

	  if (false) {}

	  if (el.component) {
		genComponentModel(el, value, modifiers);
		// component v-model doesn't need extra runtime
		return false
	  } else if (tag === 'select') {
		genSelect(el, value, modifiers);
	  } else if (tag === 'input' && type === 'checkbox') {
		genCheckboxModel(el, value, modifiers);
	  } else if (tag === 'input' && type === 'radio') {
		genRadioModel(el, value, modifiers);
	  } else if (tag === 'input' || tag === 'textarea') {
		genDefaultModel(el, value, modifiers);
	  } else if (!config.isReservedTag(tag)) {
		genComponentModel(el, value, modifiers);
		// component v-model doesn't need extra runtime
		return false
	  } else if (false) {}

	  // ensure runtime directive metadata
	  return true
	}

	function genCheckboxModel (
		el,
		value,
		modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
	  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
	  addProp(el, 'checked',
		  "Array.isArray(" + value + ")" +
		  "?_i(" + value + "," + valueBinding + ")>-1" + (
			  trueValueBinding === 'true'
				  ? (":(" + value + ")")
				  : (":_q(" + value + "," + trueValueBinding + ")")
		  )
	  );
	  addHandler(el, 'change',
		  "var $$a=" + value + "," +
		  '$$el=$event.target,' +
		  "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
		  'if(Array.isArray($$a)){' +
		  "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
		  '$$i=_i($$a,$$v);' +
		  "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
		  "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
		  "}else{" + (genAssignmentCode(value, '$$c')) + "}",
		  null, true
	  );
	}

	function genRadioModel (
		el,
		value,
		modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
	  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
	  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
	}

	function genSelect (
		el,
		value,
		modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var selectedVal = "Array.prototype.filter" +
		  ".call($event.target.options,function(o){return o.selected})" +
		  ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
		  "return " + (number ? '_n(val)' : 'val') + "})";

	  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
	  var code = "var $$selectedVal = " + selectedVal + ";";
	  code = code + " " + (genAssignmentCode(value, assignment));
	  addHandler(el, 'change', code, null, true);
	}

	function genDefaultModel (
		el,
		value,
		modifiers
	) {
	  var type = el.attrsMap.type;

	  // warn if v-bind:value conflicts with v-model
	  // except for inputs with v-bind:type
	  if (false) { var binding, typeBinding, value$1; }

	  var ref = modifiers || {};
	  var lazy = ref.lazy;
	  var number = ref.number;
	  var trim = ref.trim;
	  var needCompositionGuard = !lazy && type !== 'range';
	  var event = lazy
		  ? 'change'
		  : type === 'range'
			  ? RANGE_TOKEN
			  : 'input';

	  var valueExpression = '$event.target.value';
	  if (trim) {
		valueExpression = "$event.target.value.trim()";
	  }
	  if (number) {
		valueExpression = "_n(" + valueExpression + ")";
	  }

	  var code = genAssignmentCode(value, valueExpression);
	  if (needCompositionGuard) {
		code = "if($event.target.composing)return;" + code;
	  }

	  addProp(el, 'value', ("(" + value + ")"));
	  addHandler(el, event, code, null, true);
	  if (trim || number) {
		addHandler(el, 'blur', '$forceUpdate()');
	  }
	}

	/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
	function normalizeEvents (on) {
	  /* istanbul ignore if */
	  if (isDef(on[RANGE_TOKEN])) {
		// IE input[type=range] only supports `change` event
		var event = isIE ? 'change' : 'input';
		on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
		delete on[RANGE_TOKEN];
	  }
	  // This was originally intended to fix #4521 but no longer necessary
	  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
	  /* istanbul ignore if */
	  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
		on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
		delete on[CHECKBOX_RADIO_TOKEN];
	  }
	}

	var target$1;

	function createOnceHandler$1 (event, handler, capture) {
	  var _target = target$1; // save current target element in closure
	  return function onceHandler () {
		var res = handler.apply(null, arguments);
		if (res !== null) {
		  remove$2(event, onceHandler, capture, _target);
		}
	  }
	}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
	var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

	function add$1 (
		name,
		handler,
		capture,
		passive
	) {
	  // async edge case #6566: inner click event triggers patch, event handler
	  // attached to outer element during patch, and triggered again. This
	  // happens because browsers fire microtask ticks between event propagation.
	  // the solution is simple: we save the timestamp when a handler is attached,
	  // and the handler would only fire if the event passed to it was fired
	  // AFTER it was attached.
	  if (useMicrotaskFix) {
		var attachedTimestamp = currentFlushTimestamp;
		var original = handler;
		handler = original._wrapper = function (e) {
		  if (
			  // no bubbling, should always fire.
			  // this is just a safety net in case event.timeStamp is unreliable in
			  // certain weird environments...
			  e.target === e.currentTarget ||
			  // event is fired after handler attachment
			  e.timeStamp >= attachedTimestamp ||
			  // bail for environments that have buggy event.timeStamp implementations
			  // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
			  // #9681 QtWebEngine event.timeStamp is negative value
			  e.timeStamp <= 0 ||
			  // #9448 bail if event is fired in another document in a multi-page
			  // electron/nw.js app, since event.timeStamp will be using a different
			  // starting reference
			  e.target.ownerDocument !== document
		  ) {
			return original.apply(this, arguments)
		  }
		};
	  }
	  target$1.addEventListener(
		  name,
		  handler,
		  supportsPassive
			  ? { capture: capture, passive: passive }
			  : capture
	  );
	}

	function remove$2 (
		name,
		handler,
		capture,
		_target
	) {
	  (_target || target$1).removeEventListener(
		  name,
		  handler._wrapper || handler,
		  capture
	  );
	}

	function updateDOMListeners (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
		return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  normalizeEvents(on);
	  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
	  target$1 = undefined;
	}

	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};

	/*  */

	var svgContainer;

	function updateDOMProps (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
		return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(props.__ob__)) {
		props = vnode.data.domProps = extend({}, props);
	  }

	  for (key in oldProps) {
		if (!(key in props)) {
		  elm[key] = '';
		}
	  }

	  for (key in props) {
		cur = props[key];
		// ignore children if the node has textContent or innerHTML,
		// as these will throw away existing DOM nodes and cause removal errors
		// on subsequent patches (#3360)
		if (key === 'textContent' || key === 'innerHTML') {
		  if (vnode.children) { vnode.children.length = 0; }
		  if (cur === oldProps[key]) { continue }
		  // #6601 work around Chrome version <= 55 bug where single textNode
		  // replaced by innerHTML/textContent retains its parentNode property
		  if (elm.childNodes.length === 1) {
			elm.removeChild(elm.childNodes[0]);
		  }
		}

		if (key === 'value' && elm.tagName !== 'PROGRESS') {
		  // store value as _value as well since
		  // non-string values will be stringified
		  elm._value = cur;
		  // avoid resetting cursor position when value is the same
		  var strCur = isUndef(cur) ? '' : String(cur);
		  if (shouldUpdateValue(elm, strCur)) {
			elm.value = strCur;
		  }
		} else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
		  // IE doesn't support innerHTML for SVG elements
		  svgContainer = svgContainer || document.createElement('div');
		  svgContainer.innerHTML = "<svg>" + cur + "</svg>";
		  var svg = svgContainer.firstChild;
		  while (elm.firstChild) {
			elm.removeChild(elm.firstChild);
		  }
		  while (svg.firstChild) {
			elm.appendChild(svg.firstChild);
		  }
		} else if (
			// skip the update if old and new VDOM state is the same.
			// `value` is handled separately because the DOM value may be temporarily
			// out of sync with VDOM state due to focus, composition and modifiers.
			// This  #4521 by skipping the unnecessary `checked` update.
			cur !== oldProps[key]
		) {
		  // some property updates can throw
		  // e.g. `value` on <progress> w/ non-finite value
		  try {
			elm[key] = cur;
		  } catch (e) {}
		}
	  }
	}

// check platforms/web/util/attrs.js acceptValue


	function shouldUpdateValue (elm, checkVal) {
	  return (!elm.composing && (
		  elm.tagName === 'OPTION' ||
		  isNotInFocusAndDirty(elm, checkVal) ||
		  isDirtyWithModifiers(elm, checkVal)
	  ))
	}

	function isNotInFocusAndDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is
	  // not equal to the updated value
	  var notInFocus = true;
	  // #6157
	  // work around IE bug when accessing document.activeElement in an iframe
	  try { notInFocus = document.activeElement !== elm; } catch (e) {}
	  return notInFocus && elm.value !== checkVal
	}

	function isDirtyWithModifiers (elm, newVal) {
	  var value = elm.value;
	  var modifiers = elm._vModifiers; // injected by v-model runtime
	  if (isDef(modifiers)) {
		if (modifiers.number) {
		  return toNumber(value) !== toNumber(newVal)
		}
		if (modifiers.trim) {
		  return value.trim() !== newVal.trim()
		}
	  }
	  return value !== newVal
	}

	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};

	/*  */

	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
		if (item) {
		  var tmp = item.split(propertyDelimiter);
		  tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
		}
	  });
	  return res
	});

// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
		  ? extend(data.staticStyle, style)
		  : style
	}

// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
		return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
		return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}

	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;

	  if (checkChild) {
		var childNode = vnode;
		while (childNode.componentInstance) {
		  childNode = childNode.componentInstance._vnode;
		  if (
			  childNode && childNode.data &&
			  (styleData = normalizeStyleData(childNode.data))
		  ) {
			extend(res, styleData);
		  }
		}
	  }

	  if ((styleData = normalizeStyleData(vnode.data))) {
		extend(res, styleData);
	  }

	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
		if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
		  extend(res, styleData);
		}
	  }
	  return res
	}

	/*  */

	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
		el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
		el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
	  } else {
		var normalizedName = normalize(name);
		if (Array.isArray(val)) {
		  // Support values array created by autoprefixer, e.g.
		  // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
		  // Set them one by one, and the browser will only set those it can recognize
		  for (var i = 0, len = val.length; i < len; i++) {
			el.style[normalizedName] = val[i];
		  }
		} else {
		  el.style[normalizedName] = val;
		}
	  }
	};

	var vendorNames = ['Webkit', 'Moz', 'ms'];

	var emptyStyle;
	var normalize = cached(function (prop) {
	  emptyStyle = emptyStyle || document.createElement('div').style;
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in emptyStyle)) {
		return prop
	  }
	  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < vendorNames.length; i++) {
		var name = vendorNames[i] + capName;
		if (name in emptyStyle) {
		  return name
		}
	  }
	});

	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;

	  if (isUndef(data.staticStyle) && isUndef(data.style) &&
		  isUndef(oldData.staticStyle) && isUndef(oldData.style)
	  ) {
		return
	  }

	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldData.staticStyle;
	  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;

	  var style = normalizeStyleBinding(vnode.data.style) || {};

	  // store normalized style under a different key for next diff
	  // make sure to clone it if it's reactive, since the user likely wants
	  // to mutate it.
	  vnode.data.normalizedStyle = isDef(style.__ob__)
		  ? extend({}, style)
		  : style;

	  var newStyle = getStyle(vnode, true);

	  for (name in oldStyle) {
		if (isUndef(newStyle[name])) {
		  setProp(el, name, '');
		}
	  }
	  for (name in newStyle) {
		cur = newStyle[name];
		if (cur !== oldStyle[name]) {
		  // ie9 setting to null has no effect, must use empty string
		  setProp(el, name, cur == null ? '' : cur);
		}
	  }
	}

	var style = {
	  create: updateStyle,
	  update: updateStyle
	};

	/*  */

	var whitespaceRE = /\s+/;

	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
		return
	  }

	  /* istanbul ignore else */
	  if (el.classList) {
		if (cls.indexOf(' ') > -1) {
		  cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
		} else {
		  el.classList.add(cls);
		}
	  } else {
		var cur = " " + (el.getAttribute('class') || '') + " ";
		if (cur.indexOf(' ' + cls + ' ') < 0) {
		  el.setAttribute('class', (cur + cls).trim());
		}
	  }
	}

	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
		return
	  }

	  /* istanbul ignore else */
	  if (el.classList) {
		if (cls.indexOf(' ') > -1) {
		  cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
		} else {
		  el.classList.remove(cls);
		}
		if (!el.classList.length) {
		  el.removeAttribute('class');
		}
	  } else {
		var cur = " " + (el.getAttribute('class') || '') + " ";
		var tar = ' ' + cls + ' ';
		while (cur.indexOf(tar) >= 0) {
		  cur = cur.replace(tar, ' ');
		}
		cur = cur.trim();
		if (cur) {
		  el.setAttribute('class', cur);
		} else {
		  el.removeAttribute('class');
		}
	  }
	}

	/*  */

	function resolveTransition (def$$1) {
	  if (!def$$1) {
		return
	  }
	  /* istanbul ignore else */
	  if (typeof def$$1 === 'object') {
		var res = {};
		if (def$$1.css !== false) {
		  extend(res, autoCssTransition(def$$1.name || 'v'));
		}
		extend(res, def$$1);
		return res
	  } else if (typeof def$$1 === 'string') {
		return autoCssTransition(def$$1)
	  }
	}

	var autoCssTransition = cached(function (name) {
	  return {
		enterClass: (name + "-enter"),
		enterToClass: (name + "-enter-to"),
		enterActiveClass: (name + "-enter-active"),
		leaveClass: (name + "-leave"),
		leaveToClass: (name + "-leave-to"),
		leaveActiveClass: (name + "-leave-active")
	  }
	});

	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';

// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
		  window.onwebkittransitionend !== undefined
	  ) {
		transitionProp = 'WebkitTransition';
		transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
		  window.onwebkitanimationend !== undefined
	  ) {
		animationProp = 'WebkitAnimation';
		animationEndEvent = 'webkitAnimationEnd';
	  }
	}

// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser
		? window.requestAnimationFrame
			? window.requestAnimationFrame.bind(window)
			: setTimeout
		: /* istanbul ignore next */ function (fn) { return fn(); };

	function nextFrame (fn) {
	  raf(function () {
		raf(fn);
	  });
	}

	function addTransitionClass (el, cls) {
	  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
	  if (transitionClasses.indexOf(cls) < 0) {
		transitionClasses.push(cls);
		addClass(el, cls);
	  }
	}

	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
		remove(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}

	function whenTransitionEnds (
		el,
		expectedType,
		cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
		el.removeEventListener(event, onEnd);
		cb();
	  };
	  var onEnd = function (e) {
		if (e.target === el) {
		  if (++ended >= propCount) {
			end();
		  }
		}
	  };
	  setTimeout(function () {
		if (ended < propCount) {
		  end();
		}
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}

	var transformRE = /\b(transform|all)(,|$)/;

	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  // JSDOM may return undefined for transition properties
	  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
	  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
	  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
	  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);

	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
		if (transitionTimeout > 0) {
		  type = TRANSITION;
		  timeout = transitionTimeout;
		  propCount = transitionDurations.length;
		}
	  } else if (expectedType === ANIMATION) {
		if (animationTimeout > 0) {
		  type = ANIMATION;
		  timeout = animationTimeout;
		  propCount = animationDurations.length;
		}
	  } else {
		timeout = Math.max(transitionTimeout, animationTimeout);
		type = timeout > 0
			? transitionTimeout > animationTimeout
				? TRANSITION
				: ANIMATION
			: null;
		propCount = type
			? type === TRANSITION
				? transitionDurations.length
				: animationDurations.length
			: 0;
	  }
	  var hasTransform =
		  type === TRANSITION &&
		  transformRE.test(styles[transitionProp + 'Property']);
	  return {
		type: type,
		timeout: timeout,
		propCount: propCount,
		hasTransform: hasTransform
	  }
	}

	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
		delays = delays.concat(delays);
	  }

	  return Math.max.apply(null, durations.map(function (d, i) {
		return toMs(d) + toMs(delays[i])
	  }))
	}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
	function toMs (s) {
	  return Number(s.slice(0, -1).replace(',', '.')) * 1000
	}

	/*  */

	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;

	  // call leave callback now
	  if (isDef(el._leaveCb)) {
		el._leaveCb.cancelled = true;
		el._leaveCb();
	  }

	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
		return
	  }

	  /* istanbul ignore if */
	  if (isDef(el._enterCb) || el.nodeType !== 1) {
		return
	  }

	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	  var duration = data.duration;

	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
		context = transitionNode.context;
		transitionNode = transitionNode.parent;
	  }

	  var isAppear = !context._isMounted || !vnode.isRootInsert;

	  if (isAppear && !appear && appear !== '') {
		return
	  }

	  var startClass = isAppear && appearClass
		  ? appearClass
		  : enterClass;
	  var activeClass = isAppear && appearActiveClass
		  ? appearActiveClass
		  : enterActiveClass;
	  var toClass = isAppear && appearToClass
		  ? appearToClass
		  : enterToClass;

	  var beforeEnterHook = isAppear
		  ? (beforeAppear || beforeEnter)
		  : beforeEnter;
	  var enterHook = isAppear
		  ? (typeof appear === 'function' ? appear : enter)
		  : enter;
	  var afterEnterHook = isAppear
		  ? (afterAppear || afterEnter)
		  : afterEnter;
	  var enterCancelledHook = isAppear
		  ? (appearCancelled || enterCancelled)
		  : enterCancelled;

	  var explicitEnterDuration = toNumber(
		  isObject(duration)
			  ? duration.enter
			  : duration
	  );

	  if (false) {}

	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(enterHook);

	  var cb = el._enterCb = once(function () {
		if (expectsCSS) {
		  removeTransitionClass(el, toClass);
		  removeTransitionClass(el, activeClass);
		}
		if (cb.cancelled) {
		  if (expectsCSS) {
			removeTransitionClass(el, startClass);
		  }
		  enterCancelledHook && enterCancelledHook(el);
		} else {
		  afterEnterHook && afterEnterHook(el);
		}
		el._enterCb = null;
	  });

	  if (!vnode.data.show) {
		// remove pending leave element on enter by injecting an insert hook
		mergeVNodeHook(vnode, 'insert', function () {
		  var parent = el.parentNode;
		  var pendingNode = parent && parent._pending && parent._pending[vnode.key];
		  if (pendingNode &&
			  pendingNode.tag === vnode.tag &&
			  pendingNode.elm._leaveCb
		  ) {
			pendingNode.elm._leaveCb();
		  }
		  enterHook && enterHook(el, cb);
		});
	  }

	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
		addTransitionClass(el, startClass);
		addTransitionClass(el, activeClass);
		nextFrame(function () {
		  removeTransitionClass(el, startClass);
		  if (!cb.cancelled) {
			addTransitionClass(el, toClass);
			if (!userWantsControl) {
			  if (isValidDuration(explicitEnterDuration)) {
				setTimeout(cb, explicitEnterDuration);
			  } else {
				whenTransitionEnds(el, type, cb);
			  }
			}
		  }
		});
	  }

	  if (vnode.data.show) {
		toggleDisplay && toggleDisplay();
		enterHook && enterHook(el, cb);
	  }

	  if (!expectsCSS && !userWantsControl) {
		cb();
	  }
	}

	function leave (vnode, rm) {
	  var el = vnode.elm;

	  // call enter callback now
	  if (isDef(el._enterCb)) {
		el._enterCb.cancelled = true;
		el._enterCb();
	  }

	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data) || el.nodeType !== 1) {
		return rm()
	  }

	  /* istanbul ignore if */
	  if (isDef(el._leaveCb)) {
		return
	  }

	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	  var duration = data.duration;

	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(leave);

	  var explicitLeaveDuration = toNumber(
		  isObject(duration)
			  ? duration.leave
			  : duration
	  );

	  if (false) {}

	  var cb = el._leaveCb = once(function () {
		if (el.parentNode && el.parentNode._pending) {
		  el.parentNode._pending[vnode.key] = null;
		}
		if (expectsCSS) {
		  removeTransitionClass(el, leaveToClass);
		  removeTransitionClass(el, leaveActiveClass);
		}
		if (cb.cancelled) {
		  if (expectsCSS) {
			removeTransitionClass(el, leaveClass);
		  }
		  leaveCancelled && leaveCancelled(el);
		} else {
		  rm();
		  afterLeave && afterLeave(el);
		}
		el._leaveCb = null;
	  });

	  if (delayLeave) {
		delayLeave(performLeave);
	  } else {
		performLeave();
	  }

	  function performLeave () {
		// the delayed leave may have already been cancelled
		if (cb.cancelled) {
		  return
		}
		// record leaving element
		if (!vnode.data.show && el.parentNode) {
		  (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
		}
		beforeLeave && beforeLeave(el);
		if (expectsCSS) {
		  addTransitionClass(el, leaveClass);
		  addTransitionClass(el, leaveActiveClass);
		  nextFrame(function () {
			removeTransitionClass(el, leaveClass);
			if (!cb.cancelled) {
			  addTransitionClass(el, leaveToClass);
			  if (!userWantsControl) {
				if (isValidDuration(explicitLeaveDuration)) {
				  setTimeout(cb, explicitLeaveDuration);
				} else {
				  whenTransitionEnds(el, type, cb);
				}
			  }
			}
		  });
		}
		leave && leave(el, cb);
		if (!expectsCSS && !userWantsControl) {
		  cb();
		}
	  }
	}

// only used in dev mode
	function checkDuration (val, name, vnode) {
	  if (typeof val !== 'number') {
		warn(
			"<transition> explicit " + name + " duration is not a valid number - " +
			"got " + (JSON.stringify(val)) + ".",
			vnode.context
		);
	  } else if (isNaN(val)) {
		warn(
			"<transition> explicit " + name + " duration is NaN - " +
			'the duration expression might be incorrect.',
			vnode.context
		);
	  }
	}

	function isValidDuration (val) {
	  return typeof val === 'number' && !isNaN(val)
	}

	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength (fn) {
	  if (isUndef(fn)) {
		return false
	  }
	  var invokerFns = fn.fns;
	  if (isDef(invokerFns)) {
		// invoker
		return getHookArgumentsLength(
			Array.isArray(invokerFns)
				? invokerFns[0]
				: invokerFns
		)
	  } else {
		return (fn._length || fn.length) > 1
	  }
	}

	function _enter (_, vnode) {
	  if (vnode.data.show !== true) {
		enter(vnode);
	  }
	}

	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove$$1 (vnode, rm) {
		/* istanbul ignore else */
		if (vnode.data.show !== true) {
		  leave(vnode, rm);
		} else {
		  rm();
		}
	  }
	} : {};

	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];

	/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);

	var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */

	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
		var el = document.activeElement;
		if (el && el.vmodel) {
		  trigger(el, 'input');
		}
	  });
	}

	var directive = {
	  inserted: function inserted (el, binding, vnode, oldVnode) {
		if (vnode.tag === 'select') {
		  // #6903
		  if (oldVnode.elm && !oldVnode.elm._vOptions) {
			mergeVNodeHook(vnode, 'postpatch', function () {
			  directive.componentUpdated(el, binding, vnode);
			});
		  } else {
			setSelected(el, binding, vnode.context);
		  }
		  el._vOptions = [].map.call(el.options, getValue);
		} else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
		  el._vModifiers = binding.modifiers;
		  if (!binding.modifiers.lazy) {
			el.addEventListener('compositionstart', onCompositionStart);
			el.addEventListener('compositionend', onCompositionEnd);
			// Safari < 10.2 & UIWebView doesn't fire compositionend when
			// switching focus before confirming composition choice
			// this also fixes the issue where some browsers e.g. iOS Chrome
			// fires "change" instead of "input" on autocomplete.
			el.addEventListener('change', onCompositionEnd);
			/* istanbul ignore if */
			if (isIE9) {
			  el.vmodel = true;
			}
		  }
		}
	  },

	  componentUpdated: function componentUpdated (el, binding, vnode) {
		if (vnode.tag === 'select') {
		  setSelected(el, binding, vnode.context);
		  // in case the options rendered by v-for have changed,
		  // it's possible that the value is out-of-sync with the rendered options.
		  // detect such cases and filter out values that no longer has a matching
		  // option in the DOM.
		  var prevOptions = el._vOptions;
		  var curOptions = el._vOptions = [].map.call(el.options, getValue);
		  if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
			// trigger change event if
			// no matching option found for at least one value
			var needReset = el.multiple
				? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
				: binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
			if (needReset) {
			  trigger(el, 'change');
			}
		  }
		}
	  }
	};

	function setSelected (el, binding, vm) {
	  actuallySetSelected(el, binding, vm);
	  /* istanbul ignore if */
	  if (isIE || isEdge) {
		setTimeout(function () {
		  actuallySetSelected(el, binding, vm);
		}, 0);
	  }
	}

	function actuallySetSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
		false && 0;
		return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
		option = el.options[i];
		if (isMultiple) {
		  selected = looseIndexOf(value, getValue(option)) > -1;
		  if (option.selected !== selected) {
			option.selected = selected;
		  }
		} else {
		  if (looseEqual(getValue(option), value)) {
			if (el.selectedIndex !== i) {
			  el.selectedIndex = i;
			}
			return
		  }
		}
	  }
	  if (!isMultiple) {
		el.selectedIndex = -1;
	  }
	}

	function hasNoMatchingOption (value, options) {
	  return options.every(function (o) { return !looseEqual(o, value); })
	}

	function getValue (option) {
	  return '_value' in option
		  ? option._value
		  : option.value
	}

	function onCompositionStart (e) {
	  e.target.composing = true;
	}

	function onCompositionEnd (e) {
	  // prevent triggering an input event for no reason
	  if (!e.target.composing) { return }
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}

	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}

	/*  */

// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
		  ? locateNode(vnode.componentInstance._vnode)
		  : vnode
	}

	var show = {
	  bind: function bind (el, ref, vnode) {
		var value = ref.value;

		vnode = locateNode(vnode);
		var transition$$1 = vnode.data && vnode.data.transition;
		var originalDisplay = el.__vOriginalDisplay =
			el.style.display === 'none' ? '' : el.style.display;
		if (value && transition$$1) {
		  vnode.data.show = true;
		  enter(vnode, function () {
			el.style.display = originalDisplay;
		  });
		} else {
		  el.style.display = value ? originalDisplay : 'none';
		}
	  },

	  update: function update (el, ref, vnode) {
		var value = ref.value;
		var oldValue = ref.oldValue;

		/* istanbul ignore if */
		if (!value === !oldValue) { return }
		vnode = locateNode(vnode);
		var transition$$1 = vnode.data && vnode.data.transition;
		if (transition$$1) {
		  vnode.data.show = true;
		  if (value) {
			enter(vnode, function () {
			  el.style.display = el.__vOriginalDisplay;
			});
		  } else {
			leave(vnode, function () {
			  el.style.display = 'none';
			});
		  }
		} else {
		  el.style.display = value ? el.__vOriginalDisplay : 'none';
		}
	  },

	  unbind: function unbind (
		  el,
		  binding,
		  vnode,
		  oldVnode,
		  isDestroy
	  ) {
		if (!isDestroy) {
		  el.style.display = el.__vOriginalDisplay;
		}
	  }
	};

	var platformDirectives = {
	  model: directive,
	  show: show
	};

	/*  */

	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String,
	  duration: [Number, String, Object]
	};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
		return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
		return vnode
	  }
	}

	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
		data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
		data[camelize(key$1)] = listeners[key$1];
	  }
	  return data
	}

	function placeholder (h, rawChild) {
	  if (/\d-keep-alive$/.test(rawChild.tag)) {
		return h('keep-alive', {
		  props: rawChild.componentOptions.propsData
		})
	  }
	}

	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
		if (vnode.data.transition) {
		  return true
		}
	  }
	}

	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}

	var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

	var isVShowDirective = function (d) { return d.name === 'show'; };

	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,

	  render: function render (h) {
		var this$1 = this;

		var children = this.$slots.default;
		if (!children) {
		  return
		}

		// filter out text nodes (possible whitespaces)
		children = children.filter(isNotTextNode);
		/* istanbul ignore if */
		if (!children.length) {
		  return
		}

		// warn multiple elements
		if (false) {}

		var mode = this.mode;

		// warn invalid mode
		if (false
		) {}

		var rawChild = children[0];

		// if this is a component root node and the component's
		// parent container node also has transition, skip.
		if (hasParentTransition(this.$vnode)) {
		  return rawChild
		}

		// apply transition data to child
		// use getRealChild() to ignore abstract components e.g. keep-alive
		var child = getRealChild(rawChild);
		/* istanbul ignore if */
		if (!child) {
		  return rawChild
		}

		if (this._leaving) {
		  return placeholder(h, rawChild)
		}

		// ensure a key that is unique to the vnode type and to this transition
		// component instance. This key will be used to remove pending leaving nodes
		// during entering.
		var id = "__transition-" + (this._uid) + "-";
		child.key = child.key == null
			? child.isComment
				? id + 'comment'
				: id + child.tag
			: isPrimitive(child.key)
				? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
				: child.key;

		var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
		var oldRawChild = this._vnode;
		var oldChild = getRealChild(oldRawChild);

		// mark v-show
		// so that the transition module can hand over the control to the directive
		if (child.data.directives && child.data.directives.some(isVShowDirective)) {
		  child.data.show = true;
		}

		if (
			oldChild &&
			oldChild.data &&
			!isSameChild(child, oldChild) &&
			!isAsyncPlaceholder(oldChild) &&
			// #6687 component root is a comment node
			!(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
		) {
		  // replace old child transition data with fresh one
		  // important for dynamic transitions!
		  var oldData = oldChild.data.transition = extend({}, data);
		  // handle transition mode
		  if (mode === 'out-in') {
			// return placeholder node and queue update when leave finishes
			this._leaving = true;
			mergeVNodeHook(oldData, 'afterLeave', function () {
			  this$1._leaving = false;
			  this$1.$forceUpdate();
			});
			return placeholder(h, rawChild)
		  } else if (mode === 'in-out') {
			if (isAsyncPlaceholder(child)) {
			  return oldRawChild
			}
			var delayedLeave;
			var performLeave = function () { delayedLeave(); };
			mergeVNodeHook(data, 'afterEnter', performLeave);
			mergeVNodeHook(data, 'enterCancelled', performLeave);
			mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
		  }
		}

		return rawChild
	  }
	};

	/*  */

	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);

	delete props.mode;

	var TransitionGroup = {
	  props: props,

	  beforeMount: function beforeMount () {
		var this$1 = this;

		var update = this._update;
		this._update = function (vnode, hydrating) {
		  var restoreActiveInstance = setActiveInstance(this$1);
		  // force removing pass
		  this$1.__patch__(
			  this$1._vnode,
			  this$1.kept,
			  false, // hydrating
			  true // removeOnly (!important, avoids unnecessary moves)
		  );
		  this$1._vnode = this$1.kept;
		  restoreActiveInstance();
		  update.call(this$1, vnode, hydrating);
		};
	  },

	  render: function render (h) {
		var tag = this.tag || this.$vnode.data.tag || 'span';
		var map = Object.create(null);
		var prevChildren = this.prevChildren = this.children;
		var rawChildren = this.$slots.default || [];
		var children = this.children = [];
		var transitionData = extractTransitionData(this);

		for (var i = 0; i < rawChildren.length; i++) {
		  var c = rawChildren[i];
		  if (c.tag) {
			if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
			  children.push(c);
			  map[c.key] = c
			  ;(c.data || (c.data = {})).transition = transitionData;
			} else if (false) { var name, opts; }
		  }
		}

		if (prevChildren) {
		  var kept = [];
		  var removed = [];
		  for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
			var c$1 = prevChildren[i$1];
			c$1.data.transition = transitionData;
			c$1.data.pos = c$1.elm.getBoundingClientRect();
			if (map[c$1.key]) {
			  kept.push(c$1);
			} else {
			  removed.push(c$1);
			}
		  }
		  this.kept = h(tag, null, kept);
		  this.removed = removed;
		}

		return h(tag, null, children)
	  },

	  updated: function updated () {
		var children = this.prevChildren;
		var moveClass = this.moveClass || ((this.name || 'v') + '-move');
		if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
		  return
		}

		// we divide the work into three loops to avoid mixing DOM reads and writes
		// in each iteration - which helps prevent layout thrashing.
		children.forEach(callPendingCbs);
		children.forEach(recordPosition);
		children.forEach(applyTranslation);

		// force reflow to put everything in position
		// assign to this to avoid being removed in tree-shaking
		// $flow-disable-line
		this._reflow = document.body.offsetHeight;

		children.forEach(function (c) {
		  if (c.data.moved) {
			var el = c.elm;
			var s = el.style;
			addTransitionClass(el, moveClass);
			s.transform = s.WebkitTransform = s.transitionDuration = '';
			el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
			  if (e && e.target !== el) {
				return
			  }
			  if (!e || /transform$/.test(e.propertyName)) {
				el.removeEventListener(transitionEndEvent, cb);
				el._moveCb = null;
				removeTransitionClass(el, moveClass);
			  }
			});
		  }
		});
	  },

	  methods: {
		hasMove: function hasMove (el, moveClass) {
		  /* istanbul ignore if */
		  if (!hasTransition) {
			return false
		  }
		  /* istanbul ignore if */
		  if (this._hasMove) {
			return this._hasMove
		  }
		  // Detect whether an element with the move class applied has
		  // CSS transitions. Since the element may be inside an entering
		  // transition at this very moment, we make a clone of it and remove
		  // all other transition classes applied to ensure only the move class
		  // is applied.
		  var clone = el.cloneNode();
		  if (el._transitionClasses) {
			el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
		  }
		  addClass(clone, moveClass);
		  clone.style.display = 'none';
		  this.$el.appendChild(clone);
		  var info = getTransitionInfo(clone);
		  this.$el.removeChild(clone);
		  return (this._hasMove = info.hasTransform)
		}
	  }
	};

	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
		c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
		c.elm._enterCb();
	  }
	}

	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}

	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
		c.data.moved = true;
		var s = c.elm.style;
		s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
		s.transitionDuration = '0s';
	  }
	}

	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};

	/*  */

// install platform specific utils
	vue_esm_Vue.config.mustUseProp = mustUseProp;
	vue_esm_Vue.config.isReservedTag = isReservedTag;
	vue_esm_Vue.config.isReservedAttr = isReservedAttr;
	vue_esm_Vue.config.getTagNamespace = getTagNamespace;
	vue_esm_Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
	extend(vue_esm_Vue.options.directives, platformDirectives);
	extend(vue_esm_Vue.options.components, platformComponents);

// install platform patch function
	vue_esm_Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
	vue_esm_Vue.prototype.$mount = function (
		el,
		hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return mountComponent(this, el, hydrating)
	};

// devtools global hook
	/* istanbul ignore next */
	if (inBrowser) {
	  setTimeout(function () {
		if (config.devtools) {
		  if (devtools) {
			devtools.emit('init', vue_esm_Vue);
		  } else if (
			  false
		  ) {}
		}
		if (false
		) {}
	  }, 0);
	}

	/*  */

	var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

	var buildRegex = cached(function (delimiters) {
	  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
	  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
	  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
	});



	function parseText (
		text,
		delimiters
	) {
	  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
	  if (!tagRE.test(text)) {
		return
	  }
	  var tokens = [];
	  var rawTokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index, tokenValue;
	  while ((match = tagRE.exec(text))) {
		index = match.index;
		// push text token
		if (index > lastIndex) {
		  rawTokens.push(tokenValue = text.slice(lastIndex, index));
		  tokens.push(JSON.stringify(tokenValue));
		}
		// tag token
		var exp = parseFilters(match[1].trim());
		tokens.push(("_s(" + exp + ")"));
		rawTokens.push({ '@binding': exp });
		lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
		rawTokens.push(tokenValue = text.slice(lastIndex));
		tokens.push(JSON.stringify(tokenValue));
	  }
	  return {
		expression: tokens.join('+'),
		tokens: rawTokens
	  }
	}

	/*  */

	function transformNode (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticClass = getAndRemoveAttr(el, 'class');
	  if (false) { var res; }
	  if (staticClass) {
		el.staticClass = JSON.stringify(staticClass);
	  }
	  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
	  if (classBinding) {
		el.classBinding = classBinding;
	  }
	}

	function genData (el) {
	  var data = '';
	  if (el.staticClass) {
		data += "staticClass:" + (el.staticClass) + ",";
	  }
	  if (el.classBinding) {
		data += "class:" + (el.classBinding) + ",";
	  }
	  return data
	}

	var klass$1 = {
	  staticKeys: ['staticClass'],
	  transformNode: transformNode,
	  genData: genData
	};

	/*  */

	function transformNode$1 (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticStyle = getAndRemoveAttr(el, 'style');
	  if (staticStyle) {
		/* istanbul ignore if */
		if (false) { var res; }
		el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
	  }

	  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
	  if (styleBinding) {
		el.styleBinding = styleBinding;
	  }
	}

	function genData$1 (el) {
	  var data = '';
	  if (el.staticStyle) {
		data += "staticStyle:" + (el.staticStyle) + ",";
	  }
	  if (el.styleBinding) {
		data += "style:(" + (el.styleBinding) + "),";
	  }
	  return data
	}

	var style$1 = {
	  staticKeys: ['staticStyle'],
	  transformNode: transformNode$1,
	  genData: genData$1
	};

	/*  */

	var decoder;

	var he = {
	  decode: function decode (html) {
		decoder = decoder || document.createElement('div');
		decoder.innerHTML = html;
		return decoder.textContent
	  }
	};

	/*  */

	var isUnaryTag = makeMap(
		'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
		'link,meta,param,source,track,wbr'
	);

// Elements that you can, intentionally, leave open
// (and which close themselves)
	var canBeLeftOpenTag = makeMap(
		'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
	);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
	var isNonPhrasingTag = makeMap(
		'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
		'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
		'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
		'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
		'title,tr,track'
	);

	/**
	 * Not type-checking this file because it's mostly vendor code.
	 */

// Regular Expressions for parsing tags and attributes
	var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
	var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
	var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
	var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
	var startTagOpen = new RegExp(("^<" + qnameCapture));
	var startTagClose = /^\s*(\/?)>/;
	var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
	var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
	var comment = /^<!\--/;
	var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
	var isPlainTextElement = makeMap('script,style,textarea', true);
	var reCache = {};

	var decodingMap = {
	  '&lt;': '<',
	  '&gt;': '>',
	  '&quot;': '"',
	  '&amp;': '&',
	  '&#10;': '\n',
	  '&#9;': '\t',
	  '&#39;': "'"
	};
	var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
	var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
	var isIgnoreNewlineTag = makeMap('pre,textarea', true);
	var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

	function decodeAttr (value, shouldDecodeNewlines) {
	  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
	  return value.replace(re, function (match) { return decodingMap[match]; })
	}

	function parseHTML (html, options) {
	  var stack = [];
	  var expectHTML = options.expectHTML;
	  var isUnaryTag$$1 = options.isUnaryTag || no;
	  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
	  var index = 0;
	  var last, lastTag;
	  while (html) {
		last = html;
		// Make sure we're not in a plaintext content element like script/style
		if (!lastTag || !isPlainTextElement(lastTag)) {
		  var textEnd = html.indexOf('<');
		  if (textEnd === 0) {
			// Comment:
			if (comment.test(html)) {
			  var commentEnd = html.indexOf('-->');

			  if (commentEnd >= 0) {
				if (options.shouldKeepComment) {
				  options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
				}
				advance(commentEnd + 3);
				continue
			  }
			}

			// http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
			if (conditionalComment.test(html)) {
			  var conditionalEnd = html.indexOf(']>');

			  if (conditionalEnd >= 0) {
				advance(conditionalEnd + 2);
				continue
			  }
			}

			// Doctype:
			var doctypeMatch = html.match(doctype);
			if (doctypeMatch) {
			  advance(doctypeMatch[0].length);
			  continue
			}

			// End tag:
			var endTagMatch = html.match(endTag);
			if (endTagMatch) {
			  var curIndex = index;
			  advance(endTagMatch[0].length);
			  parseEndTag(endTagMatch[1], curIndex, index);
			  continue
			}

			// Start tag:
			var startTagMatch = parseStartTag();
			if (startTagMatch) {
			  handleStartTag(startTagMatch);
			  if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
				advance(1);
			  }
			  continue
			}
		  }

		  var text = (void 0), rest = (void 0), next = (void 0);
		  if (textEnd >= 0) {
			rest = html.slice(textEnd);
			while (
				!endTag.test(rest) &&
				!startTagOpen.test(rest) &&
				!comment.test(rest) &&
				!conditionalComment.test(rest)
				) {
			  // < in plain text, be forgiving and treat it as text
			  next = rest.indexOf('<', 1);
			  if (next < 0) { break }
			  textEnd += next;
			  rest = html.slice(textEnd);
			}
			text = html.substring(0, textEnd);
		  }

		  if (textEnd < 0) {
			text = html;
		  }

		  if (text) {
			advance(text.length);
		  }

		  if (options.chars && text) {
			options.chars(text, index - text.length, index);
		  }
		} else {
		  var endTagLength = 0;
		  var stackedTag = lastTag.toLowerCase();
		  var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
		  var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
			endTagLength = endTag.length;
			if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
			  text = text
				  .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
				  .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
			}
			if (shouldIgnoreFirstNewline(stackedTag, text)) {
			  text = text.slice(1);
			}
			if (options.chars) {
			  options.chars(text);
			}
			return ''
		  });
		  index += html.length - rest$1.length;
		  html = rest$1;
		  parseEndTag(stackedTag, index - endTagLength, index);
		}

		if (html === last) {
		  options.chars && options.chars(html);
		  if (false) {}
		  break
		}
	  }

	  // Clean up any remaining tags
	  parseEndTag();

	  function advance (n) {
		index += n;
		html = html.substring(n);
	  }

	  function parseStartTag () {
		var start = html.match(startTagOpen);
		if (start) {
		  var match = {
			tagName: start[1],
			attrs: [],
			start: index
		  };
		  advance(start[0].length);
		  var end, attr;
		  while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
			attr.start = index;
			advance(attr[0].length);
			attr.end = index;
			match.attrs.push(attr);
		  }
		  if (end) {
			match.unarySlash = end[1];
			advance(end[0].length);
			match.end = index;
			return match
		  }
		}
	  }

	  function handleStartTag (match) {
		var tagName = match.tagName;
		var unarySlash = match.unarySlash;

		if (expectHTML) {
		  if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
			parseEndTag(lastTag);
		  }
		  if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
			parseEndTag(tagName);
		  }
		}

		var unary = isUnaryTag$$1(tagName) || !!unarySlash;

		var l = match.attrs.length;
		var attrs = new Array(l);
		for (var i = 0; i < l; i++) {
		  var args = match.attrs[i];
		  var value = args[3] || args[4] || args[5] || '';
		  var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
			  ? options.shouldDecodeNewlinesForHref
			  : options.shouldDecodeNewlines;
		  attrs[i] = {
			name: args[1],
			value: decodeAttr(value, shouldDecodeNewlines)
		  };
		  if (false) {}
		}

		if (!unary) {
		  stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
		  lastTag = tagName;
		}

		if (options.start) {
		  options.start(tagName, attrs, unary, match.start, match.end);
		}
	  }

	  function parseEndTag (tagName, start, end) {
		var pos, lowerCasedTagName;
		if (start == null) { start = index; }
		if (end == null) { end = index; }

		// Find the closest opened tag of the same type
		if (tagName) {
		  lowerCasedTagName = tagName.toLowerCase();
		  for (pos = stack.length - 1; pos >= 0; pos--) {
			if (stack[pos].lowerCasedTag === lowerCasedTagName) {
			  break
			}
		  }
		} else {
		  // If no tag name is provided, clean shop
		  pos = 0;
		}

		if (pos >= 0) {
		  // Close all the open elements, up the stack
		  for (var i = stack.length - 1; i >= pos; i--) {
			if (false
			) {}
			if (options.end) {
			  options.end(stack[i].tag, start, end);
			}
		  }

		  // Remove the open elements from the stack
		  stack.length = pos;
		  lastTag = pos && stack[pos - 1].tag;
		} else if (lowerCasedTagName === 'br') {
		  if (options.start) {
			options.start(tagName, [], true, start, end);
		  }
		} else if (lowerCasedTagName === 'p') {
		  if (options.start) {
			options.start(tagName, [], false, start, end);
		  }
		  if (options.end) {
			options.end(tagName, start, end);
		  }
		}
	  }
	}

	/*  */

	var onRE = /^@|^v-on:/;
	var dirRE = /^v-|^@|^:|^#/;
	var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
	var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
	var stripParensRE = /^\(|\)$/g;
	var dynamicArgRE = /^\[.*\]$/;

	var argRE = /:(.*)$/;
	var bindRE = /^:|^\.|^v-bind:/;
	var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

	var slotRE = /^v-slot(:|$)|^#/;

	var lineBreakRE = /[\r\n]/;
	var whitespaceRE$1 = /[ \f\t\r\n]+/g;

	var invalidAttributeRE = /[\s"'<>\/=]/;

	var decodeHTMLCached = cached(he.decode);

	var emptySlotScopeToken = "_empty_";

// configurable state
	var warn$2;
	var delimiters;
	var transforms;
	var preTransforms;
	var postTransforms;
	var platformIsPreTag;
	var platformMustUseProp;
	var platformGetTagNamespace;
	var maybeComponent;

	function createASTElement (
		tag,
		attrs,
		parent
	) {
	  return {
		type: 1,
		tag: tag,
		attrsList: attrs,
		attrsMap: makeAttrsMap(attrs),
		rawAttrsMap: {},
		parent: parent,
		children: []
	  }
	}

	/**
	 * Convert HTML string to AST.
	 */
	function parse (
		template,
		options
	) {
	  warn$2 = options.warn || baseWarn;

	  platformIsPreTag = options.isPreTag || no;
	  platformMustUseProp = options.mustUseProp || no;
	  platformGetTagNamespace = options.getTagNamespace || no;
	  var isReservedTag = options.isReservedTag || no;
	  maybeComponent = function (el) { return !!(
		  el.component ||
		  el.attrsMap[':is'] ||
		  el.attrsMap['v-bind:is'] ||
		  !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
	  ); };
	  transforms = pluckModuleFunction(options.modules, 'transformNode');
	  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
	  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

	  delimiters = options.delimiters;

	  var stack = [];
	  var preserveWhitespace = options.preserveWhitespace !== false;
	  var whitespaceOption = options.whitespace;
	  var root;
	  var currentParent;
	  var inVPre = false;
	  var inPre = false;
	  var warned = false;

	  function warnOnce (msg, range) {
		if (!warned) {
		  warned = true;
		  warn$2(msg, range);
		}
	  }

	  function closeElement (element) {
		trimEndingWhitespace(element);
		if (!inVPre && !element.processed) {
		  element = processElement(element, options);
		}
		// tree management
		if (!stack.length && element !== root) {
		  // allow root elements with v-if, v-else-if and v-else
		  if (root.if && (element.elseif || element.else)) {
			if (false) {}
			addIfCondition(root, {
			  exp: element.elseif,
			  block: element
			});
		  } else if (false) {}
		}
		if (currentParent && !element.forbidden) {
		  if (element.elseif || element.else) {
			processIfConditions(element, currentParent);
		  } else {
			if (element.slotScope) {
			  // scoped slot
			  // keep it in the children list so that v-else(-if) conditions can
			  // find it as the prev node.
			  var name = element.slotTarget || '"default"'
			  ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
			}
			currentParent.children.push(element);
			element.parent = currentParent;
		  }
		}

		// final children cleanup
		// filter out scoped slots
		element.children = element.children.filter(function (c) { return !(c).slotScope; });
		// remove trailing whitespace node again
		trimEndingWhitespace(element);

		// check pre state
		if (element.pre) {
		  inVPre = false;
		}
		if (platformIsPreTag(element.tag)) {
		  inPre = false;
		}
		// apply post-transforms
		for (var i = 0; i < postTransforms.length; i++) {
		  postTransforms[i](element, options);
		}
	  }

	  function trimEndingWhitespace (el) {
		// remove trailing whitespace node
		if (!inPre) {
		  var lastNode;
		  while (
			  (lastNode = el.children[el.children.length - 1]) &&
			  lastNode.type === 3 &&
			  lastNode.text === ' '
			  ) {
			el.children.pop();
		  }
		}
	  }

	  function checkRootConstraints (el) {
		if (el.tag === 'slot' || el.tag === 'template') {
		  warnOnce(
			  "Cannot use <" + (el.tag) + "> as component root element because it may " +
			  'contain multiple nodes.',
			  { start: el.start }
		  );
		}
		if (el.attrsMap.hasOwnProperty('v-for')) {
		  warnOnce(
			  'Cannot use v-for on stateful component root element because ' +
			  'it renders multiple elements.',
			  el.rawAttrsMap['v-for']
		  );
		}
	  }

	  parseHTML(template, {
		warn: warn$2,
		expectHTML: options.expectHTML,
		isUnaryTag: options.isUnaryTag,
		canBeLeftOpenTag: options.canBeLeftOpenTag,
		shouldDecodeNewlines: options.shouldDecodeNewlines,
		shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
		shouldKeepComment: options.comments,
		outputSourceRange: options.outputSourceRange,
		start: function start (tag, attrs, unary, start$1, end) {
		  // check namespace.
		  // inherit parent ns if there is one
		  var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

		  // handle IE svg bug
		  /* istanbul ignore if */
		  if (isIE && ns === 'svg') {
			attrs = guardIESVGBug(attrs);
		  }

		  var element = createASTElement(tag, attrs, currentParent);
		  if (ns) {
			element.ns = ns;
		  }

		  if (false) {}

		  if (isForbiddenTag(element) && !isServerRendering()) {
			element.forbidden = true;
			false && 0;
		  }

		  // apply pre-transforms
		  for (var i = 0; i < preTransforms.length; i++) {
			element = preTransforms[i](element, options) || element;
		  }

		  if (!inVPre) {
			processPre(element);
			if (element.pre) {
			  inVPre = true;
			}
		  }
		  if (platformIsPreTag(element.tag)) {
			inPre = true;
		  }
		  if (inVPre) {
			processRawAttrs(element);
		  } else if (!element.processed) {
			// structural directives
			processFor(element);
			processIf(element);
			processOnce(element);
		  }

		  if (!root) {
			root = element;
			if (false) {}
		  }

		  if (!unary) {
			currentParent = element;
			stack.push(element);
		  } else {
			closeElement(element);
		  }
		},

		end: function end (tag, start, end$1) {
		  var element = stack[stack.length - 1];
		  // pop stack
		  stack.length -= 1;
		  currentParent = stack[stack.length - 1];
		  if (false) {}
		  closeElement(element);
		},

		chars: function chars (text, start, end) {
		  if (!currentParent) {
			if (false) {}
			return
		  }
		  // IE textarea placeholder bug
		  /* istanbul ignore if */
		  if (isIE &&
			  currentParent.tag === 'textarea' &&
			  currentParent.attrsMap.placeholder === text
		  ) {
			return
		  }
		  var children = currentParent.children;
		  if (inPre || text.trim()) {
			text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
		  } else if (!children.length) {
			// remove the whitespace-only node right after an opening tag
			text = '';
		  } else if (whitespaceOption) {
			if (whitespaceOption === 'condense') {
			  // in condense mode, remove the whitespace node if it contains
			  // line break, otherwise condense to a single space
			  text = lineBreakRE.test(text) ? '' : ' ';
			} else {
			  text = ' ';
			}
		  } else {
			text = preserveWhitespace ? ' ' : '';
		  }
		  if (text) {
			if (!inPre && whitespaceOption === 'condense') {
			  // condense consecutive whitespaces into single space
			  text = text.replace(whitespaceRE$1, ' ');
			}
			var res;
			var child;
			if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
			  child = {
				type: 2,
				expression: res.expression,
				tokens: res.tokens,
				text: text
			  };
			} else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
			  child = {
				type: 3,
				text: text
			  };
			}
			if (child) {
			  if (false) {}
			  children.push(child);
			}
		  }
		},
		comment: function comment (text, start, end) {
		  // adding anything as a sibling to the root node is forbidden
		  // comments should still be allowed, but ignored
		  if (currentParent) {
			var child = {
			  type: 3,
			  text: text,
			  isComment: true
			};
			if (false) {}
			currentParent.children.push(child);
		  }
		}
	  });
	  return root
	}

	function processPre (el) {
	  if (getAndRemoveAttr(el, 'v-pre') != null) {
		el.pre = true;
	  }
	}

	function processRawAttrs (el) {
	  var list = el.attrsList;
	  var len = list.length;
	  if (len) {
		var attrs = el.attrs = new Array(len);
		for (var i = 0; i < len; i++) {
		  attrs[i] = {
			name: list[i].name,
			value: JSON.stringify(list[i].value)
		  };
		  if (list[i].start != null) {
			attrs[i].start = list[i].start;
			attrs[i].end = list[i].end;
		  }
		}
	  } else if (!el.pre) {
		// non root node in pre blocks with no attributes
		el.plain = true;
	  }
	}

	function processElement (
		element,
		options
	) {
	  processKey(element);

	  // determine whether this is a plain element after
	  // removing structural attributes
	  element.plain = (
		  !element.key &&
		  !element.scopedSlots &&
		  !element.attrsList.length
	  );

	  processRef(element);
	  processSlotContent(element);
	  processSlotOutlet(element);
	  processComponent(element);
	  for (var i = 0; i < transforms.length; i++) {
		element = transforms[i](element, options) || element;
	  }
	  processAttrs(element);
	  return element
	}

	function processKey (el) {
	  var exp = getBindingAttr(el, 'key');
	  if (exp) {
		if (false) { var parent, iterator; }
		el.key = exp;
	  }
	}

	function processRef (el) {
	  var ref = getBindingAttr(el, 'ref');
	  if (ref) {
		el.ref = ref;
		el.refInFor = checkInFor(el);
	  }
	}

	function processFor (el) {
	  var exp;
	  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
		var res = parseFor(exp);
		if (res) {
		  extend(el, res);
		} else if (false) {}
	  }
	}



	function parseFor (exp) {
	  var inMatch = exp.match(forAliasRE);
	  if (!inMatch) { return }
	  var res = {};
	  res.for = inMatch[2].trim();
	  var alias = inMatch[1].trim().replace(stripParensRE, '');
	  var iteratorMatch = alias.match(forIteratorRE);
	  if (iteratorMatch) {
		res.alias = alias.replace(forIteratorRE, '').trim();
		res.iterator1 = iteratorMatch[1].trim();
		if (iteratorMatch[2]) {
		  res.iterator2 = iteratorMatch[2].trim();
		}
	  } else {
		res.alias = alias;
	  }
	  return res
	}

	function processIf (el) {
	  var exp = getAndRemoveAttr(el, 'v-if');
	  if (exp) {
		el.if = exp;
		addIfCondition(el, {
		  exp: exp,
		  block: el
		});
	  } else {
		if (getAndRemoveAttr(el, 'v-else') != null) {
		  el.else = true;
		}
		var elseif = getAndRemoveAttr(el, 'v-else-if');
		if (elseif) {
		  el.elseif = elseif;
		}
	  }
	}

	function processIfConditions (el, parent) {
	  var prev = findPrevElement(parent.children);
	  if (prev && prev.if) {
		addIfCondition(prev, {
		  exp: el.elseif,
		  block: el
		});
	  } else if (false) {}
	}

	function findPrevElement (children) {
	  var i = children.length;
	  while (i--) {
		if (children[i].type === 1) {
		  return children[i]
		} else {
		  if (false) {}
		  children.pop();
		}
	  }
	}

	function addIfCondition (el, condition) {
	  if (!el.ifConditions) {
		el.ifConditions = [];
	  }
	  el.ifConditions.push(condition);
	}

	function processOnce (el) {
	  var once$$1 = getAndRemoveAttr(el, 'v-once');
	  if (once$$1 != null) {
		el.once = true;
	  }
	}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
	function processSlotContent (el) {
	  var slotScope;
	  if (el.tag === 'template') {
		slotScope = getAndRemoveAttr(el, 'scope');
		/* istanbul ignore if */
		if (false) {}
		el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
	  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
		/* istanbul ignore if */
		if (false) {}
		el.slotScope = slotScope;
	  }

	  // slot="xxx"
	  var slotTarget = getBindingAttr(el, 'slot');
	  if (slotTarget) {
		el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
		el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
		// preserve slot as an attribute for native shadow DOM compat
		// only for non-scoped slots.
		if (el.tag !== 'template' && !el.slotScope) {
		  addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
		}
	  }

	  // 2.6 v-slot syntax
	  {
		if (el.tag === 'template') {
		  // v-slot on <template>
		  var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
		  if (slotBinding) {
			if (false) {}
			var ref = getSlotName(slotBinding);
			var name = ref.name;
			var dynamic = ref.dynamic;
			el.slotTarget = name;
			el.slotTargetDynamic = dynamic;
			el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
		  }
		} else {
		  // v-slot on component, denotes default slot
		  var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
		  if (slotBinding$1) {
			if (false) {}
			// add the component's children to its default slot
			var slots = el.scopedSlots || (el.scopedSlots = {});
			var ref$1 = getSlotName(slotBinding$1);
			var name$1 = ref$1.name;
			var dynamic$1 = ref$1.dynamic;
			var slotContainer = slots[name$1] = createASTElement('template', [], el);
			slotContainer.slotTarget = name$1;
			slotContainer.slotTargetDynamic = dynamic$1;
			slotContainer.children = el.children.filter(function (c) {
			  if (!c.slotScope) {
				c.parent = slotContainer;
				return true
			  }
			});
			slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
			// remove children as they are returned from scopedSlots now
			el.children = [];
			// mark el non-plain so data gets generated
			el.plain = false;
		  }
		}
	  }
	}

	function getSlotName (binding) {
	  var name = binding.name.replace(slotRE, '');
	  if (!name) {
		if (binding.name[0] !== '#') {
		  name = 'default';
		} else if (false) {}
	  }
	  return dynamicArgRE.test(name)
		  // dynamic [name]
		  ? { name: name.slice(1, -1), dynamic: true }
		  // static name
		  : { name: ("\"" + name + "\""), dynamic: false }
	}

// handle <slot/> outlets
	function processSlotOutlet (el) {
	  if (el.tag === 'slot') {
		el.slotName = getBindingAttr(el, 'name');
		if (false) {}
	  }
	}

	function processComponent (el) {
	  var binding;
	  if ((binding = getBindingAttr(el, 'is'))) {
		el.component = binding;
	  }
	  if (getAndRemoveAttr(el, 'inline-template') != null) {
		el.inlineTemplate = true;
	  }
	}

	function processAttrs (el) {
	  var list = el.attrsList;
	  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
	  for (i = 0, l = list.length; i < l; i++) {
		name = rawName = list[i].name;
		value = list[i].value;
		if (dirRE.test(name)) {
		  // mark element as dynamic
		  el.hasBindings = true;
		  // modifiers
		  modifiers = parseModifiers(name.replace(dirRE, ''));
		  // support .foo shorthand syntax for the .prop modifier
		  if (modifiers) {
			name = name.replace(modifierRE, '');
		  }
		  if (bindRE.test(name)) { // v-bind
			name = name.replace(bindRE, '');
			value = parseFilters(value);
			isDynamic = dynamicArgRE.test(name);
			if (isDynamic) {
			  name = name.slice(1, -1);
			}
			if (
				false
			) {}
			if (modifiers) {
			  if (modifiers.prop && !isDynamic) {
				name = camelize(name);
				if (name === 'innerHtml') { name = 'innerHTML'; }
			  }
			  if (modifiers.camel && !isDynamic) {
				name = camelize(name);
			  }
			  if (modifiers.sync) {
				syncGen = genAssignmentCode(value, "$event");
				if (!isDynamic) {
				  addHandler(
					  el,
					  ("update:" + (camelize(name))),
					  syncGen,
					  null,
					  false,
					  warn$2,
					  list[i]
				  );
				  if (hyphenate(name) !== camelize(name)) {
					addHandler(
						el,
						("update:" + (hyphenate(name))),
						syncGen,
						null,
						false,
						warn$2,
						list[i]
					);
				  }
				} else {
				  // handler w/ dynamic event name
				  addHandler(
					  el,
					  ("\"update:\"+(" + name + ")"),
					  syncGen,
					  null,
					  false,
					  warn$2,
					  list[i],
					  true // dynamic
				  );
				}
			  }
			}
			if ((modifiers && modifiers.prop) || (
				!el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
			)) {
			  addProp(el, name, value, list[i], isDynamic);
			} else {
			  addAttr(el, name, value, list[i], isDynamic);
			}
		  } else if (onRE.test(name)) { // v-on
			name = name.replace(onRE, '');
			isDynamic = dynamicArgRE.test(name);
			if (isDynamic) {
			  name = name.slice(1, -1);
			}
			addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
		  } else { // normal directives
			name = name.replace(dirRE, '');
			// parse arg
			var argMatch = name.match(argRE);
			var arg = argMatch && argMatch[1];
			isDynamic = false;
			if (arg) {
			  name = name.slice(0, -(arg.length + 1));
			  if (dynamicArgRE.test(arg)) {
				arg = arg.slice(1, -1);
				isDynamic = true;
			  }
			}
			addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
			if (false) {}
		  }
		} else {
		  // literal attribute
		  if (false) { var res; }
		  addAttr(el, name, JSON.stringify(value), list[i]);
		  // #6887 firefox doesn't update muted state if set via attribute
		  // even immediately after element creation
		  if (!el.component &&
			  name === 'muted' &&
			  platformMustUseProp(el.tag, el.attrsMap.type, name)) {
			addProp(el, name, 'true', list[i]);
		  }
		}
	  }
	}

	function checkInFor (el) {
	  var parent = el;
	  while (parent) {
		if (parent.for !== undefined) {
		  return true
		}
		parent = parent.parent;
	  }
	  return false
	}

	function parseModifiers (name) {
	  var match = name.match(modifierRE);
	  if (match) {
		var ret = {};
		match.forEach(function (m) { ret[m.slice(1)] = true; });
		return ret
	  }
	}

	function makeAttrsMap (attrs) {
	  var map = {};
	  for (var i = 0, l = attrs.length; i < l; i++) {
		if (
			false
		) {}
		map[attrs[i].name] = attrs[i].value;
	  }
	  return map
	}

// for script (e.g. type="x/template") or style, do not decode content
	function isTextTag (el) {
	  return el.tag === 'script' || el.tag === 'style'
	}

	function isForbiddenTag (el) {
	  return (
		  el.tag === 'style' ||
		  (el.tag === 'script' && (
			  !el.attrsMap.type ||
			  el.attrsMap.type === 'text/javascript'
		  ))
	  )
	}

	var ieNSBug = /^xmlns:NS\d+/;
	var ieNSPrefix = /^NS\d+:/;

	/* istanbul ignore next */
	function guardIESVGBug (attrs) {
	  var res = [];
	  for (var i = 0; i < attrs.length; i++) {
		var attr = attrs[i];
		if (!ieNSBug.test(attr.name)) {
		  attr.name = attr.name.replace(ieNSPrefix, '');
		  res.push(attr);
		}
	  }
	  return res
	}

	function checkForAliasModel (el, value) {
	  var _el = el;
	  while (_el) {
		if (_el.for && _el.alias === value) {
		  warn$2(
			  "<" + (el.tag) + " v-model=\"" + value + "\">: " +
			  "You are binding v-model directly to a v-for iteration alias. " +
			  "This will not be able to modify the v-for source array because " +
			  "writing to the alias is like modifying a function local variable. " +
			  "Consider using an array of objects and use v-model on an object property instead.",
			  el.rawAttrsMap['v-model']
		  );
		}
		_el = _el.parent;
	  }
	}

	/*  */

	function preTransformNode (el, options) {
	  if (el.tag === 'input') {
		var map = el.attrsMap;
		if (!map['v-model']) {
		  return
		}

		var typeBinding;
		if (map[':type'] || map['v-bind:type']) {
		  typeBinding = getBindingAttr(el, 'type');
		}
		if (!map.type && !typeBinding && map['v-bind']) {
		  typeBinding = "(" + (map['v-bind']) + ").type";
		}

		if (typeBinding) {
		  var ifCondition = getAndRemoveAttr(el, 'v-if', true);
		  var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
		  var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
		  var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
		  // 1. checkbox
		  var branch0 = cloneASTElement(el);
		  // process for on the main node
		  processFor(branch0);
		  addRawAttr(branch0, 'type', 'checkbox');
		  processElement(branch0, options);
		  branch0.processed = true; // prevent it from double-processed
		  branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
		  addIfCondition(branch0, {
			exp: branch0.if,
			block: branch0
		  });
		  // 2. add radio else-if condition
		  var branch1 = cloneASTElement(el);
		  getAndRemoveAttr(branch1, 'v-for', true);
		  addRawAttr(branch1, 'type', 'radio');
		  processElement(branch1, options);
		  addIfCondition(branch0, {
			exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
			block: branch1
		  });
		  // 3. other
		  var branch2 = cloneASTElement(el);
		  getAndRemoveAttr(branch2, 'v-for', true);
		  addRawAttr(branch2, ':type', typeBinding);
		  processElement(branch2, options);
		  addIfCondition(branch0, {
			exp: ifCondition,
			block: branch2
		  });

		  if (hasElse) {
			branch0.else = true;
		  } else if (elseIfCondition) {
			branch0.elseif = elseIfCondition;
		  }

		  return branch0
		}
	  }
	}

	function cloneASTElement (el) {
	  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
	}

	var model$1 = {
	  preTransformNode: preTransformNode
	};

	var modules$1 = [
	  klass$1,
	  style$1,
	  model$1
	];

	/*  */

	function vue_esm_text (el, dir) {
	  if (dir.value) {
		addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
	  }
	}

	/*  */

	function html (el, dir) {
	  if (dir.value) {
		addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
	  }
	}

	var directives$1 = {
	  model: model,
	  text: vue_esm_text,
	  html: html
	};

	/*  */

	var baseOptions = {
	  expectHTML: true,
	  modules: modules$1,
	  directives: directives$1,
	  isPreTag: isPreTag,
	  isUnaryTag: isUnaryTag,
	  mustUseProp: mustUseProp,
	  canBeLeftOpenTag: canBeLeftOpenTag,
	  isReservedTag: isReservedTag,
	  getTagNamespace: getTagNamespace,
	  staticKeys: genStaticKeys(modules$1)
	};

	/*  */

	var isStaticKey;
	var isPlatformReservedTag;

	var genStaticKeysCached = cached(genStaticKeys$1);

	/**
	 * Goal of the optimizer: walk the generated template AST tree
	 * and detect sub-trees that are purely static, i.e. parts of
	 * the DOM that never needs to change.
	 *
	 * Once we detect these sub-trees, we can:
	 *
	 * 1. Hoist them into constants, so that we no longer need to
	 *    create fresh nodes for them on each re-render;
	 * 2. Completely skip them in the patching process.
	 */
	function optimize (root, options) {
	  if (!root) { return }
	  isStaticKey = genStaticKeysCached(options.staticKeys || '');
	  isPlatformReservedTag = options.isReservedTag || no;
	  // first pass: mark all non-static nodes.
	  markStatic$1(root);
	  // second pass: mark static roots.
	  markStaticRoots(root, false);
	}

	function genStaticKeys$1 (keys) {
	  return makeMap(
		  'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
		  (keys ? ',' + keys : '')
	  )
	}

	function markStatic$1 (node) {
	  node.static = isStatic(node);
	  if (node.type === 1) {
		// do not make component slot content static. this avoids
		// 1. components not able to mutate slot nodes
		// 2. static slot content fails for hot-reloading
		if (
			!isPlatformReservedTag(node.tag) &&
			node.tag !== 'slot' &&
			node.attrsMap['inline-template'] == null
		) {
		  return
		}
		for (var i = 0, l = node.children.length; i < l; i++) {
		  var child = node.children[i];
		  markStatic$1(child);
		  if (!child.static) {
			node.static = false;
		  }
		}
		if (node.ifConditions) {
		  for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
			var block = node.ifConditions[i$1].block;
			markStatic$1(block);
			if (!block.static) {
			  node.static = false;
			}
		  }
		}
	  }
	}

	function markStaticRoots (node, isInFor) {
	  if (node.type === 1) {
		if (node.static || node.once) {
		  node.staticInFor = isInFor;
		}
		// For a node to qualify as a static root, it should have children that
		// are not just static text. Otherwise the cost of hoisting out will
		// outweigh the benefits and it's better off to just always render it fresh.
		if (node.static && node.children.length && !(
			node.children.length === 1 &&
			node.children[0].type === 3
		)) {
		  node.staticRoot = true;
		  return
		} else {
		  node.staticRoot = false;
		}
		if (node.children) {
		  for (var i = 0, l = node.children.length; i < l; i++) {
			markStaticRoots(node.children[i], isInFor || !!node.for);
		  }
		}
		if (node.ifConditions) {
		  for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
			markStaticRoots(node.ifConditions[i$1].block, isInFor);
		  }
		}
	  }
	}

	function isStatic (node) {
	  if (node.type === 2) { // expression
		return false
	  }
	  if (node.type === 3) { // text
		return true
	  }
	  return !!(node.pre || (
		  !node.hasBindings && // no dynamic bindings
		  !node.if && !node.for && // not v-if or v-for or v-else
		  !isBuiltInTag(node.tag) && // not a built-in
		  isPlatformReservedTag(node.tag) && // not a component
		  !isDirectChildOfTemplateFor(node) &&
		  Object.keys(node).every(isStaticKey)
	  ))
	}

	function isDirectChildOfTemplateFor (node) {
	  while (node.parent) {
		node = node.parent;
		if (node.tag !== 'template') {
		  return false
		}
		if (node.for) {
		  return true
		}
	  }
	  return false
	}

	/*  */

	var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
	var fnInvokeRE = /\([^)]*?\);*$/;
	var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40,
	  'delete': [8, 46]
	};

// KeyboardEvent.key aliases
	var keyNames = {
	  // #7880: IE11 and Edge use `Esc` for Escape key name.
	  esc: ['Esc', 'Escape'],
	  tab: 'Tab',
	  enter: 'Enter',
	  // #9112: IE11 uses `Spacebar` for Space key name.
	  space: [' ', 'Spacebar'],
	  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
	  up: ['Up', 'ArrowUp'],
	  left: ['Left', 'ArrowLeft'],
	  right: ['Right', 'ArrowRight'],
	  down: ['Down', 'ArrowDown'],
	  // #9112: IE11 uses `Del` for Delete key name.
	  'delete': ['Backspace', 'Delete', 'Del']
	};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
	var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

	var modifierCode = {
	  stop: '$event.stopPropagation();',
	  prevent: '$event.preventDefault();',
	  self: genGuard("$event.target !== $event.currentTarget"),
	  ctrl: genGuard("!$event.ctrlKey"),
	  shift: genGuard("!$event.shiftKey"),
	  alt: genGuard("!$event.altKey"),
	  meta: genGuard("!$event.metaKey"),
	  left: genGuard("'button' in $event && $event.button !== 0"),
	  middle: genGuard("'button' in $event && $event.button !== 1"),
	  right: genGuard("'button' in $event && $event.button !== 2")
	};

	function genHandlers (
		events,
		isNative
	) {
	  var prefix = isNative ? 'nativeOn:' : 'on:';
	  var staticHandlers = "";
	  var dynamicHandlers = "";
	  for (var name in events) {
		var handlerCode = genHandler(events[name]);
		if (events[name] && events[name].dynamic) {
		  dynamicHandlers += name + "," + handlerCode + ",";
		} else {
		  staticHandlers += "\"" + name + "\":" + handlerCode + ",";
		}
	  }
	  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
	  if (dynamicHandlers) {
		return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
	  } else {
		return prefix + staticHandlers
	  }
	}

	function genHandler (handler) {
	  if (!handler) {
		return 'function(){}'
	  }

	  if (Array.isArray(handler)) {
		return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
	  }

	  var isMethodPath = simplePathRE.test(handler.value);
	  var isFunctionExpression = fnExpRE.test(handler.value);
	  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

	  if (!handler.modifiers) {
		if (isMethodPath || isFunctionExpression) {
		  return handler.value
		}
		return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
	  } else {
		var code = '';
		var genModifierCode = '';
		var keys = [];
		for (var key in handler.modifiers) {
		  if (modifierCode[key]) {
			genModifierCode += modifierCode[key];
			// left/right
			if (keyCodes[key]) {
			  keys.push(key);
			}
		  } else if (key === 'exact') {
			var modifiers = (handler.modifiers);
			genModifierCode += genGuard(
				['ctrl', 'shift', 'alt', 'meta']
					.filter(function (keyModifier) { return !modifiers[keyModifier]; })
					.map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
					.join('||')
			);
		  } else {
			keys.push(key);
		  }
		}
		if (keys.length) {
		  code += genKeyFilter(keys);
		}
		// Make sure modifiers like prevent and stop get executed after key filtering
		if (genModifierCode) {
		  code += genModifierCode;
		}
		var handlerCode = isMethodPath
			? ("return " + (handler.value) + ".apply(null, arguments)")
			: isFunctionExpression
				? ("return (" + (handler.value) + ").apply(null, arguments)")
				: isFunctionInvocation
					? ("return " + (handler.value))
					: handler.value;
		return ("function($event){" + code + handlerCode + "}")
	  }
	}

	function genKeyFilter (keys) {
	  return (
		  // make sure the key filters only apply to KeyboardEvents
		  // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
		  // key events that do not have keyCode property...
		  "if(!$event.type.indexOf('key')&&" +
		  (keys.map(genFilterCode).join('&&')) + ")return null;"
	  )
	}

	function genFilterCode (key) {
	  var keyVal = parseInt(key, 10);
	  if (keyVal) {
		return ("$event.keyCode!==" + keyVal)
	  }
	  var keyCode = keyCodes[key];
	  var keyName = keyNames[key];
	  return (
		  "_k($event.keyCode," +
		  (JSON.stringify(key)) + "," +
		  (JSON.stringify(keyCode)) + "," +
		  "$event.key," +
		  "" + (JSON.stringify(keyName)) +
		  ")"
	  )
	}

	/*  */

	function on (el, dir) {
	  if (false) {}
	  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
	}

	/*  */

	function bind$1 (el, dir) {
	  el.wrapData = function (code) {
		return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
	  };
	}

	/*  */

	var baseDirectives = {
	  on: on,
	  bind: bind$1,
	  cloak: noop
	};

	/*  */





	var CodegenState = function CodegenState (options) {
	  this.options = options;
	  this.warn = options.warn || baseWarn;
	  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
	  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
	  this.directives = extend(extend({}, baseDirectives), options.directives);
	  var isReservedTag = options.isReservedTag || no;
	  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
	  this.onceId = 0;
	  this.staticRenderFns = [];
	  this.pre = false;
	};



	function generate (
		ast,
		options
	) {
	  var state = new CodegenState(options);
	  // fix #11483, Root level <script> tags should not be rendered.
	  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
	  return {
		render: ("with(this){return " + code + "}"),
		staticRenderFns: state.staticRenderFns
	  }
	}

	function genElement (el, state) {
	  if (el.parent) {
		el.pre = el.pre || el.parent.pre;
	  }

	  if (el.staticRoot && !el.staticProcessed) {
		return genStatic(el, state)
	  } else if (el.once && !el.onceProcessed) {
		return genOnce(el, state)
	  } else if (el.for && !el.forProcessed) {
		return genFor(el, state)
	  } else if (el.if && !el.ifProcessed) {
		return genIf(el, state)
	  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
		return genChildren(el, state) || 'void 0'
	  } else if (el.tag === 'slot') {
		return genSlot(el, state)
	  } else {
		// component or element
		var code;
		if (el.component) {
		  code = genComponent(el.component, el, state);
		} else {
		  var data;
		  if (!el.plain || (el.pre && state.maybeComponent(el))) {
			data = genData$2(el, state);
		  }

		  var children = el.inlineTemplate ? null : genChildren(el, state, true);
		  code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
		}
		// module transforms
		for (var i = 0; i < state.transforms.length; i++) {
		  code = state.transforms[i](el, code);
		}
		return code
	  }
	}

// hoist static sub-trees out
	function genStatic (el, state) {
	  el.staticProcessed = true;
	  // Some elements (templates) need to behave differently inside of a v-pre
	  // node.  All pre nodes are static roots, so we can use this as a location to
	  // wrap a state change and reset it upon exiting the pre node.
	  var originalPreState = state.pre;
	  if (el.pre) {
		state.pre = el.pre;
	  }
	  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
	  state.pre = originalPreState;
	  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
	}

// v-once
	function genOnce (el, state) {
	  el.onceProcessed = true;
	  if (el.if && !el.ifProcessed) {
		return genIf(el, state)
	  } else if (el.staticInFor) {
		var key = '';
		var parent = el.parent;
		while (parent) {
		  if (parent.for) {
			key = parent.key;
			break
		  }
		  parent = parent.parent;
		}
		if (!key) {
		  false && 0;
		  return genElement(el, state)
		}
		return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
	  } else {
		return genStatic(el, state)
	  }
	}

	function genIf (
		el,
		state,
		altGen,
		altEmpty
	) {
	  el.ifProcessed = true; // avoid recursion
	  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
	}

	function genIfConditions (
		conditions,
		state,
		altGen,
		altEmpty
	) {
	  if (!conditions.length) {
		return altEmpty || '_e()'
	  }

	  var condition = conditions.shift();
	  if (condition.exp) {
		return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
	  } else {
		return ("" + (genTernaryExp(condition.block)))
	  }

	  // v-if with v-once should generate code like (a)?_m(0):_m(1)
	  function genTernaryExp (el) {
		return altGen
			? altGen(el, state)
			: el.once
				? genOnce(el, state)
				: genElement(el, state)
	  }
	}

	function genFor (
		el,
		state,
		altGen,
		altHelper
	) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

	  if (false
	  ) {}

	  el.forProcessed = true; // avoid recursion
	  return (altHelper || '_l') + "((" + exp + ")," +
		  "function(" + alias + iterator1 + iterator2 + "){" +
		  "return " + ((altGen || genElement)(el, state)) +
		  '})'
	}

	function genData$2 (el, state) {
	  var data = '{';

	  // directives first.
	  // directives may mutate the el's other properties before they are generated.
	  var dirs = genDirectives(el, state);
	  if (dirs) { data += dirs + ','; }

	  // key
	  if (el.key) {
		data += "key:" + (el.key) + ",";
	  }
	  // ref
	  if (el.ref) {
		data += "ref:" + (el.ref) + ",";
	  }
	  if (el.refInFor) {
		data += "refInFor:true,";
	  }
	  // pre
	  if (el.pre) {
		data += "pre:true,";
	  }
	  // record original tag name for components using "is" attribute
	  if (el.component) {
		data += "tag:\"" + (el.tag) + "\",";
	  }
	  // module data generation functions
	  for (var i = 0; i < state.dataGenFns.length; i++) {
		data += state.dataGenFns[i](el);
	  }
	  // attributes
	  if (el.attrs) {
		data += "attrs:" + (genProps(el.attrs)) + ",";
	  }
	  // DOM props
	  if (el.props) {
		data += "domProps:" + (genProps(el.props)) + ",";
	  }
	  // event handlers
	  if (el.events) {
		data += (genHandlers(el.events, false)) + ",";
	  }
	  if (el.nativeEvents) {
		data += (genHandlers(el.nativeEvents, true)) + ",";
	  }
	  // slot target
	  // only for non-scoped slots
	  if (el.slotTarget && !el.slotScope) {
		data += "slot:" + (el.slotTarget) + ",";
	  }
	  // scoped slots
	  if (el.scopedSlots) {
		data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
	  }
	  // component v-model
	  if (el.model) {
		data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
	  }
	  // inline-template
	  if (el.inlineTemplate) {
		var inlineTemplate = genInlineTemplate(el, state);
		if (inlineTemplate) {
		  data += inlineTemplate + ",";
		}
	  }
	  data = data.replace(/,$/, '') + '}';
	  // v-bind dynamic argument wrap
	  // v-bind with dynamic arguments must be applied using the same v-bind object
	  // merge helper so that class/style/mustUseProp attrs are handled correctly.
	  if (el.dynamicAttrs) {
		data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
	  }
	  // v-bind data wrap
	  if (el.wrapData) {
		data = el.wrapData(data);
	  }
	  // v-on data wrap
	  if (el.wrapListeners) {
		data = el.wrapListeners(data);
	  }
	  return data
	}

	function genDirectives (el, state) {
	  var dirs = el.directives;
	  if (!dirs) { return }
	  var res = 'directives:[';
	  var hasRuntime = false;
	  var i, l, dir, needRuntime;
	  for (i = 0, l = dirs.length; i < l; i++) {
		dir = dirs[i];
		needRuntime = true;
		var gen = state.directives[dir.name];
		if (gen) {
		  // compile-time directive that manipulates AST.
		  // returns true if it also needs a runtime counterpart.
		  needRuntime = !!gen(el, dir, state.warn);
		}
		if (needRuntime) {
		  hasRuntime = true;
		  res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
		}
	  }
	  if (hasRuntime) {
		return res.slice(0, -1) + ']'
	  }
	}

	function genInlineTemplate (el, state) {
	  var ast = el.children[0];
	  if (false) {}
	  if (ast && ast.type === 1) {
		var inlineRenderFns = generate(ast, state.options);
		return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
	  }
	}

	function genScopedSlots (
		el,
		slots,
		state
	) {
	  // by default scoped slots are considered "stable", this allows child
	  // components with only scoped slots to skip forced updates from parent.
	  // but in some cases we have to bail-out of this optimization
	  // for example if the slot contains dynamic names, has v-if or v-for on them...
	  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
		var slot = slots[key];
		return (
			slot.slotTargetDynamic ||
			slot.if ||
			slot.for ||
			containsSlotChild(slot) // is passing down slot from parent which may be dynamic
		)
	  });

	  // #9534: if a component with scoped slots is inside a conditional branch,
	  // it's possible for the same component to be reused but with different
	  // compiled slot content. To avoid that, we generate a unique key based on
	  // the generated code of all the slot contents.
	  var needsKey = !!el.if;

	  // OR when it is inside another scoped slot or v-for (the reactivity may be
	  // disconnected due to the intermediate scope variable)
	  // #9438, #9506
	  // TODO: this can be further optimized by properly analyzing in-scope bindings
	  // and skip force updating ones that do not actually use scope variables.
	  if (!needsForceUpdate) {
		var parent = el.parent;
		while (parent) {
		  if (
			  (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
			  parent.for
		  ) {
			needsForceUpdate = true;
			break
		  }
		  if (parent.if) {
			needsKey = true;
		  }
		  parent = parent.parent;
		}
	  }

	  var generatedSlots = Object.keys(slots)
		  .map(function (key) { return genScopedSlot(slots[key], state); })
		  .join(',');

	  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
	}

	function hash(str) {
	  var hash = 5381;
	  var i = str.length;
	  while(i) {
		hash = (hash * 33) ^ str.charCodeAt(--i);
	  }
	  return hash >>> 0
	}

	function containsSlotChild (el) {
	  if (el.type === 1) {
		if (el.tag === 'slot') {
		  return true
		}
		return el.children.some(containsSlotChild)
	  }
	  return false
	}

	function genScopedSlot (
		el,
		state
	) {
	  var isLegacySyntax = el.attrsMap['slot-scope'];
	  if (el.if && !el.ifProcessed && !isLegacySyntax) {
		return genIf(el, state, genScopedSlot, "null")
	  }
	  if (el.for && !el.forProcessed) {
		return genFor(el, state, genScopedSlot)
	  }
	  var slotScope = el.slotScope === emptySlotScopeToken
		  ? ""
		  : String(el.slotScope);
	  var fn = "function(" + slotScope + "){" +
		  "return " + (el.tag === 'template'
			  ? el.if && isLegacySyntax
				  ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
				  : genChildren(el, state) || 'undefined'
			  : genElement(el, state)) + "}";
	  // reverse proxy v-slot without scope on this.$slots
	  var reverseProxy = slotScope ? "" : ",proxy:true";
	  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
	}

	function genChildren (
		el,
		state,
		checkSkip,
		altGenElement,
		altGenNode
	) {
	  var children = el.children;
	  if (children.length) {
		var el$1 = children[0];
		// optimize single v-for
		if (children.length === 1 &&
			el$1.for &&
			el$1.tag !== 'template' &&
			el$1.tag !== 'slot'
		) {
		  var normalizationType = checkSkip
			  ? state.maybeComponent(el$1) ? ",1" : ",0"
			  : "";
		  return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
		}
		var normalizationType$1 = checkSkip
			? getNormalizationType(children, state.maybeComponent)
			: 0;
		var gen = altGenNode || genNode;
		return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
	  }
	}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
	function getNormalizationType (
		children,
		maybeComponent
	) {
	  var res = 0;
	  for (var i = 0; i < children.length; i++) {
		var el = children[i];
		if (el.type !== 1) {
		  continue
		}
		if (needsNormalization(el) ||
			(el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
		  res = 2;
		  break
		}
		if (maybeComponent(el) ||
			(el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
		  res = 1;
		}
	  }
	  return res
	}

	function needsNormalization (el) {
	  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
	}

	function genNode (node, state) {
	  if (node.type === 1) {
		return genElement(node, state)
	  } else if (node.type === 3 && node.isComment) {
		return genComment(node)
	  } else {
		return genText(node)
	  }
	}

	function genText (text) {
	  return ("_v(" + (text.type === 2
		  ? text.expression // no need for () because already wrapped in _s()
		  : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
	}

	function genComment (comment) {
	  return ("_e(" + (JSON.stringify(comment.text)) + ")")
	}

	function genSlot (el, state) {
	  var slotName = el.slotName || '"default"';
	  var children = genChildren(el, state);
	  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
	  var attrs = el.attrs || el.dynamicAttrs
		  ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
			// slot props are camelized
			name: camelize(attr.name),
			value: attr.value,
			dynamic: attr.dynamic
		  }); }))
		  : null;
	  var bind$$1 = el.attrsMap['v-bind'];
	  if ((attrs || bind$$1) && !children) {
		res += ",null";
	  }
	  if (attrs) {
		res += "," + attrs;
	  }
	  if (bind$$1) {
		res += (attrs ? '' : ',null') + "," + bind$$1;
	  }
	  return res + ')'
	}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
	function genComponent (
		componentName,
		el,
		state
	) {
	  var children = el.inlineTemplate ? null : genChildren(el, state, true);
	  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
	}

	function genProps (props) {
	  var staticProps = "";
	  var dynamicProps = "";
	  for (var i = 0; i < props.length; i++) {
		var prop = props[i];
		var value = transformSpecialNewlines(prop.value);
		if (prop.dynamic) {
		  dynamicProps += (prop.name) + "," + value + ",";
		} else {
		  staticProps += "\"" + (prop.name) + "\":" + value + ",";
		}
	  }
	  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
	  if (dynamicProps) {
		return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
	  } else {
		return staticProps
	  }
	}

// #3895, #4268
	function transformSpecialNewlines (text) {
	  return text
		  .replace(/\u2028/g, '\\u2028')
		  .replace(/\u2029/g, '\\u2029')
	}

	/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
	var prohibitedKeywordRE = new RegExp('\\b' + (
		'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
		'super,throw,while,yield,delete,export,import,return,switch,default,' +
		'extends,finally,continue,debugger,function,arguments'
	).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
	var unaryOperatorsRE = new RegExp('\\b' + (
		'delete,typeof,void'
	).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
	var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
	function detectErrors (ast, warn) {
	  if (ast) {
		checkNode(ast, warn);
	  }
	}

	function checkNode (node, warn) {
	  if (node.type === 1) {
		for (var name in node.attrsMap) {
		  if (dirRE.test(name)) {
			var value = node.attrsMap[name];
			if (value) {
			  var range = node.rawAttrsMap[name];
			  if (name === 'v-for') {
				checkFor(node, ("v-for=\"" + value + "\""), warn, range);
			  } else if (name === 'v-slot' || name[0] === '#') {
				checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
			  } else if (onRE.test(name)) {
				checkEvent(value, (name + "=\"" + value + "\""), warn, range);
			  } else {
				checkExpression(value, (name + "=\"" + value + "\""), warn, range);
			  }
			}
		  }
		}
		if (node.children) {
		  for (var i = 0; i < node.children.length; i++) {
			checkNode(node.children[i], warn);
		  }
		}
	  } else if (node.type === 2) {
		checkExpression(node.expression, node.text, warn, node);
	  }
	}

	function checkEvent (exp, text, warn, range) {
	  var stripped = exp.replace(stripStringRE, '');
	  var keywordMatch = stripped.match(unaryOperatorsRE);
	  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
		warn(
			"avoid using JavaScript unary operator as property name: " +
			"\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
			range
		);
	  }
	  checkExpression(exp, text, warn, range);
	}

	function checkFor (node, text, warn, range) {
	  checkExpression(node.for || '', text, warn, range);
	  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
	  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
	  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
	}

	function checkIdentifier (
		ident,
		type,
		text,
		warn,
		range
	) {
	  if (typeof ident === 'string') {
		try {
		  new Function(("var " + ident + "=_"));
		} catch (e) {
		  warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
		}
	  }
	}

	function checkExpression (exp, text, warn, range) {
	  try {
		new Function(("return " + exp));
	  } catch (e) {
		var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
		if (keywordMatch) {
		  warn(
			  "avoid using JavaScript keyword as property name: " +
			  "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
			  range
		  );
		} else {
		  warn(
			  "invalid expression: " + (e.message) + " in\n\n" +
			  "    " + exp + "\n\n" +
			  "  Raw expression: " + (text.trim()) + "\n",
			  range
		  );
		}
	  }
	}

	function checkFunctionParameterExpression (exp, text, warn, range) {
	  try {
		new Function(exp, '');
	  } catch (e) {
		warn(
			"invalid function parameter expression: " + (e.message) + " in\n\n" +
			"    " + exp + "\n\n" +
			"  Raw expression: " + (text.trim()) + "\n",
			range
		);
	  }
	}

	/*  */

	var range = 2;

	function generateCodeFrame (
		source,
		start,
		end
	) {
	  if ( start === void 0 ) start = 0;
	  if ( end === void 0 ) end = source.length;

	  var lines = source.split(/\r?\n/);
	  var count = 0;
	  var res = [];
	  for (var i = 0; i < lines.length; i++) {
		count += lines[i].length + 1;
		if (count >= start) {
		  for (var j = i - range; j <= i + range || end > count; j++) {
			if (j < 0 || j >= lines.length) { continue }
			res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
			var lineLength = lines[j].length;
			if (j === i) {
			  // push underline
			  var pad = start - (count - lineLength) + 1;
			  var length = end > count ? lineLength - pad : end - start;
			  res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
			} else if (j > i) {
			  if (end > count) {
				var length$1 = Math.min(end - count, lineLength);
				res.push("   |  " + repeat$1("^", length$1));
			  }
			  count += lineLength + 1;
			}
		  }
		  break
		}
	  }
	  return res.join('\n')
	}

	function repeat$1 (str, n) {
	  var result = '';
	  if (n > 0) {
		while (true) { // eslint-disable-line
		  if (n & 1) { result += str; }
		  n >>>= 1;
		  if (n <= 0) { break }
		  str += str;
		}
	  }
	  return result
	}

	/*  */



	function createFunction (code, errors) {
	  try {
		return new Function(code)
	  } catch (err) {
		errors.push({ err: err, code: code });
		return noop
	  }
	}

	function createCompileToFunctionFn (compile) {
	  var cache = Object.create(null);

	  return function compileToFunctions (
		  template,
		  options,
		  vm
	  ) {
		options = extend({}, options);
		var warn$$1 = options.warn || warn;
		delete options.warn;

		/* istanbul ignore if */
		if (false) {}

		// check cache
		var key = options.delimiters
			? String(options.delimiters) + template
			: template;
		if (cache[key]) {
		  return cache[key]
		}

		// compile
		var compiled = compile(template, options);

		// check compilation errors/tips
		if (false) {}

		// turn code into functions
		var res = {};
		var fnGenErrors = [];
		res.render = createFunction(compiled.render, fnGenErrors);
		res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
		  return createFunction(code, fnGenErrors)
		});

		// check function generation errors.
		// this should only happen if there is a bug in the compiler itself.
		// mostly for codegen development use
		/* istanbul ignore if */
		if (false) {}

		return (cache[key] = res)
	  }
	}

	/*  */

	function createCompilerCreator (baseCompile) {
	  return function createCompiler (baseOptions) {
		function compile (
			template,
			options
		) {
		  var finalOptions = Object.create(baseOptions);
		  var errors = [];
		  var tips = [];

		  var warn = function (msg, range, tip) {
			(tip ? tips : errors).push(msg);
		  };

		  if (options) {
			if (false) { var leadingSpaceLength; }
			// merge custom modules
			if (options.modules) {
			  finalOptions.modules =
				  (baseOptions.modules || []).concat(options.modules);
			}
			// merge custom directives
			if (options.directives) {
			  finalOptions.directives = extend(
				  Object.create(baseOptions.directives || null),
				  options.directives
			  );
			}
			// copy other options
			for (var key in options) {
			  if (key !== 'modules' && key !== 'directives') {
				finalOptions[key] = options[key];
			  }
			}
		  }

		  finalOptions.warn = warn;

		  var compiled = baseCompile(template.trim(), finalOptions);
		  if (false) {}
		  compiled.errors = errors;
		  compiled.tips = tips;
		  return compiled
		}

		return {
		  compile: compile,
		  compileToFunctions: createCompileToFunctionFn(compile)
		}
	  }
	}

	/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
	var createCompiler = createCompilerCreator(function baseCompile (
		template,
		options
	) {
	  var ast = parse(template.trim(), options);
	  if (options.optimize !== false) {
		optimize(ast, options);
	  }
	  var code = generate(ast, options);
	  return {
		ast: ast,
		render: code.render,
		staticRenderFns: code.staticRenderFns
	  }
	});

	/*  */

	var ref$1 = createCompiler(baseOptions);
	var compile = ref$1.compile;
	var compileToFunctions = ref$1.compileToFunctions;

	/*  */

// check whether current browser encodes a char inside attribute values
	var div;
	function getShouldDecode (href) {
	  div = div || document.createElement('div');
	  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
	  return div.innerHTML.indexOf('&#10;') > 0
	}

// #3663: IE encodes newlines inside attribute values while other browsers don't
	var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
	var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

	/*  */

	var idToTemplate = cached(function (id) {
	  var el = query(id);
	  return el && el.innerHTML
	});

	var mount = vue_esm_Vue.prototype.$mount;
	vue_esm_Vue.prototype.$mount = function (
		el,
		hydrating
	) {
	  el = el && query(el);

	  /* istanbul ignore if */
	  if (el === document.body || el === document.documentElement) {
		false && 0;
		return this
	  }

	  var options = this.$options;
	  // resolve template/el and convert to render function
	  if (!options.render) {
		var template = options.template;
		if (template) {
		  if (typeof template === 'string') {
			if (template.charAt(0) === '#') {
			  template = idToTemplate(template);
			  /* istanbul ignore if */
			  if (false) {}
			}
		  } else if (template.nodeType) {
			template = template.innerHTML;
		  } else {
			if (false) {}
			return this
		  }
		} else if (el) {
		  template = getOuterHTML(el);
		}
		if (template) {
		  /* istanbul ignore if */
		  if (false) {}

		  var ref = compileToFunctions(template, {
			outputSourceRange: "production" !== 'production',
			shouldDecodeNewlines: shouldDecodeNewlines,
			shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
			delimiters: options.delimiters,
			comments: options.comments
		  }, this);
		  var render = ref.render;
		  var staticRenderFns = ref.staticRenderFns;
		  options.render = render;
		  options.staticRenderFns = staticRenderFns;

		  /* istanbul ignore if */
		  if (false) {}
		}
	  }
	  return mount.call(this, el, hydrating)
	};

	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 */
	function getOuterHTML (el) {
	  if (el.outerHTML) {
		return el.outerHTML
	  } else {
		var container = document.createElement('div');
		container.appendChild(el.cloneNode(true));
		return container.innerHTML
	  }
	}

	vue_esm_Vue.compile = compileToFunctions;

	/* harmony default export */ const vue_esm = (vue_esm_Vue);


	/**
	 * @typedef {Object} Breakpoint
	 * @param {number} min
	 * @param {number} max
	 * @param {string} name
	 * @param {number} order
	 */

	/** @enum {Breakpoint} */
	const Breakpoints = {
	  xs: {
		min: 0,
		max: 480,
		name: 'xs',
		order: 1
	  },
	  // Extra small devices (portrait phones, less than 576px)
	  sm: {
		min: 481,
		max: 767,
		name: 'sm',
		order: 2
	  },
	  // Small devices (landscape phones, 576px and up)
	  md: {
		min: 768,
		max: 991,
		name: 'md',
		order: 3
	  },
	  // Medium devices (tablets, 768px and up)
	  lg: {
		min: 992,
		max: 1199,
		name: 'lg',
		order: 4
	  },
	  // Large devices (desktops, 992px and up)
	  xl: {
		min: 1200,
		max: Number.POSITIVE_INFINITY,
		name: 'xl',
		order: 5
	  } // Extra large devices (large desktops, 1200px and up)
	};

	/* eslint-disable no-unused-vars */


	const TOGGLE_RIGHT_DRAWER_EVENT = 'bulletproof-toggle-right-drawer';
	const TOGGLE_LEFT_DRAWER_EVENT = 'bulletproof-toggle-left-drawer';
	const CART_UPDATE_EVENT = 'bulletproof-cart-update';
	class ThemeBase {
	  constructor() {
		this.$ = void 0;
		this.translations = void 0;
		this.moneyFormat = void 0;
		this.giftwrapProduct = void 0;
		this.giftwrapEnabled = void 0;
		this.breakpoint = void 0;
		this.formatMoney = (cents, format) => {
		  var moneyFormat = this.moneyFormat;
		  if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		  }
		  var value = '';
		  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		  var formatString = format || moneyFormat;
		  function formatWithDelimiters(number, precision, thousands, decimal) {
			if (precision === null || precision === undefined) {
			  precision = 2;
			}
			thousands = thousands || ',';
			decimal = decimal || '.';
			if (isNaN(number) || number == null) {
			  return 0;
			}
			number = (number / 100.0).toFixed(precision);
			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var centsAmount = parts[1] ? decimal + parts[1] : '';
			return dollarsAmount + centsAmount;
		  }
		  switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
			  value = formatWithDelimiters(cents, 2);
			  break;
			case 'amount_no_decimals':
			  value = formatWithDelimiters(cents, 0);
			  break;
			case 'amount_with_comma_separator':
			  value = formatWithDelimiters(cents, 2, '.', ',');
			  break;
			case 'amount_no_decimals_with_comma_separator':
			  value = formatWithDelimiters(cents, 0, '.', ',');
			  break;
			case 'amount_no_decimals_with_space_separator':
			  value = formatWithDelimiters(cents, 0, ' ');
			  break;
		  }
		  return '<span class="money">' + formatString.replace(placeholderRegex, value) + '</span>';
		};
		this.getWindowWidth = () => {
		  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		};
		this.getBreakpoint = (width = undefined) => {
		  const w = width === null || width === undefined ? this.getWindowWidth() : width;
		  let breakpoint;
		  Object.values(Breakpoints).forEach(b => {
			if (w >= b.min && w <= b.max) {
			  breakpoint = b;
			}
		  });
		  return breakpoint;
		};
		this.toggleRightDrawer = (type = 'cart', forceOpen = undefined, params = {}) => {};
		this.toggleLeftDrawer = (forceOpen = undefined) => {};
		this.updateCartDrawer = cart => {};
		this.loadYoutubeApi = () => {
		  return;
		};
		this.loadVimeoApi = () => {
		  return;
		};
		this.loadGoogleMapApi = apiKey => {
		  return;
		};
		this.createScript = (id, src) => {
		  return;
		};
		this.registerComponent = component => {};
		this.addBadges = (root, timeout) => {};
	  }
	}

	class Component {
	  /**
	   * Generic component, inherited class will be called to receive things like resize events.
	   *
	   * @param {import('./ThemeBase').default} theme
	   * @param {HTMLElement} element
	   */
	  constructor(theme, element) {
		this.onWindowResizeRaw = ({
									width
								  }) => {};
		this.onWindowResize = ({
								 width,
								 oldWidth,
								 breakpoint
							   }) => {};
		this.onWindowResizeBreakpoint = ({
										   width,
										   breakpoint,
										   oldBreakpoint
										 }) => {};
		this.onWindowScroll = () => {};
		this.theme = theme;
		this.element = element;
		theme.registerComponent(this);
	  }

	  /**
	   * This will be called immediatelly when window resizes.
	   *
	   * NOTE: prefer using onWindowResize as it's already debounced.
	   *
	   * @param {Object} params
	   * @param {number} params.width Width of the window
	   */
	}



	/**
	 * Base class for all the section components
	 *
	 * All components should inherit this class and implement what method they need
	 */
	class Section extends Component {
	  /**
	   *
	   * @param {import("./ThemeBase").default} theme Global theme object
	   * @param {HTMLElement} element Toplevel element for the section
	   * @param {boolean} pageLoad True on initial page load, False when this section reloads
	   */
	  constructor(theme, element, pageLoad) {
		super(theme, element);
		this.onSectionSelect = ({
								  element,
								  sectionId,
								  load
								}) => {};
		this.onSectionDeselect = ({
									element,
									sectionId
								  }) => {};
		this.onSectionReorder = ({
								   element,
								   sectionId
								 }) => {};
		this.onBlockSelect = ({
								element,
								sectionId,
								blockId,
								load
							  }) => {};
		this.onBlockDeselect = ({
								  element,
								  sectionId,
								  blockId
								}) => {};
		this.destroy = ({
						  element
						}) => {};
		this.theme = theme;
		this.element = element;
	  }

	  /**
	   * This will be called when section gets selected in Shopify Theme Editor
	   *
	   * @param {Object} params
	   * @param {HTMLElement} params.element Toplevel element for the section
	   * @param {string} params.sectionId Identification of the section
	   * @param {boolean} params.load True if block was loaded, False if user just openeded previously selected block
	   * */
	}


	class MobileMenu {
	  constructor(theme, element) {
		this.handleToggle = e => {
		  this.toggle(e.detail.forceOpen);
		};
		this.close = () => {
		  document.body.classList.remove('js-drawer-open');
		  document.body.classList.remove('js-drawer-open-left');
		  this.isOpen = false;
		};
		this.open = () => {
		  document.body.classList.add('js-drawer-open');
		  document.body.classList.add('js-drawer-open-left');
		  this.isOpen = true;
		};
		this.toggle = (forceOpen = undefined) => {
		  if (forceOpen === true) {
			this.open();
		  } else if (forceOpen === false) {
			this.close();
		  } else if (this.isOpen) {
			this.close();
		  } else {
			this.open();
		  }
		};
		this.theme = theme;
		this.element = element;
		this.isOpen = false;
		document.documentElement.addEventListener(TOGGLE_LEFT_DRAWER_EVENT, this.handleToggle);
		jquery_default()('.mobile-nav__toggle').off('click').on('click', function (evt) {
		  jquery_default()(this).parent().toggleClass('mobile-nav--expanded');
		});
		this.element.querySelector('.mobile-menu--close-btn').addEventListener('click', e => {
		  e.preventDefault;
		  this.close();
		});
	  }
	}
// EXTERNAL MODULE: ./node_modules/hoverintent/index.js
	var hoverintent = __webpack_require__(876);
	var hoverintent_default = /*#__PURE__*/__webpack_require__.n(hoverintent);
	;// CONCATENATED MODULE: ./src/javascripts/global/fadeInUpAnimation.js
// fadeInUpAnimation.js

// Selects all children elements within a parent element and initiates a fade in up animation
// Child elements have an opacity of 0 and a transform of translateY() applied to them initially
// See _global-sections.scss for the animation

	function initiateFadeInUpAnimation(elements) {
	  if (elements.length) {
		elements.forEach((child, index) => {
		  child.style.animation = `fade-in-up 0.15s ease-in-out forwards, fade-in-up-opacity 0.35s ease-in-out forwards`;
		  child.style.animationDelay = `${(index + 1) * 0.05}s`;
		});
	  }
	}

// Selects all children elements within a parent element and removes the fade in up animation

	function removeFadeInUpAnimation(elements) {
	  if (elements.length) {
		elements.forEach(child => {
		  child.style.animation = 'none';
		});
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/Menu.js
// @ts-nocheck

	class Menu {
	  constructor(theme, element) {
		this.initScrollHandler = $el => {
		  const $container = jquery_default()($el);
		  let scrolling;
		  $container.on('scroll', () => {
			clearTimeout(scrolling);

			// Add class to show scrollbar
			$container.addClass('scrolling');
			scrolling = setTimeout(() => {
			  // Remove class to hide scrollbar
			  $container.removeClass('scrolling');
			}, 800);
		  });
		};
		this.closeSiblings = ($el, evt) => {
		  if (!$el.hasClass(this.activeClass)) {
			evt.preventDefault();
			this.hideDropdown($el.siblings());
		  }
		};
		this.setMegaMenuPosition = () => {
		  // Position mega menu dropdowns to sit below their parent nav link
		  this.$megaMenuDropdowns.forEach(dropdown => {
			const navLink = dropdown.parentElement;
			const navLinkRect = navLink.getBoundingClientRect();

			// Calculate the position relative to the viewport
			dropdown.style.top = `${navLinkRect.bottom}px`;
		  });
		};
		this.showDropdown = $el => {
		  $el.addClass(this.activeClass);
		  const self2 = this;

		  // Initiate mega menu animation
		  const megaMenuChildrenArray = Array.from($el.find('.mega-menu-block .dropdown-submenu'));
		  initiateFadeInUpAnimation(megaMenuChildrenArray);

		  // Remove iOS workaround because it breaks menu z-index
		  jquery_default()('.sticky-header').removeClass('sticky-header-transformed');
		  setTimeout(function () {
			jquery_default()(document.body).on('touchstart', evt => {
			  if (jquery_default()(evt.target).closest('.site-nav__link,.dropdown-submenu').length === 0) {
				// Hide dropdown if the touchstart was not on nav link
				self2.hideDropdown($el);
			  }
			});
		  }, 250);
		};
		this.hideDropdown = $el => {
		  if ($el !== undefined) {
			$el.removeClass(this.activeClass);

			// Remove mega menu animation
			const megaMenuChildrenArray = Array.from($el.find('.mega-menu-block .dropdown-submenu'));
			if (!this.$element.hasClass('section-selected') && !this.$parents.hasClass('nav-hover')) {
			  removeFadeInUpAnimation(megaMenuChildrenArray);
			}
		  } else {
			jquery_default()('.site-nav--has-dropdown').removeClass(this.activeClass);

			// Remove mega menu animation
			if (!this.$element.hasClass('section-selected') && !this.$parents.hasClass('nav-hover')) {
			  removeFadeInUpAnimation(this.$megaMenuChildren);
			}
		  }
		  jquery_default()(document.body).off('touchstart');

		  // Reenable iOS workaround
		  if (jquery_default()('.nav-hover').length === 0) {
			jquery_default()('.sticky-header').addClass('sticky-header-transformed');
		  }
		};
		this.setDropdownOffset = $el => {
		  const dropdown = $el.find('.site-nav__dropdown.standard-dropdown');
		  if (dropdown.length === 0) return;
		  const nav_position = jquery_default()(dropdown).data('logoPlacement');
		  const subDropdown = jquery_default()(dropdown).find('.site-nav__subdropdown');

		  // Get dropdown's distance from the right side of the window
		  const dropdownRight = jquery_default()(window).width() - (dropdown.offset().left + dropdown.outerWidth());

		  // If it's less than 15px from the right edge of the window, it is too far right.
		  if (dropdownRight < 15) {
			dropdown.css({
			  right: '0',
			  left: 'auto'
			});
		  }
		  if (subDropdown.length === 0) return;

		  // Get the subdropdown's distance from the right side of the window
		  const subDropdownRight = jquery_default()(window).width() - (subDropdown.offset().left + subDropdown.outerWidth());
		  if (subDropdownRight < 15) {
			if (nav_position == 'left' || nav_position == 'above') {
			  subDropdown.css({
				left: 'auto',
				right: '100%'
			  });
			} else {
			  subDropdown.css({
				left: '100%',
				right: 'auto'
			  });
			}
		  }
		};
		const self = this;
		this.theme = theme;
		this.element = element;
		this.$element = jquery_default()(element);
		this.$nav = jquery_default()('#AccessibleNav');
		this.$allLinks = this.$nav.find('a');
		this.$topLevel = this.$nav.children('li').find('a');
		this.$parents = this.$nav.find('.site-nav--has-dropdown');
		this.$mainLinks = this.$nav.find('.site-nav--has-dropdown.first-level-dropdown');
		this.$subMenus = this.$nav.find('.site-nav__dropdown');
		this.$subMenuLinks = this.$subMenus.find('a');
		this.activeClass = 'nav-hover';
		this.$sectionId = this.$element.attr('data-bulletproof-section-id');
		this.$megaMenuDropdowns = document.querySelectorAll('.site-nav__dropdown.mega-menu-dropdown');
		this.$megaMenu = document.querySelector('.mega-menu-block');
		this.$megaMenuChildren = document.querySelectorAll('.mega-menu-block .dropdown-submenu');
		this.$resizeTimeout = null;
		this.$parents.each((i, el) => {
		  this.setDropdownOffset(jquery_default()(el));
		});
		this.$subMenus.each((i, el) => {
		  this.initScrollHandler(el);
		});
		this.setMegaMenuPosition();
		window.addEventListener('resize', () => {
		  this.$parents.each((i, el) => {
			// If there's a scheduled resize, cancel it
			if (this.$resizeTimeout) {
			  clearTimeout(this.$resizeTimeout);
			}

			// Schedule a new resize event to run 300ms from now
			this.$resizeTimeout = setTimeout(() => {
			  this.$parents.each((i, el) => {
				this.setDropdownOffset(jquery_default()(el));
				this.setMegaMenuPosition();
			  });
			}, 300);
		  });
		});
		if (window.Shopify.designMode) {
		  document.addEventListener('shopify:section:select', e => {
			if (e.detail.sectionId == this.$sectionId) {
			  this.$element.addClass('section-selected');
			  this.setMegaMenuPosition();
			} else {
			  this.$element.removeClass('section-selected');
			}
		  });
		  document.addEventListener('shopify:section:deselect', e => {
			if (e.detail.sectionId == this.$sectionId) {
			  this.$element.removeClass('section-selected');
			  this.setMegaMenuPosition();
			}
		  });
		  document.addEventListener('shopify:section:load', e => {
			if (e.detail.sectionId == this.$sectionId) {
			  this.setMegaMenuPosition();
			}
		  });
		}
		document.addEventListener('headerSticked', e => {
		  this.setMegaMenuPosition();
		});
		document.addEventListener('headerUnstuck', e => {
		  setTimeout(() => {
			this.setMegaMenuPosition();
		  }, 300);
		});
		this.$parents.on('mouseover touchstart focusin', function (evt) {
		  var ret = true;
		  var $el = jquery_default()(this);
		  if (!$el.hasClass(self.activeClass)) {
			evt.preventDefault();
			self.hideDropdown($el.siblings());
			ret = false;
		  }
		  self.showDropdown($el);
		  return ret;
		});
		this.$parents.each((i, el) => {
		  hoverintent_default()(el, function (evt) {
			jquery_default()('.' + self.activeClass).each(function (el) {
			  var $active = jquery_default()(this);
			  if ($active.has(evt.target).length === 0) {
				$active.removeClass(self.activeClass);
			  }
			});
		  }, function () {
			// This is triggered when hovering over sub-menus /
			// child elements, so avoid using self.hideDropdown()
			// here.
		  });
		});

		// Handle focus for submenus.
		this.$parents.each((i, el) => {
		  jquery_default()(el).on('focusin', function (elem) {
			self.showDropdown(jquery_default()(el));
		  });
		});

		// Hide dropdown when moving away from top level links.
		this.$mainLinks.each((i, el) => {
		  jquery_default()(el).on('mouseleave', function (elem) {
			self.hideDropdown();
		  });
		});

		// Mouseout / blur.
		jquery_default()('.site-header').on('mouseleave', () => {
		  self.hideDropdown();
		});
		jquery_default()('.site-nav__dropdown').on('mouseleave focusout', evt => {
		  self.hideDropdown(jquery_default()(this));
		});
		jquery_default()(this.$megaMenu).on('mouseleave', () => {
		  self.hideDropdown();
		});
		this.$subMenuLinks.on('touchstart', function (evt) {
		  // Prevent touchstart on body from firing instead of link
		  evt.stopImmediatePropagation();
		});
		this.$allLinks.on('focusin', function (evt) {
		  let $el = jquery_default()(this).parent();
		  self.closeSiblings($el, evt);
		});
		jquery_default()('.site-header').find('a, button, select').on('focusin', function () {
		  // If this is not a menu (e.g. icon, logo), close all menus.
		  let thisElem = this;
		  let closeAllMenus = true;
		  self.$allLinks.each(function () {
			if (jquery_default()(this).is(thisElem)) {
			  closeAllMenus = false;
			}
		  });
		  if (closeAllMenus) {
			self.$parents.each(function () {
			  self.hideDropdown(jquery_default()(this));
			});
		  }
		});
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Header.js






	class Header extends Section {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   * @param {boolean} pageLoad
	   */
	  constructor(theme, _element, pageLoad) {
		super(theme, _element, pageLoad);
		this.onCartUpdate = e => {
		  Array.prototype.forEach.call(document.querySelectorAll('.cart-item-count-header--quantity'), el => {
			el.classList.add('hide');
			const cartHasItems = e.detail.cart.item_count > 0;
			el.textContent = e.detail.cart.item_count;
			if (cartHasItems) el.classList.remove('hide');
		  });
		};
		this.onCartButtonClick = e => {
		  e.preventDefault();
		  this.theme.toggleRightDrawer('cart');
		};
		this.onMobileMenuButtonClick = e => {
		  e.preventDefault();
		  this.mobileMenu.toggle();
		};
		this.loadSearchDrawer = () => {
		  document.querySelectorAll('.search-button').forEach(item => {
			item.addEventListener('click', this.onSearch);
		  });
		};
		this.onSearch = e => {
		  e.preventDefault();
		  this.theme.toggleRightDrawer('search', true);
		};
		this.loadAccessibleMenu = () => {
		  this.$element.find('.site-nav').addClass('js');
		  this.$element.find('.site-nav li a').focus(function () {
			// main nav anchor focus
			jquery_default()(this).parent().children('ul').fadeIn();
		  });
		  this.$element.find('.site-nav li li a').off(); // unbind hide drop downs from sub nav anchors

		  const self = this;
		  this.$element.find('.mobile-nav__link').on('click', function () {
			const a = /** @type {HTMLAnchorElement} */this;
			if (a.href && a.href.split('#')[0] === window.location.href.split('#')[0]) {
			  // Anchor on same page - just close the drawer
			  self.theme.toggleLeftDrawer(false);
			}
		  });
		  this.tabindexMobileNav();
		};
		this.tabindexMobileNav = () => {
		  // Mobile menu should not be keyboard-navigable while viewing on desktop.
		  if (window.innerWidth > 767) {
			this.$element.find('#NavDrawer a, #NavDrawer button').attr('tabindex', -1);
		  } else {
			this.$element.find('#NavDrawer a:not(.promo-text), #NavDrawer button').removeAttr('tabindex');
		  }
		};
		this.onWindowResize = ({
								 width,
								 oldWidth,
								 breakpoint
							   }) => {
		  this.tabindexMobileNav();
		};
		this.loadStickyHeader = () => {
		  if ('IntersectionObserver' in window) {
			// We need to apply sticky to child of element that is being scrolled, in
			// this case it's the whole `shopify-section`
			const headerWrapper = this.element.closest('.shopify-section.header-section');
			headerWrapper.classList.add('sticky-header');
			const observer = new IntersectionObserver(([e]) => {
			  if (e.intersectionRatio < 1) {
				e.target.classList.add('sticked');
				// Dispatch a custom event when the header becomes 'sticked'
				const stickedEvent = new CustomEvent('headerSticked', {
				  detail: e.target
				});
				document.dispatchEvent(stickedEvent);
			  } else {
				e.target.classList.remove('sticked');
				// Dispatch a custom event when the header becomes 'unstuck'
				const unstuckEvent = new CustomEvent('headerUnstuck', {
				  detail: e.target
				});
				document.dispatchEvent(unstuckEvent);
			  }
			}, {
			  threshold: [1]
			});
			observer.observe(headerWrapper);
		  }
		};
		this.onBlockSelect = ({
								element
							  }) => {
		  // Open mega menu and make overlay force-hovered
		  if (element.dataset.megaMenuBlockId) {
			this.$element.find('[data-mega-menu-block-id=' + element.dataset.megaMenuBlockId + ']').closest('li.mega-menu').addClass('force-open');
			this.$element.find('.overlay-header').addClass('force-hover');
			const megaMenuChildrenArray = Array.from(this.$element.find('li.mega-menu.force-open .mega-menu-block .dropdown-submenu'));
			initiateFadeInUpAnimation(megaMenuChildrenArray); // Initiate mega menu animation
		  }
		};
		this.onBlockDeselect = () => {
		  // Close mega menu and make overlay non-hovered
		  this.$element.find('li.mega-menu.force-open').removeClass('force-open');
		  this.$element.find('.overlay-header').removeClass('force-hover');
		  const megaMenuChildrenArray = Array.from(this.$element.find('li.mega-menu .mega-menu-block .dropdown-submenu'));
		  removeFadeInUpAnimation(megaMenuChildrenArray); // Remove mega menu animation
		};
		this.handleExternalLinks = () => {
		  var links = this.element.querySelectorAll('a');
		  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
			if (links[i].hostname !== window.location.hostname) {
			  links[i].target = '_blank';
			  links[i].rel = 'noreferrer noopener';
			}
		  }
		};
		this.$element = jquery_default()(this.element);
		Array.prototype.forEach.call(this.element.querySelectorAll('.js-drawer-open-right-link'), el => el.addEventListener('click', this.onCartButtonClick));
		this.element.querySelector('.js-drawer-open-left-link').addEventListener('click', this.onMobileMenuButtonClick);
		this.mobileMenu = new MobileMenu(theme, this.element.querySelector('.drawer--left'));
		document.documentElement.addEventListener(CART_UPDATE_EVENT, this.onCartUpdate);
		if (window.Shopify.designMode) {
		  const headerEl = this.element.querySelector('header');
		  const overlayHeader = this.element.dataset.headerOverlay;
		  document.addEventListener('shopify:inspector:activate', () => {
			// Disable sticky header
			this.element.setAttribute('data-inspector-active', 'true');
			const headerWrapper = this.element.closest('.shopify-section');
			if (this.element.dataset.headerSticky === 'true') headerWrapper.classList.remove('sticky-header');

			// Disable overlay header
			if (overlayHeader == 'true') {
			  this.element.classList.remove('overlay-header-wrapper');
			  if (headerEl) headerEl.classList.remove('overlay-header');
			}
		  });
		  document.addEventListener('shopify:inspector:deactivate', () => {
			// Re-enable sticky header
			this.element.setAttribute('data-inspector-active', 'false');
			if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){

			} else {
			  if (this.element.dataset.headerSticky === 'true') this.loadStickyHeader();
			}

			// Re-enable overlay header
			if (overlayHeader == 'true') {
			  this.element.classList.add('overlay-header-wrapper');
			  if (headerEl) headerEl.classList.add('overlay-header');
			}
		  });
		}

		// Close mobile menu on overlay click
		this.element.querySelector('#NavDrawerOverlay').addEventListener('click', () => this.theme.toggleLeftDrawer(false));
		this.loadAccessibleMenu();

		if (this.element.dataset.headerSticky === 'true' && (this.element.dataset.inspectorActive == 'false' || !this.element.dataset.inspectorActive)) {
		  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){

		  } else {
			this.loadStickyHeader();
		  }
		}

		this.loadSearchDrawer();
		this.menu = new Menu(this, _element);
		this.handleExternalLinks();
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Footer.js

	class Footer extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.fixFooterToBottom = () => {
		  let heightOfContent = this.pageContainer.offsetHeight + this.footerWrapper.offsetHeight;
		  this.footerWrapper.classList.remove('fix-to-bottom');

		  // If the viewport is higher than the content.
		  if (window.innerHeight > heightOfContent) {
			this.footerWrapper.classList.add('fix-to-bottom');
		  }
		};
		this.onBlockSelect = () => {
		  this.fixFooterToBottom();
		};
		this.footerWrapper = /** @type {HTMLElement} */document.querySelector('.footer-wrapper');
		this.footer = /** @type {HTMLElement} */document.querySelector('footer');
		this.pageContainer = /** @type {HTMLElement} */document.querySelector('#PageContainer');
		this.fixFooterToBottom();
		let self = this;
		document.addEventListener('shopify:section:load', this.fixFooterToBottom);
		document.addEventListener('shopify:section:unload', this.fixFooterToBottom);
		document.addEventListener('shopify:section:select', this.fixFooterToBottom);
		document.addEventListener('shopify:section:deselect', this.fixFooterToBottom);
		document.addEventListener('shopify:section:reorder', this.fixFooterToBottom);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/AnnouncementBar.js

	class AnnouncementBar extends Section {}
	;// CONCATENATED MODULE: ./src/javascripts/global/KenBurns.js
// CONCATENATED MODULE: ./src/javascripts/sections/AnimatedText.js


	class AnimatedText extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		//
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/CustomHtml.js

	class CustomHtml extends Section {}
// EXTERNAL MODULE: ./node_modules/imagesloaded/imagesloaded.js
	var imagesloaded = 'https://dev-store-bph.myshopify.com/cdn/shop/t/91/assets/imagesLoaded.js'
	var imagesloaded_default = /*#__PURE__*/__webpack_require__.n(imagesloaded);
	;// CONCATENATED MODULE: ./src/javascripts/sections/Hero.js




	class Hero extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.hoverEffect = $link => {
		  const $overlay = jquery_default()('#' + $link.data('overlayId'));
		  $link.hover(() => {
			$overlay.addClass("active");
		  }, () => {
			$overlay.removeClass("active");
		  });

		  // Apply hover on page load
		  if ($link.is(':hover')) {
			$overlay.addClass("active");
		  }
		};
		imagesloaded_default()(this.element.querySelectorAll('.homepage-hero-content-overlay-menu-item'), {
		  background: true
		}, () => {
		  //
		  jquery_default()(".homepage-hero-text-advert-link").each((index, link) => {
			this.hoverEffect(jquery_default()(link));
		  });
		  jquery_default()('.homepage-hero-menu li').each((index, link) => {
			this.hoverEffect(jquery_default()(link));
		  });
		});
	  }
	}
	;// CONCATENATED MODULE: ./node_modules/ssr-window/dist/ssr-window.esm.js
	/**
	 * SSR Window 2.0.0
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: May 12, 2020
	 */
	/* eslint-disable no-param-reassign */
	function ssr_window_esm_isObject(obj) {
	  return (obj !== null &&
		  typeof obj === 'object' &&
		  'constructor' in obj &&
		  obj.constructor === Object);
	}
	function ssr_window_esm_extend(target, src) {
	  if (target === void 0) { target = {}; }
	  if (src === void 0) { src = {}; }
	  Object.keys(src).forEach(function (key) {
		if (typeof target[key] === 'undefined')
		  target[key] = src[key];
		else if (ssr_window_esm_isObject(src[key]) &&
			ssr_window_esm_isObject(target[key]) &&
			Object.keys(src[key]).length > 0) {
		  ssr_window_esm_extend(target[key], src[key]);
		}
	  });
	}

	var doc = typeof document !== 'undefined' ? document : {};
	var ssrDocument = {
	  body: {},
	  addEventListener: function () { },
	  removeEventListener: function () { },
	  activeElement: {
		blur: function () { },
		nodeName: '',
	  },
	  querySelector: function () {
		return null;
	  },
	  querySelectorAll: function () {
		return [];
	  },
	  getElementById: function () {
		return null;
	  },
	  createEvent: function () {
		return {
		  initEvent: function () { },
		};
	  },
	  createElement: function () {
		return {
		  children: [],
		  childNodes: [],
		  style: {},
		  setAttribute: function () { },
		  getElementsByTagName: function () {
			return [];
		  },
		};
	  },
	  createElementNS: function () {
		return {};
	  },
	  importNode: function () {
		return null;
	  },
	  location: {
		hash: '',
		host: '',
		hostname: '',
		href: '',
		origin: '',
		pathname: '',
		protocol: '',
		search: '',
	  },
	};
	ssr_window_esm_extend(doc, ssrDocument);

	var win = typeof window !== 'undefined' ? window : {};
	var ssrWindow = {
	  document: ssrDocument,
	  navigator: {
		userAgent: '',
	  },
	  location: {
		hash: '',
		host: '',
		hostname: '',
		href: '',
		origin: '',
		pathname: '',
		protocol: '',
		search: '',
	  },
	  history: {
		replaceState: function () { },
		pushState: function () { },
		go: function () { },
		back: function () { },
	  },
	  CustomEvent: function CustomEvent() {
		return this;
	  },
	  addEventListener: function () { },
	  removeEventListener: function () { },
	  getComputedStyle: function () {
		return {
		  getPropertyValue: function () {
			return '';
		  },
		};
	  },
	  Image: function () { },
	  Date: function () { },
	  screen: {},
	  setTimeout: function () { },
	  clearTimeout: function () { },
	  matchMedia: function () {
		return {};
	  },
	};
	ssr_window_esm_extend(win, ssrWindow);



	;// CONCATENATED MODULE: ./node_modules/dom7/dist/dom7.modular.js
	/**
	 * Dom7 2.1.5
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * http://framework7.io/docs/dom.html
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 *
	 * Licensed under MIT
	 *
	 * Released on: May 15, 2020
	 */


	class Dom7 {
	  constructor(arr) {
		const self = this;
		// Create array-like object
		for (let i = 0; i < arr.length; i += 1) {
		  self[i] = arr[i];
		}
		self.length = arr.length;
		// Return collection with methods
		return this;
	  }
	}

	function $(selector, context) {
	  const arr = [];
	  let i = 0;
	  if (selector && !context) {
		if (selector instanceof Dom7) {
		  return selector;
		}
	  }
	  if (selector) {
		// String
		if (typeof selector === 'string') {
		  let els;
		  let tempParent;
		  const html = selector.trim();
		  if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
			let toCreate = 'div';
			if (html.indexOf('<li') === 0) toCreate = 'ul';
			if (html.indexOf('<tr') === 0) toCreate = 'tbody';
			if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
			if (html.indexOf('<tbody') === 0) toCreate = 'table';
			if (html.indexOf('<option') === 0) toCreate = 'select';
			tempParent = doc.createElement(toCreate);
			tempParent.innerHTML = html;
			for (i = 0; i < tempParent.childNodes.length; i += 1) {
			  arr.push(tempParent.childNodes[i]);
			}
		  } else {
			if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
			  // Pure ID selector
			  els = [doc.getElementById(selector.trim().split('#')[1])];
			} else {
			  // Other selectors
			  els = (context || doc).querySelectorAll(selector.trim());
			}
			for (i = 0; i < els.length; i += 1) {
			  if (els[i]) arr.push(els[i]);
			}
		  }
		} else if (selector.nodeType || selector === win || selector === doc) {
		  // Node/element
		  arr.push(selector);
		} else if (selector.length > 0 && selector[0].nodeType) {
		  // Array of elements or instance of Dom
		  for (i = 0; i < selector.length; i += 1) {
			arr.push(selector[i]);
		  }
		}
	  }
	  return new Dom7(arr);
	}

	$.fn = Dom7.prototype;
	$.Class = Dom7;
	$.Dom7 = Dom7;

	function unique(arr) {
	  const uniqueArray = [];
	  for (let i = 0; i < arr.length; i += 1) {
		if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }
	  return uniqueArray;
	}
	function toCamelCase(string) {
	  return string.toLowerCase().replace(/-(.)/g, (match, group1) => group1.toUpperCase());
	}

	function dom7_modular_requestAnimationFrame(callback) {
	  if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
	  else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
	  return window.setTimeout(callback, 1000 / 60);
	}
	function dom7_modular_cancelAnimationFrame(id) {
	  if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
	  else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
	  return window.clearTimeout(id);
	}

// Classes and attributes
	function dom7_modular_addClass(className) {
	  if (typeof className === 'undefined') {
		return this;
	  }
	  const classes = className.split(' ');
	  for (let i = 0; i < classes.length; i += 1) {
		for (let j = 0; j < this.length; j += 1) {
		  if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
		}
	  }
	  return this;
	}
	function dom7_modular_removeClass(className) {
	  const classes = className.split(' ');
	  for (let i = 0; i < classes.length; i += 1) {
		for (let j = 0; j < this.length; j += 1) {
		  if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
		}
	  }
	  return this;
	}
	function hasClass(className) {
	  if (!this[0]) return false;
	  return this[0].classList.contains(className);
	}
	function toggleClass(className) {
	  const classes = className.split(' ');
	  for (let i = 0; i < classes.length; i += 1) {
		for (let j = 0; j < this.length; j += 1) {
		  if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
		}
	  }
	  return this;
	}
	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
		// Get attr
		if (this[0]) return this[0].getAttribute(attrs);
		return undefined;
	  }

	  // Set attrs
	  for (let i = 0; i < this.length; i += 1) {
		if (arguments.length === 2) {
		  // String
		  this[i].setAttribute(attrs, value);
		} else {
		  // Object
		  // eslint-disable-next-line
		  for (const attrName in attrs) {
			this[i][attrName] = attrs[attrName];
			this[i].setAttribute(attrName, attrs[attrName]);
		  }
		}
	  }
	  return this;
	}
// eslint-disable-next-line
	function removeAttr(attr) {
	  for (let i = 0; i < this.length; i += 1) {
		this[i].removeAttribute(attr);
	  }
	  return this;
	}
// eslint-disable-next-line
	function prop(props, value) {
	  if (arguments.length === 1 && typeof props === 'string') {
		// Get prop
		if (this[0]) return this[0][props];
	  } else {
		// Set props
		for (let i = 0; i < this.length; i += 1) {
		  if (arguments.length === 2) {
			// String
			this[i][props] = value;
		  } else {
			// Object
			// eslint-disable-next-line
			for (const propName in props) {
			  this[i][propName] = props[propName];
			}
		  }
		}
		return this;
	  }
	}
	function data(key, value) {
	  let el;
	  if (typeof value === 'undefined') {
		el = this[0];
		// Get value
		if (el) {
		  if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
			return el.dom7ElementDataStorage[key];
		  }

		  const dataKey = el.getAttribute(`data-${key}`);
		  if (dataKey) {
			return dataKey;
		  }
		  return undefined;
		}
		return undefined;
	  }

	  // Set value
	  for (let i = 0; i < this.length; i += 1) {
		el = this[i];
		if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
		el.dom7ElementDataStorage[key] = value;
	  }
	  return this;
	}
	function removeData(key) {
	  for (let i = 0; i < this.length; i += 1) {
		const el = this[i];
		if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
		  el.dom7ElementDataStorage[key] = null;
		  delete el.dom7ElementDataStorage[key];
		}
	  }
	}
	function dataset() {
	  const el = this[0];
	  if (!el) return undefined;
	  const dataset = {}; // eslint-disable-line
	  if (el.dataset) {
		// eslint-disable-next-line
		for (const dataKey in el.dataset) {
		  dataset[dataKey] = el.dataset[dataKey];
		}
	  } else {
		for (let i = 0; i < el.attributes.length; i += 1) {
		  // eslint-disable-next-line
		  const attr = el.attributes[i];
		  if (attr.name.indexOf('data-') >= 0) {
			dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
		  }
		}
	  }
	  // eslint-disable-next-line
	  for (const key in dataset) {
		if (dataset[key] === 'false') dataset[key] = false;
		else if (dataset[key] === 'true') dataset[key] = true;
		else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
	  }
	  return dataset;
	}
	function val(value) {
	  const dom = this;
	  if (typeof value === 'undefined') {
		if (dom[0]) {
		  if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
			const values = [];
			for (let i = 0; i < dom[0].selectedOptions.length; i += 1) {
			  values.push(dom[0].selectedOptions[i].value);
			}
			return values;
		  }
		  return dom[0].value;
		}
		return undefined;
	  }

	  for (let i = 0; i < dom.length; i += 1) {
		const el = dom[i];
		if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
		  for (let j = 0; j < el.options.length; j += 1) {
			el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
		  }
		} else {
		  el.value = value;
		}
	  }
	  return dom;
	}
// Transforms
// eslint-disable-next-line
	function transform(transform) {
	  for (let i = 0; i < this.length; i += 1) {
		const elStyle = this[i].style;
		elStyle.webkitTransform = transform;
		elStyle.transform = transform;
	  }
	  return this;
	}
	function dom7_modular_transition(duration) {
	  if (typeof duration !== 'string') {
		duration = `${duration}ms`; // eslint-disable-line
	  }
	  for (let i = 0; i < this.length; i += 1) {
		const elStyle = this[i].style;
		elStyle.webkitTransitionDuration = duration;
		elStyle.transitionDuration = duration;
	  }
	  return this;
	}
// Events
	function dom7_modular_on(...args) {
	  let [eventType, targetSelector, listener, capture] = args;
	  if (typeof args[1] === 'function') {
		[eventType, listener, capture] = args;
		targetSelector = undefined;
	  }
	  if (!capture) capture = false;

	  function handleLiveEvent(e) {
		const target = e.target;
		if (!target) return;
		const eventData = e.target.dom7EventData || [];
		if (eventData.indexOf(e) < 0) {
		  eventData.unshift(e);
		}
		if ($(target).is(targetSelector)) listener.apply(target, eventData);
		else {
		  const parents = $(target).parents(); // eslint-disable-line
		  for (let k = 0; k < parents.length; k += 1) {
			if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
		  }
		}
	  }
	  function handleEvent(e) {
		const eventData = e && e.target ? e.target.dom7EventData || [] : [];
		if (eventData.indexOf(e) < 0) {
		  eventData.unshift(e);
		}
		listener.apply(this, eventData);
	  }
	  const events = eventType.split(' ');
	  let j;
	  for (let i = 0; i < this.length; i += 1) {
		const el = this[i];
		if (!targetSelector) {
		  for (j = 0; j < events.length; j += 1) {
			const event = events[j];
			if (!el.dom7Listeners) el.dom7Listeners = {};
			if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
			el.dom7Listeners[event].push({
			  listener,
			  proxyListener: handleEvent,
			});
			el.addEventListener(event, handleEvent, capture);
		  }
		} else {
		  // Live events
		  for (j = 0; j < events.length; j += 1) {
			const event = events[j];
			if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
			if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
			el.dom7LiveListeners[event].push({
			  listener,
			  proxyListener: handleLiveEvent,
			});
			el.addEventListener(event, handleLiveEvent, capture);
		  }
		}
	  }
	  return this;
	}
	function off(...args) {
	  let [eventType, targetSelector, listener, capture] = args;
	  if (typeof args[1] === 'function') {
		[eventType, listener, capture] = args;
		targetSelector = undefined;
	  }
	  if (!capture) capture = false;

	  const events = eventType.split(' ');
	  for (let i = 0; i < events.length; i += 1) {
		const event = events[i];
		for (let j = 0; j < this.length; j += 1) {
		  const el = this[j];
		  let handlers;
		  if (!targetSelector && el.dom7Listeners) {
			handlers = el.dom7Listeners[event];
		  } else if (targetSelector && el.dom7LiveListeners) {
			handlers = el.dom7LiveListeners[event];
		  }
		  if (handlers && handlers.length) {
			for (let k = handlers.length - 1; k >= 0; k -= 1) {
			  const handler = handlers[k];
			  if (listener && handler.listener === listener) {
				el.removeEventListener(event, handler.proxyListener, capture);
				handlers.splice(k, 1);
			  } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
				el.removeEventListener(event, handler.proxyListener, capture);
				handlers.splice(k, 1);
			  } else if (!listener) {
				el.removeEventListener(event, handler.proxyListener, capture);
				handlers.splice(k, 1);
			  }
			}
		  }
		}
	  }
	  return this;
	}
	function dom7_modular_once(...args) {
	  const dom = this;
	  let [eventName, targetSelector, listener, capture] = args;
	  if (typeof args[1] === 'function') {
		[eventName, listener, capture] = args;
		targetSelector = undefined;
	  }
	  function onceHandler(...eventArgs) {
		listener.apply(this, eventArgs);
		dom.off(eventName, targetSelector, onceHandler, capture);
		if (onceHandler.dom7proxy) {
		  delete onceHandler.dom7proxy;
		}
	  }
	  onceHandler.dom7proxy = listener;
	  return dom.on(eventName, targetSelector, onceHandler, capture);
	}
	function dom7_modular_trigger(...args) {
	  const events = args[0].split(' ');
	  const eventData = args[1];
	  for (let i = 0; i < events.length; i += 1) {
		const event = events[i];
		for (let j = 0; j < this.length; j += 1) {
		  const el = this[j];
		  let evt;
		  try {
			evt = new win.CustomEvent(event, {
			  detail: eventData,
			  bubbles: true,
			  cancelable: true,
			});
		  } catch (e) {
			evt = doc.createEvent('Event');
			evt.initEvent(event, true, true);
			evt.detail = eventData;
		  }
		  // eslint-disable-next-line
		  el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
		  el.dispatchEvent(evt);
		  el.dom7EventData = [];
		  delete el.dom7EventData;
		}
	  }
	  return this;
	}
	function transitionEnd(callback) {
	  const events = ['webkitTransitionEnd', 'transitionend'];
	  const dom = this;
	  let i;
	  function fireCallBack(e) {
		/* jshint validthis:true */
		if (e.target !== this) return;
		callback.call(this, e);
		for (i = 0; i < events.length; i += 1) {
		  dom.off(events[i], fireCallBack);
		}
	  }
	  if (callback) {
		for (i = 0; i < events.length; i += 1) {
		  dom.on(events[i], fireCallBack);
		}
	  }
	  return this;
	}
	function animationEnd(callback) {
	  const events = ['webkitAnimationEnd', 'animationend'];
	  const dom = this;
	  let i;
	  function fireCallBack(e) {
		if (e.target !== this) return;
		callback.call(this, e);
		for (i = 0; i < events.length; i += 1) {
		  dom.off(events[i], fireCallBack);
		}
	  }
	  if (callback) {
		for (i = 0; i < events.length; i += 1) {
		  dom.on(events[i], fireCallBack);
		}
	  }
	  return this;
	}
// Sizing/Styles
	function width() {
	  if (this[0] === window) {
		return window.innerWidth;
	  }

	  if (this.length > 0) {
		return parseFloat(this.css('width'));
	  }

	  return null;
	}
	function dom7_modular_outerWidth(includeMargins) {
	  if (this.length > 0) {
		if (includeMargins) {
		  // eslint-disable-next-line
		  const styles = this.styles();
		  return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
		}
		return this[0].offsetWidth;
	  }
	  return null;
	}
	function height() {
	  if (this[0] === window) {
		return window.innerHeight;
	  }

	  if (this.length > 0) {
		return parseFloat(this.css('height'));
	  }

	  return null;
	}
	function dom7_modular_outerHeight(includeMargins) {
	  if (this.length > 0) {
		if (includeMargins) {
		  // eslint-disable-next-line
		  const styles = this.styles();
		  return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
		}
		return this[0].offsetHeight;
	  }
	  return null;
	}
	function offset() {
	  if (this.length > 0) {
		const el = this[0];
		const box = el.getBoundingClientRect();
		const body = doc.body;
		const clientTop = el.clientTop || body.clientTop || 0;
		const clientLeft = el.clientLeft || body.clientLeft || 0;
		const scrollTop = el === win ? win.scrollY : el.scrollTop;
		const scrollLeft = el === win ? win.scrollX : el.scrollLeft;
		return {
		  top: (box.top + scrollTop) - clientTop,
		  left: (box.left + scrollLeft) - clientLeft,
		};
	  }

	  return null;
	}
	function hide() {
	  for (let i = 0; i < this.length; i += 1) {
		this[i].style.display = 'none';
	  }
	  return this;
	}
	function dom7_modular_show() {
	  for (let i = 0; i < this.length; i += 1) {
		const el = this[i];
		if (el.style.display === 'none') {
		  el.style.display = '';
		}
		if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
		  // Still not visible
		  el.style.display = 'block';
		}
	  }
	  return this;
	}
	function styles() {
	  if (this[0]) return win.getComputedStyle(this[0], null);
	  return {};
	}
	function css(props, value) {
	  let i;
	  if (arguments.length === 1) {
		if (typeof props === 'string') {
		  if (this[0]) return win.getComputedStyle(this[0], null).getPropertyValue(props);
		} else {
		  for (i = 0; i < this.length; i += 1) {
			// eslint-disable-next-line
			for (let prop in props) {
			  this[i].style[prop] = props[prop];
			}
		  }
		  return this;
		}
	  }
	  if (arguments.length === 2 && typeof props === 'string') {
		for (i = 0; i < this.length; i += 1) {
		  this[i].style[props] = value;
		}
		return this;
	  }
	  return this;
	}

// Dom manipulation
	function dom7_modular_toArray() {
	  const arr = [];
	  for (let i = 0; i < this.length; i += 1) {
		arr.push(this[i]);
	  }
	  return arr;
	}
// Iterate over the collection passing elements to `callback`
	function each(callback) {
	  // Don't bother continuing without a callback
	  if (!callback) return this;
	  // Iterate over the current collection
	  for (let i = 0; i < this.length; i += 1) {
		// If the callback returns false
		if (callback.call(this[i], i, this[i]) === false) {
		  // End the loop early
		  return this;
		}
	  }
	  // Return `this` to allow chained DOM operations
	  return this;
	}
	function forEach(callback) {
	  // Don't bother continuing without a callback
	  if (!callback) return this;
	  // Iterate over the current collection
	  for (let i = 0; i < this.length; i += 1) {
		// If the callback returns false
		if (callback.call(this[i], this[i], i) === false) {
		  // End the loop early
		  return this;
		}
	  }
	  // Return `this` to allow chained DOM operations
	  return this;
	}
	function filter(callback) {
	  const matchedItems = [];
	  const dom = this;
	  for (let i = 0; i < dom.length; i += 1) {
		if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
	  }
	  return new Dom7(matchedItems);
	}
	function map(callback) {
	  const modifiedItems = [];
	  const dom = this;
	  for (let i = 0; i < dom.length; i += 1) {
		modifiedItems.push(callback.call(dom[i], i, dom[i]));
	  }
	  return new Dom7(modifiedItems);
	}
// eslint-disable-next-line
	function dom7_modular_html(html) {
	  if (typeof html === 'undefined') {
		return this[0] ? this[0].innerHTML : undefined;
	  }

	  for (let i = 0; i < this.length; i += 1) {
		this[i].innerHTML = html;
	  }
	  return this;
	}
// eslint-disable-next-line
	function dom7_modular_text(text) {
	  if (typeof text === 'undefined') {
		if (this[0]) {
		  return this[0].textContent.trim();
		}
		return null;
	  }

	  for (let i = 0; i < this.length; i += 1) {
		this[i].textContent = text;
	  }
	  return this;
	}
	function is(selector) {
	  const el = this[0];
	  let compareWith;
	  let i;
	  if (!el || typeof selector === 'undefined') return false;
	  if (typeof selector === 'string') {
		if (el.matches) return el.matches(selector);
		else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
		else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

		compareWith = $(selector);
		for (i = 0; i < compareWith.length; i += 1) {
		  if (compareWith[i] === el) return true;
		}
		return false;
	  } else if (selector === doc) return el === doc;
	  else if (selector === win) return el === win;

	  if (selector.nodeType || selector instanceof Dom7) {
		compareWith = selector.nodeType ? [selector] : selector;
		for (i = 0; i < compareWith.length; i += 1) {
		  if (compareWith[i] === el) return true;
		}
		return false;
	  }
	  return false;
	}
	function indexOf(el) {
	  for (let i = 0; i < this.length; i += 1) {
		if (this[i] === el) return i;
	  }
	  return -1;
	}
	function dom7_modular_index() {
	  let child = this[0];
	  let i;
	  if (child) {
		i = 0;
		// eslint-disable-next-line
		while ((child = child.previousSibling) !== null) {
		  if (child.nodeType === 1) i += 1;
		}
		return i;
	  }
	  return undefined;
	}
// eslint-disable-next-line
	function eq(index) {
	  if (typeof index === 'undefined') return this;
	  const length = this.length;
	  let returnIndex;
	  if (index > length - 1) {
		return new Dom7([]);
	  }
	  if (index < 0) {
		returnIndex = length + index;
		if (returnIndex < 0) return new Dom7([]);
		return new Dom7([this[returnIndex]]);
	  }
	  return new Dom7([this[index]]);
	}
	function append(...args) {
	  let newChild;

	  for (let k = 0; k < args.length; k += 1) {
		newChild = args[k];
		for (let i = 0; i < this.length; i += 1) {
		  if (typeof newChild === 'string') {
			const tempDiv = doc.createElement('div');
			tempDiv.innerHTML = newChild;
			while (tempDiv.firstChild) {
			  this[i].appendChild(tempDiv.firstChild);
			}
		  } else if (newChild instanceof Dom7) {
			for (let j = 0; j < newChild.length; j += 1) {
			  this[i].appendChild(newChild[j]);
			}
		  } else {
			this[i].appendChild(newChild);
		  }
		}
	  }

	  return this;
	}
// eslint-disable-next-line
	function appendTo(parent) {
	  $(parent).append(this);
	  return this;
	}
	function prepend(newChild) {
	  let i;
	  let j;
	  for (i = 0; i < this.length; i += 1) {
		if (typeof newChild === 'string') {
		  const tempDiv = doc.createElement('div');
		  tempDiv.innerHTML = newChild;
		  for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
			this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
		  }
		} else if (newChild instanceof Dom7) {
		  for (j = 0; j < newChild.length; j += 1) {
			this[i].insertBefore(newChild[j], this[i].childNodes[0]);
		  }
		} else {
		  this[i].insertBefore(newChild, this[i].childNodes[0]);
		}
	  }
	  return this;
	}
// eslint-disable-next-line
	function prependTo(parent) {
	  $(parent).prepend(this);
	  return this;
	}
	function dom7_modular_insertBefore(selector) {
	  const before = $(selector);
	  for (let i = 0; i < this.length; i += 1) {
		if (before.length === 1) {
		  before[0].parentNode.insertBefore(this[i], before[0]);
		} else if (before.length > 1) {
		  for (let j = 0; j < before.length; j += 1) {
			before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
		  }
		}
	  }
	}
	function insertAfter(selector) {
	  const after = $(selector);
	  for (let i = 0; i < this.length; i += 1) {
		if (after.length === 1) {
		  after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
		} else if (after.length > 1) {
		  for (let j = 0; j < after.length; j += 1) {
			after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
		  }
		}
	  }
	}
	function dom7_modular_next(selector) {
	  if (this.length > 0) {
		if (selector) {
		  if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
			return new Dom7([this[0].nextElementSibling]);
		  }
		  return new Dom7([]);
		}

		if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
		return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function nextAll(selector) {
	  const nextEls = [];
	  let el = this[0];
	  if (!el) return new Dom7([]);
	  while (el.nextElementSibling) {
		const next = el.nextElementSibling; // eslint-disable-line
		if (selector) {
		  if ($(next).is(selector)) nextEls.push(next);
		} else nextEls.push(next);
		el = next;
	  }
	  return new Dom7(nextEls);
	}
	function prev(selector) {
	  if (this.length > 0) {
		const el = this[0];
		if (selector) {
		  if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
			return new Dom7([el.previousElementSibling]);
		  }
		  return new Dom7([]);
		}

		if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
		return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function prevAll(selector) {
	  const prevEls = [];
	  let el = this[0];
	  if (!el) return new Dom7([]);
	  while (el.previousElementSibling) {
		const prev = el.previousElementSibling; // eslint-disable-line
		if (selector) {
		  if ($(prev).is(selector)) prevEls.push(prev);
		} else prevEls.push(prev);
		el = prev;
	  }
	  return new Dom7(prevEls);
	}
	function siblings(selector) {
	  return this.nextAll(selector).add(this.prevAll(selector));
	}
	function dom7_modular_parent(selector) {
	  const parents = []; // eslint-disable-line
	  for (let i = 0; i < this.length; i += 1) {
		if (this[i].parentNode !== null) {
		  if (selector) {
			if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
		  } else {
			parents.push(this[i].parentNode);
		  }
		}
	  }
	  return $(unique(parents));
	}
	function parents(selector) {
	  const parents = []; // eslint-disable-line
	  for (let i = 0; i < this.length; i += 1) {
		let parent = this[i].parentNode; // eslint-disable-line
		while (parent) {
		  if (selector) {
			if ($(parent).is(selector)) parents.push(parent);
		  } else {
			parents.push(parent);
		  }
		  parent = parent.parentNode;
		}
	  }
	  return $(unique(parents));
	}
	function closest(selector) {
	  let closest = this; // eslint-disable-line
	  if (typeof selector === 'undefined') {
		return new Dom7([]);
	  }
	  if (!closest.is(selector)) {
		closest = closest.parents(selector).eq(0);
	  }
	  return closest;
	}
	function find(selector) {
	  const foundElements = [];
	  for (let i = 0; i < this.length; i += 1) {
		const found = this[i].querySelectorAll(selector);
		for (let j = 0; j < found.length; j += 1) {
		  foundElements.push(found[j]);
		}
	  }
	  return new Dom7(foundElements);
	}
	function children(selector) {
	  const children = []; // eslint-disable-line
	  for (let i = 0; i < this.length; i += 1) {
		const childNodes = this[i].childNodes;

		for (let j = 0; j < childNodes.length; j += 1) {
		  if (!selector) {
			if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
		  } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
			children.push(childNodes[j]);
		  }
		}
	  }
	  return new Dom7(unique(children));
	}
	function dom7_modular_remove() {
	  for (let i = 0; i < this.length; i += 1) {
		if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }
	  return this;
	}
	function detach() {
	  return this.remove();
	}
	function dom7_modular_add(...args) {
	  const dom = this;
	  let i;
	  let j;
	  for (i = 0; i < args.length; i += 1) {
		const toAdd = $(args[i]);
		for (j = 0; j < toAdd.length; j += 1) {
		  dom[dom.length] = toAdd[j];
		  dom.length += 1;
		}
	  }
	  return dom;
	}
	function empty() {
	  for (let i = 0; i < this.length; i += 1) {
		const el = this[i];
		if (el.nodeType === 1) {
		  for (let j = 0; j < el.childNodes.length; j += 1) {
			if (el.childNodes[j].parentNode) {
			  el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
			}
		  }
		  el.textContent = '';
		}
	  }
	  return this;
	}

	function scrollTo(...args) {
	  let [left, top, duration, easing, callback] = args;
	  if (args.length === 4 && typeof easing === 'function') {
		callback = easing;
		[left, top, duration, callback, easing] = args;
	  }
	  if (typeof easing === 'undefined') easing = 'swing';

	  return this.each(function animate() {
		const el = this;
		let currentTop;
		let currentLeft;
		let maxTop;
		let maxLeft;
		let newTop;
		let newLeft;
		let scrollTop; // eslint-disable-line
		let scrollLeft; // eslint-disable-line
		let animateTop = top > 0 || top === 0;
		let animateLeft = left > 0 || left === 0;
		if (typeof easing === 'undefined') {
		  easing = 'swing';
		}
		if (animateTop) {
		  currentTop = el.scrollTop;
		  if (!duration) {
			el.scrollTop = top;
		  }
		}
		if (animateLeft) {
		  currentLeft = el.scrollLeft;
		  if (!duration) {
			el.scrollLeft = left;
		  }
		}
		if (!duration) return;
		if (animateTop) {
		  maxTop = el.scrollHeight - el.offsetHeight;
		  newTop = Math.max(Math.min(top, maxTop), 0);
		}
		if (animateLeft) {
		  maxLeft = el.scrollWidth - el.offsetWidth;
		  newLeft = Math.max(Math.min(left, maxLeft), 0);
		}
		let startTime = null;
		if (animateTop && newTop === currentTop) animateTop = false;
		if (animateLeft && newLeft === currentLeft) animateLeft = false;
		function render(time = new Date().getTime()) {
		  if (startTime === null) {
			startTime = time;
		  }
		  const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
		  const easeProgress = easing === 'linear' ? progress : (0.5 - (Math.cos(progress * Math.PI) / 2));
		  let done;
		  if (animateTop) scrollTop = currentTop + (easeProgress * (newTop - currentTop));
		  if (animateLeft) scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
		  if (animateTop && newTop > currentTop && scrollTop >= newTop) {
			el.scrollTop = newTop;
			done = true;
		  }
		  if (animateTop && newTop < currentTop && scrollTop <= newTop) {
			el.scrollTop = newTop;
			done = true;
		  }
		  if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
			el.scrollLeft = newLeft;
			done = true;
		  }
		  if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
			el.scrollLeft = newLeft;
			done = true;
		  }

		  if (done) {
			if (callback) callback();
			return;
		  }
		  if (animateTop) el.scrollTop = scrollTop;
		  if (animateLeft) el.scrollLeft = scrollLeft;
		  dom7_modular_requestAnimationFrame(render);
		}
		dom7_modular_requestAnimationFrame(render);
	  });
	}
// scrollTop(top, duration, easing, callback) {
	function scrollTop(...args) {
	  let [top, duration, easing, callback] = args;
	  if (args.length === 3 && typeof easing === 'function') {
		[top, duration, callback, easing] = args;
	  }
	  const dom = this;
	  if (typeof top === 'undefined') {
		if (dom.length > 0) return dom[0].scrollTop;
		return null;
	  }
	  return dom.scrollTo(undefined, top, duration, easing, callback);
	}
	function scrollLeft(...args) {
	  let [left, duration, easing, callback] = args;
	  if (args.length === 3 && typeof easing === 'function') {
		[left, duration, callback, easing] = args;
	  }
	  const dom = this;
	  if (typeof left === 'undefined') {
		if (dom.length > 0) return dom[0].scrollLeft;
		return null;
	  }
	  return dom.scrollTo(left, undefined, duration, easing, callback);
	}

	function animate(initialProps, initialParams) {
	  const els = this;
	  const a = {
		props: Object.assign({}, initialProps),
		params: Object.assign({
		  duration: 300,
		  easing: 'swing', // or 'linear'
		  /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
		}, initialParams),

		elements: els,
		animating: false,
		que: [],

		easingProgress(easing, progress) {
		  if (easing === 'swing') {
			return 0.5 - (Math.cos(progress * Math.PI) / 2);
		  }
		  if (typeof easing === 'function') {
			return easing(progress);
		  }
		  return progress;
		},
		stop() {
		  if (a.frameId) {
			dom7_modular_cancelAnimationFrame(a.frameId);
		  }
		  a.animating = false;
		  a.elements.each((index, el) => {
			const element = el;
			delete element.dom7AnimateInstance;
		  });
		  a.que = [];
		},
		done(complete) {
		  a.animating = false;
		  a.elements.each((index, el) => {
			const element = el;
			delete element.dom7AnimateInstance;
		  });
		  if (complete) complete(els);
		  if (a.que.length > 0) {
			const que = a.que.shift();
			a.animate(que[0], que[1]);
		  }
		},
		animate(props, params) {
		  if (a.animating) {
			a.que.push([props, params]);
			return a;
		  }
		  const elements = [];

		  // Define & Cache Initials & Units
		  a.elements.each((index, el) => {
			let initialFullValue;
			let initialValue;
			let unit;
			let finalValue;
			let finalFullValue;

			if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;

			elements[index] = {
			  container: el,
			};
			Object.keys(props).forEach((prop) => {
			  initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
			  initialValue = parseFloat(initialFullValue);
			  unit = initialFullValue.replace(initialValue, '');
			  finalValue = parseFloat(props[prop]);
			  finalFullValue = props[prop] + unit;
			  elements[index][prop] = {
				initialFullValue,
				initialValue,
				unit,
				finalValue,
				finalFullValue,
				currentValue: initialValue,
			  };
			});
		  });

		  let startTime = null;
		  let time;
		  let elementsDone = 0;
		  let propsDone = 0;
		  let done;
		  let began = false;

		  a.animating = true;

		  function render() {
			time = new Date().getTime();
			let progress;
			let easeProgress;
			// let el;
			if (!began) {
			  began = true;
			  if (params.begin) params.begin(els);
			}
			if (startTime === null) {
			  startTime = time;
			}
			if (params.progress) {
			  // eslint-disable-next-line
			  params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time), startTime);
			}

			elements.forEach((element) => {
			  const el = element;
			  if (done || el.done) return;
			  Object.keys(props).forEach((prop) => {
				if (done || el.done) return;
				progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
				easeProgress = a.easingProgress(params.easing, progress);
				const { initialValue, finalValue, unit } = el[prop];
				el[prop].currentValue = initialValue + (easeProgress * (finalValue - initialValue));
				const currentValue = el[prop].currentValue;

				if (
					(finalValue > initialValue && currentValue >= finalValue) ||
					(finalValue < initialValue && currentValue <= finalValue)) {
				  el.container.style[prop] = finalValue + unit;
				  propsDone += 1;
				  if (propsDone === Object.keys(props).length) {
					el.done = true;
					elementsDone += 1;
				  }
				  if (elementsDone === elements.length) {
					done = true;
				  }
				}
				if (done) {
				  a.done(params.complete);
				  return;
				}
				el.container.style[prop] = currentValue + unit;
			  });
			});
			if (done) return;
			// Then call
			a.frameId = dom7_modular_requestAnimationFrame(render);
		  }
		  a.frameId = dom7_modular_requestAnimationFrame(render);
		  return a;
		},
	  };

	  if (a.elements.length === 0) {
		return els;
	  }

	  let animateInstance;
	  for (let i = 0; i < a.elements.length; i += 1) {
		if (a.elements[i].dom7AnimateInstance) {
		  animateInstance = a.elements[i].dom7AnimateInstance;
		} else a.elements[i].dom7AnimateInstance = a;
	  }
	  if (!animateInstance) {
		animateInstance = a;
	  }

	  if (initialProps === 'stop') {
		animateInstance.stop();
	  } else {
		animateInstance.animate(a.props, a.params);
	  }

	  return els;
	}

	function stop() {
	  const els = this;
	  for (let i = 0; i < els.length; i += 1) {
		if (els[i].dom7AnimateInstance) {
		  els[i].dom7AnimateInstance.stop();
		}
	  }
	}

	const noTrigger = ('resize scroll').split(' ');
	function eventShortcut(name, ...args) {
	  if (typeof args[0] === 'undefined') {
		for (let i = 0; i < this.length; i += 1) {
		  if (noTrigger.indexOf(name) < 0) {
			if (name in this[i]) this[i][name]();
			else {
			  $(this[i]).trigger(name);
			}
		  }
		}
		return this;
	  }
	  return this.on(name, ...args);
	}

	function click(...args) {
	  return eventShortcut.bind(this)('click', ...args);
	}
	function dom7_modular_blur(...args) {
	  return eventShortcut.bind(this)('blur', ...args);
	}
	function dom7_modular_focus(...args) {
	  return eventShortcut.bind(this)('focus', ...args);
	}
	function focusin(...args) {
	  return eventShortcut.bind(this)('focusin', ...args);
	}
	function focusout(...args) {
	  return eventShortcut.bind(this)('focusout', ...args);
	}
	function keyup(...args) {
	  return eventShortcut.bind(this)('keyup', ...args);
	}
	function keydown(...args) {
	  return eventShortcut.bind(this)('keydown', ...args);
	}
	function keypress(...args) {
	  return eventShortcut.bind(this)('keypress', ...args);
	}
	function dom7_modular_submit(...args) {
	  return eventShortcut.bind(this)('submit', ...args);
	}
	function change(...args) {
	  return eventShortcut.bind(this)('change', ...args);
	}
	function mousedown(...args) {
	  return eventShortcut.bind(this)('mousedown', ...args);
	}
	function mousemove(...args) {
	  return eventShortcut.bind(this)('mousemove', ...args);
	}
	function mouseup(...args) {
	  return eventShortcut.bind(this)('mouseup', ...args);
	}
	function mouseenter(...args) {
	  return eventShortcut.bind(this)('mouseenter', ...args);
	}
	function mouseleave(...args) {
	  return eventShortcut.bind(this)('mouseleave', ...args);
	}
	function mouseout(...args) {
	  return eventShortcut.bind(this)('mouseout', ...args);
	}
	function mouseover(...args) {
	  return eventShortcut.bind(this)('mouseover', ...args);
	}
	function touchstart(...args) {
	  return eventShortcut.bind(this)('touchstart', ...args);
	}
	function touchend(...args) {
	  return eventShortcut.bind(this)('touchend', ...args);
	}
	function touchmove(...args) {
	  return eventShortcut.bind(this)('touchmove', ...args);
	}
	function resize(...args) {
	  return eventShortcut.bind(this)('resize', ...args);
	}
	function dom7_modular_scroll(...args) {
	  return eventShortcut.bind(this)('scroll', ...args);
	}



	;// CONCATENATED MODULE: ./node_modules/swiper/js/swiper.esm.bundle.js
	/**
	 * Swiper 5.4.5
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * http://swiperjs.com
	 *
	 * Copyright 2014-2020 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: June 16, 2020
	 */




	const Methods = {
	  addClass: dom7_modular_addClass,
	  removeClass: dom7_modular_removeClass,
	  hasClass: hasClass,
	  toggleClass: toggleClass,
	  attr: attr,
	  removeAttr: removeAttr,
	  data: data,
	  transform: transform,
	  transition: dom7_modular_transition,
	  on: dom7_modular_on,
	  off: off,
	  trigger: dom7_modular_trigger,
	  transitionEnd: transitionEnd,
	  outerWidth: dom7_modular_outerWidth,
	  outerHeight: dom7_modular_outerHeight,
	  offset: offset,
	  css: css,
	  each: each,
	  html: dom7_modular_html,
	  text: dom7_modular_text,
	  is: is,
	  index: dom7_modular_index,
	  eq: eq,
	  append: append,
	  prepend: prepend,
	  next: dom7_modular_next,
	  nextAll: nextAll,
	  prev: prev,
	  prevAll: prevAll,
	  parent: dom7_modular_parent,
	  parents: parents,
	  closest: closest,
	  find: find,
	  children: children,
	  filter: filter,
	  remove: dom7_modular_remove,
	  add: dom7_modular_add,
	  styles: styles,
	};

	Object.keys(Methods).forEach((methodName) => {
	  $.fn[methodName] = $.fn[methodName] || Methods[methodName];
	});

	const Utils = {
	  deleteProps(obj) {
		const object = obj;
		Object.keys(object).forEach((key) => {
		  try {
			object[key] = null;
		  } catch (e) {
			// no getter for object
		  }
		  try {
			delete object[key];
		  } catch (e) {
			// something got wrong
		  }
		});
	  },
	  nextTick(callback, delay = 0) {
		return setTimeout(callback, delay);
	  },
	  now() {
		return Date.now();
	  },
	  getTranslate(el, axis = 'x') {
		let matrix;
		let curTransform;
		let transformMatrix;

		const curStyle = win.getComputedStyle(el, null);

		if (win.WebKitCSSMatrix) {
		  curTransform = curStyle.transform || curStyle.webkitTransform;
		  if (curTransform.split(',').length > 6) {
			curTransform = curTransform.split(', ').map((a) => a.replace(',', '.')).join(', ');
		  }
		  // Some old versions of Webkit choke when 'none' is passed; pass
		  // empty string instead in this case
		  transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
		} else {
		  transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
		  matrix = transformMatrix.toString().split(',');
		}

		if (axis === 'x') {
		  // Latest Chrome and webkits Fix
		  if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41;
		  // Crazy IE10 Matrix
		  else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
		  // Normal Browsers
		  else curTransform = parseFloat(matrix[4]);
		}
		if (axis === 'y') {
		  // Latest Chrome and webkits Fix
		  if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42;
		  // Crazy IE10 Matrix
		  else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
		  // Normal Browsers
		  else curTransform = parseFloat(matrix[5]);
		}
		return curTransform || 0;
	  },
	  parseUrlQuery(url) {
		const query = {};
		let urlToParse = url || win.location.href;
		let i;
		let params;
		let param;
		let length;
		if (typeof urlToParse === 'string' && urlToParse.length) {
		  urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
		  params = urlToParse.split('&').filter((paramsPart) => paramsPart !== '');
		  length = params.length;

		  for (i = 0; i < length; i += 1) {
			param = params[i].replace(/#\S+/g, '').split('=');
			query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
		  }
		}
		return query;
	  },
	  isObject(o) {
		return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	  },
	  extend(...args) {
		const to = Object(args[0]);
		for (let i = 1; i < args.length; i += 1) {
		  const nextSource = args[i];
		  if (nextSource !== undefined && nextSource !== null) {
			const keysArray = Object.keys(Object(nextSource));
			for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
			  const nextKey = keysArray[nextIndex];
			  const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
			  if (desc !== undefined && desc.enumerable) {
				if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
				  Utils.extend(to[nextKey], nextSource[nextKey]);
				} else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
				  to[nextKey] = {};
				  Utils.extend(to[nextKey], nextSource[nextKey]);
				} else {
				  to[nextKey] = nextSource[nextKey];
				}
			  }
			}
		  }
		}
		return to;
	  },
	};

	const Support = (function Support() {
	  return {
		touch: !!(("ontouchstart" in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch)),

		pointerEvents: !!win.PointerEvent && ("maxTouchPoints" in win.navigator) && win.navigator.maxTouchPoints >= 0,

		observer: (function checkObserver() {
		  return ("MutationObserver" in win || "WebkitMutationObserver" in win);
		}()),

		passiveListener: (function checkPassiveListener() {
		  let supportsPassive = false;
		  try {
			const opts = Object.defineProperty({}, 'passive', {
			  // eslint-disable-next-line
			  get() {
				supportsPassive = true;
			  },
			});
			win.addEventListener('testPassiveListener', null, opts);
		  } catch (e) {
			// No support
		  }
		  return supportsPassive;
		}()),

		gestures: (function checkGestures() {
		  return "ongesturestart" in win;
		}()),
	  };
	}());

	class SwiperClass {
	  constructor(params = {}) {
		const self = this;
		self.params = params;

		// Events
		self.eventsListeners = {};

		if (self.params && self.params.on) {
		  Object.keys(self.params.on).forEach((eventName) => {
			self.on(eventName, self.params.on[eventName]);
		  });
		}
	  }

	  on(events, handler, priority) {
		const self = this;
		if (typeof handler !== 'function') return self;
		const method = priority ? 'unshift' : 'push';
		events.split(' ').forEach((event) => {
		  if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
		  self.eventsListeners[event][method](handler);
		});
		return self;
	  }

	  once(events, handler, priority) {
		const self = this;
		if (typeof handler !== 'function') return self;
		function onceHandler(...args) {
		  self.off(events, onceHandler);
		  if (onceHandler.f7proxy) {
			delete onceHandler.f7proxy;
		  }
		  handler.apply(self, args);
		}
		onceHandler.f7proxy = handler;
		return self.on(events, onceHandler, priority);
	  }

	  off(events, handler) {
		const self = this;
		if (!self.eventsListeners) return self;
		events.split(' ').forEach((event) => {
		  if (typeof handler === 'undefined') {
			self.eventsListeners[event] = [];
		  } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
			self.eventsListeners[event].forEach((eventHandler, index) => {
			  if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
				self.eventsListeners[event].splice(index, 1);
			  }
			});
		  }
		});
		return self;
	  }

	  emit(...args) {
		const self = this;
		if (!self.eventsListeners) return self;
		let events;
		let data;
		let context;
		if (typeof args[0] === 'string' || Array.isArray(args[0])) {
		  events = args[0];
		  data = args.slice(1, args.length);
		  context = self;
		} else {
		  events = args[0].events;
		  data = args[0].data;
		  context = args[0].context || self;
		}
		const eventsArray = Array.isArray(events) ? events : events.split(' ');
		eventsArray.forEach((event) => {
		  if (self.eventsListeners && self.eventsListeners[event]) {
			const handlers = [];
			self.eventsListeners[event].forEach((eventHandler) => {
			  handlers.push(eventHandler);
			});
			handlers.forEach((eventHandler) => {
			  eventHandler.apply(context, data);
			});
		  }
		});
		return self;
	  }

	  useModulesParams(instanceParams) {
		const instance = this;
		if (!instance.modules) return;
		Object.keys(instance.modules).forEach((moduleName) => {
		  const module = instance.modules[moduleName];
		  // Extend params
		  if (module.params) {
			Utils.extend(instanceParams, module.params);
		  }
		});
	  }

	  useModules(modulesParams = {}) {
		const instance = this;
		if (!instance.modules) return;
		Object.keys(instance.modules).forEach((moduleName) => {
		  const module = instance.modules[moduleName];
		  const moduleParams = modulesParams[moduleName] || {};
		  // Extend instance methods and props
		  if (module.instance) {
			Object.keys(module.instance).forEach((modulePropName) => {
			  const moduleProp = module.instance[modulePropName];
			  if (typeof moduleProp === 'function') {
				instance[modulePropName] = moduleProp.bind(instance);
			  } else {
				instance[modulePropName] = moduleProp;
			  }
			});
		  }
		  // Add event listeners
		  if (module.on && instance.on) {
			Object.keys(module.on).forEach((moduleEventName) => {
			  instance.on(moduleEventName, module.on[moduleEventName]);
			});
		  }

		  // Module create callback
		  if (module.create) {
			module.create.bind(instance)(moduleParams);
		  }
		});
	  }

	  static set components(components) {
		const Class = this;
		if (!Class.use) return;
		Class.use(components);
	  }

	  static installModule(module, ...params) {
		const Class = this;
		if (!Class.prototype.modules) Class.prototype.modules = {};
		const name = module.name || (`${Object.keys(Class.prototype.modules).length}_${Utils.now()}`);
		Class.prototype.modules[name] = module;
		// Prototype
		if (module.proto) {
		  Object.keys(module.proto).forEach((key) => {
			Class.prototype[key] = module.proto[key];
		  });
		}
		// Class
		if (module.static) {
		  Object.keys(module.static).forEach((key) => {
			Class[key] = module.static[key];
		  });
		}
		// Callback
		if (module.install) {
		  module.install.apply(Class, params);
		}
		return Class;
	  }

	  static use(module, ...params) {
		const Class = this;
		if (Array.isArray(module)) {
		  module.forEach((m) => Class.installModule(m));
		  return Class;
		}
		return Class.installModule(module, ...params);
	  }
	}

	function updateSize () {
	  const swiper = this;
	  let width;
	  let height;
	  const $el = swiper.$el;
	  if (typeof swiper.params.width !== 'undefined') {
		width = swiper.params.width;
	  } else {
		width = $el[0].clientWidth;
	  }
	  if (typeof swiper.params.height !== 'undefined') {
		height = swiper.params.height;
	  } else {
		height = $el[0].clientHeight;
	  }
	  if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
		return;
	  }

	  // Subtract paddings
	  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

	  Utils.extend(swiper, {
		width,
		height,
		size: swiper.isHorizontal() ? width : height,
	  });
	}

	function updateSlides () {
	  const swiper = this;
	  const params = swiper.params;

	  const {
		$wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL,
	  } = swiper;
	  const isVirtual = swiper.virtual && params.virtual.enabled;
	  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
	  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  let snapGrid = [];
	  const slidesGrid = [];
	  const slidesSizesGrid = [];

	  function slidesForMargin(slideIndex) {
		if (!params.cssMode) return true;
		if (slideIndex === slides.length - 1) {
		  return false;
		}
		return true;
	  }

	  let offsetBefore = params.slidesOffsetBefore;
	  if (typeof offsetBefore === 'function') {
		offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }

	  let offsetAfter = params.slidesOffsetAfter;
	  if (typeof offsetAfter === 'function') {
		offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }

	  const previousSnapGridLength = swiper.snapGrid.length;
	  const previousSlidesGridLength = swiper.snapGrid.length;

	  let spaceBetween = params.spaceBetween;
	  let slidePosition = -offsetBefore;
	  let prevSlideSize = 0;
	  let index = 0;
	  if (typeof swiperSize === 'undefined') {
		return;
	  }
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
		spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	  }

	  swiper.virtualSize = -spaceBetween;

	  // reset margins
	  if (rtl) slides.css({ marginLeft: '', marginTop: '' });
	  else slides.css({ marginRight: '', marginBottom: '' });

	  let slidesNumberEvenToRows;
	  if (params.slidesPerColumn > 1) {
		if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
		  slidesNumberEvenToRows = slidesLength;
		} else {
		  slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
		}
		if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
		  slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
		}
	  }

	  // Calc slides
	  let slideSize;
	  const slidesPerColumn = params.slidesPerColumn;
	  const slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  const numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
	  for (let i = 0; i < slidesLength; i += 1) {
		slideSize = 0;
		const slide = slides.eq(i);
		if (params.slidesPerColumn > 1) {
		  // Set slides order
		  let newSlideOrderIndex;
		  let column;
		  let row;
		  if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
			const groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
			const slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
			const columnsInGroup = groupIndex === 0
				? params.slidesPerGroup
				: Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
			row = Math.floor(slideIndexInGroup / columnsInGroup);
			column = (slideIndexInGroup - row * columnsInGroup) + groupIndex * params.slidesPerGroup;

			newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
			slide
				.css({
				  '-webkit-box-ordinal-group': newSlideOrderIndex,
				  '-moz-box-ordinal-group': newSlideOrderIndex,
				  '-ms-flex-order': newSlideOrderIndex,
				  '-webkit-order': newSlideOrderIndex,
				  order: newSlideOrderIndex,
				});
		  } else if (params.slidesPerColumnFill === 'column') {
			column = Math.floor(i / slidesPerColumn);
			row = i - (column * slidesPerColumn);
			if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
			  row += 1;
			  if (row >= slidesPerColumn) {
				row = 0;
				column += 1;
			  }
			}
		  } else {
			row = Math.floor(i / slidesPerRow);
			column = i - (row * slidesPerRow);
		  }
		  slide.css(
			  `margin-${swiper.isHorizontal() ? 'top' : 'left'}`,
			  (row !== 0 && params.spaceBetween) && (`${params.spaceBetween}px`)
		  );
		}
		if (slide.css('display') === 'none') continue; // eslint-disable-line

		if (params.slidesPerView === 'auto') {
		  const slideStyles = win.getComputedStyle(slide[0], null);
		  const currentTransform = slide[0].style.transform;
		  const currentWebKitTransform = slide[0].style.webkitTransform;
		  if (currentTransform) {
			slide[0].style.transform = 'none';
		  }
		  if (currentWebKitTransform) {
			slide[0].style.webkitTransform = 'none';
		  }
		  if (params.roundLengths) {
			slideSize = swiper.isHorizontal()
				? slide.outerWidth(true)
				: slide.outerHeight(true);
		  } else {
			// eslint-disable-next-line
			if (swiper.isHorizontal()) {
			  const width = parseFloat(slideStyles.getPropertyValue('width'));
			  const paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
			  const paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
			  const marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
			  const marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
			  const boxSizing = slideStyles.getPropertyValue('box-sizing');
			  if (boxSizing && boxSizing === 'border-box') {
				slideSize = width + marginLeft + marginRight;
			  } else {
				slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
			  }
			} else {
			  const height = parseFloat(slideStyles.getPropertyValue('height'));
			  const paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
			  const paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
			  const marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
			  const marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
			  const boxSizing = slideStyles.getPropertyValue('box-sizing');
			  if (boxSizing && boxSizing === 'border-box') {
				slideSize = height + marginTop + marginBottom;
			  } else {
				slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
			  }
			}
		  }
		  if (currentTransform) {
			slide[0].style.transform = currentTransform;
		  }
		  if (currentWebKitTransform) {
			slide[0].style.webkitTransform = currentWebKitTransform;
		  }
		  if (params.roundLengths) slideSize = Math.floor(slideSize);
		} else {
		  slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
		  if (params.roundLengths) slideSize = Math.floor(slideSize);

		  if (slides[i]) {
			if (swiper.isHorizontal()) {
			  slides[i].style.width = `${slideSize}px`;
			} else {
			  slides[i].style.height = `${slideSize}px`;
			}
		  }
		}
		if (slides[i]) {
		  slides[i].swiperSlideSize = slideSize;
		}
		slidesSizesGrid.push(slideSize);


		if (params.centeredSlides) {
		  slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
		  if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - (swiperSize / 2) - spaceBetween;
		  if (i === 0) slidePosition = slidePosition - (swiperSize / 2) - spaceBetween;
		  if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
		  if (params.roundLengths) slidePosition = Math.floor(slidePosition);
		  if ((index) % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
		  slidesGrid.push(slidePosition);
		} else {
		  if (params.roundLengths) slidePosition = Math.floor(slidePosition);
		  if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
		  slidesGrid.push(slidePosition);
		  slidePosition = slidePosition + slideSize + spaceBetween;
		}

		swiper.virtualSize += slideSize + spaceBetween;

		prevSlideSize = slideSize;

		index += 1;
	  }
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  let newSlidesGrid;

	  if (
		  rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
		$wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
	  }
	  if (params.setWrapperSize) {
		if (swiper.isHorizontal()) $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
		else $wrapperEl.css({ height: `${swiper.virtualSize + params.spaceBetween}px` });
	  }

	  if (params.slidesPerColumn > 1) {
		swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
		swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
		if (swiper.isHorizontal()) $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
		else $wrapperEl.css({ height: `${swiper.virtualSize + params.spaceBetween}px` });
		if (params.centeredSlides) {
		  newSlidesGrid = [];
		  for (let i = 0; i < snapGrid.length; i += 1) {
			let slidesGridItem = snapGrid[i];
			if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
			if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
		  }
		  snapGrid = newSlidesGrid;
		}
	  }

	  // Remove last grid elements depending on width
	  if (!params.centeredSlides) {
		newSlidesGrid = [];
		for (let i = 0; i < snapGrid.length; i += 1) {
		  let slidesGridItem = snapGrid[i];
		  if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
		  if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
			newSlidesGrid.push(slidesGridItem);
		  }
		}
		snapGrid = newSlidesGrid;
		if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
		  snapGrid.push(swiper.virtualSize - swiperSize);
		}
	  }
	  if (snapGrid.length === 0) snapGrid = [0];

	  if (params.spaceBetween !== 0) {
		if (swiper.isHorizontal()) {
		  if (rtl) slides.filter(slidesForMargin).css({ marginLeft: `${spaceBetween}px` });
		  else slides.filter(slidesForMargin).css({ marginRight: `${spaceBetween}px` });
		} else slides.filter(slidesForMargin).css({ marginBottom: `${spaceBetween}px` });
	  }

	  if (params.centeredSlides && params.centeredSlidesBounds) {
		let allSlidesSize = 0;
		slidesSizesGrid.forEach((slideSizeValue) => {
		  allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
		});
		allSlidesSize -= params.spaceBetween;
		const maxSnap = allSlidesSize - swiperSize;
		snapGrid = snapGrid.map((snap) => {
		  if (snap < 0) return -offsetBefore;
		  if (snap > maxSnap) return maxSnap + offsetAfter;
		  return snap;
		});
	  }

	  if (params.centerInsufficientSlides) {
		let allSlidesSize = 0;
		slidesSizesGrid.forEach((slideSizeValue) => {
		  allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
		});
		allSlidesSize -= params.spaceBetween;
		if (allSlidesSize < swiperSize) {
		  const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
		  snapGrid.forEach((snap, snapIndex) => {
			snapGrid[snapIndex] = snap - allSlidesOffset;
		  });
		  slidesGrid.forEach((snap, snapIndex) => {
			slidesGrid[snapIndex] = snap + allSlidesOffset;
		  });
		}
	  }

	  Utils.extend(swiper, {
		slides,
		snapGrid,
		slidesGrid,
		slidesSizesGrid,
	  });

	  if (slidesLength !== previousSlidesLength) {
		swiper.emit('slidesLengthChange');
	  }
	  if (snapGrid.length !== previousSnapGridLength) {
		if (swiper.params.watchOverflow) swiper.checkOverflow();
		swiper.emit('snapGridLengthChange');
	  }
	  if (slidesGrid.length !== previousSlidesGridLength) {
		swiper.emit('slidesGridLengthChange');
	  }

	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
		swiper.updateSlidesOffset();
	  }
	}

	function updateAutoHeight (speed) {
	  const swiper = this;
	  const activeSlides = [];
	  let newHeight = 0;
	  let i;
	  if (typeof speed === 'number') {
		swiper.setTransition(speed);
	  } else if (speed === true) {
		swiper.setTransition(swiper.params.speed);
	  }
	  // Find slides currently in view
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
		if (swiper.params.centeredSlides) {
		  swiper.visibleSlides.each((index, slide) => {
			activeSlides.push(slide);
		  });
		} else {
		  for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
			const index = swiper.activeIndex + i;
			if (index > swiper.slides.length) break;
			activeSlides.push(swiper.slides.eq(index)[0]);
		  }
		}
	  } else {
		activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	  }

	  // Find new height from highest slide in view
	  for (i = 0; i < activeSlides.length; i += 1) {
		if (typeof activeSlides[i] !== 'undefined') {
		  const height = activeSlides[i].offsetHeight;
		  newHeight = height > newHeight ? height : newHeight;
		}
	  }

	  // Update Height
	  if (newHeight) swiper.$wrapperEl.css('height', `${newHeight}px`);
	}

	function updateSlidesOffset () {
	  const swiper = this;
	  const slides = swiper.slides;
	  for (let i = 0; i < slides.length; i += 1) {
		slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

	function updateSlidesProgress (translate = (this && this.translate) || 0) {
	  const swiper = this;
	  const params = swiper.params;

	  const { slides, rtlTranslate: rtl } = swiper;

	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();

	  let offsetCenter = -translate;
	  if (rtl) offsetCenter = translate;

	  // Visible Slides
	  slides.removeClass(params.slideVisibleClass);

	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];

	  for (let i = 0; i < slides.length; i += 1) {
		const slide = slides[i];
		const slideProgress = (
			(offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
		) / (slide.swiperSlideSize + params.spaceBetween);
		if (params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) {
		  const slideBefore = -(offsetCenter - slide.swiperSlideOffset);
		  const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
		  const isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
			  || (slideAfter > 1 && slideAfter <= swiper.size)
			  || (slideBefore <= 0 && slideAfter >= swiper.size);
		  if (isVisible) {
			swiper.visibleSlides.push(slide);
			swiper.visibleSlidesIndexes.push(i);
			slides.eq(i).addClass(params.slideVisibleClass);
		  }
		}
		slide.progress = rtl ? -slideProgress : slideProgress;
	  }
	  swiper.visibleSlides = $(swiper.visibleSlides);
	}

	function updateProgress (translate) {
	  const swiper = this;
	  if (typeof translate === 'undefined') {
		const multiplier = swiper.rtlTranslate ? -1 : 1;
		// eslint-disable-next-line
		translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
	  }
	  const params = swiper.params;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  let { progress, isBeginning, isEnd } = swiper;
	  const wasBeginning = isBeginning;
	  const wasEnd = isEnd;
	  if (translatesDiff === 0) {
		progress = 0;
		isBeginning = true;
		isEnd = true;
	  } else {
		progress = (translate - swiper.minTranslate()) / (translatesDiff);
		isBeginning = progress <= 0;
		isEnd = progress >= 1;
	  }
	  Utils.extend(swiper, {
		progress,
		isBeginning,
		isEnd,
	  });

	  if (params.watchSlidesProgress || params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) swiper.updateSlidesProgress(translate);

	  if (isBeginning && !wasBeginning) {
		swiper.emit('reachBeginning toEdge');
	  }
	  if (isEnd && !wasEnd) {
		swiper.emit('reachEnd toEdge');
	  }
	  if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
		swiper.emit('fromEdge');
	  }

	  swiper.emit('progress', progress);
	}

	function updateSlidesClasses () {
	  const swiper = this;

	  const {
		slides, params, $wrapperEl, activeIndex, realIndex,
	  } = swiper;
	  const isVirtual = swiper.virtual && params.virtual.enabled;

	  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);

	  let activeSlide;
	  if (isVirtual) {
		activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
	  } else {
		activeSlide = slides.eq(activeIndex);
	  }

	  // Active classes
	  activeSlide.addClass(params.slideActiveClass);

	  if (params.loop) {
		// Duplicate to all looped slides
		if (activeSlide.hasClass(params.slideDuplicateClass)) {
		  $wrapperEl
			  .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`)
			  .addClass(params.slideDuplicateActiveClass);
		} else {
		  $wrapperEl
			  .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`)
			  .addClass(params.slideDuplicateActiveClass);
		}
	  }
	  // Next Slide
	  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
	  if (params.loop && nextSlide.length === 0) {
		nextSlide = slides.eq(0);
		nextSlide.addClass(params.slideNextClass);
	  }
	  // Prev Slide
	  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
	  if (params.loop && prevSlide.length === 0) {
		prevSlide = slides.eq(-1);
		prevSlide.addClass(params.slidePrevClass);
	  }
	  if (params.loop) {
		// Duplicate to all looped slides
		if (nextSlide.hasClass(params.slideDuplicateClass)) {
		  $wrapperEl
			  .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`)
			  .addClass(params.slideDuplicateNextClass);
		} else {
		  $wrapperEl
			  .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`)
			  .addClass(params.slideDuplicateNextClass);
		}
		if (prevSlide.hasClass(params.slideDuplicateClass)) {
		  $wrapperEl
			  .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`)
			  .addClass(params.slideDuplicatePrevClass);
		} else {
		  $wrapperEl
			  .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`)
			  .addClass(params.slideDuplicatePrevClass);
		}
	  }
	}

	function updateActiveIndex (newActiveIndex) {
	  const swiper = this;
	  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  const {
		slidesGrid, snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex,
	  } = swiper;
	  let activeIndex = newActiveIndex;
	  let snapIndex;
	  if (typeof activeIndex === 'undefined') {
		for (let i = 0; i < slidesGrid.length; i += 1) {
		  if (typeof slidesGrid[i + 1] !== 'undefined') {
			if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
			  activeIndex = i;
			} else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
			  activeIndex = i + 1;
			}
		  } else if (translate >= slidesGrid[i]) {
			activeIndex = i;
		  }
		}
		// Normalize slideIndex
		if (params.normalizeSlideIndex) {
		  if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
		}
	  }
	  if (snapGrid.indexOf(translate) >= 0) {
		snapIndex = snapGrid.indexOf(translate);
	  } else {
		const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
		snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	  if (activeIndex === previousIndex) {
		if (snapIndex !== previousSnapIndex) {
		  swiper.snapIndex = snapIndex;
		  swiper.emit('snapIndexChange');
		}
		return;
	  }

	  // Get real index
	  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

	  Utils.extend(swiper, {
		snapIndex,
		realIndex,
		previousIndex,
		activeIndex,
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	  if (previousRealIndex !== realIndex) {
		swiper.emit('realIndexChange');
	  }
	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
		swiper.emit('slideChange');
	  }
	}

	function updateClickedSlide (e) {
	  const swiper = this;
	  const params = swiper.params;
	  const slide = $(e.target).closest(`.${params.slideClass}`)[0];
	  let slideFound = false;
	  if (slide) {
		for (let i = 0; i < swiper.slides.length; i += 1) {
		  if (swiper.slides[i] === slide) slideFound = true;
		}
	  }

	  if (slide && slideFound) {
		swiper.clickedSlide = slide;
		if (swiper.virtual && swiper.params.virtual.enabled) {
		  swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
		} else {
		  swiper.clickedIndex = $(slide).index();
		}
	  } else {
		swiper.clickedSlide = undefined;
		swiper.clickedIndex = undefined;
		return;
	  }
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
		swiper.slideToClickedSlide();
	  }
	}

	var update = {
	  updateSize,
	  updateSlides,
	  updateAutoHeight,
	  updateSlidesOffset,
	  updateSlidesProgress,
	  updateProgress,
	  updateSlidesClasses,
	  updateActiveIndex,
	  updateClickedSlide,
	};

	function getTranslate (axis = this.isHorizontal() ? 'x' : 'y') {
	  const swiper = this;

	  const {
		params, rtlTranslate: rtl, translate, $wrapperEl,
	  } = swiper;

	  if (params.virtualTranslate) {
		return rtl ? -translate : translate;
	  }
	  if (params.cssMode) {
		return translate;
	  }

	  let currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	  if (rtl) currentTranslate = -currentTranslate;

	  return currentTranslate || 0;
	}

	function setTranslate (translate, byController) {
	  const swiper = this;
	  const {
		rtlTranslate: rtl, params, $wrapperEl, wrapperEl, progress,
	  } = swiper;
	  let x = 0;
	  let y = 0;
	  const z = 0;

	  if (swiper.isHorizontal()) {
		x = rtl ? -translate : translate;
	  } else {
		y = translate;
	  }

	  if (params.roundLengths) {
		x = Math.floor(x);
		y = Math.floor(y);
	  }

	  if (params.cssMode) {
		wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
		$wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
	  }
	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y;

	  // Check if we need to update progress
	  let newProgress;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
		newProgress = 0;
	  } else {
		newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	  }
	  if (newProgress !== progress) {
		swiper.updateProgress(translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, byController);
	}

	function minTranslate () {
	  return (-this.snapGrid[0]);
	}

	function maxTranslate () {
	  return (-this.snapGrid[this.snapGrid.length - 1]);
	}

	function translateTo (translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
	  const swiper = this;

	  const {
		params,
		wrapperEl,
	  } = swiper;

	  if (swiper.animating && params.preventInteractionOnTransition) {
		return false;
	  }

	  const minTranslate = swiper.minTranslate();
	  const maxTranslate = swiper.maxTranslate();
	  let newTranslate;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
	  else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
	  else newTranslate = translate;

	  // Update progress
	  swiper.updateProgress(newTranslate);

	  if (params.cssMode) {
		const isH = swiper.isHorizontal();
		if (speed === 0) {
		  wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
		} else {
		  // eslint-disable-next-line
		  if (wrapperEl.scrollTo) {
			wrapperEl.scrollTo({
			  [isH ? 'left' : 'top']: -newTranslate,
			  behavior: 'smooth',
			});
		  } else {
			wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
		  }
		}
		return true;
	  }

	  if (speed === 0) {
		swiper.setTransition(0);
		swiper.setTranslate(newTranslate);
		if (runCallbacks) {
		  swiper.emit('beforeTransitionStart', speed, internal);
		  swiper.emit('transitionEnd');
		}
	  } else {
		swiper.setTransition(speed);
		swiper.setTranslate(newTranslate);
		if (runCallbacks) {
		  swiper.emit('beforeTransitionStart', speed, internal);
		  swiper.emit('transitionStart');
		}
		if (!swiper.animating) {
		  swiper.animating = true;
		  if (!swiper.onTranslateToWrapperTransitionEnd) {
			swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
			  if (!swiper || swiper.destroyed) return;
			  if (e.target !== this) return;
			  swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
			  swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
			  swiper.onTranslateToWrapperTransitionEnd = null;
			  delete swiper.onTranslateToWrapperTransitionEnd;
			  if (runCallbacks) {
				swiper.emit('transitionEnd');
			  }
			};
		  }
		  swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
		  swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
		}
	  }

	  return true;
	}

	var translate = {
	  getTranslate,
	  setTranslate,
	  minTranslate,
	  maxTranslate,
	  translateTo,
	};

	function setTransition (duration, byController) {
	  const swiper = this;

	  if (!swiper.params.cssMode) {
		swiper.$wrapperEl.transition(duration);
	  }

	  swiper.emit('setTransition', duration, byController);
	}

	function transitionStart (runCallbacks = true, direction) {
	  const swiper = this;
	  const { activeIndex, params, previousIndex } = swiper;
	  if (params.cssMode) return;
	  if (params.autoHeight) {
		swiper.updateAutoHeight();
	  }

	  let dir = direction;
	  if (!dir) {
		if (activeIndex > previousIndex) dir = 'next';
		else if (activeIndex < previousIndex) dir = 'prev';
		else dir = 'reset';
	  }

	  swiper.emit('transitionStart');

	  if (runCallbacks && activeIndex !== previousIndex) {
		if (dir === 'reset') {
		  swiper.emit('slideResetTransitionStart');
		  return;
		}
		swiper.emit('slideChangeTransitionStart');
		if (dir === 'next') {
		  swiper.emit('slideNextTransitionStart');
		} else {
		  swiper.emit('slidePrevTransitionStart');
		}
	  }
	}

	function swiper_esm_bundle_transitionEnd (runCallbacks = true, direction) {
	  const swiper = this;
	  const { activeIndex, previousIndex, params } = swiper;
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);

	  let dir = direction;
	  if (!dir) {
		if (activeIndex > previousIndex) dir = 'next';
		else if (activeIndex < previousIndex) dir = 'prev';
		else dir = 'reset';
	  }

	  swiper.emit('transitionEnd');

	  if (runCallbacks && activeIndex !== previousIndex) {
		if (dir === 'reset') {
		  swiper.emit('slideResetTransitionEnd');
		  return;
		}
		swiper.emit('slideChangeTransitionEnd');
		if (dir === 'next') {
		  swiper.emit('slideNextTransitionEnd');
		} else {
		  swiper.emit('slidePrevTransitionEnd');
		}
	  }
	}

	var swiper_esm_bundle_transition = {
	  setTransition,
	  transitionStart,
	  transitionEnd: swiper_esm_bundle_transitionEnd,
	};

	function slideTo (index = 0, speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  let slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;

	  const {
		params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl,
	  } = swiper;
	  if (swiper.animating && params.preventInteractionOnTransition) {
		return false;
	  }

	  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
		swiper.emit('beforeSlideChangeStart');
	  }

	  const translate = -snapGrid[snapIndex];

	  // Update progress
	  swiper.updateProgress(translate);

	  // Normalize slideIndex
	  if (params.normalizeSlideIndex) {
		for (let i = 0; i < slidesGrid.length; i += 1) {
		  if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
			slideIndex = i;
		  }
		}
	  }
	  // Directions locks
	  if (swiper.initialized && slideIndex !== activeIndex) {
		if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
		  return false;
		}
		if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
		  if ((activeIndex || 0) !== slideIndex) return false;
		}
	  }

	  let direction;
	  if (slideIndex > activeIndex) direction = 'next';
	  else if (slideIndex < activeIndex) direction = 'prev';
	  else direction = 'reset';


	  // Update Index
	  if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
		swiper.updateActiveIndex(slideIndex);
		// Update Height
		if (params.autoHeight) {
		  swiper.updateAutoHeight();
		}
		swiper.updateSlidesClasses();
		if (params.effect !== 'slide') {
		  swiper.setTranslate(translate);
		}
		if (direction !== 'reset') {
		  swiper.transitionStart(runCallbacks, direction);
		  swiper.transitionEnd(runCallbacks, direction);
		}
		return false;
	  }
	  if (params.cssMode) {
		const isH = swiper.isHorizontal();
		let t = -translate;
		if (rtl) {
		  t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
		}
		if (speed === 0) {
		  wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
		} else {
		  // eslint-disable-next-line
		  if (wrapperEl.scrollTo) {
			wrapperEl.scrollTo({
			  [isH ? 'left' : 'top']: t,
			  behavior: 'smooth',
			});
		  } else {
			wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
		  }
		}
		return true;
	  }

	  if (speed === 0) {
		swiper.setTransition(0);
		swiper.setTranslate(translate);
		swiper.updateActiveIndex(slideIndex);
		swiper.updateSlidesClasses();
		swiper.emit('beforeTransitionStart', speed, internal);
		swiper.transitionStart(runCallbacks, direction);
		swiper.transitionEnd(runCallbacks, direction);
	  } else {
		swiper.setTransition(speed);
		swiper.setTranslate(translate);
		swiper.updateActiveIndex(slideIndex);
		swiper.updateSlidesClasses();
		swiper.emit('beforeTransitionStart', speed, internal);
		swiper.transitionStart(runCallbacks, direction);
		if (!swiper.animating) {
		  swiper.animating = true;
		  if (!swiper.onSlideToWrapperTransitionEnd) {
			swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
			  if (!swiper || swiper.destroyed) return;
			  if (e.target !== this) return;
			  swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
			  swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
			  swiper.onSlideToWrapperTransitionEnd = null;
			  delete swiper.onSlideToWrapperTransitionEnd;
			  swiper.transitionEnd(runCallbacks, direction);
			};
		  }
		  swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
		  swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
		}
	  }

	  return true;
	}

	function slideToLoop (index = 0, speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  let newIndex = index;
	  if (swiper.params.loop) {
		newIndex += swiper.loopedSlides;
	  }

	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideNext (speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  const { params, animating } = swiper;
	  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
	  if (params.loop) {
		if (animating) return false;
		swiper.loopFix();
		// eslint-disable-next-line
		swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slidePrev (speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  const {
		params, animating, snapGrid, slidesGrid, rtlTranslate,
	  } = swiper;

	  if (params.loop) {
		if (animating) return false;
		swiper.loopFix();
		// eslint-disable-next-line
		swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
	  function normalize(val) {
		if (val < 0) return -Math.floor(Math.abs(val));
		return Math.floor(val);
	  }
	  const normalizedTranslate = normalize(translate);
	  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
	  const normalizedSlidesGrid = slidesGrid.map((val) => normalize(val));

	  const currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	  if (typeof prevSnap === 'undefined' && params.cssMode) {
		snapGrid.forEach((snap) => {
		  if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
		});
	  }
	  let prevIndex;
	  if (typeof prevSnap !== 'undefined') {
		prevIndex = slidesGrid.indexOf(prevSnap);
		if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
	  }
	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideReset (speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideToClosest (speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
	  const swiper = this;
	  let index = swiper.activeIndex;
	  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);

	  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

	  if (translate >= swiper.snapGrid[snapIndex]) {
		// The current translate is on or after the current snap index, so the choice
		// is between the current index and the one after it.
		const currentSnap = swiper.snapGrid[snapIndex];
		const nextSnap = swiper.snapGrid[snapIndex + 1];
		if ((translate - currentSnap) > (nextSnap - currentSnap) * threshold) {
		  index += swiper.params.slidesPerGroup;
		}
	  } else {
		// The current translate is before the current snap index, so the choice
		// is between the current index and the one before it.
		const prevSnap = swiper.snapGrid[snapIndex - 1];
		const currentSnap = swiper.snapGrid[snapIndex];
		if ((translate - prevSnap) <= (currentSnap - prevSnap) * threshold) {
		  index -= swiper.params.slidesPerGroup;
		}
	  }
	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);

	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

	function slideToClickedSlide () {
	  const swiper = this;
	  const { params, $wrapperEl } = swiper;

	  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  let slideToIndex = swiper.clickedIndex;
	  let realIndex;
	  if (params.loop) {
		if (swiper.animating) return;
		realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
		if (params.centeredSlides) {
		  if (
			  (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
			  || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
		  ) {
			swiper.loopFix();
			slideToIndex = $wrapperEl
				.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`)
				.eq(0)
				.index();

			Utils.nextTick(() => {
			  swiper.slideTo(slideToIndex);
			});
		  } else {
			swiper.slideTo(slideToIndex);
		  }
		} else if (slideToIndex > swiper.slides.length - slidesPerView) {
		  swiper.loopFix();
		  slideToIndex = $wrapperEl
			  .children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`)
			  .eq(0)
			  .index();

		  Utils.nextTick(() => {
			swiper.slideTo(slideToIndex);
		  });
		} else {
		  swiper.slideTo(slideToIndex);
		}
	  } else {
		swiper.slideTo(slideToIndex);
	  }
	}

	var slide = {
	  slideTo,
	  slideToLoop,
	  slideNext,
	  slidePrev,
	  slideReset,
	  slideToClosest,
	  slideToClickedSlide,
	};

	function loopCreate () {
	  const swiper = this;
	  const { params, $wrapperEl } = swiper;
	  // Remove duplicated slides
	  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();

	  let slides = $wrapperEl.children(`.${params.slideClass}`);

	  if (params.loopFillGroupWithBlank) {
		const blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
		if (blankSlidesNum !== params.slidesPerGroup) {
		  for (let i = 0; i < blankSlidesNum; i += 1) {
			const blankNode = $(doc.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
			$wrapperEl.append(blankNode);
		  }
		  slides = $wrapperEl.children(`.${params.slideClass}`);
		}
	  }

	  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;

	  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	  swiper.loopedSlides += params.loopAdditionalSlides;
	  if (swiper.loopedSlides > slides.length) {
		swiper.loopedSlides = slides.length;
	  }

	  const prependSlides = [];
	  const appendSlides = [];
	  slides.each((index, el) => {
		const slide = $(el);
		if (index < swiper.loopedSlides) appendSlides.push(el);
		if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
		slide.attr('data-swiper-slide-index', index);
	  });
	  for (let i = 0; i < appendSlides.length; i += 1) {
		$wrapperEl.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
		$wrapperEl.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

	function loopFix () {
	  const swiper = this;

	  swiper.emit('beforeLoopFix');

	  const {
		activeIndex, slides, loopedSlides, allowSlidePrev, allowSlideNext, snapGrid, rtlTranslate: rtl,
	  } = swiper;
	  let newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;

	  const snapTranslate = -snapGrid[activeIndex];
	  const diff = snapTranslate - swiper.getTranslate();

	  // Fix For Negative Oversliding
	  if (activeIndex < loopedSlides) {
		newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
		newIndex += loopedSlides;
		const slideChanged = swiper.slideTo(newIndex, 0, false, true);
		if (slideChanged && diff !== 0) {
		  swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
		}
	  } else if (activeIndex >= slides.length - loopedSlides) {
		// Fix For Positive Oversliding
		newIndex = -slides.length + activeIndex + loopedSlides;
		newIndex += loopedSlides;
		const slideChanged = swiper.slideTo(newIndex, 0, false, true);
		if (slideChanged && diff !== 0) {
		  swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
		}
	  }
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;

	  swiper.emit('loopFix');
	}

	function loopDestroy () {
	  const swiper = this;
	  const { $wrapperEl, params, slides } = swiper;
	  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

	var loop = {
	  loopCreate,
	  loopFix,
	  loopDestroy,
	};

	function setGrabCursor (moving) {
	  const swiper = this;
	  if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
	  const el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

	function unsetGrabCursor () {
	  const swiper = this;
	  if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
	  swiper.el.style.cursor = '';
	}

	var grabCursor = {
	  setGrabCursor,
	  unsetGrabCursor,
	};

	function appendSlide (slides) {
	  const swiper = this;
	  const { $wrapperEl, params } = swiper;
	  if (params.loop) {
		swiper.loopDestroy();
	  }
	  if (typeof slides === 'object' && 'length' in slides) {
		for (let i = 0; i < slides.length; i += 1) {
		  if (slides[i]) $wrapperEl.append(slides[i]);
		}
	  } else {
		$wrapperEl.append(slides);
	  }
	  if (params.loop) {
		swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
		swiper.update();
	  }
	}

	function prependSlide (slides) {
	  const swiper = this;
	  const { params, $wrapperEl, activeIndex } = swiper;

	  if (params.loop) {
		swiper.loopDestroy();
	  }
	  let newActiveIndex = activeIndex + 1;
	  if (typeof slides === 'object' && 'length' in slides) {
		for (let i = 0; i < slides.length; i += 1) {
		  if (slides[i]) $wrapperEl.prepend(slides[i]);
		}
		newActiveIndex = activeIndex + slides.length;
	  } else {
		$wrapperEl.prepend(slides);
	  }
	  if (params.loop) {
		swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
		swiper.update();
	  }
	  swiper.slideTo(newActiveIndex, 0, false);
	}

	function addSlide (index, slides) {
	  const swiper = this;
	  const { $wrapperEl, params, activeIndex } = swiper;
	  let activeIndexBuffer = activeIndex;
	  if (params.loop) {
		activeIndexBuffer -= swiper.loopedSlides;
		swiper.loopDestroy();
		swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
	  }
	  const baseLength = swiper.slides.length;
	  if (index <= 0) {
		swiper.prependSlide(slides);
		return;
	  }
	  if (index >= baseLength) {
		swiper.appendSlide(slides);
		return;
	  }
	  let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

	  const slidesBuffer = [];
	  for (let i = baseLength - 1; i >= index; i -= 1) {
		const currentSlide = swiper.slides.eq(i);
		currentSlide.remove();
		slidesBuffer.unshift(currentSlide);
	  }

	  if (typeof slides === 'object' && 'length' in slides) {
		for (let i = 0; i < slides.length; i += 1) {
		  if (slides[i]) $wrapperEl.append(slides[i]);
		}
		newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	  } else {
		$wrapperEl.append(slides);
	  }

	  for (let i = 0; i < slidesBuffer.length; i += 1) {
		$wrapperEl.append(slidesBuffer[i]);
	  }

	  if (params.loop) {
		swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
		swiper.update();
	  }
	  if (params.loop) {
		swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
		swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

	function removeSlide (slidesIndexes) {
	  const swiper = this;
	  const { params, $wrapperEl, activeIndex } = swiper;

	  let activeIndexBuffer = activeIndex;
	  if (params.loop) {
		activeIndexBuffer -= swiper.loopedSlides;
		swiper.loopDestroy();
		swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
	  }
	  let newActiveIndex = activeIndexBuffer;
	  let indexToRemove;

	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
		for (let i = 0; i < slidesIndexes.length; i += 1) {
		  indexToRemove = slidesIndexes[i];
		  if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
		  if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
		}
		newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
		indexToRemove = slidesIndexes;
		if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
		if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
		newActiveIndex = Math.max(newActiveIndex, 0);
	  }

	  if (params.loop) {
		swiper.loopCreate();
	  }

	  if (!(params.observer && Support.observer)) {
		swiper.update();
	  }
	  if (params.loop) {
		swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
		swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

	function removeAllSlides () {
	  const swiper = this;

	  const slidesIndexes = [];
	  for (let i = 0; i < swiper.slides.length; i += 1) {
		slidesIndexes.push(i);
	  }
	  swiper.removeSlide(slidesIndexes);
	}

	var manipulation = {
	  appendSlide,
	  prependSlide,
	  addSlide,
	  removeSlide,
	  removeAllSlides,
	};

	const Device = (function Device() {
	  const platform = win.navigator.platform;
	  const ua = win.navigator.userAgent;

	  const device = {
		ios: false,
		android: false,
		androidChrome: false,
		desktop: false,
		iphone: false,
		ipod: false,
		ipad: false,
		edge: false,
		ie: false,
		firefox: false,
		macos: false,
		windows: false,
		cordova: !!(win.cordova || win.phonegap),
		phonegap: !!(win.cordova || win.phonegap),
		electron: false,
	  };

	  const screenWidth = win.screen.width;
	  const screenHeight = win.screen.height;

	  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  const ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
	  const edge = ua.indexOf('Edge/') >= 0;
	  const firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
	  const windows = platform === 'Win32';
	  const electron = ua.toLowerCase().indexOf('electron') >= 0;
	  let macos = platform === 'MacIntel';

	  // iPadOs 13 fix
	  if (!ipad
		  && macos
		  && Support.touch
		  && (
			  (screenWidth === 1024 && screenHeight === 1366) // Pro 12.9
			  || (screenWidth === 834 && screenHeight === 1194) // Pro 11
			  || (screenWidth === 834 && screenHeight === 1112) // Pro 10.5
			  || (screenWidth === 768 && screenHeight === 1024) // other
		  )
	  ) {
		ipad = ua.match(/(Version)\/([\d.]+)/);
		macos = false;
	  }

	  device.ie = ie;
	  device.edge = edge;
	  device.firefox = firefox;

	  // Android
	  if (android && !windows) {
		device.os = 'android';
		device.osVersion = android[2];
		device.android = true;
		device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	  }
	  if (ipad || iphone || ipod) {
		device.os = 'ios';
		device.ios = true;
	  }
	  // iOS
	  if (iphone && !ipod) {
		device.osVersion = iphone[2].replace(/_/g, '.');
		device.iphone = true;
	  }
	  if (ipad) {
		device.osVersion = ipad[2].replace(/_/g, '.');
		device.ipad = true;
	  }
	  if (ipod) {
		device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
		device.ipod = true;
	  }
	  // iOS 8+ changed UA
	  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
		if (device.osVersion.split('.')[0] === '10') {
		  device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
		}
	  }

	  // Webview
	  device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone))
		  || (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
	  device.webview = device.webView;
	  device.standalone = device.webView;

	  // Desktop
	  device.desktop = !(device.ios || device.android) || electron;
	  if (device.desktop) {
		device.electron = electron;
		device.macos = macos;
		device.windows = windows;
		if (device.macos) {
		  device.os = 'macos';
		}
		if (device.windows) {
		  device.os = 'windows';
		}
	  }

	  // Pixel Ratio
	  device.pixelRatio = win.devicePixelRatio || 1;

	  // Export object
	  return device;
	}());

	function onTouchStart (event) {
	  const swiper = this;
	  const data = swiper.touchEventsData;
	  const { params, touches } = swiper;

	  if (swiper.animating && params.preventInteractionOnTransition) {
		return;
	  }
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  const $targetEl = $(e.target);

	  if (params.touchEventsTarget === 'wrapper') {
		if (!$targetEl.closest(swiper.wrapperEl).length) return;
	  }
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
	  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return;
	  if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`)[0]) {
		swiper.allowClick = true;
		return;
	  }
	  if (params.swipeHandler) {
		if (!$targetEl.closest(params.swipeHandler)[0]) return;
	  }

	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  const startX = touches.currentX;
	  const startY = touches.currentY;

	  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

	  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	  if (
		  edgeSwipeDetection
		  && ((startX <= edgeSwipeThreshold)
			  || (startX >= win.screen.width - edgeSwipeThreshold))
	  ) {
		return;
	  }

	  Utils.extend(data, {
		isTouched: true,
		isMoved: false,
		allowTouchCallbacks: true,
		isScrolling: undefined,
		startMoving: undefined,
	  });

	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = Utils.now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;
	  if (e.type !== 'touchstart') {
		let preventDefault = true;
		if ($targetEl.is(data.formElements)) preventDefault = false;
		if (
			doc.activeElement
			&& $(doc.activeElement).is(data.formElements)
			&& doc.activeElement !== $targetEl[0]
		) {
		  doc.activeElement.blur();
		}

		const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
		if (params.touchStartForcePreventDefault || shouldPreventDefault) {
		  e.preventDefault();
		}
	  }
	  swiper.emit('touchStart', e);
	}

	function onTouchMove (event) {
	  const swiper = this;
	  const data = swiper.touchEventsData;
	  const { params, touches, rtlTranslate: rtl } = swiper;
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  if (!data.isTouched) {
		if (data.startMoving && data.isScrolling) {
		  swiper.emit('touchMoveOpposite', e);
		}
		return;
	  }
	  if (data.isTouchEvent && e.type !== 'touchmove') return;
	  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
	  if (e.preventedByNestedSwiper) {
		touches.startX = pageX;
		touches.startY = pageY;
		return;
	  }
	  if (!swiper.allowTouchMove) {
		// isMoved = true;
		swiper.allowClick = false;
		if (data.isTouched) {
		  Utils.extend(touches, {
			startX: pageX,
			startY: pageY,
			currentX: pageX,
			currentY: pageY,
		  });
		  data.touchStartTime = Utils.now();
		}
		return;
	  }
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
		if (swiper.isVertical()) {
		  // Vertical
		  if (
			  (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
			  || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
		  ) {
			data.isTouched = false;
			data.isMoved = false;
			return;
		  }
		} else if (
			(pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
			|| (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
		) {
		  return;
		}
	  }
	  if (data.isTouchEvent && doc.activeElement) {
		if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
		  data.isMoved = true;
		  swiper.allowClick = false;
		  return;
		}
	  }
	  if (data.allowTouchCallbacks) {
		swiper.emit('touchMove', e);
	  }
	  if (e.targetTouches && e.targetTouches.length > 1) return;

	  touches.currentX = pageX;
	  touches.currentY = pageY;

	  const diffX = touches.currentX - touches.startX;
	  const diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt((diffX ** 2) + (diffY ** 2)) < swiper.params.threshold) return;

	  if (typeof data.isScrolling === 'undefined') {
		let touchAngle;
		if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
		  data.isScrolling = false;
		} else {
		  // eslint-disable-next-line
		  if ((diffX * diffX) + (diffY * diffY) >= 25) {
			touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
			data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
		  }
		}
	  }
	  if (data.isScrolling) {
		swiper.emit('touchMoveOpposite', e);
	  }
	  if (typeof data.startMoving === 'undefined') {
		if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
		  data.startMoving = true;
		}
	  }
	  if (data.isScrolling) {
		data.isTouched = false;
		return;
	  }
	  if (!data.startMoving) {
		return;
	  }
	  swiper.allowClick = false;
	  if (!params.cssMode && e.cancelable) {
		e.preventDefault();
	  }
	  if (params.touchMoveStopPropagation && !params.nested) {
		e.stopPropagation();
	  }

	  if (!data.isMoved) {
		if (params.loop) {
		  swiper.loopFix();
		}
		data.startTranslate = swiper.getTranslate();
		swiper.setTransition(0);
		if (swiper.animating) {
		  swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
		}
		data.allowMomentumBounce = false;
		// Grab Cursor
		if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
		  swiper.setGrabCursor(true);
		}
		swiper.emit('sliderFirstMove', e);
	  }
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;

	  let diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;

	  diff *= params.touchRatio;
	  if (rtl) diff = -diff;

	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;

	  let disableParentSwiper = true;
	  let resistanceRatio = params.resistanceRatio;
	  if (params.touchReleaseOnEdges) {
		resistanceRatio = 0;
	  }
	  if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
		disableParentSwiper = false;
		if (params.resistance) data.currentTranslate = (swiper.minTranslate() - 1) + ((-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio);
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
		disableParentSwiper = false;
		if (params.resistance) data.currentTranslate = (swiper.maxTranslate() + 1) - ((swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio);
	  }

	  if (disableParentSwiper) {
		e.preventedByNestedSwiper = true;
	  }

	  // Directions locks
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
		data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
		data.currentTranslate = data.startTranslate;
	  }


	  // Threshold
	  if (params.threshold > 0) {
		if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
		  if (!data.allowThresholdMove) {
			data.allowThresholdMove = true;
			touches.startX = touches.currentX;
			touches.startY = touches.currentY;
			data.currentTranslate = data.startTranslate;
			touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
			return;
		  }
		} else {
		  data.currentTranslate = data.startTranslate;
		  return;
		}
	  }

	  if (!params.followFinger || params.cssMode) return;

	  // Update active index in free mode
	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
		swiper.updateActiveIndex();
		swiper.updateSlidesClasses();
	  }
	  if (params.freeMode) {
		// Velocity
		if (data.velocities.length === 0) {
		  data.velocities.push({
			position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
			time: data.touchStartTime,
		  });
		}
		data.velocities.push({
		  position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
		  time: Utils.now(),
		});
	  }
	  // Update progress
	  swiper.updateProgress(data.currentTranslate);
	  // Update translate
	  swiper.setTranslate(data.currentTranslate);
	}

	function onTouchEnd (event) {
	  const swiper = this;
	  const data = swiper.touchEventsData;

	  const {
		params, touches, rtlTranslate: rtl, $wrapperEl, slidesGrid, snapGrid,
	  } = swiper;
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  if (data.allowTouchCallbacks) {
		swiper.emit('touchEnd', e);
	  }
	  data.allowTouchCallbacks = false;
	  if (!data.isTouched) {
		if (data.isMoved && params.grabCursor) {
		  swiper.setGrabCursor(false);
		}
		data.isMoved = false;
		data.startMoving = false;
		return;
	  }
	  // Return Grab Cursor
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
		swiper.setGrabCursor(false);
	  }

	  // Time diff
	  const touchEndTime = Utils.now();
	  const timeDiff = touchEndTime - data.touchStartTime;

	  // Tap, doubleTap, Click
	  if (swiper.allowClick) {
		swiper.updateClickedSlide(e);
		swiper.emit('tap click', e);
		if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
		  swiper.emit('doubleTap doubleClick', e);
		}
	  }

	  data.lastClickTime = Utils.now();
	  Utils.nextTick(() => {
		if (!swiper.destroyed) swiper.allowClick = true;
	  });

	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
		data.isTouched = false;
		data.isMoved = false;
		data.startMoving = false;
		return;
	  }
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;

	  let currentPos;
	  if (params.followFinger) {
		currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
		currentPos = -data.currentTranslate;
	  }

	  if (params.cssMode) {
		return;
	  }

	  if (params.freeMode) {
		if (currentPos < -swiper.minTranslate()) {
		  swiper.slideTo(swiper.activeIndex);
		  return;
		}
		if (currentPos > -swiper.maxTranslate()) {
		  if (swiper.slides.length < snapGrid.length) {
			swiper.slideTo(snapGrid.length - 1);
		  } else {
			swiper.slideTo(swiper.slides.length - 1);
		  }
		  return;
		}

		if (params.freeModeMomentum) {
		  if (data.velocities.length > 1) {
			const lastMoveEvent = data.velocities.pop();
			const velocityEvent = data.velocities.pop();

			const distance = lastMoveEvent.position - velocityEvent.position;
			const time = lastMoveEvent.time - velocityEvent.time;
			swiper.velocity = distance / time;
			swiper.velocity /= 2;
			if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
			  swiper.velocity = 0;
			}
			// this implies that the user stopped moving a finger then released.
			// There would be no events with distance zero, so the last event is stale.
			if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
			  swiper.velocity = 0;
			}
		  } else {
			swiper.velocity = 0;
		  }
		  swiper.velocity *= params.freeModeMomentumVelocityRatio;

		  data.velocities.length = 0;
		  let momentumDuration = 1000 * params.freeModeMomentumRatio;
		  const momentumDistance = swiper.velocity * momentumDuration;

		  let newPosition = swiper.translate + momentumDistance;
		  if (rtl) newPosition = -newPosition;

		  let doBounce = false;
		  let afterBouncePosition;
		  const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
		  let needsLoopFix;
		  if (newPosition < swiper.maxTranslate()) {
			if (params.freeModeMomentumBounce) {
			  if (newPosition + swiper.maxTranslate() < -bounceAmount) {
				newPosition = swiper.maxTranslate() - bounceAmount;
			  }
			  afterBouncePosition = swiper.maxTranslate();
			  doBounce = true;
			  data.allowMomentumBounce = true;
			} else {
			  newPosition = swiper.maxTranslate();
			}
			if (params.loop && params.centeredSlides) needsLoopFix = true;
		  } else if (newPosition > swiper.minTranslate()) {
			if (params.freeModeMomentumBounce) {
			  if (newPosition - swiper.minTranslate() > bounceAmount) {
				newPosition = swiper.minTranslate() + bounceAmount;
			  }
			  afterBouncePosition = swiper.minTranslate();
			  doBounce = true;
			  data.allowMomentumBounce = true;
			} else {
			  newPosition = swiper.minTranslate();
			}
			if (params.loop && params.centeredSlides) needsLoopFix = true;
		  } else if (params.freeModeSticky) {
			let nextSlide;
			for (let j = 0; j < snapGrid.length; j += 1) {
			  if (snapGrid[j] > -newPosition) {
				nextSlide = j;
				break;
			  }
			}

			if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
			  newPosition = snapGrid[nextSlide];
			} else {
			  newPosition = snapGrid[nextSlide - 1];
			}
			newPosition = -newPosition;
		  }
		  if (needsLoopFix) {
			swiper.once('transitionEnd', () => {
			  swiper.loopFix();
			});
		  }
		  // Fix duration
		  if (swiper.velocity !== 0) {
			if (rtl) {
			  momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
			} else {
			  momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
			}
			if (params.freeModeSticky) {
			  // If freeModeSticky is active and the user ends a swipe with a slow-velocity
			  // event, then durations can be 20+ seconds to slide one (or zero!) slides.
			  // It's easy to see this when simulating touch with mouse events. To fix this,
			  // limit single-slide swipes to the default slide duration. This also has the
			  // nice side effect of matching slide speed if the user stopped moving before
			  // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
			  // For faster swipes, also apply limits (albeit higher ones).
			  const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
			  const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
			  if (moveDistance < currentSlideSize) {
				momentumDuration = params.speed;
			  } else if (moveDistance < 2 * currentSlideSize) {
				momentumDuration = params.speed * 1.5;
			  } else {
				momentumDuration = params.speed * 2.5;
			  }
			}
		  } else if (params.freeModeSticky) {
			swiper.slideToClosest();
			return;
		  }

		  if (params.freeModeMomentumBounce && doBounce) {
			swiper.updateProgress(afterBouncePosition);
			swiper.setTransition(momentumDuration);
			swiper.setTranslate(newPosition);
			swiper.transitionStart(true, swiper.swipeDirection);
			swiper.animating = true;
			$wrapperEl.transitionEnd(() => {
			  if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
			  swiper.emit('momentumBounce');
			  swiper.setTransition(params.speed);
			  setTimeout(() => {
				swiper.setTranslate(afterBouncePosition);
				$wrapperEl.transitionEnd(() => {
				  if (!swiper || swiper.destroyed) return;
				  swiper.transitionEnd();
				});
			  }, 0);
			});
		  } else if (swiper.velocity) {
			swiper.updateProgress(newPosition);
			swiper.setTransition(momentumDuration);
			swiper.setTranslate(newPosition);
			swiper.transitionStart(true, swiper.swipeDirection);
			if (!swiper.animating) {
			  swiper.animating = true;
			  $wrapperEl.transitionEnd(() => {
				if (!swiper || swiper.destroyed) return;
				swiper.transitionEnd();
			  });
			}
		  } else {
			swiper.updateProgress(newPosition);
		  }

		  swiper.updateActiveIndex();
		  swiper.updateSlidesClasses();
		} else if (params.freeModeSticky) {
		  swiper.slideToClosest();
		  return;
		}

		if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
		  swiper.updateProgress();
		  swiper.updateActiveIndex();
		  swiper.updateSlidesClasses();
		}
		return;
	  }

	  // Find current slide
	  let stopIndex = 0;
	  let groupSize = swiper.slidesSizesGrid[0];
	  for (let i = 0; i < slidesGrid.length; i += (i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup)) {
		const increment = (i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);
		if (typeof slidesGrid[i + increment] !== 'undefined') {
		  if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
			stopIndex = i;
			groupSize = slidesGrid[i + increment] - slidesGrid[i];
		  }
		} else if (currentPos >= slidesGrid[i]) {
		  stopIndex = i;
		  groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
		}
	  }

	  // Find current slide size
	  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  const increment = (stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);

	  if (timeDiff > params.longSwipesMs) {
		// Long touches
		if (!params.longSwipes) {
		  swiper.slideTo(swiper.activeIndex);
		  return;
		}
		if (swiper.swipeDirection === 'next') {
		  if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
		  else swiper.slideTo(stopIndex);
		}
		if (swiper.swipeDirection === 'prev') {
		  if (ratio > (1 - params.longSwipesRatio)) swiper.slideTo(stopIndex + increment);
		  else swiper.slideTo(stopIndex);
		}
	  } else {
		// Short swipes
		if (!params.shortSwipes) {
		  swiper.slideTo(swiper.activeIndex);
		  return;
		}
		const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
		if (!isNavButtonTarget) {
		  if (swiper.swipeDirection === 'next') {
			swiper.slideTo(stopIndex + increment);
		  }
		  if (swiper.swipeDirection === 'prev') {
			swiper.slideTo(stopIndex);
		  }
		} else if (e.target === swiper.navigation.nextEl) {
		  swiper.slideTo(stopIndex + increment);
		} else {
		  swiper.slideTo(stopIndex);
		}
	  }
	}

	function onResize () {
	  const swiper = this;

	  const { params, el } = swiper;

	  if (el && el.offsetWidth === 0) return;

	  // Breakpoints
	  if (params.breakpoints) {
		swiper.setBreakpoint();
	  }

	  // Save locks
	  const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;

	  // Disable locks on resize
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;

	  swiper.updateSize();
	  swiper.updateSlides();

	  swiper.updateSlidesClasses();
	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
		swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
		swiper.slideTo(swiper.activeIndex, 0, false, true);
	  }

	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
		swiper.autoplay.run();
	  }
	  // Return locks after resize
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;

	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
		swiper.checkOverflow();
	  }
	}

	function onClick (e) {
	  const swiper = this;
	  if (!swiper.allowClick) {
		if (swiper.params.preventClicks) e.preventDefault();
		if (swiper.params.preventClicksPropagation && swiper.animating) {
		  e.stopPropagation();
		  e.stopImmediatePropagation();
		}
	  }
	}

	function onScroll () {
	  const swiper = this;
	  const { wrapperEl, rtlTranslate } = swiper;
	  swiper.previousTranslate = swiper.translate;
	  if (swiper.isHorizontal()) {
		if (rtlTranslate) {
		  swiper.translate = ((wrapperEl.scrollWidth - wrapperEl.offsetWidth) - wrapperEl.scrollLeft);
		} else {
		  swiper.translate = -wrapperEl.scrollLeft;
		}
	  } else {
		swiper.translate = -wrapperEl.scrollTop;
	  }
	  // eslint-disable-next-line
	  if (swiper.translate === -0) swiper.translate = 0;

	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();

	  let newProgress;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
		newProgress = 0;
	  } else {
		newProgress = (swiper.translate - swiper.minTranslate()) / (translatesDiff);
	  }
	  if (newProgress !== swiper.progress) {
		swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, false);
	}

	let dummyEventAttached = false;
	function dummyEventListener() {}

	function attachEvents() {
	  const swiper = this;
	  const {
		params, touchEvents, el, wrapperEl,
	  } = swiper;

	  swiper.onTouchStart = onTouchStart.bind(swiper);
	  swiper.onTouchMove = onTouchMove.bind(swiper);
	  swiper.onTouchEnd = onTouchEnd.bind(swiper);
	  if (params.cssMode) {
		swiper.onScroll = onScroll.bind(swiper);
	  }

	  swiper.onClick = onClick.bind(swiper);

	  const capture = !!params.nested;

	  // Touch Events
	  if (!Support.touch && Support.pointerEvents) {
		el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
		doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
		doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
		if (Support.touch) {
		  const passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
		  el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
		  el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture } : capture);
		  el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
		  if (touchEvents.cancel) {
			el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
		  }
		  if (!dummyEventAttached) {
			doc.addEventListener('touchstart', dummyEventListener);
			dummyEventAttached = true;
		  }
		}
		if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
		  el.addEventListener('mousedown', swiper.onTouchStart, false);
		  doc.addEventListener('mousemove', swiper.onTouchMove, capture);
		  doc.addEventListener('mouseup', swiper.onTouchEnd, false);
		}
	  }
	  // Prevent Links Clicks
	  if (params.preventClicks || params.preventClicksPropagation) {
		el.addEventListener('click', swiper.onClick, true);
	  }
	  if (params.cssMode) {
		wrapperEl.addEventListener('scroll', swiper.onScroll);
	  }

	  // Resize handler
	  if (params.updateOnWindowResize) {
		swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
	  } else {
		swiper.on('observerUpdate', onResize, true);
	  }
	}

	function detachEvents() {
	  const swiper = this;

	  const {
		params, touchEvents, el, wrapperEl,
	  } = swiper;

	  const capture = !!params.nested;

	  // Touch Events
	  if (!Support.touch && Support.pointerEvents) {
		el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
		doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
		doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
		if (Support.touch) {
		  const passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
		  el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
		  el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
		  el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
		  if (touchEvents.cancel) {
			el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
		  }
		}
		if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
		  el.removeEventListener('mousedown', swiper.onTouchStart, false);
		  doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
		  doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
		}
	  }
	  // Prevent Links Clicks
	  if (params.preventClicks || params.preventClicksPropagation) {
		el.removeEventListener('click', swiper.onClick, true);
	  }

	  if (params.cssMode) {
		wrapperEl.removeEventListener('scroll', swiper.onScroll);
	  }

	  // Resize handler
	  swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
	}

	var swiper_esm_bundle_events = {
	  attachEvents,
	  detachEvents,
	};

	function setBreakpoint () {
	  const swiper = this;
	  const {
		activeIndex, initialized, loopedSlides = 0, params, $el,
	  } = swiper;
	  const breakpoints = params.breakpoints;
	  if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) return;

	  // Get breakpoint for window width and update parameters
	  const breakpoint = swiper.getBreakpoint(breakpoints);

	  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
		const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
		if (breakpointOnlyParams) {
		  ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach((param) => {
			const paramValue = breakpointOnlyParams[param];
			if (typeof paramValue === 'undefined') return;
			if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
			  breakpointOnlyParams[param] = 'auto';
			} else if (param === 'slidesPerView') {
			  breakpointOnlyParams[param] = parseFloat(paramValue);
			} else {
			  breakpointOnlyParams[param] = parseInt(paramValue, 10);
			}
		  });
		}

		const breakpointParams = breakpointOnlyParams || swiper.originalParams;
		const wasMultiRow = params.slidesPerColumn > 1;
		const isMultiRow = breakpointParams.slidesPerColumn > 1;
		if (wasMultiRow && !isMultiRow) {
		  $el.removeClass(`${params.containerModifierClass}multirow ${params.containerModifierClass}multirow-column`);
		} else if (!wasMultiRow && isMultiRow) {
		  $el.addClass(`${params.containerModifierClass}multirow`);
		  if (breakpointParams.slidesPerColumnFill === 'column') {
			$el.addClass(`${params.containerModifierClass}multirow-column`);
		  }
		}

		const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
		const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

		if (directionChanged && initialized) {
		  swiper.changeDirection();
		}

		Utils.extend(swiper.params, breakpointParams);

		Utils.extend(swiper, {
		  allowTouchMove: swiper.params.allowTouchMove,
		  allowSlideNext: swiper.params.allowSlideNext,
		  allowSlidePrev: swiper.params.allowSlidePrev,
		});

		swiper.currentBreakpoint = breakpoint;

		if (needsReLoop && initialized) {
		  swiper.loopDestroy();
		  swiper.loopCreate();
		  swiper.updateSlides();
		  swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
		}

		swiper.emit('breakpoint', breakpointParams);
	  }
	}

	function getBreakpoint (breakpoints) {
	  // Get breakpoint for window width
	  if (!breakpoints) return undefined;
	  let breakpoint = false;

	  const points = Object.keys(breakpoints).map((point) => {
		if (typeof point === 'string' && point.indexOf('@') === 0) {
		  const minRatio = parseFloat(point.substr(1));
		  const value = win.innerHeight * minRatio;
		  return { value, point };
		}
		return { value: point, point };
	  });

	  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
	  for (let i = 0; i < points.length; i += 1) {
		const { point, value } = points[i];
		if (value <= win.innerWidth) {
		  breakpoint = point;
		}
	  }
	  return breakpoint || 'max';
	}

	var breakpoints = { setBreakpoint, getBreakpoint };

	function addClasses () {
	  const swiper = this;
	  const {
		classNames, params, rtl, $el,
	  } = swiper;
	  const suffixes = [];

	  suffixes.push('initialized');
	  suffixes.push(params.direction);

	  if (params.freeMode) {
		suffixes.push('free-mode');
	  }
	  if (params.autoHeight) {
		suffixes.push('autoheight');
	  }
	  if (rtl) {
		suffixes.push('rtl');
	  }
	  if (params.slidesPerColumn > 1) {
		suffixes.push('multirow');
		if (params.slidesPerColumnFill === 'column') {
		  suffixes.push('multirow-column');
		}
	  }
	  if (Device.android) {
		suffixes.push('android');
	  }
	  if (Device.ios) {
		suffixes.push('ios');
	  }

	  if (params.cssMode) {
		suffixes.push('css-mode');
	  }

	  suffixes.forEach((suffix) => {
		classNames.push(params.containerModifierClass + suffix);
	  });

	  $el.addClass(classNames.join(' '));
	}

	function removeClasses () {
	  const swiper = this;
	  const { $el, classNames } = swiper;

	  $el.removeClass(classNames.join(' '));
	}

	var classes = { addClasses, removeClasses };

	function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
	  let image;
	  function onReady() {
		if (callback) callback();
	  }
	  const isPicture = $(imageEl).parent('picture')[0];

	  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
		if (src) {
		  image = new win.Image();
		  image.onload = onReady;
		  image.onerror = onReady;
		  if (sizes) {
			image.sizes = sizes;
		  }
		  if (srcset) {
			image.srcset = srcset;
		  }
		  if (src) {
			image.src = src;
		  }
		} else {
		  onReady();
		}
	  } else {
		// image already loaded...
		onReady();
	  }
	}

	function preloadImages () {
	  const swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	  function onReady() {
		if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
		if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
		if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
		  if (swiper.params.updateOnImagesReady) swiper.update();
		  swiper.emit('imagesReady');
		}
	  }
	  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
		const imageEl = swiper.imagesToLoad[i];
		swiper.loadImage(
			imageEl,
			imageEl.currentSrc || imageEl.getAttribute('src'),
			imageEl.srcset || imageEl.getAttribute('srcset'),
			imageEl.sizes || imageEl.getAttribute('sizes'),
			true,
			onReady
		);
	  }
	}

	var swiper_esm_bundle_images = {
	  loadImage,
	  preloadImages,
	};

	function checkOverflow() {
	  const swiper = this;
	  const params = swiper.params;
	  const wasLocked = swiper.isLocked;
	  const lastSlidePosition = swiper.slides.length > 0 && (params.slidesOffsetBefore + (params.spaceBetween * (swiper.slides.length - 1)) + ((swiper.slides[0]).offsetWidth) * swiper.slides.length);

	  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
		swiper.isLocked = lastSlidePosition <= swiper.size;
	  } else {
		swiper.isLocked = swiper.snapGrid.length === 1;
	  }

	  swiper.allowSlideNext = !swiper.isLocked;
	  swiper.allowSlidePrev = !swiper.isLocked;

	  // events
	  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

	  if (wasLocked && wasLocked !== swiper.isLocked) {
		swiper.isEnd = false;
		if (swiper.navigation) swiper.navigation.update();
	  }
	}

	var checkOverflow$1 = { checkOverflow };

	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  //
	  preventInteractionOnTransition: false,

	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,

	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,

	  // Autoheight
	  autoHeight: false,

	  // Set wrapper width
	  setWrapperSize: false,

	  // Virtual Translate
	  virtualTranslate: false,

	  // Effects
	  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

	  // Breakpoints
	  breakpoints: undefined,

	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0, // in px
	  slidesOffsetAfter: 0, // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,

	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,

	  // Round length
	  roundLengths: false,

	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,

	  // Unique Navigation Elements
	  uniqueNavElements: true,

	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,

	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,

	  // Cursor
	  grabCursor: false,

	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,

	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,

	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,

	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null, // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,

	  // Passive Listeners
	  passiveListeners: true,

	  // NS
	  containerModifierClass: 'swiper-container-', // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',

	  // Callbacks
	  runCallbacksOnInit: true,
	};

	/* eslint no-param-reassign: "off" */

	const prototypes = {
	  update,
	  translate,
	  transition: swiper_esm_bundle_transition,
	  slide,
	  loop,
	  grabCursor,
	  manipulation,
	  events: swiper_esm_bundle_events,
	  breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes,
	  images: swiper_esm_bundle_images,
	};

	const extendedDefaults = {};

	class Swiper extends SwiperClass {
	  constructor(...args) {
		let el;
		let params;
		if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
		  params = args[0];
		} else {
		  [el, params] = args;
		}
		if (!params) params = {};

		params = Utils.extend({}, params);
		if (el && !params.el) params.el = el;

		super(params);

		Object.keys(prototypes).forEach((prototypeGroup) => {
		  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
			if (!Swiper.prototype[protoMethod]) {
			  Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
			}
		  });
		});

		// Swiper Instance
		const swiper = this;
		if (typeof swiper.modules === 'undefined') {
		  swiper.modules = {};
		}
		Object.keys(swiper.modules).forEach((moduleName) => {
		  const module = swiper.modules[moduleName];
		  if (module.params) {
			const moduleParamName = Object.keys(module.params)[0];
			const moduleParams = module.params[moduleParamName];
			if (typeof moduleParams !== 'object' || moduleParams === null) return;
			if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
			if (params[moduleParamName] === true) {
			  params[moduleParamName] = { enabled: true };
			}
			if (
				typeof params[moduleParamName] === 'object'
				&& !('enabled' in params[moduleParamName])
			) {
			  params[moduleParamName].enabled = true;
			}
			if (!params[moduleParamName]) params[moduleParamName] = { enabled: false };
		  }
		});

		// Extend defaults with modules params
		const swiperParams = Utils.extend({}, defaults);
		swiper.useModulesParams(swiperParams);

		// Extend defaults with passed params
		swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
		swiper.originalParams = Utils.extend({}, swiper.params);
		swiper.passedParams = Utils.extend({}, params);

		// Save Dom lib
		swiper.$ = $;

		// Find el
		const $el = $(swiper.params.el);
		el = $el[0];

		if (!el) {
		  return undefined;
		}

		if ($el.length > 1) {
		  const swipers = [];
		  $el.each((index, containerEl) => {
			const newParams = Utils.extend({}, params, { el: containerEl });
			swipers.push(new Swiper(newParams));
		  });
		  return swipers;
		}

		el.swiper = swiper;
		$el.data('swiper', swiper);

		// Find Wrapper
		let $wrapperEl;
		if (el && el.shadowRoot && el.shadowRoot.querySelector) {
		  $wrapperEl = $(el.shadowRoot.querySelector(`.${swiper.params.wrapperClass}`));
		  // Children needs to return slot items
		  $wrapperEl.children = (options) => $el.children(options);
		} else {
		  $wrapperEl = $el.children(`.${swiper.params.wrapperClass}`);
		}
		// Extend Swiper
		Utils.extend(swiper, {
		  $el,
		  el,
		  $wrapperEl,
		  wrapperEl: $wrapperEl[0],

		  // Classes
		  classNames: [],

		  // Slides
		  slides: $(),
		  slidesGrid: [],
		  snapGrid: [],
		  slidesSizesGrid: [],

		  // isDirection
		  isHorizontal() {
			return swiper.params.direction === 'horizontal';
		  },
		  isVertical() {
			return swiper.params.direction === 'vertical';
		  },
		  // RTL
		  rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
		  rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
		  wrongRTL: $wrapperEl.css('display') === '-webkit-box',

		  // Indexes
		  activeIndex: 0,
		  realIndex: 0,

		  //
		  isBeginning: true,
		  isEnd: false,

		  // Props
		  translate: 0,
		  previousTranslate: 0,
		  progress: 0,
		  velocity: 0,
		  animating: false,

		  // Locks
		  allowSlideNext: swiper.params.allowSlideNext,
		  allowSlidePrev: swiper.params.allowSlidePrev,

		  // Touch Events
		  touchEvents: (function touchEvents() {
			const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
			let desktop = ['mousedown', 'mousemove', 'mouseup'];
			if (Support.pointerEvents) {
			  desktop = ['pointerdown', 'pointermove', 'pointerup'];
			}
			swiper.touchEventsTouch = {
			  start: touch[0],
			  move: touch[1],
			  end: touch[2],
			  cancel: touch[3],
			};
			swiper.touchEventsDesktop = {
			  start: desktop[0],
			  move: desktop[1],
			  end: desktop[2],
			};
			return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
		  }()),
		  touchEventsData: {
			isTouched: undefined,
			isMoved: undefined,
			allowTouchCallbacks: undefined,
			touchStartTime: undefined,
			isScrolling: undefined,
			currentTranslate: undefined,
			startTranslate: undefined,
			allowThresholdMove: undefined,
			// Form elements to match
			formElements: 'input, select, option, textarea, button, video, label',
			// Last click time
			lastClickTime: Utils.now(),
			clickTimeout: undefined,
			// Velocities
			velocities: [],
			allowMomentumBounce: undefined,
			isTouchEvent: undefined,
			startMoving: undefined,
		  },

		  // Clicks
		  allowClick: true,

		  // Touches
		  allowTouchMove: swiper.params.allowTouchMove,

		  touches: {
			startX: 0,
			startY: 0,
			currentX: 0,
			currentY: 0,
			diff: 0,
		  },

		  // Images
		  imagesToLoad: [],
		  imagesLoaded: 0,

		});

		// Install Modules
		swiper.useModules();

		// Init
		if (swiper.params.init) {
		  swiper.init();
		}

		// Return app instance
		return swiper;
	  }

	  slidesPerViewDynamic() {
		const swiper = this;
		const {
		  params, slides, slidesGrid, size: swiperSize, activeIndex,
		} = swiper;
		let spv = 1;
		if (params.centeredSlides) {
		  let slideSize = slides[activeIndex].swiperSlideSize;
		  let breakLoop;
		  for (let i = activeIndex + 1; i < slides.length; i += 1) {
			if (slides[i] && !breakLoop) {
			  slideSize += slides[i].swiperSlideSize;
			  spv += 1;
			  if (slideSize > swiperSize) breakLoop = true;
			}
		  }
		  for (let i = activeIndex - 1; i >= 0; i -= 1) {
			if (slides[i] && !breakLoop) {
			  slideSize += slides[i].swiperSlideSize;
			  spv += 1;
			  if (slideSize > swiperSize) breakLoop = true;
			}
		  }
		} else {
		  for (let i = activeIndex + 1; i < slides.length; i += 1) {
			if (slidesGrid[i] - slidesGrid[activeIndex] < swiperSize) {
			  spv += 1;
			}
		  }
		}
		return spv;
	  }

	  update() {
		const swiper = this;
		if (!swiper || swiper.destroyed) return;
		const { snapGrid, params } = swiper;
		// Breakpoints
		if (params.breakpoints) {
		  swiper.setBreakpoint();
		}
		swiper.updateSize();
		swiper.updateSlides();
		swiper.updateProgress();
		swiper.updateSlidesClasses();

		function setTranslate() {
		  const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
		  const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
		  swiper.setTranslate(newTranslate);
		  swiper.updateActiveIndex();
		  swiper.updateSlidesClasses();
		}
		let translated;
		if (swiper.params.freeMode) {
		  setTranslate();
		  if (swiper.params.autoHeight) {
			swiper.updateAutoHeight();
		  }
		} else {
		  if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
			translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
		  } else {
			translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
		  }
		  if (!translated) {
			setTranslate();
		  }
		}
		if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
		  swiper.checkOverflow();
		}
		swiper.emit('update');
	  }

	  changeDirection(newDirection, needUpdate = true) {
		const swiper = this;
		const currentDirection = swiper.params.direction;
		if (!newDirection) {
		  // eslint-disable-next-line
		  newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
		}
		if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
		  return swiper;
		}

		swiper.$el
			.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`)
			.addClass(`${swiper.params.containerModifierClass}${newDirection}`);

		swiper.params.direction = newDirection;

		swiper.slides.each((slideIndex, slideEl) => {
		  if (newDirection === 'vertical') {
			slideEl.style.width = '';
		  } else {
			slideEl.style.height = '';
		  }
		});

		swiper.emit('changeDirection');
		if (needUpdate) swiper.update();

		return swiper;
	  }

	  init() {
		const swiper = this;
		if (swiper.initialized) return;

		swiper.emit('beforeInit');

		// Set breakpoint
		if (swiper.params.breakpoints) {
		  swiper.setBreakpoint();
		}

		// Add Classes
		swiper.addClasses();

		// Create loop
		if (swiper.params.loop) {
		  swiper.loopCreate();
		}

		// Update size
		swiper.updateSize();

		// Update slides
		swiper.updateSlides();

		if (swiper.params.watchOverflow) {
		  swiper.checkOverflow();
		}

		// Set Grab Cursor
		if (swiper.params.grabCursor) {
		  swiper.setGrabCursor();
		}

		if (swiper.params.preloadImages) {
		  swiper.preloadImages();
		}

		// Slide To Initial Slide
		if (swiper.params.loop) {
		  swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
		} else {
		  swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
		}

		// Attach events
		swiper.attachEvents();

		// Init Flag
		swiper.initialized = true;

		// Emit
		swiper.emit('init');
	  }

	  destroy(deleteInstance = true, cleanStyles = true) {
		const swiper = this;
		const {
		  params, $el, $wrapperEl, slides,
		} = swiper;

		if (typeof swiper.params === 'undefined' || swiper.destroyed) {
		  return null;
		}

		swiper.emit('beforeDestroy');

		// Init Flag
		swiper.initialized = false;

		// Detach events
		swiper.detachEvents();

		// Destroy loop
		if (params.loop) {
		  swiper.loopDestroy();
		}

		// Cleanup styles
		if (cleanStyles) {
		  swiper.removeClasses();
		  $el.removeAttr('style');
		  $wrapperEl.removeAttr('style');
		  if (slides && slides.length) {
			slides
				.removeClass([
				  params.slideVisibleClass,
				  params.slideActiveClass,
				  params.slideNextClass,
				  params.slidePrevClass,
				].join(' '))
				.removeAttr('style')
				.removeAttr('data-swiper-slide-index');
		  }
		}

		swiper.emit('destroy');

		// Detach emitter events
		Object.keys(swiper.eventsListeners).forEach((eventName) => {
		  swiper.off(eventName);
		});

		if (deleteInstance !== false) {
		  swiper.$el[0].swiper = null;
		  swiper.$el.data('swiper', null);
		  Utils.deleteProps(swiper);
		}
		swiper.destroyed = true;

		return null;
	  }

	  static extendDefaults(newDefaults) {
		Utils.extend(extendedDefaults, newDefaults);
	  }

	  static get extendedDefaults() {
		return extendedDefaults;
	  }

	  static get defaults() {
		return defaults;
	  }

	  static get Class() {
		return SwiperClass;
	  }

	  static get $() {
		return $;
	  }
	}

	var Device$1 = {
	  name: 'device',
	  proto: {
		device: Device,
	  },
	  static: {
		device: Device,
	  },
	};

	var Support$1 = {
	  name: 'support',
	  proto: {
		support: Support,
	  },
	  static: {
		support: Support,
	  },
	};

	const Browser = (function Browser() {
	  function isSafari() {
		const ua = win.navigator.userAgent.toLowerCase();
		return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	  }
	  return {
		isEdge: !!win.navigator.userAgent.match(/Edge/g),
		isSafari: isSafari(),
		isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	  };
	}());

	var Browser$1 = {
	  name: 'browser',
	  proto: {
		browser: Browser,
	  },
	  static: {
		browser: Browser,
	  },
	};

	var Resize = {
	  name: 'resize',
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  resize: {
			resizeHandler() {
			  if (!swiper || swiper.destroyed || !swiper.initialized) return;
			  swiper.emit('beforeResize');
			  swiper.emit('resize');
			},
			orientationChangeHandler() {
			  if (!swiper || swiper.destroyed || !swiper.initialized) return;
			  swiper.emit('orientationchange');
			},
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  // Emit resize
		  win.addEventListener('resize', swiper.resize.resizeHandler);

		  // Emit orientationchange
		  win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
		},
		destroy() {
		  const swiper = this;
		  win.removeEventListener('resize', swiper.resize.resizeHandler);
		  win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
		},
	  },
	};

	const swiper_esm_bundle_Observer = {
	  func: win.MutationObserver || win.WebkitMutationObserver,
	  attach(target, options = {}) {
		const swiper = this;

		const ObserverFunc = swiper_esm_bundle_Observer.func;
		const observer = new ObserverFunc((mutations) => {
		  // The observerUpdate event should only be triggered
		  // once despite the number of mutations.  Additional
		  // triggers are redundant and are very costly
		  if (mutations.length === 1) {
			swiper.emit('observerUpdate', mutations[0]);
			return;
		  }
		  const observerUpdate = function observerUpdate() {
			swiper.emit('observerUpdate', mutations[0]);
		  };

		  if (win.requestAnimationFrame) {
			win.requestAnimationFrame(observerUpdate);
		  } else {
			win.setTimeout(observerUpdate, 0);
		  }
		});

		observer.observe(target, {
		  attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
		  childList: typeof options.childList === 'undefined' ? true : options.childList,
		  characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
		});

		swiper.observer.observers.push(observer);
	  },
	  init() {
		const swiper = this;
		if (!Support.observer || !swiper.params.observer) return;
		if (swiper.params.observeParents) {
		  const containerParents = swiper.$el.parents();
		  for (let i = 0; i < containerParents.length; i += 1) {
			swiper.observer.attach(containerParents[i]);
		  }
		}
		// Observe container
		swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

		// Observe wrapper
		swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	  },
	  destroy() {
		const swiper = this;
		swiper.observer.observers.forEach((observer) => {
		  observer.disconnect();
		});
		swiper.observer.observers = [];
	  },
	};

	var Observer$1 = {
	  name: 'observer',
	  params: {
		observer: false,
		observeParents: false,
		observeSlideChildren: false,
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  observer: {
			init: swiper_esm_bundle_Observer.init.bind(swiper),
			attach: swiper_esm_bundle_Observer.attach.bind(swiper),
			destroy: swiper_esm_bundle_Observer.destroy.bind(swiper),
			observers: [],
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  swiper.observer.init();
		},
		destroy() {
		  const swiper = this;
		  swiper.observer.destroy();
		},
	  },
	};

	const Virtual = {
	  update(force) {
		const swiper = this;
		const { slidesPerView, slidesPerGroup, centeredSlides } = swiper.params;
		const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
		const {
		  from: previousFrom,
		  to: previousTo,
		  slides,
		  slidesGrid: previousSlidesGrid,
		  renderSlide,
		  offset: previousOffset,
		} = swiper.virtual;
		swiper.updateActiveIndex();
		const activeIndex = swiper.activeIndex || 0;

		let offsetProp;
		if (swiper.rtlTranslate) offsetProp = 'right';
		else offsetProp = swiper.isHorizontal() ? 'left' : 'top';

		let slidesAfter;
		let slidesBefore;
		if (centeredSlides) {
		  slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
		  slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
		} else {
		  slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
		  slidesBefore = slidesPerGroup + addSlidesAfter;
		}
		const from = Math.max((activeIndex || 0) - slidesBefore, 0);
		const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
		const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

		Utils.extend(swiper.virtual, {
		  from,
		  to,
		  offset,
		  slidesGrid: swiper.slidesGrid,
		});

		function onRendered() {
		  swiper.updateSlides();
		  swiper.updateProgress();
		  swiper.updateSlidesClasses();
		  if (swiper.lazy && swiper.params.lazy.enabled) {
			swiper.lazy.load();
		  }
		}

		if (previousFrom === from && previousTo === to && !force) {
		  if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
			swiper.slides.css(offsetProp, `${offset}px`);
		  }
		  swiper.updateProgress();
		  return;
		}
		if (swiper.params.virtual.renderExternal) {
		  swiper.params.virtual.renderExternal.call(swiper, {
			offset,
			from,
			to,
			slides: (function getSlides() {
			  const slidesToRender = [];
			  for (let i = from; i <= to; i += 1) {
				slidesToRender.push(slides[i]);
			  }
			  return slidesToRender;
			}()),
		  });
		  onRendered();
		  return;
		}
		const prependIndexes = [];
		const appendIndexes = [];
		if (force) {
		  swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
		} else {
		  for (let i = previousFrom; i <= previousTo; i += 1) {
			if (i < from || i > to) {
			  swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
			}
		  }
		}
		for (let i = 0; i < slides.length; i += 1) {
		  if (i >= from && i <= to) {
			if (typeof previousTo === 'undefined' || force) {
			  appendIndexes.push(i);
			} else {
			  if (i > previousTo) appendIndexes.push(i);
			  if (i < previousFrom) prependIndexes.push(i);
			}
		  }
		}
		appendIndexes.forEach((index) => {
		  swiper.$wrapperEl.append(renderSlide(slides[index], index));
		});
		prependIndexes.sort((a, b) => b - a).forEach((index) => {
		  swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
		});
		swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
		onRendered();
	  },
	  renderSlide(slide, index) {
		const swiper = this;
		const params = swiper.params.virtual;
		if (params.cache && swiper.virtual.cache[index]) {
		  return swiper.virtual.cache[index];
		}
		const $slideEl = params.renderSlide
			? $(params.renderSlide.call(swiper, slide, index))
			: $(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
		if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
		if (params.cache) swiper.virtual.cache[index] = $slideEl;
		return $slideEl;
	  },
	  appendSlide(slides) {
		const swiper = this;
		if (typeof slides === 'object' && 'length' in slides) {
		  for (let i = 0; i < slides.length; i += 1) {
			if (slides[i]) swiper.virtual.slides.push(slides[i]);
		  }
		} else {
		  swiper.virtual.slides.push(slides);
		}
		swiper.virtual.update(true);
	  },
	  prependSlide(slides) {
		const swiper = this;
		const activeIndex = swiper.activeIndex;
		let newActiveIndex = activeIndex + 1;
		let numberOfNewSlides = 1;

		if (Array.isArray(slides)) {
		  for (let i = 0; i < slides.length; i += 1) {
			if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
		  }
		  newActiveIndex = activeIndex + slides.length;
		  numberOfNewSlides = slides.length;
		} else {
		  swiper.virtual.slides.unshift(slides);
		}
		if (swiper.params.virtual.cache) {
		  const cache = swiper.virtual.cache;
		  const newCache = {};
		  Object.keys(cache).forEach((cachedIndex) => {
			const $cachedEl = cache[cachedIndex];
			const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
			if (cachedElIndex) {
			  $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
			}
			newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
		  });
		  swiper.virtual.cache = newCache;
		}
		swiper.virtual.update(true);
		swiper.slideTo(newActiveIndex, 0);
	  },
	  removeSlide(slidesIndexes) {
		const swiper = this;
		if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
		let activeIndex = swiper.activeIndex;
		if (Array.isArray(slidesIndexes)) {
		  for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
			swiper.virtual.slides.splice(slidesIndexes[i], 1);
			if (swiper.params.virtual.cache) {
			  delete swiper.virtual.cache[slidesIndexes[i]];
			}
			if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
			activeIndex = Math.max(activeIndex, 0);
		  }
		} else {
		  swiper.virtual.slides.splice(slidesIndexes, 1);
		  if (swiper.params.virtual.cache) {
			delete swiper.virtual.cache[slidesIndexes];
		  }
		  if (slidesIndexes < activeIndex) activeIndex -= 1;
		  activeIndex = Math.max(activeIndex, 0);
		}
		swiper.virtual.update(true);
		swiper.slideTo(activeIndex, 0);
	  },
	  removeAllSlides() {
		const swiper = this;
		swiper.virtual.slides = [];
		if (swiper.params.virtual.cache) {
		  swiper.virtual.cache = {};
		}
		swiper.virtual.update(true);
		swiper.slideTo(0, 0);
	  },
	};

	var Virtual$1 = {
	  name: 'virtual',
	  params: {
		virtual: {
		  enabled: false,
		  slides: [],
		  cache: true,
		  renderSlide: null,
		  renderExternal: null,
		  addSlidesBefore: 0,
		  addSlidesAfter: 0,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  virtual: {
			update: Virtual.update.bind(swiper),
			appendSlide: Virtual.appendSlide.bind(swiper),
			prependSlide: Virtual.prependSlide.bind(swiper),
			removeSlide: Virtual.removeSlide.bind(swiper),
			removeAllSlides: Virtual.removeAllSlides.bind(swiper),
			renderSlide: Virtual.renderSlide.bind(swiper),
			slides: swiper.params.virtual.slides,
			cache: {},
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (!swiper.params.virtual.enabled) return;
		  swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
		  const overwriteParams = {
			watchSlidesProgress: true,
		  };
		  Utils.extend(swiper.params, overwriteParams);
		  Utils.extend(swiper.originalParams, overwriteParams);

		  if (!swiper.params.initialSlide) {
			swiper.virtual.update();
		  }
		},
		setTranslate() {
		  const swiper = this;
		  if (!swiper.params.virtual.enabled) return;
		  swiper.virtual.update();
		},
	  },
	};

	const Keyboard = {
	  handle(event) {
		const swiper = this;
		const { rtlTranslate: rtl } = swiper;
		let e = event;
		if (e.originalEvent) e = e.originalEvent; // jquery fix
		const kc = e.keyCode || e.charCode;
		const pageUpDown = swiper.params.keyboard.pageUpDown;
		const isPageUp = pageUpDown && kc === 33;
		const isPageDown = pageUpDown && kc === 34;
		const isArrowLeft = kc === 37;
		const isArrowRight = kc === 39;
		const isArrowUp = kc === 38;
		const isArrowDown = kc === 40;
		// Directions locks
		if (!swiper.allowSlideNext && ((swiper.isHorizontal() && isArrowRight) || (swiper.isVertical() && isArrowDown) || isPageDown)) {
		  return false;
		}
		if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && isArrowLeft) || (swiper.isVertical() && isArrowUp) || isPageUp)) {
		  return false;
		}
		if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
		  return undefined;
		}
		if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
		  return undefined;
		}
		if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
		  let inView = false;
		  // Check that swiper should be inside of visible area of window
		  if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
			return undefined;
		  }
		  const windowWidth = win.innerWidth;
		  const windowHeight = win.innerHeight;
		  const swiperOffset = swiper.$el.offset();
		  if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
		  const swiperCoord = [
			[swiperOffset.left, swiperOffset.top],
			[swiperOffset.left + swiper.width, swiperOffset.top],
			[swiperOffset.left, swiperOffset.top + swiper.height],
			[swiperOffset.left + swiper.width, swiperOffset.top + swiper.height],
		  ];
		  for (let i = 0; i < swiperCoord.length; i += 1) {
			const point = swiperCoord[i];
			if (
				point[0] >= 0 && point[0] <= windowWidth
				&& point[1] >= 0 && point[1] <= windowHeight
			) {
			  inView = true;
			}
		  }
		  if (!inView) return undefined;
		}
		if (swiper.isHorizontal()) {
		  if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
			if (e.preventDefault) e.preventDefault();
			else e.returnValue = false;
		  }
		  if (((isPageDown || isArrowRight) && !rtl) || ((isPageUp || isArrowLeft) && rtl)) swiper.slideNext();
		  if (((isPageUp || isArrowLeft) && !rtl) || ((isPageDown || isArrowRight) && rtl)) swiper.slidePrev();
		} else {
		  if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
			if (e.preventDefault) e.preventDefault();
			else e.returnValue = false;
		  }
		  if (isPageDown || isArrowDown) swiper.slideNext();
		  if (isPageUp || isArrowUp) swiper.slidePrev();
		}
		swiper.emit('keyPress', kc);
		return undefined;
	  },
	  enable() {
		const swiper = this;
		if (swiper.keyboard.enabled) return;
		$(doc).on('keydown', swiper.keyboard.handle);
		swiper.keyboard.enabled = true;
	  },
	  disable() {
		const swiper = this;
		if (!swiper.keyboard.enabled) return;
		$(doc).off('keydown', swiper.keyboard.handle);
		swiper.keyboard.enabled = false;
	  },
	};

	var Keyboard$1 = {
	  name: 'keyboard',
	  params: {
		keyboard: {
		  enabled: false,
		  onlyInViewport: true,
		  pageUpDown: true,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  keyboard: {
			enabled: false,
			enable: Keyboard.enable.bind(swiper),
			disable: Keyboard.disable.bind(swiper),
			handle: Keyboard.handle.bind(swiper),
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (swiper.params.keyboard.enabled) {
			swiper.keyboard.enable();
		  }
		},
		destroy() {
		  const swiper = this;
		  if (swiper.keyboard.enabled) {
			swiper.keyboard.disable();
		  }
		},
	  },
	};

	function isEventSupported() {
	  const eventName = 'onwheel';
	  let isSupported = eventName in doc;

	  if (!isSupported) {
		const element = doc.createElement('div');
		element.setAttribute(eventName, 'return;');
		isSupported = typeof element[eventName] === 'function';
	  }

	  if (!isSupported
		  && doc.implementation
		  && doc.implementation.hasFeature
		  // always returns true in newer browsers as per the standard.
		  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
		  && doc.implementation.hasFeature('', '') !== true
	  ) {
		// This is the only way to test support for the `wheel` event in IE9+.
		isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
	  }

	  return isSupported;
	}
	const Mousewheel = {
	  lastScrollTime: Utils.now(),
	  lastEventBeforeSnap: undefined,
	  recentWheelEvents: [],
	  event() {
		if (win.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
		return isEventSupported() ? 'wheel' : 'mousewheel';
	  },
	  normalize(e) {
		// Reasonable defaults
		const PIXEL_STEP = 10;
		const LINE_HEIGHT = 40;
		const PAGE_HEIGHT = 800;

		let sX = 0;
		let sY = 0; // spinX, spinY
		let pX = 0;
		let pY = 0; // pixelX, pixelY

		// Legacy
		if ('detail' in e) {
		  sY = e.detail;
		}
		if ('wheelDelta' in e) {
		  sY = -e.wheelDelta / 120;
		}
		if ('wheelDeltaY' in e) {
		  sY = -e.wheelDeltaY / 120;
		}
		if ('wheelDeltaX' in e) {
		  sX = -e.wheelDeltaX / 120;
		}

		// side scrolling on FF with DOMMouseScroll
		if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
		  sX = sY;
		  sY = 0;
		}

		pX = sX * PIXEL_STEP;
		pY = sY * PIXEL_STEP;

		if ('deltaY' in e) {
		  pY = e.deltaY;
		}
		if ('deltaX' in e) {
		  pX = e.deltaX;
		}

		if (e.shiftKey && !pX) { // if user scrolls with shift he wants horizontal scroll
		  pX = pY;
		  pY = 0;
		}

		if ((pX || pY) && e.deltaMode) {
		  if (e.deltaMode === 1) { // delta in LINE units
			pX *= LINE_HEIGHT;
			pY *= LINE_HEIGHT;
		  } else { // delta in PAGE units
			pX *= PAGE_HEIGHT;
			pY *= PAGE_HEIGHT;
		  }
		}

		// Fall-back if spin cannot be determined
		if (pX && !sX) {
		  sX = (pX < 1) ? -1 : 1;
		}
		if (pY && !sY) {
		  sY = (pY < 1) ? -1 : 1;
		}

		return {
		  spinX: sX,
		  spinY: sY,
		  pixelX: pX,
		  pixelY: pY,
		};
	  },
	  handleMouseEnter() {
		const swiper = this;
		swiper.mouseEntered = true;
	  },
	  handleMouseLeave() {
		const swiper = this;
		swiper.mouseEntered = false;
	  },
	  handle(event) {
		let e = event;
		const swiper = this;
		const params = swiper.params.mousewheel;

		if (swiper.params.cssMode) {
		  e.preventDefault();
		}

		let target = swiper.$el;
		if (swiper.params.mousewheel.eventsTarged !== 'container') {
		  target = $(swiper.params.mousewheel.eventsTarged);
		}
		if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;

		if (e.originalEvent) e = e.originalEvent; // jquery fix
		let delta = 0;
		const rtlFactor = swiper.rtlTranslate ? -1 : 1;

		const data = Mousewheel.normalize(e);

		if (params.forceToAxis) {
		  if (swiper.isHorizontal()) {
			if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
			else return true;
		  } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
		  else return true;
		} else {
		  delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
		}

		if (delta === 0) return true;

		if (params.invert) delta = -delta;

		if (!swiper.params.freeMode) {
		  // Register the new event in a variable which stores the relevant data
		  const newEvent = {
			time: Utils.now(),
			delta: Math.abs(delta),
			direction: Math.sign(delta),
			raw: event,
		  };

		  // Keep the most recent events
		  const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
		  if (recentWheelEvents.length >= 2) {
			recentWheelEvents.shift(); // only store the last N events
		  }
		  const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
		  recentWheelEvents.push(newEvent);

		  // If there is at least one previous recorded event:
		  //   If direction has changed or
		  //   if the scroll is quicker than the previous one:
		  //     Animate the slider.
		  // Else (this is the first time the wheel is moved):
		  //     Animate the slider.
		  if (prevEvent) {
			if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
			  swiper.mousewheel.animateSlider(newEvent);
			}
		  } else {
			swiper.mousewheel.animateSlider(newEvent);
		  }

		  // If it's time to release the scroll:
		  //   Return now so you don't hit the preventDefault.
		  if (swiper.mousewheel.releaseScroll(newEvent)) {
			return true;
		  }
		} else {
		  // Freemode or scrollContainer:

		  // If we recently snapped after a momentum scroll, then ignore wheel events
		  // to give time for the deceleration to finish. Stop ignoring after 500 msecs
		  // or if it's a new scroll (larger delta or inverse sign as last event before
		  // an end-of-momentum snap).
		  const newEvent = { time: Utils.now(), delta: Math.abs(delta), direction: Math.sign(delta) };
		  const { lastEventBeforeSnap } = swiper.mousewheel;
		  const ignoreWheelEvents = lastEventBeforeSnap
			  && newEvent.time < lastEventBeforeSnap.time + 500
			  && newEvent.delta <= lastEventBeforeSnap.delta
			  && newEvent.direction === lastEventBeforeSnap.direction;
		  if (!ignoreWheelEvents) {
			swiper.mousewheel.lastEventBeforeSnap = undefined;

			if (swiper.params.loop) {
			  swiper.loopFix();
			}
			let position = swiper.getTranslate() + (delta * params.sensitivity);
			const wasBeginning = swiper.isBeginning;
			const wasEnd = swiper.isEnd;

			if (position >= swiper.minTranslate()) position = swiper.minTranslate();
			if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();

			swiper.setTransition(0);
			swiper.setTranslate(position);
			swiper.updateProgress();
			swiper.updateActiveIndex();
			swiper.updateSlidesClasses();

			if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
			  swiper.updateSlidesClasses();
			}

			if (swiper.params.freeModeSticky) {
			  // When wheel scrolling starts with sticky (aka snap) enabled, then detect
			  // the end of a momentum scroll by storing recent (N=15?) wheel events.
			  // 1. do all N events have decreasing or same (absolute value) delta?
			  // 2. did all N events arrive in the last M (M=500?) msecs?
			  // 3. does the earliest event have an (absolute value) delta that's
			  //    at least P (P=1?) larger than the most recent event's delta?
			  // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
			  // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
			  // Snap immediately and ignore remaining wheel events in this scroll.
			  // See comment above for "remaining wheel events in this scroll" determination.
			  // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
			  clearTimeout(swiper.mousewheel.timeout);
			  swiper.mousewheel.timeout = undefined;
			  const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
			  if (recentWheelEvents.length >= 15) {
				recentWheelEvents.shift(); // only store the last N events
			  }
			  const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
			  const firstEvent = recentWheelEvents[0];
			  recentWheelEvents.push(newEvent);
			  if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
				// Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
				recentWheelEvents.splice(0);
			  } else if (recentWheelEvents.length >= 15
				  && newEvent.time - firstEvent.time < 500
				  && firstEvent.delta - newEvent.delta >= 1
				  && newEvent.delta <= 6
			  ) {
				// We're at the end of the deceleration of a momentum scroll, so there's no need
				// to wait for more events. Snap ASAP on the next tick.
				// Also, because there's some remaining momentum we'll bias the snap in the
				// direction of the ongoing scroll because it's better UX for the scroll to snap
				// in the same direction as the scroll instead of reversing to snap.  Therefore,
				// if it's already scrolled more than 20% in the current direction, keep going.
				const snapToThreshold = delta > 0 ? 0.8 : 0.2;
				swiper.mousewheel.lastEventBeforeSnap = newEvent;
				recentWheelEvents.splice(0);
				swiper.mousewheel.timeout = Utils.nextTick(() => {
				  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
				}, 0); // no delay; move on next tick
			  }
			  if (!swiper.mousewheel.timeout) {
				// if we get here, then we haven't detected the end of a momentum scroll, so
				// we'll consider a scroll "complete" when there haven't been any wheel events
				// for 500ms.
				swiper.mousewheel.timeout = Utils.nextTick(() => {
				  const snapToThreshold = 0.5;
				  swiper.mousewheel.lastEventBeforeSnap = newEvent;
				  recentWheelEvents.splice(0);
				  swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
				}, 500);
			  }
			}

			// Emit event
			if (!ignoreWheelEvents) swiper.emit('scroll', e);

			// Stop autoplay
			if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
			// Return page scroll on edge positions
			if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
		  }
		}

		if (e.preventDefault) e.preventDefault();
		else e.returnValue = false;
		return false;
	  },
	  animateSlider(newEvent) {
		const swiper = this;
		// If the movement is NOT big enough and
		// if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
		//   Don't go any further (avoid insignificant scroll movement).
		if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
		  // Return false as a default
		  return true;
		}
		// If user is scrolling towards the end:
		//   If the slider hasn't hit the latest slide or
		//   if the slider is a loop and
		//   if the slider isn't moving right now:
		//     Go to next slide and
		//     emit a scroll event.
		// Else (the user is scrolling towards the beginning) and
		// if the slider hasn't hit the first slide or
		// if the slider is a loop and
		// if the slider isn't moving right now:
		//   Go to prev slide and
		//   emit a scroll event.
		if (newEvent.direction < 0) {
		  if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
			swiper.slideNext();
			swiper.emit('scroll', newEvent.raw);
		  }
		} else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
		  swiper.slidePrev();
		  swiper.emit('scroll', newEvent.raw);
		}
		// If you got here is because an animation has been triggered so store the current time
		swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
		// Return false as a default
		return false;
	  },
	  releaseScroll(newEvent) {
		const swiper = this;
		const params = swiper.params.mousewheel;
		if (newEvent.direction < 0) {
		  if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
			// Return true to animate scroll on edges
			return true;
		  }
		} else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
		  // Return true to animate scroll on edges
		  return true;
		}
		return false;
	  },
	  enable() {
		const swiper = this;
		const event = Mousewheel.event();
		if (swiper.params.cssMode) {
		  swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
		  return true;
		}
		if (!event) return false;
		if (swiper.mousewheel.enabled) return false;
		let target = swiper.$el;
		if (swiper.params.mousewheel.eventsTarged !== 'container') {
		  target = $(swiper.params.mousewheel.eventsTarged);
		}
		target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
		target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
		target.on(event, swiper.mousewheel.handle);
		swiper.mousewheel.enabled = true;
		return true;
	  },
	  disable() {
		const swiper = this;
		const event = Mousewheel.event();
		if (swiper.params.cssMode) {
		  swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
		  return true;
		}
		if (!event) return false;
		if (!swiper.mousewheel.enabled) return false;
		let target = swiper.$el;
		if (swiper.params.mousewheel.eventsTarged !== 'container') {
		  target = $(swiper.params.mousewheel.eventsTarged);
		}
		target.off(event, swiper.mousewheel.handle);
		swiper.mousewheel.enabled = false;
		return true;
	  },
	};

	var Mousewheel$1 = {
	  name: 'mousewheel',
	  params: {
		mousewheel: {
		  enabled: false,
		  releaseOnEdges: false,
		  invert: false,
		  forceToAxis: false,
		  sensitivity: 1,
		  eventsTarged: 'container',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  mousewheel: {
			enabled: false,
			enable: Mousewheel.enable.bind(swiper),
			disable: Mousewheel.disable.bind(swiper),
			handle: Mousewheel.handle.bind(swiper),
			handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
			handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
			animateSlider: Mousewheel.animateSlider.bind(swiper),
			releaseScroll: Mousewheel.releaseScroll.bind(swiper),
			lastScrollTime: Utils.now(),
			lastEventBeforeSnap: undefined,
			recentWheelEvents: [],
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
			swiper.mousewheel.disable();
		  }
		  if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
		},
		destroy() {
		  const swiper = this;
		  if (swiper.params.cssMode) {
			swiper.mousewheel.enable();
		  }
		  if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
		},
	  },
	};

	const Navigation = {
	  update() {
		// Update Navigation Buttons
		const swiper = this;
		const params = swiper.params.navigation;

		if (swiper.params.loop) return;
		const { $nextEl, $prevEl } = swiper.navigation;

		if ($prevEl && $prevEl.length > 0) {
		  if (swiper.isBeginning) {
			$prevEl.addClass(params.disabledClass);
		  } else {
			$prevEl.removeClass(params.disabledClass);
		  }
		  $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
		}
		if ($nextEl && $nextEl.length > 0) {
		  if (swiper.isEnd) {
			$nextEl.addClass(params.disabledClass);
		  } else {
			$nextEl.removeClass(params.disabledClass);
		  }
		  $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
		}
	  },
	  onPrevClick(e) {
		const swiper = this;
		e.preventDefault();
		if (swiper.isBeginning && !swiper.params.loop) return;
		swiper.slidePrev();
	  },
	  onNextClick(e) {
		const swiper = this;
		e.preventDefault();
		if (swiper.isEnd && !swiper.params.loop) return;
		swiper.slideNext();
	  },
	  init() {
		const swiper = this;
		const params = swiper.params.navigation;
		if (!(params.nextEl || params.prevEl)) return;

		let $nextEl;
		let $prevEl;
		if (params.nextEl) {
		  $nextEl = $(params.nextEl);
		  if (
			  swiper.params.uniqueNavElements
			  && typeof params.nextEl === 'string'
			  && $nextEl.length > 1
			  && swiper.$el.find(params.nextEl).length === 1
		  ) {
			$nextEl = swiper.$el.find(params.nextEl);
		  }
		}
		if (params.prevEl) {
		  $prevEl = $(params.prevEl);
		  if (
			  swiper.params.uniqueNavElements
			  && typeof params.prevEl === 'string'
			  && $prevEl.length > 1
			  && swiper.$el.find(params.prevEl).length === 1
		  ) {
			$prevEl = swiper.$el.find(params.prevEl);
		  }
		}

		if ($nextEl && $nextEl.length > 0) {
		  $nextEl.on('click', swiper.navigation.onNextClick);
		}
		if ($prevEl && $prevEl.length > 0) {
		  $prevEl.on('click', swiper.navigation.onPrevClick);
		}

		Utils.extend(swiper.navigation, {
		  $nextEl,
		  nextEl: $nextEl && $nextEl[0],
		  $prevEl,
		  prevEl: $prevEl && $prevEl[0],
		});
	  },
	  destroy() {
		const swiper = this;
		const { $nextEl, $prevEl } = swiper.navigation;
		if ($nextEl && $nextEl.length) {
		  $nextEl.off('click', swiper.navigation.onNextClick);
		  $nextEl.removeClass(swiper.params.navigation.disabledClass);
		}
		if ($prevEl && $prevEl.length) {
		  $prevEl.off('click', swiper.navigation.onPrevClick);
		  $prevEl.removeClass(swiper.params.navigation.disabledClass);
		}
	  },
	};

	var Navigation$1 = {
	  name: 'navigation',
	  params: {
		navigation: {
		  nextEl: null,
		  prevEl: null,

		  hideOnClick: false,
		  disabledClass: 'swiper-button-disabled',
		  hiddenClass: 'swiper-button-hidden',
		  lockClass: 'swiper-button-lock',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  navigation: {
			init: Navigation.init.bind(swiper),
			update: Navigation.update.bind(swiper),
			destroy: Navigation.destroy.bind(swiper),
			onNextClick: Navigation.onNextClick.bind(swiper),
			onPrevClick: Navigation.onPrevClick.bind(swiper),
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  swiper.navigation.init();
		  swiper.navigation.update();
		},
		toEdge() {
		  const swiper = this;
		  swiper.navigation.update();
		},
		fromEdge() {
		  const swiper = this;
		  swiper.navigation.update();
		},
		destroy() {
		  const swiper = this;
		  swiper.navigation.destroy();
		},
		click(e) {
		  const swiper = this;
		  const { $nextEl, $prevEl } = swiper.navigation;
		  if (
			  swiper.params.navigation.hideOnClick
			  && !$(e.target).is($prevEl)
			  && !$(e.target).is($nextEl)
		  ) {
			let isHidden;
			if ($nextEl) {
			  isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
			} else if ($prevEl) {
			  isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
			}
			if (isHidden === true) {
			  swiper.emit('navigationShow', swiper);
			} else {
			  swiper.emit('navigationHide', swiper);
			}
			if ($nextEl) {
			  $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
			}
			if ($prevEl) {
			  $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
			}
		  }
		},
	  },
	};

	const Pagination = {
	  update() {
		// Render || Update Pagination bullets/items
		const swiper = this;
		const rtl = swiper.rtl;
		const params = swiper.params.pagination;
		if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
		const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
		const $el = swiper.pagination.$el;
		// Current/Total
		let current;
		const total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
		if (swiper.params.loop) {
		  current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
		  if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
			current -= (slidesLength - (swiper.loopedSlides * 2));
		  }
		  if (current > total - 1) current -= total;
		  if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
		} else if (typeof swiper.snapIndex !== 'undefined') {
		  current = swiper.snapIndex;
		} else {
		  current = swiper.activeIndex || 0;
		}
		// Types
		if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
		  const bullets = swiper.pagination.bullets;
		  let firstIndex;
		  let lastIndex;
		  let midIndex;
		  if (params.dynamicBullets) {
			swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
			$el.css(swiper.isHorizontal() ? 'width' : 'height', `${swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)}px`);
			if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
			  swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
			  if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
				swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
			  } else if (swiper.pagination.dynamicBulletIndex < 0) {
				swiper.pagination.dynamicBulletIndex = 0;
			  }
			}
			firstIndex = current - swiper.pagination.dynamicBulletIndex;
			lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
			midIndex = (lastIndex + firstIndex) / 2;
		  }
		  bullets.removeClass(`${params.bulletActiveClass} ${params.bulletActiveClass}-next ${params.bulletActiveClass}-next-next ${params.bulletActiveClass}-prev ${params.bulletActiveClass}-prev-prev ${params.bulletActiveClass}-main`);
		  if ($el.length > 1) {
			bullets.each((index, bullet) => {
			  const $bullet = $(bullet);
			  const bulletIndex = $bullet.index();
			  if (bulletIndex === current) {
				$bullet.addClass(params.bulletActiveClass);
			  }
			  if (params.dynamicBullets) {
				if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
				  $bullet.addClass(`${params.bulletActiveClass}-main`);
				}
				if (bulletIndex === firstIndex) {
				  $bullet
					  .prev()
					  .addClass(`${params.bulletActiveClass}-prev`)
					  .prev()
					  .addClass(`${params.bulletActiveClass}-prev-prev`);
				}
				if (bulletIndex === lastIndex) {
				  $bullet
					  .next()
					  .addClass(`${params.bulletActiveClass}-next`)
					  .next()
					  .addClass(`${params.bulletActiveClass}-next-next`);
				}
			  }
			});
		  } else {
			const $bullet = bullets.eq(current);
			const bulletIndex = $bullet.index();
			$bullet.addClass(params.bulletActiveClass);
			if (params.dynamicBullets) {
			  const $firstDisplayedBullet = bullets.eq(firstIndex);
			  const $lastDisplayedBullet = bullets.eq(lastIndex);
			  for (let i = firstIndex; i <= lastIndex; i += 1) {
				bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
			  }
			  if (swiper.params.loop) {
				if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
				  for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
					bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
				  }
				  bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
				} else {
				  $firstDisplayedBullet
					  .prev()
					  .addClass(`${params.bulletActiveClass}-prev`)
					  .prev()
					  .addClass(`${params.bulletActiveClass}-prev-prev`);
				  $lastDisplayedBullet
					  .next()
					  .addClass(`${params.bulletActiveClass}-next`)
					  .next()
					  .addClass(`${params.bulletActiveClass}-next-next`);
				}
			  } else {
				$firstDisplayedBullet
					.prev()
					.addClass(`${params.bulletActiveClass}-prev`)
					.prev()
					.addClass(`${params.bulletActiveClass}-prev-prev`);
				$lastDisplayedBullet
					.next()
					.addClass(`${params.bulletActiveClass}-next`)
					.next()
					.addClass(`${params.bulletActiveClass}-next-next`);
			  }
			}
		  }
		  if (params.dynamicBullets) {
			const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
			const bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
			const offsetProp = rtl ? 'right' : 'left';
			bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
		  }
		}
		if (params.type === 'fraction') {
		  $el.find(`.${params.currentClass}`).text(params.formatFractionCurrent(current + 1));
		  $el.find(`.${params.totalClass}`).text(params.formatFractionTotal(total));
		}
		if (params.type === 'progressbar') {
		  let progressbarDirection;
		  if (params.progressbarOpposite) {
			progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
		  } else {
			progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
		  }
		  const scale = (current + 1) / total;
		  let scaleX = 1;
		  let scaleY = 1;
		  if (progressbarDirection === 'horizontal') {
			scaleX = scale;
		  } else {
			scaleY = scale;
		  }
		  $el.find(`.${params.progressbarFillClass}`).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
		}
		if (params.type === 'custom' && params.renderCustom) {
		  $el.html(params.renderCustom(swiper, current + 1, total));
		  swiper.emit('paginationRender', swiper, $el[0]);
		} else {
		  swiper.emit('paginationUpdate', swiper, $el[0]);
		}
		$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	  },
	  render() {
		// Render Container
		const swiper = this;
		const params = swiper.params.pagination;
		if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
		const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

		const $el = swiper.pagination.$el;
		let paginationHTML = '';
		if (params.type === 'bullets') {
		  const numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
		  for (let i = 0; i < numberOfBullets; i += 1) {
			if (params.renderBullet) {
			  paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
			} else {
			  paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
			}
		  }
		  $el.html(paginationHTML);
		  swiper.pagination.bullets = $el.find(`.${params.bulletClass}`);
		}
		if (params.type === 'fraction') {
		  if (params.renderFraction) {
			paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
		  } else {
			paginationHTML = `<span class="${params.currentClass}"></span>`
				+ ' / '
				+ `<span class="${params.totalClass}"></span>`;
		  }
		  $el.html(paginationHTML);
		}
		if (params.type === 'progressbar') {
		  if (params.renderProgressbar) {
			paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
		  } else {
			paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
		  }
		  $el.html(paginationHTML);
		}
		if (params.type !== 'custom') {
		  swiper.emit('paginationRender', swiper.pagination.$el[0]);
		}
	  },
	  init() {
		const swiper = this;
		const params = swiper.params.pagination;
		if (!params.el) return;

		let $el = $(params.el);
		if ($el.length === 0) return;

		if (
			swiper.params.uniqueNavElements
			&& typeof params.el === 'string'
			&& $el.length > 1
		) {
		  $el = swiper.$el.find(params.el);
		}

		if (params.type === 'bullets' && params.clickable) {
		  $el.addClass(params.clickableClass);
		}

		$el.addClass(params.modifierClass + params.type);

		if (params.type === 'bullets' && params.dynamicBullets) {
		  $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
		  swiper.pagination.dynamicBulletIndex = 0;
		  if (params.dynamicMainBullets < 1) {
			params.dynamicMainBullets = 1;
		  }
		}
		if (params.type === 'progressbar' && params.progressbarOpposite) {
		  $el.addClass(params.progressbarOppositeClass);
		}

		if (params.clickable) {
		  $el.on('click', `.${params.bulletClass}`, function onClick(e) {
			e.preventDefault();
			let index = $(this).index() * swiper.params.slidesPerGroup;
			if (swiper.params.loop) index += swiper.loopedSlides;
			swiper.slideTo(index);
		  });
		}

		Utils.extend(swiper.pagination, {
		  $el,
		  el: $el[0],
		});
	  },
	  destroy() {
		const swiper = this;
		const params = swiper.params.pagination;
		if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
		const $el = swiper.pagination.$el;

		$el.removeClass(params.hiddenClass);
		$el.removeClass(params.modifierClass + params.type);
		if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
		if (params.clickable) {
		  $el.off('click', `.${params.bulletClass}`);
		}
	  },
	};

	var Pagination$1 = {
	  name: 'pagination',
	  params: {
		pagination: {
		  el: null,
		  bulletElement: 'span',
		  clickable: false,
		  hideOnClick: false,
		  renderBullet: null,
		  renderProgressbar: null,
		  renderFraction: null,
		  renderCustom: null,
		  progressbarOpposite: false,
		  type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
		  dynamicBullets: false,
		  dynamicMainBullets: 1,
		  formatFractionCurrent: (number) => number,
		  formatFractionTotal: (number) => number,
		  bulletClass: 'swiper-pagination-bullet',
		  bulletActiveClass: 'swiper-pagination-bullet-active',
		  modifierClass: 'swiper-pagination-', // NEW
		  currentClass: 'swiper-pagination-current',
		  totalClass: 'swiper-pagination-total',
		  hiddenClass: 'swiper-pagination-hidden',
		  progressbarFillClass: 'swiper-pagination-progressbar-fill',
		  progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
		  clickableClass: 'swiper-pagination-clickable', // NEW
		  lockClass: 'swiper-pagination-lock',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  pagination: {
			init: Pagination.init.bind(swiper),
			render: Pagination.render.bind(swiper),
			update: Pagination.update.bind(swiper),
			destroy: Pagination.destroy.bind(swiper),
			dynamicBulletIndex: 0,
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  swiper.pagination.init();
		  swiper.pagination.render();
		  swiper.pagination.update();
		},
		activeIndexChange() {
		  const swiper = this;
		  if (swiper.params.loop) {
			swiper.pagination.update();
		  } else if (typeof swiper.snapIndex === 'undefined') {
			swiper.pagination.update();
		  }
		},
		snapIndexChange() {
		  const swiper = this;
		  if (!swiper.params.loop) {
			swiper.pagination.update();
		  }
		},
		slidesLengthChange() {
		  const swiper = this;
		  if (swiper.params.loop) {
			swiper.pagination.render();
			swiper.pagination.update();
		  }
		},
		snapGridLengthChange() {
		  const swiper = this;
		  if (!swiper.params.loop) {
			swiper.pagination.render();
			swiper.pagination.update();
		  }
		},
		destroy() {
		  const swiper = this;
		  swiper.pagination.destroy();
		},
		click(e) {
		  const swiper = this;
		  if (
			  swiper.params.pagination.el
			  && swiper.params.pagination.hideOnClick
			  && swiper.pagination.$el.length > 0
			  && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
		  ) {
			const isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
			if (isHidden === true) {
			  swiper.emit('paginationShow', swiper);
			} else {
			  swiper.emit('paginationHide', swiper);
			}
			swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
		  }
		},
	  },
	};

	const Scrollbar = {
	  setTranslate() {
		const swiper = this;
		if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
		const { scrollbar, rtlTranslate: rtl, progress } = swiper;
		const {
		  dragSize, trackSize, $dragEl, $el,
		} = scrollbar;
		const params = swiper.params.scrollbar;

		let newSize = dragSize;
		let newPos = (trackSize - dragSize) * progress;
		if (rtl) {
		  newPos = -newPos;
		  if (newPos > 0) {
			newSize = dragSize - newPos;
			newPos = 0;
		  } else if (-newPos + dragSize > trackSize) {
			newSize = trackSize + newPos;
		  }
		} else if (newPos < 0) {
		  newSize = dragSize + newPos;
		  newPos = 0;
		} else if (newPos + dragSize > trackSize) {
		  newSize = trackSize - newPos;
		}
		if (swiper.isHorizontal()) {
		  $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
		  $dragEl[0].style.width = `${newSize}px`;
		} else {
		  $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
		  $dragEl[0].style.height = `${newSize}px`;
		}
		if (params.hide) {
		  clearTimeout(swiper.scrollbar.timeout);
		  $el[0].style.opacity = 1;
		  swiper.scrollbar.timeout = setTimeout(() => {
			$el[0].style.opacity = 0;
			$el.transition(400);
		  }, 1000);
		}
	  },
	  setTransition(duration) {
		const swiper = this;
		if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
		swiper.scrollbar.$dragEl.transition(duration);
	  },
	  updateSize() {
		const swiper = this;
		if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;

		const { scrollbar } = swiper;
		const { $dragEl, $el } = scrollbar;

		$dragEl[0].style.width = '';
		$dragEl[0].style.height = '';
		const trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

		const divider = swiper.size / swiper.virtualSize;
		const moveDivider = divider * (trackSize / swiper.size);
		let dragSize;
		if (swiper.params.scrollbar.dragSize === 'auto') {
		  dragSize = trackSize * divider;
		} else {
		  dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
		}

		if (swiper.isHorizontal()) {
		  $dragEl[0].style.width = `${dragSize}px`;
		} else {
		  $dragEl[0].style.height = `${dragSize}px`;
		}

		if (divider >= 1) {
		  $el[0].style.display = 'none';
		} else {
		  $el[0].style.display = '';
		}
		if (swiper.params.scrollbar.hide) {
		  $el[0].style.opacity = 0;
		}
		Utils.extend(scrollbar, {
		  trackSize,
		  divider,
		  moveDivider,
		  dragSize,
		});
		scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	  },
	  getPointerPosition(e) {
		const swiper = this;
		if (swiper.isHorizontal()) {
		  return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientX : e.clientX);
		}
		return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientY : e.clientY);
	  },
	  setDragPosition(e) {
		const swiper = this;
		const { scrollbar, rtlTranslate: rtl } = swiper;
		const {
		  $el,
		  dragSize,
		  trackSize,
		  dragStartPos,
		} = scrollbar;

		let positionRatio;
		positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
			- (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
		positionRatio = Math.max(Math.min(positionRatio, 1), 0);
		if (rtl) {
		  positionRatio = 1 - positionRatio;
		}

		const position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

		swiper.updateProgress(position);
		swiper.setTranslate(position);
		swiper.updateActiveIndex();
		swiper.updateSlidesClasses();
	  },
	  onDragStart(e) {
		const swiper = this;
		const params = swiper.params.scrollbar;
		const { scrollbar, $wrapperEl } = swiper;
		const { $el, $dragEl } = scrollbar;
		swiper.scrollbar.isTouched = true;
		swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
			? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
		e.preventDefault();
		e.stopPropagation();

		$wrapperEl.transition(100);
		$dragEl.transition(100);
		scrollbar.setDragPosition(e);

		clearTimeout(swiper.scrollbar.dragTimeout);

		$el.transition(0);
		if (params.hide) {
		  $el.css('opacity', 1);
		}
		if (swiper.params.cssMode) {
		  swiper.$wrapperEl.css('scroll-snap-type', 'none');
		}
		swiper.emit('scrollbarDragStart', e);
	  },
	  onDragMove(e) {
		const swiper = this;
		const { scrollbar, $wrapperEl } = swiper;
		const { $el, $dragEl } = scrollbar;

		if (!swiper.scrollbar.isTouched) return;
		if (e.preventDefault) e.preventDefault();
		else e.returnValue = false;
		scrollbar.setDragPosition(e);
		$wrapperEl.transition(0);
		$el.transition(0);
		$dragEl.transition(0);
		swiper.emit('scrollbarDragMove', e);
	  },
	  onDragEnd(e) {
		const swiper = this;

		const params = swiper.params.scrollbar;
		const { scrollbar, $wrapperEl } = swiper;
		const { $el } = scrollbar;

		if (!swiper.scrollbar.isTouched) return;
		swiper.scrollbar.isTouched = false;
		if (swiper.params.cssMode) {
		  swiper.$wrapperEl.css('scroll-snap-type', '');
		  $wrapperEl.transition('');
		}
		if (params.hide) {
		  clearTimeout(swiper.scrollbar.dragTimeout);
		  swiper.scrollbar.dragTimeout = Utils.nextTick(() => {
			$el.css('opacity', 0);
			$el.transition(400);
		  }, 1000);
		}
		swiper.emit('scrollbarDragEnd', e);
		if (params.snapOnRelease) {
		  swiper.slideToClosest();
		}
	  },
	  enableDraggable() {
		const swiper = this;
		if (!swiper.params.scrollbar.el) return;
		const {
		  scrollbar, touchEventsTouch, touchEventsDesktop, params,
		} = swiper;
		const $el = scrollbar.$el;
		const target = $el[0];
		const activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
		const passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
		if (!Support.touch) {
		  target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
		  doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
		  doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
		} else {
		  target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
		  target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
		  target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
		}
	  },
	  disableDraggable() {
		const swiper = this;
		if (!swiper.params.scrollbar.el) return;
		const {
		  scrollbar, touchEventsTouch, touchEventsDesktop, params,
		} = swiper;
		const $el = scrollbar.$el;
		const target = $el[0];
		const activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
		const passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
		if (!Support.touch) {
		  target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
		  doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
		  doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
		} else {
		  target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
		  target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
		  target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
		}
	  },
	  init() {
		const swiper = this;
		if (!swiper.params.scrollbar.el) return;
		const { scrollbar, $el: $swiperEl } = swiper;
		const params = swiper.params.scrollbar;

		let $el = $(params.el);
		if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
		  $el = $swiperEl.find(params.el);
		}

		let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
		if ($dragEl.length === 0) {
		  $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
		  $el.append($dragEl);
		}

		Utils.extend(scrollbar, {
		  $el,
		  el: $el[0],
		  $dragEl,
		  dragEl: $dragEl[0],
		});

		if (params.draggable) {
		  scrollbar.enableDraggable();
		}
	  },
	  destroy() {
		const swiper = this;
		swiper.scrollbar.disableDraggable();
	  },
	};

	var Scrollbar$1 = {
	  name: 'scrollbar',
	  params: {
		scrollbar: {
		  el: null,
		  dragSize: 'auto',
		  hide: false,
		  draggable: false,
		  snapOnRelease: true,
		  lockClass: 'swiper-scrollbar-lock',
		  dragClass: 'swiper-scrollbar-drag',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  scrollbar: {
			init: Scrollbar.init.bind(swiper),
			destroy: Scrollbar.destroy.bind(swiper),
			updateSize: Scrollbar.updateSize.bind(swiper),
			setTranslate: Scrollbar.setTranslate.bind(swiper),
			setTransition: Scrollbar.setTransition.bind(swiper),
			enableDraggable: Scrollbar.enableDraggable.bind(swiper),
			disableDraggable: Scrollbar.disableDraggable.bind(swiper),
			setDragPosition: Scrollbar.setDragPosition.bind(swiper),
			getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
			onDragStart: Scrollbar.onDragStart.bind(swiper),
			onDragMove: Scrollbar.onDragMove.bind(swiper),
			onDragEnd: Scrollbar.onDragEnd.bind(swiper),
			isTouched: false,
			timeout: null,
			dragTimeout: null,
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  swiper.scrollbar.init();
		  swiper.scrollbar.updateSize();
		  swiper.scrollbar.setTranslate();
		},
		update() {
		  const swiper = this;
		  swiper.scrollbar.updateSize();
		},
		resize() {
		  const swiper = this;
		  swiper.scrollbar.updateSize();
		},
		observerUpdate() {
		  const swiper = this;
		  swiper.scrollbar.updateSize();
		},
		setTranslate() {
		  const swiper = this;
		  swiper.scrollbar.setTranslate();
		},
		setTransition(duration) {
		  const swiper = this;
		  swiper.scrollbar.setTransition(duration);
		},
		destroy() {
		  const swiper = this;
		  swiper.scrollbar.destroy();
		},
	  },
	};

	const Parallax = {
	  setTransform(el, progress) {
		const swiper = this;
		const { rtl } = swiper;

		const $el = $(el);
		const rtlFactor = rtl ? -1 : 1;

		const p = $el.attr('data-swiper-parallax') || '0';
		let x = $el.attr('data-swiper-parallax-x');
		let y = $el.attr('data-swiper-parallax-y');
		const scale = $el.attr('data-swiper-parallax-scale');
		const opacity = $el.attr('data-swiper-parallax-opacity');

		if (x || y) {
		  x = x || '0';
		  y = y || '0';
		} else if (swiper.isHorizontal()) {
		  x = p;
		  y = '0';
		} else {
		  y = p;
		  x = '0';
		}

		if ((x).indexOf('%') >= 0) {
		  x = `${parseInt(x, 10) * progress * rtlFactor}%`;
		} else {
		  x = `${x * progress * rtlFactor}px`;
		}
		if ((y).indexOf('%') >= 0) {
		  y = `${parseInt(y, 10) * progress}%`;
		} else {
		  y = `${y * progress}px`;
		}

		if (typeof opacity !== 'undefined' && opacity !== null) {
		  const currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
		  $el[0].style.opacity = currentOpacity;
		}
		if (typeof scale === 'undefined' || scale === null) {
		  $el.transform(`translate3d(${x}, ${y}, 0px)`);
		} else {
		  const currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
		  $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
		}
	  },
	  setTranslate() {
		const swiper = this;
		const {
		  $el, slides, progress, snapGrid,
		} = swiper;
		$el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
			.each((index, el) => {
			  swiper.parallax.setTransform(el, progress);
			});
		slides.each((slideIndex, slideEl) => {
		  let slideProgress = slideEl.progress;
		  if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
			slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
		  }
		  slideProgress = Math.min(Math.max(slideProgress, -1), 1);
		  $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
			  .each((index, el) => {
				swiper.parallax.setTransform(el, slideProgress);
			  });
		});
	  },
	  setTransition(duration = this.params.speed) {
		const swiper = this;
		const { $el } = swiper;
		$el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
			.each((index, parallaxEl) => {
			  const $parallaxEl = $(parallaxEl);
			  let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
			  if (duration === 0) parallaxDuration = 0;
			  $parallaxEl.transition(parallaxDuration);
			});
	  },
	};

	var Parallax$1 = {
	  name: 'parallax',
	  params: {
		parallax: {
		  enabled: false,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  parallax: {
			setTransform: Parallax.setTransform.bind(swiper),
			setTranslate: Parallax.setTranslate.bind(swiper),
			setTransition: Parallax.setTransition.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (!swiper.params.parallax.enabled) return;
		  swiper.params.watchSlidesProgress = true;
		  swiper.originalParams.watchSlidesProgress = true;
		},
		init() {
		  const swiper = this;
		  if (!swiper.params.parallax.enabled) return;
		  swiper.parallax.setTranslate();
		},
		setTranslate() {
		  const swiper = this;
		  if (!swiper.params.parallax.enabled) return;
		  swiper.parallax.setTranslate();
		},
		setTransition(duration) {
		  const swiper = this;
		  if (!swiper.params.parallax.enabled) return;
		  swiper.parallax.setTransition(duration);
		},
	  },
	};

	const Zoom = {
	  // Calc Scale From Multi-touches
	  getDistanceBetweenTouches(e) {
		if (e.targetTouches.length < 2) return 1;
		const x1 = e.targetTouches[0].pageX;
		const y1 = e.targetTouches[0].pageY;
		const x2 = e.targetTouches[1].pageX;
		const y2 = e.targetTouches[1].pageY;
		const distance = Math.sqrt(((x2 - x1) ** 2) + ((y2 - y1) ** 2));
		return distance;
	  },
	  // Events
	  onGestureStart(e) {
		const swiper = this;
		const params = swiper.params.zoom;
		const zoom = swiper.zoom;
		const { gesture } = zoom;
		zoom.fakeGestureTouched = false;
		zoom.fakeGestureMoved = false;
		if (!Support.gestures) {
		  if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
			return;
		  }
		  zoom.fakeGestureTouched = true;
		  gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
		}
		if (!gesture.$slideEl || !gesture.$slideEl.length) {
		  gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
		  if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
		  gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
		  gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
		  gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
		  if (gesture.$imageWrapEl.length === 0) {
			gesture.$imageEl = undefined;
			return;
		  }
		}
		if (gesture.$imageEl) {
		  gesture.$imageEl.transition(0);
		}
		swiper.zoom.isScaling = true;
	  },
	  onGestureChange(e) {
		const swiper = this;
		const params = swiper.params.zoom;
		const zoom = swiper.zoom;
		const { gesture } = zoom;
		if (!Support.gestures) {
		  if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
			return;
		  }
		  zoom.fakeGestureMoved = true;
		  gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
		}
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
		if (Support.gestures) {
		  zoom.scale = e.scale * zoom.currentScale;
		} else {
		  zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
		}
		if (zoom.scale > gesture.maxRatio) {
		  zoom.scale = (gesture.maxRatio - 1) + (((zoom.scale - gesture.maxRatio) + 1) ** 0.5);
		}
		if (zoom.scale < params.minRatio) {
		  zoom.scale = (params.minRatio + 1) - (((params.minRatio - zoom.scale) + 1) ** 0.5);
		}
		gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
	  },
	  onGestureEnd(e) {
		const swiper = this;
		const params = swiper.params.zoom;
		const zoom = swiper.zoom;
		const { gesture } = zoom;
		if (!Support.gestures) {
		  if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
			return;
		  }
		  if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
			return;
		  }
		  zoom.fakeGestureTouched = false;
		  zoom.fakeGestureMoved = false;
		}
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
		zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
		gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
		zoom.currentScale = zoom.scale;
		zoom.isScaling = false;
		if (zoom.scale === 1) gesture.$slideEl = undefined;
	  },
	  onTouchStart(e) {
		const swiper = this;
		const zoom = swiper.zoom;
		const { gesture, image } = zoom;
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
		if (image.isTouched) return;
		if (Device.android && e.cancelable) e.preventDefault();
		image.isTouched = true;
		image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
		image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  },
	  onTouchMove(e) {
		const swiper = this;
		const zoom = swiper.zoom;
		const { gesture, image, velocity } = zoom;
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
		swiper.allowClick = false;
		if (!image.isTouched || !gesture.$slideEl) return;

		if (!image.isMoved) {
		  image.width = gesture.$imageEl[0].offsetWidth;
		  image.height = gesture.$imageEl[0].offsetHeight;
		  image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
		  image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
		  gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
		  gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
		  gesture.$imageWrapEl.transition(0);
		  if (swiper.rtl) {
			image.startX = -image.startX;
			image.startY = -image.startY;
		  }
		}
		// Define if we need image drag
		const scaledWidth = image.width * zoom.scale;
		const scaledHeight = image.height * zoom.scale;

		if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;

		image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
		image.maxX = -image.minX;
		image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
		image.maxY = -image.minY;

		image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
		image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

		if (!image.isMoved && !zoom.isScaling) {
		  if (
			  swiper.isHorizontal()
			  && (
				  (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
				  || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
			  )
		  ) {
			image.isTouched = false;
			return;
		  } if (
			  !swiper.isHorizontal()
			  && (
				  (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
				  || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
			  )
		  ) {
			image.isTouched = false;
			return;
		  }
		}
		if (e.cancelable) {
		  e.preventDefault();
		}
		e.stopPropagation();

		image.isMoved = true;
		image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
		image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

		if (image.currentX < image.minX) {
		  image.currentX = (image.minX + 1) - (((image.minX - image.currentX) + 1) ** 0.8);
		}
		if (image.currentX > image.maxX) {
		  image.currentX = (image.maxX - 1) + (((image.currentX - image.maxX) + 1) ** 0.8);
		}

		if (image.currentY < image.minY) {
		  image.currentY = (image.minY + 1) - (((image.minY - image.currentY) + 1) ** 0.8);
		}
		if (image.currentY > image.maxY) {
		  image.currentY = (image.maxY - 1) + (((image.currentY - image.maxY) + 1) ** 0.8);
		}

		// Velocity
		if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
		if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
		if (!velocity.prevTime) velocity.prevTime = Date.now();
		velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
		velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
		if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
		if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
		velocity.prevPositionX = image.touchesCurrent.x;
		velocity.prevPositionY = image.touchesCurrent.y;
		velocity.prevTime = Date.now();

		gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
	  },
	  onTouchEnd() {
		const swiper = this;
		const zoom = swiper.zoom;
		const { gesture, image, velocity } = zoom;
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
		if (!image.isTouched || !image.isMoved) {
		  image.isTouched = false;
		  image.isMoved = false;
		  return;
		}
		image.isTouched = false;
		image.isMoved = false;
		let momentumDurationX = 300;
		let momentumDurationY = 300;
		const momentumDistanceX = velocity.x * momentumDurationX;
		const newPositionX = image.currentX + momentumDistanceX;
		const momentumDistanceY = velocity.y * momentumDurationY;
		const newPositionY = image.currentY + momentumDistanceY;

		// Fix duration
		if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
		if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
		const momentumDuration = Math.max(momentumDurationX, momentumDurationY);

		image.currentX = newPositionX;
		image.currentY = newPositionY;

		// Define if we need image drag
		const scaledWidth = image.width * zoom.scale;
		const scaledHeight = image.height * zoom.scale;
		image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
		image.maxX = -image.minX;
		image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
		image.maxY = -image.minY;
		image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
		image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

		gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
	  },
	  onTransitionEnd() {
		const swiper = this;
		const zoom = swiper.zoom;
		const { gesture } = zoom;
		if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
		  if (gesture.$imageEl) {
			gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
		  }
		  if (gesture.$imageWrapEl) {
			gesture.$imageWrapEl.transform('translate3d(0,0,0)');
		  }

		  zoom.scale = 1;
		  zoom.currentScale = 1;

		  gesture.$slideEl = undefined;
		  gesture.$imageEl = undefined;
		  gesture.$imageWrapEl = undefined;
		}
	  },
	  // Toggle Zoom
	  toggle(e) {
		const swiper = this;
		const zoom = swiper.zoom;

		if (zoom.scale && zoom.scale !== 1) {
		  // Zoom Out
		  zoom.out();
		} else {
		  // Zoom In
		  zoom.in(e);
		}
	  },
	  in(e) {
		const swiper = this;

		const zoom = swiper.zoom;
		const params = swiper.params.zoom;
		const { gesture, image } = zoom;

		if (!gesture.$slideEl) {
		  if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
			gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
		  } else {
			gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
		  }
		  gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
		  gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
		}
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

		gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);

		let touchX;
		let touchY;
		let offsetX;
		let offsetY;
		let diffX;
		let diffY;
		let translateX;
		let translateY;
		let imageWidth;
		let imageHeight;
		let scaledWidth;
		let scaledHeight;
		let translateMinX;
		let translateMinY;
		let translateMaxX;
		let translateMaxY;
		let slideWidth;
		let slideHeight;

		if (typeof image.touchesStart.x === 'undefined' && e) {
		  touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
		  touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
		} else {
		  touchX = image.touchesStart.x;
		  touchY = image.touchesStart.y;
		}

		zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
		zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
		if (e) {
		  slideWidth = gesture.$slideEl[0].offsetWidth;
		  slideHeight = gesture.$slideEl[0].offsetHeight;
		  offsetX = gesture.$slideEl.offset().left;
		  offsetY = gesture.$slideEl.offset().top;
		  diffX = (offsetX + (slideWidth / 2)) - touchX;
		  diffY = (offsetY + (slideHeight / 2)) - touchY;

		  imageWidth = gesture.$imageEl[0].offsetWidth;
		  imageHeight = gesture.$imageEl[0].offsetHeight;
		  scaledWidth = imageWidth * zoom.scale;
		  scaledHeight = imageHeight * zoom.scale;

		  translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
		  translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
		  translateMaxX = -translateMinX;
		  translateMaxY = -translateMinY;

		  translateX = diffX * zoom.scale;
		  translateY = diffY * zoom.scale;

		  if (translateX < translateMinX) {
			translateX = translateMinX;
		  }
		  if (translateX > translateMaxX) {
			translateX = translateMaxX;
		  }

		  if (translateY < translateMinY) {
			translateY = translateMinY;
		  }
		  if (translateY > translateMaxY) {
			translateY = translateMaxY;
		  }
		} else {
		  translateX = 0;
		  translateY = 0;
		}
		gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
		gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
	  },
	  out() {
		const swiper = this;

		const zoom = swiper.zoom;
		const params = swiper.params.zoom;
		const { gesture } = zoom;

		if (!gesture.$slideEl) {
		  if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
			gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
		  } else {
			gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
		  }
		  gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
		  gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
		}
		if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

		zoom.scale = 1;
		zoom.currentScale = 1;
		gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
		gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
		gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
		gesture.$slideEl = undefined;
	  },
	  // Attach/Detach Events
	  enable() {
		const swiper = this;
		const zoom = swiper.zoom;
		if (zoom.enabled) return;
		zoom.enabled = true;

		const passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
		const activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

		const slideSelector = `.${swiper.params.slideClass}`;

		// Scale image
		if (Support.gestures) {
		  swiper.$wrapperEl.on('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
		  swiper.$wrapperEl.on('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
		  swiper.$wrapperEl.on('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
		} else if (swiper.touchEvents.start === 'touchstart') {
		  swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
		  swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
		  swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
		  if (swiper.touchEvents.cancel) {
			swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
		  }
		}

		// Move image
		swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, zoom.onTouchMove, activeListenerWithCapture);
	  },
	  disable() {
		const swiper = this;
		const zoom = swiper.zoom;
		if (!zoom.enabled) return;

		swiper.zoom.enabled = false;

		const passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
		const activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;

		const slideSelector = `.${swiper.params.slideClass}`;

		// Scale image
		if (Support.gestures) {
		  swiper.$wrapperEl.off('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
		  swiper.$wrapperEl.off('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
		  swiper.$wrapperEl.off('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
		} else if (swiper.touchEvents.start === 'touchstart') {
		  swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
		  swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
		  swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
		  if (swiper.touchEvents.cancel) {
			swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
		  }
		}

		// Move image
		swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, zoom.onTouchMove, activeListenerWithCapture);
	  },
	};

	var Zoom$1 = {
	  name: 'zoom',
	  params: {
		zoom: {
		  enabled: false,
		  maxRatio: 3,
		  minRatio: 1,
		  toggle: true,
		  containerClass: 'swiper-zoom-container',
		  zoomedSlideClass: 'swiper-slide-zoomed',
		},
	  },
	  create() {
		const swiper = this;
		const zoom = {
		  enabled: false,
		  scale: 1,
		  currentScale: 1,
		  isScaling: false,
		  gesture: {
			$slideEl: undefined,
			slideWidth: undefined,
			slideHeight: undefined,
			$imageEl: undefined,
			$imageWrapEl: undefined,
			maxRatio: 3,
		  },
		  image: {
			isTouched: undefined,
			isMoved: undefined,
			currentX: undefined,
			currentY: undefined,
			minX: undefined,
			minY: undefined,
			maxX: undefined,
			maxY: undefined,
			width: undefined,
			height: undefined,
			startX: undefined,
			startY: undefined,
			touchesStart: {},
			touchesCurrent: {},
		  },
		  velocity: {
			x: undefined,
			y: undefined,
			prevPositionX: undefined,
			prevPositionY: undefined,
			prevTime: undefined,
		  },
		};

		('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach((methodName) => {
		  zoom[methodName] = Zoom[methodName].bind(swiper);
		});
		Utils.extend(swiper, {
		  zoom,
		});

		let scale = 1;
		Object.defineProperty(swiper.zoom, 'scale', {
		  get() {
			return scale;
		  },
		  set(value) {
			if (scale !== value) {
			  const imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
			  const slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
			  swiper.emit('zoomChange', value, imageEl, slideEl);
			}
			scale = value;
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (swiper.params.zoom.enabled) {
			swiper.zoom.enable();
		  }
		},
		destroy() {
		  const swiper = this;
		  swiper.zoom.disable();
		},
		touchStart(e) {
		  const swiper = this;
		  if (!swiper.zoom.enabled) return;
		  swiper.zoom.onTouchStart(e);
		},
		touchEnd(e) {
		  const swiper = this;
		  if (!swiper.zoom.enabled) return;
		  swiper.zoom.onTouchEnd(e);
		},
		doubleTap(e) {
		  const swiper = this;
		  if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
			swiper.zoom.toggle(e);
		  }
		},
		transitionEnd() {
		  const swiper = this;
		  if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
			swiper.zoom.onTransitionEnd();
		  }
		},
		slideChange() {
		  const swiper = this;
		  if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
			swiper.zoom.onTransitionEnd();
		  }
		},
	  },
	};

	const Lazy = {
	  loadInSlide(index, loadInDuplicate = true) {
		const swiper = this;
		const params = swiper.params.lazy;
		if (typeof index === 'undefined') return;
		if (swiper.slides.length === 0) return;
		const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

		const $slideEl = isVirtual
			? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`)
			: swiper.slides.eq(index);

		let $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
		if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
		  $images = $images.add($slideEl[0]);
		}
		if ($images.length === 0) return;

		$images.each((imageIndex, imageEl) => {
		  const $imageEl = $(imageEl);
		  $imageEl.addClass(params.loadingClass);

		  const background = $imageEl.attr('data-background');
		  const src = $imageEl.attr('data-src');
		  const srcset = $imageEl.attr('data-srcset');
		  const sizes = $imageEl.attr('data-sizes');
		  const $pictureEl = $imageEl.parent('picture');

		  swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, () => {
			if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) return;
			if (background) {
			  $imageEl.css('background-image', `url("${background}")`);
			  $imageEl.removeAttr('data-background');
			} else {
			  if (srcset) {
				$imageEl.attr('srcset', srcset);
				$imageEl.removeAttr('data-srcset');
			  }
			  if (sizes) {
				$imageEl.attr('sizes', sizes);
				$imageEl.removeAttr('data-sizes');
			  }
			  if ($pictureEl.length) {
				$pictureEl.children('source').each((sourceIndex, sourceEl) => {
				  const $source = $(sourceEl);

				  if ($source.attr('data-srcset')) {
					$source.attr('srcset', $source.attr('data-srcset'));
					$source.removeAttr('data-srcset');
				  }
				});
			  }
			  if (src) {
				$imageEl.attr('src', src);
				$imageEl.removeAttr('data-src');
			  }
			}

			$imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
			$slideEl.find(`.${params.preloaderClass}`).remove();
			if (swiper.params.loop && loadInDuplicate) {
			  const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
			  if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
				const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
				swiper.lazy.loadInSlide(originalSlide.index(), false);
			  } else {
				const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
				swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
			  }
			}
			swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
			if (swiper.params.autoHeight) {
			  swiper.updateAutoHeight();
			}
		  });

		  swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
		});
	  },
	  load() {
		const swiper = this;
		const {
		  $wrapperEl, params: swiperParams, slides, activeIndex,
		} = swiper;
		const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
		const params = swiperParams.lazy;

		let slidesPerView = swiperParams.slidesPerView;
		if (slidesPerView === 'auto') {
		  slidesPerView = 0;
		}

		function slideExist(index) {
		  if (isVirtual) {
			if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
			  return true;
			}
		  } else if (slides[index]) return true;
		  return false;
		}

		function slideIndex(slideEl) {
		  if (isVirtual) {
			return $(slideEl).attr('data-swiper-slide-index');
		  }
		  return $(slideEl).index();
		}

		if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
		if (swiper.params.watchSlidesVisibility) {
		  $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((elIndex, slideEl) => {
			const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
			swiper.lazy.loadInSlide(index);
		  });
		} else if (slidesPerView > 1) {
		  for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
			if (slideExist(i)) swiper.lazy.loadInSlide(i);
		  }
		} else {
		  swiper.lazy.loadInSlide(activeIndex);
		}
		if (params.loadPrevNext) {
		  if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
			const amount = params.loadPrevNextAmount;
			const spv = slidesPerView;
			const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
			const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
			// Next Slides
			for (let i = activeIndex + slidesPerView; i < maxIndex; i += 1) {
			  if (slideExist(i)) swiper.lazy.loadInSlide(i);
			}
			// Prev Slides
			for (let i = minIndex; i < activeIndex; i += 1) {
			  if (slideExist(i)) swiper.lazy.loadInSlide(i);
			}
		  } else {
			const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
			if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));

			const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
			if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
		  }
		}
	  },
	};

	var Lazy$1 = {
	  name: 'lazy',
	  params: {
		lazy: {
		  enabled: false,
		  loadPrevNext: false,
		  loadPrevNextAmount: 1,
		  loadOnTransitionStart: false,

		  elementClass: 'swiper-lazy',
		  loadingClass: 'swiper-lazy-loading',
		  loadedClass: 'swiper-lazy-loaded',
		  preloaderClass: 'swiper-lazy-preloader',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  lazy: {
			initialImageLoaded: false,
			load: Lazy.load.bind(swiper),
			loadInSlide: Lazy.loadInSlide.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
			swiper.params.preloadImages = false;
		  }
		},
		init() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
			swiper.lazy.load();
		  }
		},
		scroll() {
		  const swiper = this;
		  if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
			swiper.lazy.load();
		  }
		},
		resize() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled) {
			swiper.lazy.load();
		  }
		},
		scrollbarDragMove() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled) {
			swiper.lazy.load();
		  }
		},
		transitionStart() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled) {
			if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
			  swiper.lazy.load();
			}
		  }
		},
		transitionEnd() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
			swiper.lazy.load();
		  }
		},
		slideChange() {
		  const swiper = this;
		  if (swiper.params.lazy.enabled && swiper.params.cssMode) {
			swiper.lazy.load();
		  }
		},
	  },
	};

	/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

	const Controller = {
	  LinearSpline: function LinearSpline(x, y) {
		const binarySearch = (function search() {
		  let maxIndex;
		  let minIndex;
		  let guess;
		  return (array, val) => {
			minIndex = -1;
			maxIndex = array.length;
			while (maxIndex - minIndex > 1) {
			  guess = maxIndex + minIndex >> 1;
			  if (array[guess] <= val) {
				minIndex = guess;
			  } else {
				maxIndex = guess;
			  }
			}
			return maxIndex;
		  };
		}());
		this.x = x;
		this.y = y;
		this.lastIndex = x.length - 1;
		// Given an x value (x2), return the expected y2 value:
		// (x1,y1) is the known point before given value,
		// (x3,y3) is the known point after given value.
		let i1;
		let i3;

		this.interpolate = function interpolate(x2) {
		  if (!x2) return 0;

		  // Get the indexes of x1 and x3 (the array indexes before and after given x2):
		  i3 = binarySearch(this.x, x2);
		  i1 = i3 - 1;

		  // We have our indexes i1 & i3, so we can calculate already:
		  // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
		  return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
		};
		return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction(c) {
		const swiper = this;
		if (!swiper.controller.spline) {
		  swiper.controller.spline = swiper.params.loop
			  ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
			  : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
		}
	  },
	  setTranslate(setTranslate, byController) {
		const swiper = this;
		const controlled = swiper.controller.control;
		let multiplier;
		let controlledTranslate;
		function setControlledTranslate(c) {
		  // this will create an Interpolate function based on the snapGrids
		  // x is the Grid of the scrolled scroller and y will be the controlled scroller
		  // it makes sense to create this only once and recall it for the interpolation
		  // the function does a lot of value caching for performance
		  const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
		  if (swiper.params.controller.by === 'slide') {
			swiper.controller.getInterpolateFunction(c);
			// i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
			// but it did not work out
			controlledTranslate = -swiper.controller.spline.interpolate(-translate);
		  }

		  if (!controlledTranslate || swiper.params.controller.by === 'container') {
			multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
			controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
		  }

		  if (swiper.params.controller.inverse) {
			controlledTranslate = c.maxTranslate() - controlledTranslate;
		  }
		  c.updateProgress(controlledTranslate);
		  c.setTranslate(controlledTranslate, swiper);
		  c.updateActiveIndex();
		  c.updateSlidesClasses();
		}
		if (Array.isArray(controlled)) {
		  for (let i = 0; i < controlled.length; i += 1) {
			if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
			  setControlledTranslate(controlled[i]);
			}
		  }
		} else if (controlled instanceof Swiper && byController !== controlled) {
		  setControlledTranslate(controlled);
		}
	  },
	  setTransition(duration, byController) {
		const swiper = this;
		const controlled = swiper.controller.control;
		let i;
		function setControlledTransition(c) {
		  c.setTransition(duration, swiper);
		  if (duration !== 0) {
			c.transitionStart();
			if (c.params.autoHeight) {
			  Utils.nextTick(() => {
				c.updateAutoHeight();
			  });
			}
			c.$wrapperEl.transitionEnd(() => {
			  if (!controlled) return;
			  if (c.params.loop && swiper.params.controller.by === 'slide') {
				c.loopFix();
			  }
			  c.transitionEnd();
			});
		  }
		}
		if (Array.isArray(controlled)) {
		  for (i = 0; i < controlled.length; i += 1) {
			if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
			  setControlledTransition(controlled[i]);
			}
		  }
		} else if (controlled instanceof Swiper && byController !== controlled) {
		  setControlledTransition(controlled);
		}
	  },
	};
	var Controller$1 = {
	  name: 'controller',
	  params: {
		controller: {
		  control: undefined,
		  inverse: false,
		  by: 'slide', // or 'container'
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  controller: {
			control: swiper.params.controller.control,
			getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
			setTranslate: Controller.setTranslate.bind(swiper),
			setTransition: Controller.setTransition.bind(swiper),
		  },
		});
	  },
	  on: {
		update() {
		  const swiper = this;
		  if (!swiper.controller.control) return;
		  if (swiper.controller.spline) {
			swiper.controller.spline = undefined;
			delete swiper.controller.spline;
		  }
		},
		resize() {
		  const swiper = this;
		  if (!swiper.controller.control) return;
		  if (swiper.controller.spline) {
			swiper.controller.spline = undefined;
			delete swiper.controller.spline;
		  }
		},
		observerUpdate() {
		  const swiper = this;
		  if (!swiper.controller.control) return;
		  if (swiper.controller.spline) {
			swiper.controller.spline = undefined;
			delete swiper.controller.spline;
		  }
		},
		setTranslate(translate, byController) {
		  const swiper = this;
		  if (!swiper.controller.control) return;
		  swiper.controller.setTranslate(translate, byController);
		},
		setTransition(duration, byController) {
		  const swiper = this;
		  if (!swiper.controller.control) return;
		  swiper.controller.setTransition(duration, byController);
		},
	  },
	};

	const a11y = {
	  makeElFocusable($el) {
		$el.attr('tabIndex', '0');
		return $el;
	  },
	  makeElNotFocusable($el) {
		$el.attr('tabIndex', '-1');
		return $el;
	  },
	  addElRole($el, role) {
		$el.attr('role', role);
		return $el;
	  },
	  addElLabel($el, label) {
		$el.attr('aria-label', label);
		return $el;
	  },
	  disableEl($el) {
		$el.attr('aria-disabled', true);
		return $el;
	  },
	  enableEl($el) {
		$el.attr('aria-disabled', false);
		return $el;
	  },
	  onEnterKey(e) {
		const swiper = this;
		const params = swiper.params.a11y;
		if (e.keyCode !== 13) return;
		const $targetEl = $(e.target);
		if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
		  if (!(swiper.isEnd && !swiper.params.loop)) {
			swiper.slideNext();
		  }
		  if (swiper.isEnd) {
			swiper.a11y.notify(params.lastSlideMessage);
		  } else {
			swiper.a11y.notify(params.nextSlideMessage);
		  }
		}
		if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
		  if (!(swiper.isBeginning && !swiper.params.loop)) {
			swiper.slidePrev();
		  }
		  if (swiper.isBeginning) {
			swiper.a11y.notify(params.firstSlideMessage);
		  } else {
			swiper.a11y.notify(params.prevSlideMessage);
		  }
		}
		if (swiper.pagination && $targetEl.is(`.${swiper.params.pagination.bulletClass}`)) {
		  $targetEl[0].click();
		}
	  },
	  notify(message) {
		const swiper = this;
		const notification = swiper.a11y.liveRegion;
		if (notification.length === 0) return;
		notification.html('');
		notification.html(message);
	  },
	  updateNavigation() {
		const swiper = this;

		if (swiper.params.loop || !swiper.navigation) return;
		const { $nextEl, $prevEl } = swiper.navigation;

		if ($prevEl && $prevEl.length > 0) {
		  if (swiper.isBeginning) {
			swiper.a11y.disableEl($prevEl);
			swiper.a11y.makeElNotFocusable($prevEl);
		  } else {
			swiper.a11y.enableEl($prevEl);
			swiper.a11y.makeElFocusable($prevEl);
		  }
		}
		if ($nextEl && $nextEl.length > 0) {
		  if (swiper.isEnd) {
			swiper.a11y.disableEl($nextEl);
			swiper.a11y.makeElNotFocusable($nextEl);
		  } else {
			swiper.a11y.enableEl($nextEl);
			swiper.a11y.makeElFocusable($nextEl);
		  }
		}
	  },
	  updatePagination() {
		const swiper = this;
		const params = swiper.params.a11y;
		if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
		  swiper.pagination.bullets.each((bulletIndex, bulletEl) => {
			const $bulletEl = $(bulletEl);
			swiper.a11y.makeElFocusable($bulletEl);
			swiper.a11y.addElRole($bulletEl, 'button');
			swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
		  });
		}
	  },
	  init() {
		const swiper = this;

		swiper.$el.append(swiper.a11y.liveRegion);

		// Navigation
		const params = swiper.params.a11y;
		let $nextEl;
		let $prevEl;
		if (swiper.navigation && swiper.navigation.$nextEl) {
		  $nextEl = swiper.navigation.$nextEl;
		}
		if (swiper.navigation && swiper.navigation.$prevEl) {
		  $prevEl = swiper.navigation.$prevEl;
		}
		if ($nextEl) {
		  swiper.a11y.makeElFocusable($nextEl);
		  swiper.a11y.addElRole($nextEl, 'button');
		  swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
		  $nextEl.on('keydown', swiper.a11y.onEnterKey);
		}
		if ($prevEl) {
		  swiper.a11y.makeElFocusable($prevEl);
		  swiper.a11y.addElRole($prevEl, 'button');
		  swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
		  $prevEl.on('keydown', swiper.a11y.onEnterKey);
		}

		// Pagination
		if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
		  swiper.pagination.$el.on('keydown', `.${swiper.params.pagination.bulletClass}`, swiper.a11y.onEnterKey);
		}
	  },
	  destroy() {
		const swiper = this;
		if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();

		let $nextEl;
		let $prevEl;
		if (swiper.navigation && swiper.navigation.$nextEl) {
		  $nextEl = swiper.navigation.$nextEl;
		}
		if (swiper.navigation && swiper.navigation.$prevEl) {
		  $prevEl = swiper.navigation.$prevEl;
		}
		if ($nextEl) {
		  $nextEl.off('keydown', swiper.a11y.onEnterKey);
		}
		if ($prevEl) {
		  $prevEl.off('keydown', swiper.a11y.onEnterKey);
		}

		// Pagination
		if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
		  swiper.pagination.$el.off('keydown', `.${swiper.params.pagination.bulletClass}`, swiper.a11y.onEnterKey);
		}
	  },
	};
	var A11y = {
	  name: 'a11y',
	  params: {
		a11y: {
		  enabled: true,
		  notificationClass: 'swiper-notification',
		  prevSlideMessage: 'Previous slide',
		  nextSlideMessage: 'Next slide',
		  firstSlideMessage: 'This is the first slide',
		  lastSlideMessage: 'This is the last slide',
		  paginationBulletMessage: 'Go to slide {{index}}',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  a11y: {
			liveRegion: $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`),
		  },
		});
		Object.keys(a11y).forEach((methodName) => {
		  swiper.a11y[methodName] = a11y[methodName].bind(swiper);
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (!swiper.params.a11y.enabled) return;
		  swiper.a11y.init();
		  swiper.a11y.updateNavigation();
		},
		toEdge() {
		  const swiper = this;
		  if (!swiper.params.a11y.enabled) return;
		  swiper.a11y.updateNavigation();
		},
		fromEdge() {
		  const swiper = this;
		  if (!swiper.params.a11y.enabled) return;
		  swiper.a11y.updateNavigation();
		},
		paginationUpdate() {
		  const swiper = this;
		  if (!swiper.params.a11y.enabled) return;
		  swiper.a11y.updatePagination();
		},
		destroy() {
		  const swiper = this;
		  if (!swiper.params.a11y.enabled) return;
		  swiper.a11y.destroy();
		},
	  },
	};

	const History = {
	  init() {
		const swiper = this;
		if (!swiper.params.history) return;
		if (!win.history || !win.history.pushState) {
		  swiper.params.history.enabled = false;
		  swiper.params.hashNavigation.enabled = true;
		  return;
		}
		const history = swiper.history;
		history.initialized = true;
		history.paths = History.getPathValues();
		if (!history.paths.key && !history.paths.value) return;
		history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
		if (!swiper.params.history.replaceState) {
		  win.addEventListener('popstate', swiper.history.setHistoryPopState);
		}
	  },
	  destroy() {
		const swiper = this;
		if (!swiper.params.history.replaceState) {
		  win.removeEventListener('popstate', swiper.history.setHistoryPopState);
		}
	  },
	  setHistoryPopState() {
		const swiper = this;
		swiper.history.paths = History.getPathValues();
		swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	  },
	  getPathValues() {
		const pathArray = win.location.pathname.slice(1).split('/').filter((part) => part !== '');
		const total = pathArray.length;
		const key = pathArray[total - 2];
		const value = pathArray[total - 1];
		return { key, value };
	  },
	  setHistory(key, index) {
		const swiper = this;
		if (!swiper.history.initialized || !swiper.params.history.enabled) return;
		const slide = swiper.slides.eq(index);
		let value = History.slugify(slide.attr('data-history'));
		if (!win.location.pathname.includes(key)) {
		  value = `${key}/${value}`;
		}
		const currentState = win.history.state;
		if (currentState && currentState.value === value) {
		  return;
		}
		if (swiper.params.history.replaceState) {
		  win.history.replaceState({ value }, null, value);
		} else {
		  win.history.pushState({ value }, null, value);
		}
	  },
	  slugify(text) {
		return text.toString()
			.replace(/\s+/g, '-')
			.replace(/[^\w-]+/g, '')
			.replace(/--+/g, '-')
			.replace(/^-+/, '')
			.replace(/-+$/, '');
	  },
	  scrollToSlide(speed, value, runCallbacks) {
		const swiper = this;
		if (value) {
		  for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
			const slide = swiper.slides.eq(i);
			const slideHistory = History.slugify(slide.attr('data-history'));
			if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
			  const index = slide.index();
			  swiper.slideTo(index, speed, runCallbacks);
			}
		  }
		} else {
		  swiper.slideTo(0, speed, runCallbacks);
		}
	  },
	};

	var History$1 = {
	  name: 'history',
	  params: {
		history: {
		  enabled: false,
		  replaceState: false,
		  key: 'slides',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  history: {
			init: History.init.bind(swiper),
			setHistory: History.setHistory.bind(swiper),
			setHistoryPopState: History.setHistoryPopState.bind(swiper),
			scrollToSlide: History.scrollToSlide.bind(swiper),
			destroy: History.destroy.bind(swiper),
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (swiper.params.history.enabled) {
			swiper.history.init();
		  }
		},
		destroy() {
		  const swiper = this;
		  if (swiper.params.history.enabled) {
			swiper.history.destroy();
		  }
		},
		transitionEnd() {
		  const swiper = this;
		  if (swiper.history.initialized) {
			swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
		  }
		},
		slideChange() {
		  const swiper = this;
		  if (swiper.history.initialized && swiper.params.cssMode) {
			swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
		  }
		},
	  },
	};

	const HashNavigation = {
	  onHashCange() {
		const swiper = this;
		swiper.emit('hashChange');
		const newHash = doc.location.hash.replace('#', '');
		const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
		if (newHash !== activeSlideHash) {
		  const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
		  if (typeof newIndex === 'undefined') return;
		  swiper.slideTo(newIndex);
		}
	  },
	  setHash() {
		const swiper = this;
		if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
		if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
		  win.history.replaceState(null, null, (`#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || ''));
		  swiper.emit('hashSet');
		} else {
		  const slide = swiper.slides.eq(swiper.activeIndex);
		  const hash = slide.attr('data-hash') || slide.attr('data-history');
		  doc.location.hash = hash || '';
		  swiper.emit('hashSet');
		}
	  },
	  init() {
		const swiper = this;
		if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) return;
		swiper.hashNavigation.initialized = true;
		const hash = doc.location.hash.replace('#', '');
		if (hash) {
		  const speed = 0;
		  for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
			const slide = swiper.slides.eq(i);
			const slideHash = slide.attr('data-hash') || slide.attr('data-history');
			if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
			  const index = slide.index();
			  swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
			}
		  }
		}
		if (swiper.params.hashNavigation.watchState) {
		  $(win).on('hashchange', swiper.hashNavigation.onHashCange);
		}
	  },
	  destroy() {
		const swiper = this;
		if (swiper.params.hashNavigation.watchState) {
		  $(win).off('hashchange', swiper.hashNavigation.onHashCange);
		}
	  },
	};
	var HashNavigation$1 = {
	  name: 'hash-navigation',
	  params: {
		hashNavigation: {
		  enabled: false,
		  replaceState: false,
		  watchState: false,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  hashNavigation: {
			initialized: false,
			init: HashNavigation.init.bind(swiper),
			destroy: HashNavigation.destroy.bind(swiper),
			setHash: HashNavigation.setHash.bind(swiper),
			onHashCange: HashNavigation.onHashCange.bind(swiper),
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (swiper.params.hashNavigation.enabled) {
			swiper.hashNavigation.init();
		  }
		},
		destroy() {
		  const swiper = this;
		  if (swiper.params.hashNavigation.enabled) {
			swiper.hashNavigation.destroy();
		  }
		},
		transitionEnd() {
		  const swiper = this;
		  if (swiper.hashNavigation.initialized) {
			swiper.hashNavigation.setHash();
		  }
		},
		slideChange() {
		  const swiper = this;
		  if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
			swiper.hashNavigation.setHash();
		  }
		},
	  },
	};

	/* eslint no-underscore-dangle: "off" */

	const Autoplay = {
	  run() {
		const swiper = this;
		const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
		let delay = swiper.params.autoplay.delay;
		if ($activeSlideEl.attr('data-swiper-autoplay')) {
		  delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
		}
		clearTimeout(swiper.autoplay.timeout);
		swiper.autoplay.timeout = Utils.nextTick(() => {
		  if (swiper.params.autoplay.reverseDirection) {
			if (swiper.params.loop) {
			  swiper.loopFix();
			  swiper.slidePrev(swiper.params.speed, true, true);
			  swiper.emit('autoplay');
			} else if (!swiper.isBeginning) {
			  swiper.slidePrev(swiper.params.speed, true, true);
			  swiper.emit('autoplay');
			} else if (!swiper.params.autoplay.stopOnLastSlide) {
			  swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
			  swiper.emit('autoplay');
			} else {
			  swiper.autoplay.stop();
			}
		  } else if (swiper.params.loop) {
			swiper.loopFix();
			swiper.slideNext(swiper.params.speed, true, true);
			swiper.emit('autoplay');
		  } else if (!swiper.isEnd) {
			swiper.slideNext(swiper.params.speed, true, true);
			swiper.emit('autoplay');
		  } else if (!swiper.params.autoplay.stopOnLastSlide) {
			swiper.slideTo(0, swiper.params.speed, true, true);
			swiper.emit('autoplay');
		  } else {
			swiper.autoplay.stop();
		  }
		  if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
		}, delay);
	  },
	  start() {
		const swiper = this;
		if (typeof swiper.autoplay.timeout !== 'undefined') return false;
		if (swiper.autoplay.running) return false;
		swiper.autoplay.running = true;
		swiper.emit('autoplayStart');
		swiper.autoplay.run();
		return true;
	  },
	  stop() {
		const swiper = this;
		if (!swiper.autoplay.running) return false;
		if (typeof swiper.autoplay.timeout === 'undefined') return false;

		if (swiper.autoplay.timeout) {
		  clearTimeout(swiper.autoplay.timeout);
		  swiper.autoplay.timeout = undefined;
		}
		swiper.autoplay.running = false;
		swiper.emit('autoplayStop');
		return true;
	  },
	  pause(speed) {
		const swiper = this;
		if (!swiper.autoplay.running) return;
		if (swiper.autoplay.paused) return;
		if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
		swiper.autoplay.paused = true;
		if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
		  swiper.autoplay.paused = false;
		  swiper.autoplay.run();
		} else {
		  swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
		  swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
		}
	  },
	};

	var Autoplay$1 = {
	  name: 'autoplay',
	  params: {
		autoplay: {
		  enabled: false,
		  delay: 3000,
		  waitForTransition: true,
		  disableOnInteraction: true,
		  stopOnLastSlide: false,
		  reverseDirection: false,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  autoplay: {
			running: false,
			paused: false,
			run: Autoplay.run.bind(swiper),
			start: Autoplay.start.bind(swiper),
			stop: Autoplay.stop.bind(swiper),
			pause: Autoplay.pause.bind(swiper),
			onVisibilityChange() {
			  if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
				swiper.autoplay.pause();
			  }
			  if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
				swiper.autoplay.run();
				swiper.autoplay.paused = false;
			  }
			},
			onTransitionEnd(e) {
			  if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
			  if (e.target !== this) return;
			  swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
			  swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
			  swiper.autoplay.paused = false;
			  if (!swiper.autoplay.running) {
				swiper.autoplay.stop();
			  } else {
				swiper.autoplay.run();
			  }
			},
		  },
		});
	  },
	  on: {
		init() {
		  const swiper = this;
		  if (swiper.params.autoplay.enabled) {
			swiper.autoplay.start();
			document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
		  }
		},
		beforeTransitionStart(speed, internal) {
		  const swiper = this;
		  if (swiper.autoplay.running) {
			if (internal || !swiper.params.autoplay.disableOnInteraction) {
			  swiper.autoplay.pause(speed);
			} else {
			  swiper.autoplay.stop();
			}
		  }
		},
		sliderFirstMove() {
		  const swiper = this;
		  if (swiper.autoplay.running) {
			if (swiper.params.autoplay.disableOnInteraction) {
			  swiper.autoplay.stop();
			} else {
			  swiper.autoplay.pause();
			}
		  }
		},
		touchEnd() {
		  const swiper = this;
		  if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
			swiper.autoplay.run();
		  }
		},
		destroy() {
		  const swiper = this;
		  if (swiper.autoplay.running) {
			swiper.autoplay.stop();
		  }
		  document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
		},
	  },
	};

	const Fade = {
	  setTranslate() {
		const swiper = this;
		const { slides } = swiper;
		for (let i = 0; i < slides.length; i += 1) {
		  const $slideEl = swiper.slides.eq(i);
		  const offset = $slideEl[0].swiperSlideOffset;
		  let tx = -offset;
		  if (!swiper.params.virtualTranslate) tx -= swiper.translate;
		  let ty = 0;
		  if (!swiper.isHorizontal()) {
			ty = tx;
			tx = 0;
		  }
		  const slideOpacity = swiper.params.fadeEffect.crossFade
			  ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
			  : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
		  $slideEl
			  .css({
				opacity: slideOpacity,
			  })
			  .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
		}
	  },
	  setTransition(duration) {
		const swiper = this;
		const { slides, $wrapperEl } = swiper;
		slides.transition(duration);
		if (swiper.params.virtualTranslate && duration !== 0) {
		  let eventTriggered = false;
		  slides.transitionEnd(() => {
			if (eventTriggered) return;
			if (!swiper || swiper.destroyed) return;
			eventTriggered = true;
			swiper.animating = false;
			const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
			for (let i = 0; i < triggerEvents.length; i += 1) {
			  $wrapperEl.trigger(triggerEvents[i]);
			}
		  });
		}
	  },
	};

	var EffectFade = {
	  name: 'effect-fade',
	  params: {
		fadeEffect: {
		  crossFade: false,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  fadeEffect: {
			setTranslate: Fade.setTranslate.bind(swiper),
			setTransition: Fade.setTransition.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (swiper.params.effect !== 'fade') return;
		  swiper.classNames.push(`${swiper.params.containerModifierClass}fade`);
		  const overwriteParams = {
			slidesPerView: 1,
			slidesPerColumn: 1,
			slidesPerGroup: 1,
			watchSlidesProgress: true,
			spaceBetween: 0,
			virtualTranslate: true,
		  };
		  Utils.extend(swiper.params, overwriteParams);
		  Utils.extend(swiper.originalParams, overwriteParams);
		},
		setTranslate() {
		  const swiper = this;
		  if (swiper.params.effect !== 'fade') return;
		  swiper.fadeEffect.setTranslate();
		},
		setTransition(duration) {
		  const swiper = this;
		  if (swiper.params.effect !== 'fade') return;
		  swiper.fadeEffect.setTransition(duration);
		},
	  },
	};

	const Cube = {
	  setTranslate() {
		const swiper = this;
		const {
		  $el, $wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize,
		} = swiper;
		const params = swiper.params.cubeEffect;
		const isHorizontal = swiper.isHorizontal();
		const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
		let wrapperRotate = 0;
		let $cubeShadowEl;
		if (params.shadow) {
		  if (isHorizontal) {
			$cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
			if ($cubeShadowEl.length === 0) {
			  $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
			  $wrapperEl.append($cubeShadowEl);
			}
			$cubeShadowEl.css({ height: `${swiperWidth}px` });
		  } else {
			$cubeShadowEl = $el.find('.swiper-cube-shadow');
			if ($cubeShadowEl.length === 0) {
			  $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
			  $el.append($cubeShadowEl);
			}
		  }
		}
		for (let i = 0; i < slides.length; i += 1) {
		  const $slideEl = slides.eq(i);
		  let slideIndex = i;
		  if (isVirtual) {
			slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
		  }
		  let slideAngle = slideIndex * 90;
		  let round = Math.floor(slideAngle / 360);
		  if (rtl) {
			slideAngle = -slideAngle;
			round = Math.floor(-slideAngle / 360);
		  }
		  const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
		  let tx = 0;
		  let ty = 0;
		  let tz = 0;
		  if (slideIndex % 4 === 0) {
			tx = -round * 4 * swiperSize;
			tz = 0;
		  } else if ((slideIndex - 1) % 4 === 0) {
			tx = 0;
			tz = -round * 4 * swiperSize;
		  } else if ((slideIndex - 2) % 4 === 0) {
			tx = swiperSize + (round * 4 * swiperSize);
			tz = swiperSize;
		  } else if ((slideIndex - 3) % 4 === 0) {
			tx = -swiperSize;
			tz = (3 * swiperSize) + (swiperSize * 4 * round);
		  }
		  if (rtl) {
			tx = -tx;
		  }

		  if (!isHorizontal) {
			ty = tx;
			tx = 0;
		  }

		  const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
		  if (progress <= 1 && progress > -1) {
			wrapperRotate = (slideIndex * 90) + (progress * 90);
			if (rtl) wrapperRotate = (-slideIndex * 90) - (progress * 90);
		  }
		  $slideEl.transform(transform);
		  if (params.slideShadows) {
			// Set shadows
			let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
			let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
			if (shadowBefore.length === 0) {
			  shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
			  $slideEl.append(shadowBefore);
			}
			if (shadowAfter.length === 0) {
			  shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
			  $slideEl.append(shadowAfter);
			}
			if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
			if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
		  }
		}
		$wrapperEl.css({
		  '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
		  '-moz-transform-origin': `50% 50% -${swiperSize / 2}px`,
		  '-ms-transform-origin': `50% 50% -${swiperSize / 2}px`,
		  'transform-origin': `50% 50% -${swiperSize / 2}px`,
		});

		if (params.shadow) {
		  if (isHorizontal) {
			$cubeShadowEl.transform(`translate3d(0px, ${(swiperWidth / 2) + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
		  } else {
			const shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
			const multiplier = 1.5 - (
				(Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
				+ (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
			);
			const scale1 = params.shadowScale;
			const scale2 = params.shadowScale / multiplier;
			const offset = params.shadowOffset;
			$cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${(swiperHeight / 2) + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
		  }
		}
		const zFactor = (Browser.isSafari || Browser.isWebView) ? (-swiperSize / 2) : 0;
		$wrapperEl
			.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
	  },
	  setTransition(duration) {
		const swiper = this;
		const { $el, slides } = swiper;
		slides
			.transition(duration)
			.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
			.transition(duration);
		if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
		  $el.find('.swiper-cube-shadow').transition(duration);
		}
	  },
	};

	var EffectCube = {
	  name: 'effect-cube',
	  params: {
		cubeEffect: {
		  slideShadows: true,
		  shadow: true,
		  shadowOffset: 20,
		  shadowScale: 0.94,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  cubeEffect: {
			setTranslate: Cube.setTranslate.bind(swiper),
			setTransition: Cube.setTransition.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (swiper.params.effect !== 'cube') return;
		  swiper.classNames.push(`${swiper.params.containerModifierClass}cube`);
		  swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
		  const overwriteParams = {
			slidesPerView: 1,
			slidesPerColumn: 1,
			slidesPerGroup: 1,
			watchSlidesProgress: true,
			resistanceRatio: 0,
			spaceBetween: 0,
			centeredSlides: false,
			virtualTranslate: true,
		  };
		  Utils.extend(swiper.params, overwriteParams);
		  Utils.extend(swiper.originalParams, overwriteParams);
		},
		setTranslate() {
		  const swiper = this;
		  if (swiper.params.effect !== 'cube') return;
		  swiper.cubeEffect.setTranslate();
		},
		setTransition(duration) {
		  const swiper = this;
		  if (swiper.params.effect !== 'cube') return;
		  swiper.cubeEffect.setTransition(duration);
		},
	  },
	};

	const Flip = {
	  setTranslate() {
		const swiper = this;
		const { slides, rtlTranslate: rtl } = swiper;
		for (let i = 0; i < slides.length; i += 1) {
		  const $slideEl = slides.eq(i);
		  let progress = $slideEl[0].progress;
		  if (swiper.params.flipEffect.limitRotation) {
			progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
		  }
		  const offset = $slideEl[0].swiperSlideOffset;
		  const rotate = -180 * progress;
		  let rotateY = rotate;
		  let rotateX = 0;
		  let tx = -offset;
		  let ty = 0;
		  if (!swiper.isHorizontal()) {
			ty = tx;
			tx = 0;
			rotateX = -rotateY;
			rotateY = 0;
		  } else if (rtl) {
			rotateY = -rotateY;
		  }

		  $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

		  if (swiper.params.flipEffect.slideShadows) {
			// Set shadows
			let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
			let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
			if (shadowBefore.length === 0) {
			  shadowBefore = $(`<div class="swiper-slide-shadow-${swiper.isHorizontal() ? 'left' : 'top'}"></div>`);
			  $slideEl.append(shadowBefore);
			}
			if (shadowAfter.length === 0) {
			  shadowAfter = $(`<div class="swiper-slide-shadow-${swiper.isHorizontal() ? 'right' : 'bottom'}"></div>`);
			  $slideEl.append(shadowAfter);
			}
			if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
			if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
		  }
		  $slideEl
			  .transform(`translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`);
		}
	  },
	  setTransition(duration) {
		const swiper = this;
		const { slides, activeIndex, $wrapperEl } = swiper;
		slides
			.transition(duration)
			.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
			.transition(duration);
		if (swiper.params.virtualTranslate && duration !== 0) {
		  let eventTriggered = false;
		  // eslint-disable-next-line
		  slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
			if (eventTriggered) return;
			if (!swiper || swiper.destroyed) return;
			// if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
			eventTriggered = true;
			swiper.animating = false;
			const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
			for (let i = 0; i < triggerEvents.length; i += 1) {
			  $wrapperEl.trigger(triggerEvents[i]);
			}
		  });
		}
	  },
	};

	var EffectFlip = {
	  name: 'effect-flip',
	  params: {
		flipEffect: {
		  slideShadows: true,
		  limitRotation: true,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  flipEffect: {
			setTranslate: Flip.setTranslate.bind(swiper),
			setTransition: Flip.setTransition.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (swiper.params.effect !== 'flip') return;
		  swiper.classNames.push(`${swiper.params.containerModifierClass}flip`);
		  swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
		  const overwriteParams = {
			slidesPerView: 1,
			slidesPerColumn: 1,
			slidesPerGroup: 1,
			watchSlidesProgress: true,
			spaceBetween: 0,
			virtualTranslate: true,
		  };
		  Utils.extend(swiper.params, overwriteParams);
		  Utils.extend(swiper.originalParams, overwriteParams);
		},
		setTranslate() {
		  const swiper = this;
		  if (swiper.params.effect !== 'flip') return;
		  swiper.flipEffect.setTranslate();
		},
		setTransition(duration) {
		  const swiper = this;
		  if (swiper.params.effect !== 'flip') return;
		  swiper.flipEffect.setTransition(duration);
		},
	  },
	};

	const Coverflow = {
	  setTranslate() {
		const swiper = this;
		const {
		  width: swiperWidth, height: swiperHeight, slides, $wrapperEl, slidesSizesGrid,
		} = swiper;
		const params = swiper.params.coverflowEffect;
		const isHorizontal = swiper.isHorizontal();
		const transform = swiper.translate;
		const center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
		const rotate = isHorizontal ? params.rotate : -params.rotate;
		const translate = params.depth;
		// Each slide offset from center
		for (let i = 0, length = slides.length; i < length; i += 1) {
		  const $slideEl = slides.eq(i);
		  const slideSize = slidesSizesGrid[i];
		  const slideOffset = $slideEl[0].swiperSlideOffset;
		  const offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

		  let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
		  let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
		  // var rotateZ = 0
		  let translateZ = -translate * Math.abs(offsetMultiplier);

		  let stretch = params.stretch;
		  // Allow percentage to make a relative stretch for responsive sliders
		  if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
			stretch = ((parseFloat(params.stretch) / 100) * slideSize);
		  }
		  let translateY = isHorizontal ? 0 : stretch * (offsetMultiplier);
		  let translateX = isHorizontal ? stretch * (offsetMultiplier) : 0;

		  let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

		  // Fix for ultra small values
		  if (Math.abs(translateX) < 0.001) translateX = 0;
		  if (Math.abs(translateY) < 0.001) translateY = 0;
		  if (Math.abs(translateZ) < 0.001) translateZ = 0;
		  if (Math.abs(rotateY) < 0.001) rotateY = 0;
		  if (Math.abs(rotateX) < 0.001) rotateX = 0;
		  if (Math.abs(scale) < 0.001) scale = 0;

		  const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;

		  $slideEl.transform(slideTransform);
		  $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
		  if (params.slideShadows) {
			// Set shadows
			let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
			let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
			if ($shadowBeforeEl.length === 0) {
			  $shadowBeforeEl = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
			  $slideEl.append($shadowBeforeEl);
			}
			if ($shadowAfterEl.length === 0) {
			  $shadowAfterEl = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
			  $slideEl.append($shadowAfterEl);
			}
			if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
			if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
		  }
		}

		// Set correct perspective for IE10
		if (Support.pointerEvents || Support.prefixedPointerEvents) {
		  const ws = $wrapperEl[0].style;
		  ws.perspectiveOrigin = `${center}px 50%`;
		}
	  },
	  setTransition(duration) {
		const swiper = this;
		swiper.slides
			.transition(duration)
			.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
			.transition(duration);
	  },
	};

	var EffectCoverflow = {
	  name: 'effect-coverflow',
	  params: {
		coverflowEffect: {
		  rotate: 50,
		  stretch: 0,
		  depth: 100,
		  scale: 1,
		  modifier: 1,
		  slideShadows: true,
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  coverflowEffect: {
			setTranslate: Coverflow.setTranslate.bind(swiper),
			setTransition: Coverflow.setTransition.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  if (swiper.params.effect !== 'coverflow') return;

		  swiper.classNames.push(`${swiper.params.containerModifierClass}coverflow`);
		  swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);

		  swiper.params.watchSlidesProgress = true;
		  swiper.originalParams.watchSlidesProgress = true;
		},
		setTranslate() {
		  const swiper = this;
		  if (swiper.params.effect !== 'coverflow') return;
		  swiper.coverflowEffect.setTranslate();
		},
		setTransition(duration) {
		  const swiper = this;
		  if (swiper.params.effect !== 'coverflow') return;
		  swiper.coverflowEffect.setTransition(duration);
		},
	  },
	};

	const Thumbs = {
	  init() {
		const swiper = this;
		const { thumbs: thumbsParams } = swiper.params;
		const SwiperClass = swiper.constructor;
		if (thumbsParams.swiper instanceof SwiperClass) {
		  swiper.thumbs.swiper = thumbsParams.swiper;
		  Utils.extend(swiper.thumbs.swiper.originalParams, {
			watchSlidesProgress: true,
			slideToClickedSlide: false,
		  });
		  Utils.extend(swiper.thumbs.swiper.params, {
			watchSlidesProgress: true,
			slideToClickedSlide: false,
		  });
		} else if (Utils.isObject(thumbsParams.swiper)) {
		  swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			slideToClickedSlide: false,
		  }));
		  swiper.thumbs.swiperCreated = true;
		}
		swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
		swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	  },
	  onThumbClick() {
		const swiper = this;
		const thumbsSwiper = swiper.thumbs.swiper;
		if (!thumbsSwiper) return;
		const clickedIndex = thumbsSwiper.clickedIndex;
		const clickedSlide = thumbsSwiper.clickedSlide;
		if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
		if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
		let slideToIndex;
		if (thumbsSwiper.params.loop) {
		  slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
		} else {
		  slideToIndex = clickedIndex;
		}
		if (swiper.params.loop) {
		  let currentIndex = swiper.activeIndex;
		  if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
			swiper.loopFix();
			// eslint-disable-next-line
			swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
			currentIndex = swiper.activeIndex;
		  }
		  const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
		  const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
		  if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
		  else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
		  else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
		  else slideToIndex = prevIndex;
		}
		swiper.slideTo(slideToIndex);
	  },
	  update(initial) {
		const swiper = this;
		const thumbsSwiper = swiper.thumbs.swiper;
		if (!thumbsSwiper) return;

		const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
			? thumbsSwiper.slidesPerViewDynamic()
			: thumbsSwiper.params.slidesPerView;

		const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
		const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
		if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
		  let currentThumbsIndex = thumbsSwiper.activeIndex;
		  let newThumbsIndex;
		  let direction;
		  if (thumbsSwiper.params.loop) {
			if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
			  thumbsSwiper.loopFix();
			  // eslint-disable-next-line
			  thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
			  currentThumbsIndex = thumbsSwiper.activeIndex;
			}
			// Find actual thumbs index to slide to
			const prevThumbsIndex = thumbsSwiper.slides
				.eq(currentThumbsIndex)
				.prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0)
				.index();
			const nextThumbsIndex = thumbsSwiper.slides
				.eq(currentThumbsIndex)
				.nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0)
				.index();
			if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
			else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
			else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;
			else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
			else newThumbsIndex = prevThumbsIndex;
			direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
		  } else {
			newThumbsIndex = swiper.realIndex;
			direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
		  }
		  if (useOffset) {
			newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
		  }

		  if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
			if (thumbsSwiper.params.centeredSlides) {
			  if (newThumbsIndex > currentThumbsIndex) {
				newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
			  } else {
				newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
			  }
			} else if (newThumbsIndex > currentThumbsIndex) {
			  newThumbsIndex = newThumbsIndex - slidesPerView + 1;
			}
			thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
		  }
		}

		// Activate thumbs
		let thumbsToActivate = 1;
		const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

		if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
		  thumbsToActivate = swiper.params.slidesPerView;
		}

		if (!swiper.params.thumbs.multipleActiveThumbs) {
		  thumbsToActivate = 1;
		}

		thumbsToActivate = Math.floor(thumbsToActivate);

		thumbsSwiper.slides.removeClass(thumbActiveClass);
		if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
		  for (let i = 0; i < thumbsToActivate; i += 1) {
			thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
		  }
		} else {
		  for (let i = 0; i < thumbsToActivate; i += 1) {
			thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
		  }
		}
	  },
	};
	var Thumbs$1 = {
	  name: 'thumbs',
	  params: {
		thumbs: {
		  swiper: null,
		  multipleActiveThumbs: true,
		  autoScrollOffset: 0,
		  slideThumbActiveClass: 'swiper-slide-thumb-active',
		  thumbsContainerClass: 'swiper-container-thumbs',
		},
	  },
	  create() {
		const swiper = this;
		Utils.extend(swiper, {
		  thumbs: {
			swiper: null,
			init: Thumbs.init.bind(swiper),
			update: Thumbs.update.bind(swiper),
			onThumbClick: Thumbs.onThumbClick.bind(swiper),
		  },
		});
	  },
	  on: {
		beforeInit() {
		  const swiper = this;
		  const { thumbs } = swiper.params;
		  if (!thumbs || !thumbs.swiper) return;
		  swiper.thumbs.init();
		  swiper.thumbs.update(true);
		},
		slideChange() {
		  const swiper = this;
		  if (!swiper.thumbs.swiper) return;
		  swiper.thumbs.update();
		},
		update() {
		  const swiper = this;
		  if (!swiper.thumbs.swiper) return;
		  swiper.thumbs.update();
		},
		resize() {
		  const swiper = this;
		  if (!swiper.thumbs.swiper) return;
		  swiper.thumbs.update();
		},
		observerUpdate() {
		  const swiper = this;
		  if (!swiper.thumbs.swiper) return;
		  swiper.thumbs.update();
		},
		setTransition(duration) {
		  const swiper = this;
		  const thumbsSwiper = swiper.thumbs.swiper;
		  if (!thumbsSwiper) return;
		  thumbsSwiper.setTransition(duration);
		},
		beforeDestroy() {
		  const swiper = this;
		  const thumbsSwiper = swiper.thumbs.swiper;
		  if (!thumbsSwiper) return;
		  if (swiper.thumbs.swiperCreated && thumbsSwiper) {
			thumbsSwiper.destroy();
		  }
		},
	  },
	};

// Swiper Class

	const components = [
	  Device$1,
	  Support$1,
	  Browser$1,
	  Resize,
	  Observer$1,
	  Virtual$1,
	  Keyboard$1,
	  Mousewheel$1,
	  Navigation$1,
	  Pagination$1,
	  Scrollbar$1,
	  Parallax$1,
	  Zoom$1,
	  Lazy$1,
	  Controller$1,
	  A11y,
	  History$1,
	  HashNavigation$1,
	  Autoplay$1,
	  EffectFade,
	  EffectCube,
	  EffectFlip,
	  EffectCoverflow,
	  Thumbs$1
	];

	if (typeof Swiper.use === 'undefined') {
	  Swiper.use = Swiper.Class.use;
	  Swiper.installModule = Swiper.Class.installModule;
	}

	Swiper.use(components);

	/* harmony default export */ const swiper_esm_bundle = (Swiper);
//# sourceMappingURL=swiper.esm.bundle.js.map

	;// CONCATENATED MODULE: ./src/javascripts/sections/BlogPosts.js



	class BlogPosts extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);

		const swiperContainer = this.element.querySelector('.swiper-container');
		this.swiper = new swiper_esm_bundle(swiperContainer, {
		  slidesPerView: 1,
		  watchOverflow: true,
		  autoHeight: true,
		  pagination: {
			el: swiperContainer.querySelectorAll('.swiper-pagination'),
			clickable: true
		  }
		});
	  }
	}
	// EXTERNAL MODULE: ./node_modules/rellax/rellax.js
	var rellax = window.Rellax;
	var rellax_default = /*#__PURE__*/__webpack_require__.n(rellax);
	;
	// CONCATENATED MODULE: ./src/javascripts/global/Parallax.js
	class Parallax_Parallax extends Component {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   */
	  constructor(theme, element) {
		super(theme, element);

		/** @type {Rellax[]} */
		this.init = () => {
		  if (this.element.querySelector('.rellax')) {
			this.rellaxes = Array.prototype.map.call(this.element.querySelectorAll('.rellax'), el => {
			  return new (rellax_default())(el, {
				center: true
			  });
			});
		  }
		};
		this.destroy = () => {
		  this.rellaxes.forEach(rellax => rellax.destroy());
		  this.rellaxes = [];
		};
		this.isMobile = (breakpoint = null) => {
		  return (breakpoint || this.theme.getBreakpoint()).order < Breakpoints.md.order;
		};
		this.onWindowResizeBreakpoint = ({
										   breakpoint
										 }) => {
		  const isMobile = this.isMobile(breakpoint);
		  if (!isMobile && this.rellaxes.length === 0) {
			// We're on desktop and parallax is not active => activate it
			this.init();
		  } else if (isMobile && this.rellaxes.length > 0) {
			// We're on mobile and parallax is active => deactivate it
			this.destroy();
		  }
		};
		this.rellaxes = [];
		this.element = element;
		if (!this.isMobile()) {
		  this.init();
		}
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/CollectionList.js


	class CollectionList extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.parallax = new Parallax_Parallax(theme, element.parentNode);
		this.theme.addBadges(this.element, 1000);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/EventsCalendar.js


	class EventsCalendar extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);

	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/QuickAdd.js


	class QuickAdd extends Component {
	  constructor(theme, element) {
		super(theme, element);
		this.theme = theme;
		this.element = element;
		this.onSubmit = this.onSubmit.bind(this);
		this.currentButton = null;
		this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
		this.languageUrl = document.getElementById('PageContainer').dataset.languageUrl;
		this.formWrapper = /** @type {HTMLElement} */this.element.querySelectorAll('.quick-add-wrapper.is-singular');
		this.bpmGlobal = document.querySelector('script#bptheme-global');
		this.translationsObject = JSON.parse(this.bpmGlobal.textContent);
		if (!this.formWrapper) {
		  return;
		}
		Array.prototype.forEach.call(this.element.querySelectorAll('.quick-add-wrapper.is-singular .shopify-product-form'), el => {
		  el.addEventListener('submit', this.onSubmit);
		});
	  }
	  async onSubmit(e) {
		// Go straight to cart page, use html form submit event.
		if (this.cartAction == 'page') {
		  return;
		}
		e.preventDefault();
		this.currentButton = e.currentTarget.querySelector('.quick-add-button');

		// Loading spinner.
		this.currentButton.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="spin flex m-0-auto"><g clip-path="url(#clip0_7323_531303)"><path d="M10.5 19C5.52944 19 1.5 14.9706 1.5 10C1.5 5.02944 5.52944 1 10.5 1C15.4706 1 19.5 5.02944 19.5 10C19.5 12.5991 18.3983 14.9408 16.6364 16.5837" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g><defs><clipPath id="clip0_7323_531303"><rect width="20" height="20" fill="white" transform="translate(0.5)"/></clipPath></defs>${this.translationsObject.translations.loading}</svg>`;
		try {
		  const data = jquery_default()(e.currentTarget).serialize();
		  const response = await window.fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
			  'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: data
		  });
		  if (!response.ok) {
			// FIXME: error handling
			return false;
		  }
		  const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
		  const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
		  if (!response2.ok) {
			// FIXME: error handling
			return false;
		  }
		  const cart = await response2.json();
		  if (this.cartAction == 'drawer') {
			this.theme.toggleRightDrawer('cart', true, {
			  cart: cart
			});
		  } else {
			this.currentButton.innerHTML = this.translationsObject.translations.productAdded;
			this.theme.updateCartDrawer(cart);
		  }
		  setTimeout(() => {
			this.currentButton.innerHTML = this.translationsObject.translations.addToCart;
		  }, 2000);
		} catch (e) {
		  console.error('Unable to add to cart: ', e);
		  // FIXME error handling
		}

		return false;
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/FeaturedCollection.js


	class FeaturedCollection extends Section {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   * @param {boolean} pageLoad
	   */

	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.handleShopNow = e => {
		  e.preventDefault();
		  this.theme.toggleRightDrawer('shop-now', true, {
			url: e.currentTarget.href
		  });
		};
		this.isMobile = () => {
		  return window.matchMedia('(max-width: 1023px)').matches;
		};
		Array.prototype.forEach.call(element.querySelectorAll('.shop-now-button, .quick-add-button-variants'), shopNow => {
		  if (shopNow) {
			shopNow.addEventListener('click', this.handleShopNow);
		  }
		});
		this.quickAddButtons = new QuickAdd(theme, element);
		this.theme.addBadges(this.element, 1000);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/FeaturedMenu.js

	class FeaturedMenu extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/ImageGallery.js


	class ImageGallery extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);

	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/ImageWithText.js


	class ImageWithText extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.onSectionSelect = () => {
		  //this.kenBurns.reapply();
		};

	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/modules/sectionLink.js
	function createClickableSection(element) {
	  const mainLink = element.querySelector('[data-section-main-link]');
	  if (!mainLink) return;
	  const buttonHidden = mainLink.ariaHidden == 'true';
	  const handleSectionClick = () => {
		const isTextSelected = window.getSelection().toString();
		if (!isTextSelected) mainLink.click();
	  };
	  if (buttonHidden && mainLink) element.addEventListener('click', handleSectionClick);
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/ImageWithTextOverlay.js



	class ImageWithTextOverlay extends ImageWithText {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   * @param {boolean} pageLoad
	   */
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.onWindowResize = () => {
		  if (this.sectionHeightSetToOriginal) {
			this.setToOriginalHeight();
		  }
		};
		this.setToOriginalHeight = () => {
		  this.setImageWrapperHeight('auto');
		  if (this.contentIsTallerThanImage()) {
			this.toggleCoverClass('true');
			this.setImageWrapperHeight('100%');
		  } else {
			this.toggleCoverClass();
			this.setSectionMinHeight();
		  }
		};
		this.toggleCoverClass = contentIsTaller => {
		  if (!this.imageElement) return;
		  this.imageElement.classList.remove('image-cover');
		  if (contentIsTaller) this.imageElement.classList.add('image-cover');
		};
		this.setImageWrapperHeight = value => {
		  this.imageWrapper.style.height = value;
		};
		this.setSectionMinHeight = () => {
		  this.sectionWrapper.style.minHeight = `${this.getImageHeight()}px`;
		};
		this.getContentHeight = () => {
		  return this.contentWrapper.offsetHeight;
		};
		this.getImageHeight = () => {
		  return this.imageWrapper.offsetHeight;
		};
		this.contentIsTallerThanImage = () => {
		  return this.getContentHeight() > this.getImageHeight();
		};
		this.theme = theme;
		this.element = element;
		this.sectionWrapper = /** @type {HTMLElement} */this.element.querySelector('.homepage-featured-content-wrapper');
		this.imageWrapper = /** @type {HTMLElement} */this.element.querySelector('.homepage-content--image');
		this.contentWrapper = /** @type {HTMLElement} */this.element.querySelector('.homepage-featured-content-box-inner');
		this.imageElement = this.imageWrapper.getElementsByTagName('img').item(0);
		this.sectionHeightSetToOriginal = this.element.classList.contains('size-original');
		if (this.sectionHeightSetToOriginal) {
		  this.setToOriginalHeight();
		}
		this.parallax = new Parallax_Parallax(this.theme, this.element);
		createClickableSection(this.element);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/LogoList.js

	class LogoList extends Section {}
	;// CONCATENATED MODULE: ./src/javascripts/global/Slider.js

	class Slider {
	  constructor(theme, element, options) {
		this.stop = () => {
		  if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
			return;
		  }
		  this.swiper.autoplay.stop();
		};
		this.start = () => {
		  if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
			return;
		  }
		  this.swiper.autoplay.start();
		};
		this.isRunning = () => {
		  return this.swiper.autoplay.running;
		};
		this.slideTo = (index, skipAnimation = false) => {
		  this.swiper.slideTo(index, skipAnimation ? 0 : 200);
		};
		this.slideToLoop = (index, skipAnimation = false) => {
		  this.swiper.slideToLoop(index, skipAnimation ? 0 : 200);
		};
		this.onSlideChange = () => {
		  if (this.slideChangeCallback) {
			this.slideChangeCallback();
		  }
		};
		this.setAutoHeight = () => {
		  this.autoHeightEnabled = false;
		  if (this.desktopHeight && this.mobileHeight) {
			if (!this.isMobile() && this.desktopHeight == 'original') {
			  this.autoHeightEnabled = true;
			} else if (this.isMobile() && this.mobileHeight == 'original') {
			  this.autoHeightEnabled = true;
			}
		  }
		  return this.autoHeightEnabled;
		};
		this.configure = () => {
		  let paginationStyle = this.paginationType;
		  let paginationElement = this.element.querySelector('.swiper-pagination');
		  if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
			return;
		  }
		  const swiper = new swiper_esm_bundle(this.element, {
			allowTouchMove: this.isDraggable == 'true' ? true : false,
			autoHeight: this.autoHeightEnabled,
			loop: true,
			loopedSlides: this.effect === 'fade' ? 0 : 2,
			autoplay: this.speed > 0 ? {
			  delay: this.speed,
			  disableOnInteraction: false
			} : false,
			effect: this.effect,
			slidesPerView: 1,
			speed: this.transitionSpeed,
			watchOverflow: true,
			keyboard: {
			  enabled: true,
			  onlyInViewport: false
			},
			fadeEffect: {
			  crossFade: true
			},
			navigation: {
			  nextEl: this.element.querySelector('.flex-next'),
			  prevEl: this.element.querySelector('.flex-prev')
			},
			pagination: {
			  el: this.element.querySelector('.swiper-pagination'),
			  type: paginationStyle,
			  renderBullet: function (index, className) {
				const paginationOption = paginationElement.dataset.paginationStyle;
				if (paginationOption == 'bars') {
				  return '<span class="' + className + ' progress-bar">' + '<i></i>' + '<b></b>' + '</span>';
				} else if (paginationOption == 'dots') {
				  return '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>';
				}
			  },
			  clickable: true
			}
		  });
		  swiper.on('slideChange', () => {
			const event = new CustomEvent('slider:slide:change');
			document.dispatchEvent(event);
			this.onSlideChange();
		  });
		  return swiper;
		};
		this.isMobile = () => {
		  return window.matchMedia('(max-width: 1023px)').matches;
		};
		this.theme = theme;
		this.element = element;
		this.restartTimer = null;
		this.running = true;
		this.speed = options.speed !== undefined ? options.speed : 200;
		this.transitionSpeed = options.transitionSpeed !== undefined ? options.transitionSpeed : 300;
		this.paginationType = options.paginationType;
		this.effect = options.animation || 'slide';
		this.slideChangeCallback = options.onSlideChange;
		this.desktopHeight = options.desktopHeight;
		this.mobileHeight = options.mobileHeight;
		this.isDraggable = options.isDraggable;
		this.blockIsActive = false;
		if (window.Shopify.designMode) {
		  document.addEventListener('shopify:block:select', () => {
			this.blockIsActive = true;
		  });
		  document.addEventListener('shopify:block:deselect', () => {
			this.blockIsActive = false;
		  });
		}

		// Determine if we should use autoHeight
		this.setAutoHeight();
		this.swiper = this.configure();

		// Handle window resize
		window.addEventListener('resize', () => {
		  const index_currentSlide = this.swiper.activeIndex;
		  this.setAutoHeight();
		  this.swiper.destroy();
		  this.swiper = this.configure();
		  if (window.Shopify.designMode) {
			this.swiper.slideTo(index_currentSlide, 0);

			// stop autoplay when in editor
			if (this.blockIsActive) this.stop();
		  }
		});
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Slideshow.js



	class Slideshow extends Section {
	  // ms

	  constructor(theme, _element, pageLoad) {
		super(theme, _element, pageLoad);
		this.SLIDER_SELECTOR = '.swiper-container';
		this.SLIDER_REENABLE_INTERVAL = 6000;
		this.initPaginationColor = () => {
		  if (this.slideCount == 1) return;
		  const paginationEl = this.paginationType == 'fraction' ? this.sliderElement.querySelector('.image--slideshow__navigation') : this.sliderElement.querySelector('.swiper-pagination');
		  const activeSlide = this.sliderElement.querySelector('.swiper-slide-active');
		  if (!paginationEl || !activeSlide) return;
		  const captionColor = activeSlide.dataset.captionColor;
		  if (captionColor) {
			paginationEl.style.color = captionColor;
		  }
		};
		this.changePaginationColor = () => {
		  if (this.slideCount == 1) return;
		  const paginationElement = this.paginationType == 'fraction' ? this.sliderElement.querySelector('.image--slideshow__navigation') : this.slider.element.querySelector('.swiper-pagination');
		  if (!paginationElement) return;
		  const index_currentSlide = this.slider.swiper.activeIndex;
		  const currentSlide = this.slider.swiper.slides[index_currentSlide];
		  if (!currentSlide) return;
		  const color = currentSlide.dataset.captionColor;
		  if (color) {
			paginationElement.style.color = color;
		  }
		};
		this.setTabIndex = () => {
		  // Return if there's only one slide
		  if (this.slideCount == 1) return;
		  const slideshowBtns = this.slider.element.querySelectorAll('.homepage-section-btn');
		  const slideshowLinks = this.slider.element.querySelectorAll('.slideshow__link');
		  const index_currentSlide = this.slider.swiper.activeIndex;
		  const currentSlide = this.slider.swiper.slides[index_currentSlide];
		  if (!currentSlide) return;
		  const currentSlideBtns = currentSlide.querySelectorAll('.homepage-section-btn');
		  const currentSlideLinks = currentSlide.querySelectorAll('.slideshow__link');

		  // Links
		  if (slideshowLinks.length > 0) {
			slideshowLinks.forEach(link => {
			  link.setAttribute('tabindex', '-1');
			});
		  }
		  if (currentSlideLinks.length > 0) {
			currentSlideLinks.forEach(link => {
			  link.removeAttribute('tabindex');
			});
		  }

		  // Buttons
		  if (slideshowBtns.length > 0) {
			slideshowBtns.forEach(btn => {
			  btn.setAttribute('tabindex', '-1');
			});
		  }
		  if (currentSlideBtns.length > 0) {
			currentSlideBtns.forEach(btn => {
			  btn.removeAttribute('tabindex');
			});
		  }
		};
		this.slideTransitionHandler = transitionTimeout => {
		  // Handle slide transition
		  const swiper = this.slider.swiper;
		  const currentSlide = swiper.slides[swiper.activeIndex];
		  const currentSlideInner = currentSlide.querySelector('.swiper-slide--inner');
		  if (currentSlideInner) {
			// Clear any existing timeouts and animations
			clearTimeout(transitionTimeout);
			currentSlideInner.style.animation = 'none';

			// Use setTimeout to allow the browser to render the initial state and then start the transition
			transitionTimeout = setTimeout(() => {
			  // Apply the keyframes animation
			  currentSlideInner.style.animation = 'fadeInMove 600ms forwards';

			  // Listen for the animationend event
			  currentSlideInner.addEventListener('animationend', () => {
				// Reset or clear any styles if needed after the animation completes
				currentSlideInner.style.animation = 'none';
			  }, {
				once: true
			  }); // The event listener will be removed after it's called once
			}, 50);
		  }
		};
		this.autoplayHandler = () => {
		  if (window.Shopify.designMode) return; // Otherwise the slider won't remain paused on block select
		  const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) {
			  this.slider.stop();
			} else {
			  this.slider.start();
			}
		  };
		  new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 0px 0px'
		  }).observe(this.slider.element);
		};
		this.onSlideChange = () => {
		  // Handle slide transition
		  this.slideTransitionHandler(this.slideTransitionTimeout);
		  if (this.slider && this.slider.isRunning && this.speed > 0) {
			if (window.Shopify.designMode) return; // Otherwise the slider won't remain paused on block select
			// restart autoscroll after given interval since last interaction
			clearTimeout(this.restartTimer);
			this.restartTimer = setTimeout(() => {
			  this.slider.start();
			}, Math.max(0, this.SLIDER_REENABLE_INTERVAL - this.speed));
		  }
		};
		this.onBlockSelect = ({
								element
							  }) => {
		  const index = parseInt(element.dataset.swiperSlideIndex, 10);
		  this.slider.slideToLoop(index);
		  this.slider.stop();
		};
		this.onBlockDeselect = () => {
		  this.slider.start();
		};
		this.restartTimer = null;
		this.sliderElement = _element.querySelector(this.SLIDER_SELECTOR);
		this.speed = parseInt(this.sliderElement.dataset.sliderSlideTime, 10);
		this.slideTransitionSpeed = parseInt(this.sliderElement.dataset.sliderTransitionSpeed, 10);
		this.paginationType = this.sliderElement.dataset.sliderPaginationType;
		this.desktopHeight = this.sliderElement.dataset.desktopHeight;
		this.mobileHeight = this.sliderElement.dataset.mobileHeight;
		this.isDraggable = this.sliderElement.dataset.draggable;
		this.slideTransitionTimeout = null;
		if (this.paginationType == 'arrows') {
		  this.paginationType = 'fraction';
		} else if (this.paginationType == 'bars') {
		  this.paginationType = 'bullets';
		} else if (this.paginationType == 'dots') {
		  this.paginationType = 'bullets';
		}
		this.slider = new Slider(theme, this.sliderElement, {
		  speed: this.speed,
		  transitionSpeed: this.slideTransitionSpeed,
		  paginationType: this.paginationType,
		  animation: this.sliderElement.dataset.sliderAnimation,
		  onSlideChange: this.onSlideChange,
		  desktopHeight: this.desktopHeight,
		  mobileHeight: this.mobileHeight,
		  isDraggable: this.isDraggable
		});
		const slides = this.slider.element.querySelectorAll('.slideshow__link');
		slides.forEach(slide => createClickableSection(slide));

		// Get slide count
		this.slideCount = this.slider.element.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

		// Play when in viewport/stop when out of viewport
		this.autoplayHandler();

		// The slider breaks when tabbing through the slide buttons
		this.setTabIndex();

		// Pagination colors to match caption color
		this.initPaginationColor();
		window.addEventListener('resize', () => {
		  this.initPaginationColor();
		});
		document.addEventListener('slider:slide:change', () => {
		  // The slider breaks when tabbing through the slide buttons
		  this.setTabIndex();

		  // Pagination colors
		  this.changePaginationColor();
		});
		if (window.Shopify.designMode) {
		  document.addEventListener('shopify:block:select', e => {
			const index_currentSlide = this.slider.swiper.activeIndex;
			const currentSlide = this.slider.swiper.slides[index_currentSlide];

			// @ts-ignore
			const blockId = e.detail.blockId;
			if (currentSlide && blockId == currentSlide.dataset.blockId) {
			  this.onBlockSelect({
				element: currentSlide
			  });
			}
		  });
		  document.addEventListener('shopify:block:deselect', e => {
			const index_currentSlide = this.slider.swiper.activeIndex;
			const currentSlide = this.slider.swiper.slides[index_currentSlide];

			// @ts-ignore
			const blockId = e.detail.blockId;
			if (currentSlide && blockId == currentSlide.dataset.blockId) {
			  this.onBlockDeselect();
			}
		  });
		}
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Newsletter.js

	class Newsletter extends Section {}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Password.js


	class Password extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.load = () => {
		  var self = this;
		  jquery_default()('.password-show').click(function () {
			self.$head.slideToggle('slow').addClass('open');
			jquery_default()('.password--container').addClass('password-modal--open');
			self.$password.focus();
		  });
		  jquery_default()('.password--close').click(function () {
			self.$head.slideToggle('slow').removeClass('open');
			jquery_default()('.password--container').removeClass('password-modal--open');
			self.$password.blur();
		  });
		  jquery_default()(function () {
			if (jquery_default()('.storefront-password-form .errors').length) {
			  self.$head.slideDown('slow').addClass('open');
			  self.$password.focus();
			}
		  });

		  // Detect click outside of popup to close it.
		  jquery_default()('.password--wrapper').click(e => {
			if (self.$head.hasClass('open')) {
			  if (!self.$head.is(e.target) && self.$head.has(e.target).length === 0 && !jquery_default()('.password-show').is(e.target)) {
				self.$head.slideUp('slow');
			  }
			}
		  });

		  // Keep tabbing within the modal while it is open.
		  jquery_default()(document).on('keydown', function (e) {
			// @ts-ignore
			e = e || window.event;
			if (e.keyCode == 9) {
			  // Keep tab within the open modal.
			  if (e.shiftKey) {
				if (document.activeElement === self.firstFocusableEl) {
				  e.preventDefault();
				  self.lastFocusableEl.focus();
				}
			  } else {
				if (document.activeElement === self.lastFocusableEl) {
				  e.preventDefault();
				  self.firstFocusableEl.focus();
				}
			  }
			} else if (e.keyCode == 27) {
			  // Escape to close popup.
			  if (self.$head.hasClass('open')) {
				self.$head.slideToggle('slow').removeClass('open');
				self.$password.blur();
			  }
			}
		  });
		};
		this.$head = jquery_default()('.site-header');
		this.$focusableEls = this.$head.find('a[href], input:not([disabled]):not([type="hidden"]), button:not([disabled]), [tabindex="0"]');
		this.$password = this.$head.find('input#password');
		this.firstFocusableEl = /** @type {HTMLElement} */this.$focusableEls[0];
		this.lastFocusableEl = /** @type {HTMLElement} */this.$focusableEls[this.$focusableEls.length - 1];
		this.load();
	  }
	}

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
	/**
	 * vue-class-component v7.2.6
	 * (c) 2015-present Evan You
	 * @license MIT
	 */


	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
		_typeof = function (obj) {
		  return typeof obj;
		};
	  } else {
		_typeof = function (obj) {
		  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
		};
	  }

	  return _typeof(obj);
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
		Object.defineProperty(obj, key, {
		  value: value,
		  enumerable: true,
		  configurable: true,
		  writable: true
		});
	  } else {
		obj[key] = value;
	  }

	  return obj;
	}

	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	}

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
		for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

		return arr2;
	  }
	}

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
	function reflectionIsSupported() {
	  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
	}
	function copyReflectionMetadata(to, from) {
	  forwardMetadata(to, from);
	  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
		forwardMetadata(to.prototype, from.prototype, key);
	  });
	  Object.getOwnPropertyNames(from).forEach(function (key) {
		forwardMetadata(to, from, key);
	  });
	}

	function forwardMetadata(to, from, propertyKey) {
	  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
	  metaKeys.forEach(function (metaKey) {
		var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

		if (propertyKey) {
		  Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
		} else {
		  Reflect.defineMetadata(metaKey, metadata, to);
		}
	  });
	}

	var fakeArray = {
	  __proto__: []
	};
	var vue_class_component_esm_hasProto = fakeArray instanceof Array;
	function vue_class_component_esm_createDecorator(factory) {
	  return function (target, key, index) {
		var Ctor = typeof target === 'function' ? target : target.constructor;

		if (!Ctor.__decorators__) {
		  Ctor.__decorators__ = [];
		}

		if (typeof index !== 'number') {
		  index = undefined;
		}

		Ctor.__decorators__.push(function (options) {
		  return factory(options, key, index);
		});
	  };
	}
	function mixins() {
	  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
		Ctors[_key] = arguments[_key];
	  }

	  return Vue.extend({
		mixins: Ctors
	  });
	}
	function vue_class_component_esm_isPrimitive(value) {
	  var type = _typeof(value);

	  return value == null || type !== 'object' && type !== 'function';
	}
	function vue_class_component_esm_warn(message) {
	  if (typeof console !== 'undefined') {
		console.warn('[vue-class-component] ' + message);
	  }
	}

	function collectDataFromConstructor(vm, Component) {
	  // override _init to prevent to init as Vue instance
	  var originalInit = Component.prototype._init;

	  Component.prototype._init = function () {
		var _this = this;

		// proxy to actual vm
		var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

		if (vm.$options.props) {
		  for (var key in vm.$options.props) {
			if (!vm.hasOwnProperty(key)) {
			  keys.push(key);
			}
		  }
		}

		keys.forEach(function (key) {
		  Object.defineProperty(_this, key, {
			get: function get() {
			  return vm[key];
			},
			set: function set(value) {
			  vm[key] = value;
			},
			configurable: true
		  });
		});
	  }; // should be acquired class property values


	  var data = new Component(); // restore original _init to avoid memory leak (#209)

	  Component.prototype._init = originalInit; // create plain data object

	  var plainData = {};
	  Object.keys(data).forEach(function (key) {
		if (data[key] !== undefined) {
		  plainData[key] = data[key];
		}
	  });

	  if (false) {}

	  return plainData;
	}

	var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
	];
	function componentFactory(Component) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  options.name = options.name || Component._componentTag || Component.name; // prototype props.

	  var proto = Component.prototype;
	  Object.getOwnPropertyNames(proto).forEach(function (key) {
		if (key === 'constructor') {
		  return;
		} // hooks


		if ($internalHooks.indexOf(key) > -1) {
		  options[key] = proto[key];
		  return;
		}

		var descriptor = Object.getOwnPropertyDescriptor(proto, key);

		if (descriptor.value !== void 0) {
		  // methods
		  if (typeof descriptor.value === 'function') {
			(options.methods || (options.methods = {}))[key] = descriptor.value;
		  } else {
			// typescript decorated data
			(options.mixins || (options.mixins = [])).push({
			  data: function data() {
				return _defineProperty({}, key, descriptor.value);
			  }
			});
		  }
		} else if (descriptor.get || descriptor.set) {
		  // computed properties
		  (options.computed || (options.computed = {}))[key] = {
			get: descriptor.get,
			set: descriptor.set
		  };
		}
	  });
	  (options.mixins || (options.mixins = [])).push({
		data: function data() {
		  return collectDataFromConstructor(this, Component);
		}
	  }); // decorate options

	  var decorators = Component.__decorators__;

	  if (decorators) {
		decorators.forEach(function (fn) {
		  return fn(options);
		});
		delete Component.__decorators__;
	  } // find super


	  var superProto = Object.getPrototypeOf(Component.prototype);
	  var Super = superProto instanceof vue_esm ? superProto.constructor : vue_esm;
	  var Extended = Super.extend(options);
	  forwardStaticMembers(Extended, Component, Super);

	  if (reflectionIsSupported()) {
		copyReflectionMetadata(Extended, Component);
	  }

	  return Extended;
	}
	var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
	  'cid', // Super Vue constructor
	  'super', // Component options that will be used by the component
	  'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
	  'component', 'directive', 'filter']));
	var shouldIgnore = {
	  prototype: true,
	  arguments: true,
	  callee: true,
	  caller: true
	};

	function forwardStaticMembers(Extended, Original, Super) {
	  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
	  Object.getOwnPropertyNames(Original).forEach(function (key) {
		// Skip the properties that should not be overwritten
		if (shouldIgnore[key]) {
		  return;
		} // Some browsers does not allow reconfigure built-in properties


		var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

		if (extendedDescriptor && !extendedDescriptor.configurable) {
		  return;
		}

		var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
		// the sub class properties may be inherited properties from the super class in TypeScript.
		// We need to exclude such properties to prevent to overwrite
		// the component options object which stored on the extended constructor (See #192).
		// If the value is a referenced value (object or function),
		// we can check equality of them and exclude it if they have the same reference.
		// If it is a primitive value, it will be forwarded for safety.

		if (!vue_class_component_esm_hasProto) {
		  // Only `cid` is explicitly exluded from property forwarding
		  // because we cannot detect whether it is a inherited property or not
		  // on the no `__proto__` environment even though the property is reserved.
		  if (key === 'cid') {
			return;
		  }

		  var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

		  if (!vue_class_component_esm_isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
			return;
		  }
		} // Warn if the users manually declare reserved properties


		if (false) {}

		Object.defineProperty(Extended, key, descriptor);
	  });
	}

	function vue_class_component_esm_Component(options) {
	  if (typeof options === 'function') {
		return componentFactory(options);
	  }

	  return function (Component) {
		return componentFactory(Component, options);
	  };
	}

	vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
	  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
	};

	/* harmony default export */ const vue_class_component_esm = (vue_class_component_esm_Component);


	;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
	/** vue-property-decorator verson 8.5.1 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>




	/** Used for keying reactive provide/inject properties */
	var reactiveInjectKey = '__reactiveInject__';
	/**
	 * decorator of an inject
	 * @param from key
	 * @return PropertyDecorator
	 */
	function Inject(options) {
	  return createDecorator(function (componentOptions, key) {
		if (typeof componentOptions.inject === 'undefined') {
		  componentOptions.inject = {};
		}
		if (!Array.isArray(componentOptions.inject)) {
		  componentOptions.inject[key] = options || key;
		}
	  });
	}
	/**
	 * decorator of a reactive inject
	 * @param from key
	 * @return PropertyDecorator
	 */
	function InjectReactive(options) {
	  return createDecorator(function (componentOptions, key) {
		if (typeof componentOptions.inject === 'undefined') {
		  componentOptions.inject = {};
		}
		if (!Array.isArray(componentOptions.inject)) {
		  var fromKey_1 = !!options ? options.from || options : key;
		  var defaultVal_1 = (!!options && options.default) || undefined;
		  if (!componentOptions.computed)
			componentOptions.computed = {};
		  componentOptions.computed[key] = function () {
			var obj = this[reactiveInjectKey];
			return obj ? obj[fromKey_1] : defaultVal_1;
		  };
		  componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
		}
	  });
	}
	function produceProvide(original) {
	  var provide = function () {
		var _this = this;
		var rv = typeof original === 'function' ? original.call(this) : original;
		rv = Object.create(rv || null);
		// set reactive services (propagates previous services if necessary)
		rv[reactiveInjectKey] = this[reactiveInjectKey] || {};
		for (var i in provide.managed) {
		  rv[provide.managed[i]] = this[i];
		}
		var _loop_1 = function (i) {
		  rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
		  Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
			enumerable: true,
			get: function () { return _this[i]; },
		  });
		};
		var this_1 = this;
		for (var i in provide.managedReactive) {
		  _loop_1(i);
		}
		return rv;
	  };
	  provide.managed = {};
	  provide.managedReactive = {};
	  return provide;
	}
	function needToProduceProvide(original) {
	  return (typeof original !== 'function' ||
		  (!original.managed && !original.managedReactive));
	}
	/**
	 * decorator of a provide
	 * @param key key
	 * @return PropertyDecorator | void
	 */
	function Provide(key) {
	  return createDecorator(function (componentOptions, k) {
		var provide = componentOptions.provide;
		if (needToProduceProvide(provide)) {
		  provide = componentOptions.provide = produceProvide(provide);
		}
		provide.managed[k] = key || k;
	  });
	}
	/**
	 * decorator of a reactive provide
	 * @param key key
	 * @return PropertyDecorator | void
	 */
	function ProvideReactive(key) {
	  return createDecorator(function (componentOptions, k) {
		var provide = componentOptions.provide;
		// inject parent reactive services (if any)
		if (!Array.isArray(componentOptions.inject)) {
		  componentOptions.inject = componentOptions.inject || {};
		  componentOptions.inject[reactiveInjectKey] = {
			from: reactiveInjectKey,
			default: {},
		  };
		}
		if (needToProduceProvide(provide)) {
		  provide = componentOptions.provide = produceProvide(provide);
		}
		provide.managedReactive[k] = key || k;
	  });
	}
	/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
	var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
	function applyMetadata(options, target, key) {
	  if (reflectMetadataIsSupported) {
		if (!Array.isArray(options) &&
			typeof options !== 'function' &&
			typeof options.type === 'undefined') {
		  var type = Reflect.getMetadata('design:type', target, key);
		  if (type !== Object) {
			options.type = type;
		  }
		}
	  }
	}
	/**
	 * decorator of model
	 * @param  event event name
	 * @param options options
	 * @return PropertyDecorator
	 */
	function Model(event, options) {
	  if (options === void 0) { options = {}; }
	  return function (target, key) {
		applyMetadata(options, target, key);
		createDecorator(function (componentOptions, k) {
		  ;
		  (componentOptions.props || (componentOptions.props = {}))[k] = options;
		  componentOptions.model = { prop: k, event: event || k };
		})(target, key);
	  };
	}
	/**
	 * decorator of a prop
	 * @param  options the options for the prop
	 * @return PropertyDecorator | void
	 */
	function Prop(options) {
	  if (options === void 0) { options = {}; }
	  return function (target, key) {
		applyMetadata(options, target, key);
		vue_class_component_esm_createDecorator(function (componentOptions, k) {
		  ;
		  (componentOptions.props || (componentOptions.props = {}))[k] = options;
		})(target, key);
	  };
	}
	/**
	 * decorator of a synced prop
	 * @param propName the name to interface with from outside, must be different from decorated property
	 * @param options the options for the synced prop
	 * @return PropertyDecorator | void
	 */
	function PropSync(propName, options) {
	  if (options === void 0) { options = {}; }
	  // @ts-ignore
	  return function (target, key) {
		applyMetadata(options, target, key);
		createDecorator(function (componentOptions, k) {
		  ;
		  (componentOptions.props || (componentOptions.props = {}))[propName] = options;
		  (componentOptions.computed || (componentOptions.computed = {}))[k] = {
			get: function () {
			  return this[propName];
			},
			set: function (value) {
			  // @ts-ignore
			  this.$emit("update:" + propName, value);
			},
		  };
		})(target, key);
	  };
	}
	/**
	 * decorator of a watch function
	 * @param  path the path or the expression to observe
	 * @param  WatchOption
	 * @return MethodDecorator
	 */
	function Watch(path, options) {
	  if (options === void 0) { options = {}; }
	  var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
	  return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
		if (typeof componentOptions.watch !== 'object') {
		  componentOptions.watch = Object.create(null);
		}
		var watch = componentOptions.watch;
		if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
		  watch[path] = [watch[path]];
		}
		else if (typeof watch[path] === 'undefined') {
		  watch[path] = [];
		}
		watch[path].push({ handler: handler, deep: deep, immediate: immediate });
	  });
	}
// Code copied from Vue/src/shared/util.js
	var vue_property_decorator_hyphenateRE = /\B([A-Z])/g;
	var vue_property_decorator_hyphenate = function (str) { return str.replace(vue_property_decorator_hyphenateRE, '-$1').toLowerCase(); };
	/**
	 * decorator of an event-emitter function
	 * @param  event The name of the event
	 * @return MethodDecorator
	 */
	function Emit(event) {
	  return function (_target, propertyKey, descriptor) {
		var key = vue_property_decorator_hyphenate(propertyKey);
		var original = descriptor.value;
		descriptor.value = function emitter() {
		  var _this = this;
		  var args = [];
		  for (var _i = 0; _i < arguments.length; _i++) {
			args[_i] = arguments[_i];
		  }
		  var emit = function (returnValue) {
			var emitName = event || key;
			if (returnValue === undefined) {
			  if (args.length === 0) {
				_this.$emit(emitName);
			  }
			  else if (args.length === 1) {
				_this.$emit(emitName, args[0]);
			  }
			  else {
				_this.$emit.apply(_this, [emitName].concat(args));
			  }
			}
			else {
			  if (args.length === 0) {
				_this.$emit(emitName, returnValue);
			  }
			  else if (args.length === 1) {
				_this.$emit(emitName, returnValue, args[0]);
			  }
			  else {
				_this.$emit.apply(_this, [emitName, returnValue].concat(args));
			  }
			}
		  };
		  var returnValue = original.apply(this, args);
		  if (vue_property_decorator_isPromise(returnValue)) {
			returnValue.then(emit);
		  }
		  else {
			emit(returnValue);
		  }
		  return returnValue;
		};
	  };
	}
	/**
	 * decorator of a ref prop
	 * @param refKey the ref key defined in template
	 */
	function Ref(refKey) {
	  return createDecorator(function (options, key) {
		options.computed = options.computed || {};
		options.computed[key] = {
		  cache: false,
		  get: function () {
			return this.$refs[refKey || key];
		  },
		};
	  });
	}
	function vue_property_decorator_isPromise(obj) {
	  return obj instanceof Promise || (obj && typeof obj.then === 'function');
	}

	;


	;// CONCATENATED MODULE: ./node_modules/readmore-js/dist/readmore.es6.js
	/*!
 * @preserve
 *
 * Readmore.js plugin
 * Author: @jed_foster
 * Project home: jedfoster.com/Readmore.js
 * Version: 3.0.0-beta-1
 * Licensed under the MIT license
 *
 * Debounce function from davidwalsh.name/javascript-debounce-function
 */
	let uniqueIdCounter = 0;

	const isCssEmbeddedFor = [];

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
	((function removePolyfill(arr) {
	  arr.forEach((item) => {
		if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
		  return;
		}
		Object.defineProperty(item, 'remove', {
		  configurable: true,
		  enumerable: true,
		  writable: true,
		  value: function remove() {
			if (this.parentNode !== null) {
			  this.parentNode.removeChild(this);
			}
		  }
		});
	  });
	})([Element.prototype, CharacterData.prototype, DocumentType.prototype]));

	function readmore_es6_forEach(arr, callback, scope) {
	  for (let i = 0; i < arr.length; i += 1) {
		callback.call(scope, arr[i], i);
	  }
	}

	function readmore_es6_extend(...objects) {
	  const hasProp = {}.hasOwnProperty;
	  let child = objects[0];
	  let parent = objects[1];

	  if (objects.length > 2) {
		const args = [];

		Object.keys(objects).forEach((key) => {
		  args.push(objects[key]);
		});

		while (args.length > 2) {
		  const c1 = args.shift();
		  const p1 = args.shift();
		  args.unshift(readmore_es6_extend(c1, p1));
		}

		child = args.shift();
		parent = args.shift();
	  }

	  if (parent) {
		Object.keys(parent).forEach((key) => {
		  if (hasProp.call(parent, key)) {
			if (typeof parent[key] === 'object') {
			  child[key] = child[key] || {};
			  child[key] = readmore_es6_extend(child[key], parent[key]);
			} else {
			  child[key] = parent[key];
			}
		  }
		});
	  }

	  return child;
	}

	function debounce(func, wait, immediate) {
	  let timeout;

	  return function debouncedFunc(...args) {
		const callNow = immediate && !timeout;
		const later = () => {
		  timeout = null;
		  if (!immediate) func.apply(this, args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);

		if (callNow) func.apply(this, args);
	  };
	}

	function uniqueId() {
	  uniqueIdCounter += 1;

	  return `rmjs-${uniqueIdCounter}`;
	}

	function setBoxHeights(element) {
	  element.style.height = 'auto';

	  const expandedHeight = parseInt(element.getBoundingClientRect().height, 10);
	  const cssMaxHeight = parseInt(window.getComputedStyle(element).maxHeight, 10);
	  const defaultHeight = parseInt(element.readmore.defaultHeight, 10);

	  // Store our measurements.
	  element.readmore.expandedHeight = expandedHeight;
	  element.readmore.maxHeight = cssMaxHeight;
	  element.readmore.collapsedHeight = cssMaxHeight || element.readmore.collapsedHeight || defaultHeight;

	  element.style.maxHeight = 'none';
	}

	function createElementFromString(htmlString) {
	  const div = document.createElement('div');
	  div.innerHTML = htmlString;

	  return div.firstChild;
	}

	function embedCSS(selector, options) {
	  if (!isCssEmbeddedFor[selector]) {
		let styles = '';

		if (options.embedCSS && options.blockCSS !== '') {
		  styles += `${selector} + [data-readmore-toggle], ${selector}[data-readmore] {
        ${options.blockCSS}
      }`;
		}

		// Include the transition CSS even if embedCSS is false
		styles += `${selector}[data-readmore] {
      transition: height ${options.speed}ms;
      overflow: hidden;
    }`;

		(((d, u) => {
		  const css = d.createElement('style');
		  css.type = 'text/css';

		  if (css.styleSheet) {
			css.styleSheet.cssText = u;
		  } else {
			css.appendChild(d.createTextNode(u));
		  }

		  d.getElementsByTagName('head')[0].appendChild(css);
		})(document, styles));

		isCssEmbeddedFor[selector] = true;
	  }
	}

	function buildToggle(link, element, scope) {
	  function clickHandler(event) {
		this.toggle(element, event);
	  }

	  let text = link;
	  if (typeof link === 'function') {
		text = link(element);
	  }

	  const toggleLink = createElementFromString(text);
	  toggleLink.setAttribute('data-readmore-toggle', element.id);
	  toggleLink.setAttribute('aria-controls', element.id);
	  toggleLink.addEventListener('click', clickHandler.bind(scope));

	  return toggleLink;
	}

	function isEnvironmentSupported() {
	  return (typeof window !== 'undefined' && typeof document !== 'undefined')
		  && !!document.querySelectorAll && !!window.addEventListener;
	}

	const resizeBoxes = debounce(() => {
	  const elements = document.querySelectorAll('[data-readmore]');

	  readmore_es6_forEach(elements, (element) => {
		const expanded = element.getAttribute('aria-expanded') === 'true';

		setBoxHeights(element);

		element.style.height = `${expanded ? element.readmore.expandedHeight : element.readmore.collapsedHeight}px`;
	  });
	}, 100);

	const readmore_es6_defaults = {
	  speed: 100,
	  collapsedHeight: 200,
	  heightMargin: 16,
	  moreLink: '<a href="#">Read More</a>',
	  lessLink: '<a href="#">Close</a>',
	  embedCSS: true,
	  blockCSS: 'display: block; width: 100%;',
	  startOpen: false,
	  sourceOrder: 'after',

	  // callbacks
	  blockProcessed: () => {},
	  beforeToggle: () => {},
	  afterToggle: () => {}
	};

	class Readmore {
	  constructor(...args) {
		if (!isEnvironmentSupported()) return;

		const [selector, options] = args;
		let elements;

		if (typeof selector === 'string') {
		  elements = document.querySelectorAll(selector);
		} else if (selector.nodeName) {
		  elements = [selector]; // emulate a NodeList by casting a single Node as an array
		} else {
		  elements = selector;
		}

		// After all that, if we _still_ don't have iteratable NodeList, bail out.
		if (!elements.length) return;

		this.options = readmore_es6_extend({}, readmore_es6_defaults, options);

		if (typeof selector === 'string') {
		  embedCSS(selector, this.options);
		} else {
		  // Instances need distinct selectors so they don't stomp on each other.
		  this.instanceSelector = `.${uniqueId()}`;
		  embedCSS(this.instanceSelector, this.options);
		}

		// Need to resize boxes when the page has fully loaded.
		window.addEventListener('load', resizeBoxes);
		window.addEventListener('resize', resizeBoxes);

		this.elements = [];

		readmore_es6_forEach(elements, (element) => {
		  if (this.instanceSelector) {
			element.classList.add(this.instanceSelector.substr(1));
		  }

		  const expanded = this.options.startOpen;

		  element.readmore = {
			defaultHeight: this.options.collapsedHeight,
			heightMargin: this.options.heightMargin
		  };

		  setBoxHeights(element);

		  const { heightMargin } = element.readmore;

		  if (element.getBoundingClientRect().height <= element.readmore.collapsedHeight + heightMargin) {
			if (typeof this.options.blockProcessed === 'function') {
			  this.options.blockProcessed(element, false);
			}
			return;
		  }

		  element.setAttribute('data-readmore', '');
		  element.setAttribute('aria-expanded', expanded);
		  element.id = element.id || uniqueId();

		  const toggleLink = expanded ? this.options.lessLink : this.options.moreLink;
		  const toggleElement = buildToggle(toggleLink, element, this);

		  element.parentNode.insertBefore(toggleElement, (this.options.sourceOrder === 'before') ? element : element.nextSibling);

		  element.style.height = `${expanded ? element.readmore.expandedHeight : element.readmore.collapsedHeight}px`;

		  if (typeof this.options.blockProcessed === 'function') {
			this.options.blockProcessed(element, true);
		  }

		  this.elements.push(element);
		});
	  }

	  // Signature when called internally by the toggleLink click handler:
	  //   toggle(element, event)
	  //
	  // When called externally by an instance,
	  // e.g. readmoreDemo.toggle(document.querySelector('article:nth-of-type(1)')):
	  //   toggle(elementOrQuerySelector)
	  toggle(...args) {
		let el = args[0];

		const toggleElement = (element) => {
		  const trigger = document.querySelector(`[aria-controls="${element.id}"]`);
		  const expanded = element.getBoundingClientRect().height <= element.readmore.collapsedHeight;
		  const newHeight = expanded ? element.readmore.expandedHeight : element.readmore.collapsedHeight;

		  // Fire beforeToggle callback
		  // Since we determined the new "expanded" state above we're now out of sync
		  // with our true current state, so we need to flip the value of `expanded`
		  if (typeof this.options.beforeToggle === 'function') {
			const shouldContinueToggle = this.options.beforeToggle(trigger, element, !expanded);

			// if the beforeToggle callback returns false, stop toggling
			if (shouldContinueToggle === false) {
			  return;
			}
		  }

		  element.style.height = `${newHeight}px`;

		  const transitionendHandler = (transitionEvent) => {
			// Fire afterToggle callback
			if (typeof this.options.afterToggle === 'function') {
			  this.options.afterToggle(trigger, element, expanded);
			}

			transitionEvent.stopPropagation();

			element.setAttribute('aria-expanded', expanded);
			element.removeEventListener('transitionend', transitionendHandler, false);
		  };

		  element.addEventListener('transitionend', transitionendHandler, false);

		  if (this.options.speed < 1) {
			transitionendHandler.call(this, { target: element });
		  }

		  const toggleLink = expanded ? this.options.lessLink : this.options.moreLink;

		  if (!toggleLink) {
			trigger.remove();
		  } else if (trigger && trigger.parentNode) {
			trigger.parentNode.replaceChild(buildToggle(toggleLink, element, this), trigger);
		  }
		};

		if (typeof el === 'string') {
		  el = document.querySelectorAll(el);
		}

		if (!el) {
		  throw new Error('Element MUST be either an HTML node or querySelector string');
		}

		const event = args[1];

		if (event) {
		  event.preventDefault();
		  event.stopPropagation();
		}

		if (typeof el === 'object' && !el.nodeName) { // element is likely a NodeList
		  readmore_es6_forEach(el, toggleElement);
		} else {
		  toggleElement(el);
		}
	  }

	  destroy(selector) {
		let elements;

		if (!selector) {
		  elements = this.elements; // eslint-disable-line
		} else if (typeof selector === 'string') {
		  elements = document.querySelectorAll(selector);
		} else if (selector.nodeName) {
		  elements = [selector]; // emulate a NodeList by casting a single Node as an array
		} else {
		  elements = selector;
		}

		readmore_es6_forEach(elements, (element) => {
		  if (this.elements.indexOf(element) === -1) {
			return;
		  }

		  this.elements = this.elements.filter((el) => el !== element);

		  if (this.instanceSelector) {
			element.classList.remove(this.instanceSelector.substr(1));
		  }

		  delete element.readmore;

		  element.style.height = 'initial';
		  element.style.maxHeight = 'initial';

		  element.removeAttribute('data-readmore');
		  element.removeAttribute('aria-expanded');

		  const trigger = document.querySelector(`[aria-controls="${element.id}"]`);
		  if (trigger) {
			trigger.remove();
		  }

		  if (element.id.indexOf('rmjs-') !== -1) {
			element.removeAttribute('id');
		  }
		});

		delete this;
	  }
	}

	Readmore.VERSION = '3.0.0-beta-1';

	/* harmony default export */ const readmore_es6 = (Readmore);

	;// CONCATENATED MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
	function bodyScrollLock_esm_toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

	var hasPassiveEvents = false;
	if (typeof window !== 'undefined') {
	  var passiveTestOptions = {
		get passive() {
		  hasPassiveEvents = true;
		  return undefined;
		}
	  };
	  window.addEventListener('testPassive', null, passiveTestOptions);
	  window.removeEventListener('testPassive', null, passiveTestOptions);
	}

	var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


	var locks = [];
	var documentListenerAdded = false;
	var initialClientY = -1;
	var previousBodyOverflowSetting = void 0;
	var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
	var allowTouchMove = function allowTouchMove(el) {
	  return locks.some(function (lock) {
		if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
		  return true;
		}

		return false;
	  });
	};

	var preventDefault = function preventDefault(rawEvent) {
	  var e = rawEvent || window.event;

	  // For the case whereby consumers adds a touchmove event listener to document.
	  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
	  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
	  // the touchmove event on document will break.
	  if (allowTouchMove(e.target)) {
		return true;
	  }

	  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
	  if (e.touches.length > 1) return true;

	  if (e.preventDefault) e.preventDefault();

	  return false;
	};

	var setOverflowHidden = function setOverflowHidden(options) {
	  // If previousBodyPaddingRight is already set, don't set it again.
	  if (previousBodyPaddingRight === undefined) {
		var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
		var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

		if (_reserveScrollBarGap && scrollBarGap > 0) {
		  previousBodyPaddingRight = document.body.style.paddingRight;
		  document.body.style.paddingRight = scrollBarGap + 'px';
		}
	  }

	  // If previousBodyOverflowSetting is already set, don't set it again.
	  if (previousBodyOverflowSetting === undefined) {
		previousBodyOverflowSetting = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
	  }
	};

	var restoreOverflowSetting = function restoreOverflowSetting() {
	  if (previousBodyPaddingRight !== undefined) {
		document.body.style.paddingRight = previousBodyPaddingRight;

		// Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
		// can be set again.
		previousBodyPaddingRight = undefined;
	  }

	  if (previousBodyOverflowSetting !== undefined) {
		document.body.style.overflow = previousBodyOverflowSetting;

		// Restore previousBodyOverflowSetting to undefined
		// so setOverflowHidden knows it can be set again.
		previousBodyOverflowSetting = undefined;
	  }
	};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
	var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
	  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
	};

	var handleScroll = function handleScroll(event, targetElement) {
	  var clientY = event.targetTouches[0].clientY - initialClientY;

	  if (allowTouchMove(event.target)) {
		return false;
	  }

	  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
		// element is at the top of its scroll.
		return preventDefault(event);
	  }

	  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
		// element is at the bottom of its scroll.
		return preventDefault(event);
	  }

	  event.stopPropagation();
	  return true;
	};

	var disableBodyScroll = function disableBodyScroll(targetElement, options) {
	  // targetElement must be provided
	  if (!targetElement) {
		// eslint-disable-next-line no-console
		console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
		return;
	  }

	  // disableBodyScroll must not have been called on this targetElement before
	  if (locks.some(function (lock) {
		return lock.targetElement === targetElement;
	  })) {
		return;
	  }

	  var lock = {
		targetElement: targetElement,
		options: options || {}
	  };

	  locks = [].concat(bodyScrollLock_esm_toConsumableArray(locks), [lock]);

	  if (isIosDevice) {
		targetElement.ontouchstart = function (event) {
		  if (event.targetTouches.length === 1) {
			// detect single touch.
			initialClientY = event.targetTouches[0].clientY;
		  }
		};
		targetElement.ontouchmove = function (event) {
		  if (event.targetTouches.length === 1) {
			// detect single touch.
			handleScroll(event, targetElement);
		  }
		};

		if (!documentListenerAdded) {
		  document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
		  documentListenerAdded = true;
		}
	  } else {
		setOverflowHidden(options);
	  }
	};

	var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
	  if (isIosDevice) {
		// Clear all locks ontouchstart/ontouchmove handlers, and the references.
		locks.forEach(function (lock) {
		  lock.targetElement.ontouchstart = null;
		  lock.targetElement.ontouchmove = null;
		});

		if (documentListenerAdded) {
		  document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
		  documentListenerAdded = false;
		}

		// Reset initial clientY.
		initialClientY = -1;
	  } else {
		restoreOverflowSetting();
	  }

	  locks = [];
	};

	var enableBodyScroll = function enableBodyScroll(targetElement) {
	  if (!targetElement) {
		// eslint-disable-next-line no-console
		console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
		return;
	  }

	  locks = locks.filter(function (lock) {
		return lock.targetElement !== targetElement;
	  });

	  if (isIosDevice) {
		targetElement.ontouchstart = null;
		targetElement.ontouchmove = null;

		if (documentListenerAdded && locks.length === 0) {
		  document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
		  documentListenerAdded = false;
		}
	  } else if (!locks.length) {
		restoreOverflowSetting();
	  }
	};


	;// CONCATENATED MODULE: ./src/javascripts/global/MediaWrapper.js


	class MediaWrapper {
	  /**
	   *
	   * @param {import('../ThemeBase').default} theme
	   * @param {string} sectionId
	   * @param {import('theme-checker/dist/shopify').Media} media
	   * @param {HTMLElement} target
	   */
	  constructor(theme, sectionId, media, target) {
		this.load = () => {
		  return new Promise(resolve => {
			if (this.loaded) {
			  resolve();
			  return;
			}
			if (this.media.media_type === 'image') {
			  this.on_load();
			  resolve();
			  return;
			}
			var template = /** @type {HTMLTemplateElement} */document.querySelector(`#media-template-${this.sectionId}-${this.media.id}`);
			if (!template) {
			  this.on_load();
			  resolve();
			  return;
			}
			const fragment = document.importNode(template.content, true);
			while (this.target.firstChild) {
			  this.target.removeChild(this.target.lastChild);
			}
			this.target.appendChild(fragment);
			this.renderedElement = this.target.lastElementChild;
			switch (this.media.media_type) {
			  case 'model':
				window.Shopify.loadFeatures([{
				  name: 'model-viewer-ui',
				  version: '1.0'
				}], () => {
				  this.modelController = new window.Shopify.ModelViewerUI(this.renderedElement.querySelector('model-viewer'));

				  // Don't interact with the rest of the page when model is not disabled
				  this.modelController.viewer.parentElement.addEventListener('mouseup', e => {
					e.stopPropagation = function () {};
				  }, {
					capture: true
				  });

				  // Prevent activating the viewer right after it was paused when clicked in position of the button
				  this.modelController.elements.controlButton.addEventListener('click', e => {
					e.stopImmediatePropagation();
				  }, {
					capture: true
				  });
				  this.modelController.viewer.addEventListener('shopify_model_viewer_ui_toggle_pause', this.on_pause.bind(this));
				  this.modelController.viewer.addEventListener('shopify_model_viewer_ui_toggle_play', this.on_play.bind(this));
				  this.on_load();
				  resolve();
				});
				break;
			  case 'video':
				window.Shopify.loadFeatures([{
				  name: 'video-ui',
				  version: '1.0',
				  onLoad: function () {
					var video = this.renderedElement.querySelector('video');
					var loop = video.parentNode.dataset.videoLoop === 'true';
					this.plyrController = new window.Shopify.Plyr(video, {
					  loop: {
						active: loop
					  },
					  focusOnPlay: false
					});
					video.addEventListener('play', this.on_play.bind(this));
					video.addEventListener('pause', this.on_pause.bind(this));
					video.addEventListener('ended', this.on_pause.bind(this));
					this.on_load();
					resolve();
				  }.bind(this)
				}]);
				break;
			  case 'external_video':
				var iframe = /** @type {HTMLIFrameElement} */this.renderedElement.querySelector('iframe');
				var loop = /** @type {HTMLElement} */iframe.parentNode.dataset.videoLoop === 'true';
				if (iframe.src.indexOf('youtube.com') !== -1) {
				  this.externalVideoHost = 'youtube';
				  this.theme.loadYoutubeApi().then(() => {
					new window.YT.Player(iframe, {
					  events: {
						onReady: event => {
						  this.youtubeController = /** @type {import('../window').YoutubePlayer} */event.target;
						  this.on_load();
						  resolve();
						},
						onStateChange: event => {
						  if (event.data === window.YT.PlayerState.PLAYING) {
							this.on_play();
						  } else if (event.data === window.YT.PlayerState.PAUSED) {
							this.on_pause();
						  } else if (event.data === window.YT.PlayerState.ENDED) {
							if (loop) {
							  this.youtubeController.playVideo();
							} else {
							  this.on_pause();
							}
						  }
						},
						onError: event => {
						  console.warn('Youtube video error', event, event.data);
						  this.on_pause();
						}
					  }
					});
				  });
				} else if (iframe.src.indexOf('vimeo.com') !== -1) {
				  this.externalVideoHost = 'vimeo';
				  let self = this;
				  this.theme.loadVimeoApi().then(() => {
					// @ts-ignore
					let player = new window.Vimeo.Player(iframe);
					player.ready().then(function () {
					  self.vimeoController = player;
					  self.on_load();
					  resolve();
					});
					player.on('play', function () {
					  self.vimeoController.setLoop(loop);
					  self.on_play();
					});
					player.on('pause', function () {
					  self.on_pause();
					});
				  });
				}
				break;
			  default:
				this.on_load();
				resolve();
			}
		  });
		};
		this.isMobile = () => {
		  return window.matchMedia('only screen and (max-width: 767px)').matches;
		};
		this.on_load = () => {
		  this.loaded = true;
		  this.target.querySelector('.product-medias__media').classList.add('product-medias__media--loaded');
		  var e = new CustomEvent('media-load', {
			detail: {
			  parent: this.target,
			  media: this
			}
		  });
		  this.target.dispatchEvent(e);
		  if (window.ShopifyXR && window.ShopifyXR.setupXRElements) {
			window.ShopifyXR.setupXRElements();
		  }
		};
		this.play = () => {
		  if (!this.loaded) {
			this.load().then(this._play.bind(this));
		  } else {
			this._play();
		  }
		};
		this._play = () => {
		  switch (this.media.media_type) {
			case 'model':
			  this.modelController.play();
			  this.on_play();
			  break;
			case 'video':
			  this.plyrController.play().then(this.on_play.bind(this)).catch(console.warn);
			  break;
			case 'external_video':
			  if (this.externalVideoHost == 'youtube') {
				this.youtubeController.playVideo();
			  } else if (this.externalVideoHost == 'vimeo') {
				this.vimeoController.play();
			  }
			  this.on_play();
			  break;
		  }
		};
		this.on_play = () => {
		  this.active = true;
		  this.target.querySelector('.product-medias__media').classList.add('product-medias__media--active');
		  if (!this.loaded) {
			this.loaded = true;
			this.target.querySelector('.product-medias__media').classList.add('product-medias__media--loaded');
		  }
		  var e = new CustomEvent('media-play', {
			detail: {
			  parent: this.target,
			  media: this
			}
		  });
		  this.target.dispatchEvent(e);
		  if (document.activeElement === document.body) {
			// No element has focus, focus this media
			this.focus();
		  }
		};
		this.autoplay = () => {
		  if (jquery_default()(window).width() > 767 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			this.play();
		  }
		};
		this.pause = () => {
		  if (!this.active) {
			return;
		  }
		  switch (this.media.media_type) {
			case 'model':
			  break;
			case 'video':
			  this.plyrController.pause();
			  break;
			case 'external_video':
			  if (this.externalVideoHost == 'youtube') {
				this.youtubeController.pauseVideo();
			  } else if (this.externalVideoHost == 'vimeo') {
				this.vimeoController.pause();
			  }
			  break;
		  }
		  this.on_pause();
		};
		this.togglePlay = () => {
		  if (this.active) {
			this.pause();
		  } else {
			this.play();
		  }
		};
		this.on_pause = () => {
		  this.active = false;
		  this.target.querySelector('.product-medias__media').classList.remove('product-medias__media--active');
		  var e = new CustomEvent('media-pause', {
			detail: {
			  parent: this.target,
			  media: this
			}
		  });
		  this.target.dispatchEvent(e);
		};
		this.focus = () => {
		  switch (this.media.media_type) {
			case 'video':
			  /** @type {HTMLElement} */this.target.querySelector('.plyr').focus();
			  break;
			case 'model':
			  var viewer = this.target.querySelector('model-viewer');
			  if (viewer && viewer.shadowRoot) {
				/** @type {HTMLElement} */viewer.focus();
			  } else {
				// Not yet loaded, try later
				setTimeout(this.focus.bind(this), 1000);
			  }
			  break;
			case 'external_video':
			  this.target.querySelector('iframe').contentWindow.focus();
			  break;
			default:
			  this.target.focus();
		  }
		};
		this.destroy = () => {};
		this.theme = theme;
		this.sectionId = sectionId;
		this.mediaId = media.id;
		this.media = media;
		this.target = target;
		this.renderedElement = null;
		this.loaded = false;
		this.active = false;
		this.plyrController = null;
		this.modelController = null;
		this.youtubeController = null;
		this.vimeoController = null;
		this.externalVideoHost = null;
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/Accessibility.js
	class Accessibility {
	  constructor() {
		this.state = {
		  firstFocusable: null,
		  lastFocusable: null
		};
	  }

	  /**
	   * Traps the focus in a particular container
	   *
	   * @param {object} options - Options to be used
	   * @param {HTMLElement} options.container - Container to trap focus within
	   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
	   */
	  trapFocus(options) {
		var focusableElements = /** @type {HTMLElement[]} */Array.from(options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (element) {
		  var width = element.offsetWidth;
		  var height = element.offsetHeight;
		  return width !== 0 && height !== 0 && getComputedStyle(element).getPropertyValue('display') !== 'none';
		});
		this.state.firstFocusable = focusableElements[0];
		this.state.lastFocusable = focusableElements[focusableElements.length - 1];
		if (!options.elementToFocus) {
		  options.elementToFocus = options.container;
		}
		options.container.setAttribute('tabindex', '-1');
		options.elementToFocus.focus();
		this._setupHandlers();
		document.addEventListener('focusin', this._onFocusInHandler);
		document.addEventListener('focusout', this._onFocusOutHandler);
	  }
	  _setupHandlers() {
		if (!this._onFocusInHandler) {
		  this._onFocusInHandler = this._onFocusIn.bind(this);
		}
		if (!this._onFocusOutHandler) {
		  this._onFocusOutHandler = this._onFocusIn.bind(this);
		}
		if (!this._manageFocusHandler) {
		  this._manageFocusHandler = this._manageFocus.bind(this);
		}
	  }
	  _onFocusOut() {
		document.removeEventListener('keydown', this._manageFocusHandler);
	  }
	  _onFocusIn(evt) {
		if (evt.target !== this.state.lastFocusable && evt.target !== this.state.firstFocusable) return;
		document.addEventListener('keydown', this._manageFocusHandler);
	  }
	  _manageFocus(evt) {
		if (evt.keyCode !== 9) return;

		/**
		 * On the last focusable element and tab forward,
		 * focus the first element.
		 */
		if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
		  evt.preventDefault();
		  this.state.firstFocusable.focus();
		}
		/**
		 * On the first focusable element and tab backward,
		 * focus the last element.
		 */
		if (evt.target === this.state.firstFocusable && evt.shiftKey) {
		  evt.preventDefault();
		  this.state.lastFocusable.focus();
		}
	  }

	  /**
	   * Removes the trap of focus in a particular container
	   *
	   * @param {object} options - Options to be used
	   * @param {HTMLElement} options.container - Container to trap focus within
	   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
	   */
	  removeTrapFocus(options) {
		if (options.container) {
		  options.container.removeAttribute('tabindex');
		}
		if (options.elementToFocus) {
		  options.elementToFocus.focus();
		}
		document.removeEventListener('focusin', this._onFocusInHandler);
	  }
	}
	;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Dropdown.vue?vue&type=template&id=5e6c97d0&
	var render = function () {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
		  "div",
		  {
			ref: "component",
			staticClass: "bulletproof-dropdown",
			class: [
			  "fit-" + _vm.fit,
			  _vm.open ? "bulletproof-dropdown--open" : "bulletproof-dropdown--closed",
			  "bulletproof-dropdown--" + _vm.direction,
			],
		  },
		  [
			_vm.title
				? _c("div", { staticClass: "option-label-wrapper" }, [
				  _c("label", {
					staticClass: "label-font",
					attrs: { for: _vm.id },
					domProps: { textContent: _vm._s(_vm.title) },
				  }),
				  _vm._v(" "),
				  _c(
					  "div",
					  {
						staticClass: "text-link-animated",
						attrs: { id: "size-guide" },
					  },
					  [
						_vm.sizeGuideLink
							? _c("a", {
							  attrs: {
								href: _vm.sizeGuideLink,
								id: "bulletproof-dropdown__size-guide",
							  },
							  domProps: { textContent: _vm._s(_vm.sizeGuideText) },
							})
							: _vm._e(),
					  ]
				  ),
				])
				: _vm._e(),
			_vm._v(" "),
			_c(
				"div",
				{ staticClass: "bulletproof-dropdown__wrapper" },
				[
				  _c(
					  "button",
					  {
						ref: "button",
						attrs: {
						  id: _vm.id,
						  type: "button",
						  autocomplete: "off",
						  readonly: "true",
						  tabindex: "0",
						  "aria-controls": _vm.dropdownId,
						  "aria-expanded": _vm.open,
						},
						on: {
						  click: _vm.toggleOpen,
						  blur: function ($event) {
							$event.preventDefault()
							return _vm.close.apply(null, arguments)
						  },
						  keydown: [
							function ($event) {
							  if (
								  !$event.type.indexOf("key") &&
								  _vm._k($event.keyCode, "up", 38, $event.key, [
									"Up",
									"ArrowUp",
								  ])
							  ) {
								return null
							  }
							  $event.preventDefault()
							  return _vm.moveFocusedIndex(-1)
							},
							function ($event) {
							  if (
								  !$event.type.indexOf("key") &&
								  _vm._k($event.keyCode, "down", 40, $event.key, [
									"Down",
									"ArrowDown",
								  ])
							  ) {
								return null
							  }
							  $event.preventDefault()
							  return _vm.moveFocusedIndex(1)
							},
							function ($event) {
							  if (
								  !$event.type.indexOf("key") &&
								  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
							  ) {
								return null
							  }
							  $event.preventDefault()
							  return _vm.applyFocused(false)
							},
							function ($event) {
							  if (
								  !$event.type.indexOf("key") &&
								  _vm._k($event.keyCode, "space", 32, $event.key, [
									" ",
									"Spacebar",
								  ])
							  ) {
								return null
							  }
							  $event.preventDefault()
							  return _vm.applyFocused(false)
							},
							function ($event) {
							  if (
								  !$event.type.indexOf("key") &&
								  _vm._k($event.keyCode, "esc", 27, $event.key, [
									"Esc",
									"Escape",
								  ])
							  ) {
								return null
							  }
							  $event.preventDefault()
							  return _vm.close.apply(null, arguments)
							},
						  ],
						},
					  },
					  [
						_c("span", {
						  staticClass: "header--supporting-text",
						  domProps: {
							textContent: _vm._s(_vm.selectedOption.label || "\xa0"),
						  },
						}),
						_vm._v(" "),
						_c("span", { staticClass: "icon-dropdown" }, [
						  _c(
							  "svg",
							  {
								attrs: {
								  viewBox: "0 0 20 20",
								  fill: "none",
								  xmlns: "http://www.w3.org/2000/svg",
								  width: "16",
								  height: "16",
								},
							  },
							  [
								_c("path", {
								  attrs: {
									d: "M5.5 7.5L10.5 12.5L15.5 7.5",
									stroke: "currentColor",
									"stroke-width": "1.5",
									"stroke-linecap": "round",
									"stroke-linejoin": "round",
								  },
								}),
							  ]
						  ),
						]),
					  ]
				  ),
				  _vm._v(" "),
				  _c("transition", { attrs: { name: "bulletproof-dropdown-fade" } }, [
					_c(
						"ul",
						{
						  directives: [
							{
							  name: "show",
							  rawName: "v-show",
							  value: _vm.open,
							  expression: "open",
							},
						  ],
						  ref: "ul",
						  staticClass: "dropdown-list",
						  attrs: { id: _vm.dropdownId },
						},
						_vm._l(_vm.options, function (option) {
						  return _c(
							  "li",
							  {
								key: option.value,
								class: [
								  "dropdown-list--item",
								  {
									selected:
										option.value === _vm.options[_vm.focusedIndex].value,
									"sold-out": option.soldOutText,
								  },
								],
								attrs: { value: option.value },
								on: {
								  mousedown: function ($event) {
									return _vm.optionClicked(option)
								  },
								},
							  },
							  [
								_c("span", { staticClass: "option-label" }, [
								  _vm._v(_vm._s(option.label)),
								]),
								_vm._v(" "),
								option.soldOutText
									? _c("span", { staticClass: "status-text" }, [
									  _vm._v(_vm._s(option.soldOutText)),
									])
									: _vm._e(),
							  ]
						  )
						}),
						0
					),
				  ]),
				],
				1
			),
		  ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true


	;// CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue?vue&type=template&id=5e6c97d0&

	;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-2.use!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	function getElementWidth(el) {
	  const clone = el.cloneNode(true);
	  clone.style.cssText = "position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset";
	  document.body.appendChild(clone);
	  const width = clone.getBoundingClientRect().width;
	  document.body.removeChild(clone);
	  return width;
	}
	let dropdown_last_id = 0;
	/* harmony default export */ const Dropdownvue_type_script_lang_js_ = (vue_esm.extend({
	  props: {
		fit: {
		  type: String,
		  default: "parent",
		  validator: function (value) {
			return ["parent", "current", "longest"].indexOf(value) !== -1;
		  }
		},
		direction: {
		  type: String,
		  default: "down",
		  validator: function (value) {
			return ["down", "up"].indexOf(value) !== -1;
		  }
		},
		isVariantDropdown: {
		  type: Boolean,
		  default: false
		},
		soldOutString: {
		  type: String,
		  default: ''
		},
		name: {
		  type: String,
		  default: ""
		},
		value: {
		  type: String,
		  default: null
		}
	  },
	  data: function () {
		return {
		  id: "",
		  title: "",
		  open: false,
		  options: [],
		  selectedOption: undefined,
		  // focusedIndex is index of option that user navigated to using keyboard,
		  // it's equal to index of selected option when keyboard was not used
		  focusedIndex: 0,
		  selectComponent: undefined
		};
	  },
	  computed: {
		dropdownId: function () {
		  return this.id + "-dropdown";
		}
	  },
	  watch: {
		value: function (newVal) {
		  this.options.forEach((option, index) => {
			if (option.value === newVal) {
			  this.selectedOption = option;
			  this.focusedIndex = index;
			}
		  });
		}
	  },
	  beforeMount: function () {
		// Convert a <select> and <label> into options and other properties
		const el = this.$root.$el.tagName === "bulletproof-DROPDOWN" ? this.$root.$el : this.$root.$el.querySelector("bulletproof-dropdown");
		var select = el.querySelector("select");
		if (select.id) {
		  this.id = select.id;
		} else {
		  dropdown_last_id += 1;
		  this.id = "bulletproof-dropdown-" + dropdown_last_id;
		}
		var labelEl = el.querySelector("label");
		this.title = labelEl?.textContent;
		var sizeGuideEl = el.querySelector("#size-guide-link");
		this.sizeGuideLink = sizeGuideEl?.href;
		this.sizeGuideText = sizeGuideEl?.textContent;
		var options = [];
		Array.prototype.forEach.call(select.querySelectorAll("option"), (option, index) => {
		  options.push({
			value: option.value,
			label: option.textContent,
			soldOutText: option.getAttribute('data-status-text') || null
		  });
		  if (option.defaultSelected) {
			this.selectedOption = option;
			this.focusedIndex = index;
		  }
		});
		this.options = options;
		if (!this.selectedOption) {
		  this.selectedOption = options[0];
		  this.focusedIndex = 0;
		}
		this.selectWidth = getElementWidth(select);
		this.selectComponent = select;
		this.selectComponent.style.display = "none";
		this.selectComponent.addEventListener("input", console.log);
		el.parentNode.removeChild(el);
	  },
	  mounted: function () {
		if (this.fit === "longest") {
		  var w = this.selectWidth + 20; // 20px for caret
		  this.$el.style.width = w + "px";
		  this.$refs.ul.style.width = w + "px";
		}
		this.$el.appendChild(this.selectComponent);
		this.productForm = this.$el.closest('.product-single-wrapper') || this.$el.closest('#product-box');

		// Check if this.productForm is available and isVariantDropdown is true
		if (this.isVariantDropdown && this.productForm) {
		  this.productForm.addEventListener('variant:changed', this.handleVariantChange);
		}
	  },
	  methods: {
		findOptionIndex: function (option) {
		  var index;
		  this.options.forEach(function (o, i) {
			if (o.value === option.value) {
			  index = i;
			}
		  });
		  return index;
		},
		optionClicked: function (option) {
		  this.selectedOption = option;
		  this.focusedIndex = this.findOptionIndex(option);
		  this.selectComponent.value = option.value;
		  this.open = false;
		  this.$nextTick(function () {
			// Emit the event when input value is already changed
			var e = new CustomEvent("change");
			this.selectComponent.dispatchEvent(e);
		  });
		  this.$emit("change", option.value, this.name);
		},
		moveFocusedIndex: function (offset) {
		  var focusedIndex = this.focusedIndex + offset;
		  if (focusedIndex >= 0 && focusedIndex < this.options.length) {
			this.focusedIndex = focusedIndex;
		  }
		  if (!this.open) {
			this.applyFocused(true);
		  }
		},
		toggleOpen: function () {
		  this.$nextTick(function () {
			if (!this.open) {
			  this.open = true;
			  this.$refs.button.focus();
			} else {
			  this.open = false;
			  this.$refs.button.blur();
			}
		  });
		},
		applyFocused: function (force) {
		  if (!this.open && !force) {
			this.open = true;
			return;
		  }
		  this.optionClicked(this.options[this.focusedIndex]);
		  this.open = false;
		},
		handleVariantChange(event) {
		  const product = event.detail.product;
		  if (!product || product.options.length === 1) return;
		  const variant = event.detail.variant;
		  if (!variant) return;
		  this.$nextTick(() => {
			product.options.forEach((option, index) => {
			  const optionValues = product.variants.map(variant => variant[`option${index + 1}`]);
			  optionValues.forEach(value => {
				this.UpdateDropdownState(product, value, index + 1, variant, option);
			  });
			});
		  });
		},
		UpdateDropdownState(product, value, optionIndex, currentVariant) {
		  const availability = product.variants.map(variant => variant.available);
		  const optionValues = [product.variants.map(variant => variant.option1), product.variants.map(variant => variant.option2), product.variants.map(variant => variant.option3)];
		  const isOptionAvailable = optionValues[optionIndex - 1].some((optionValue, i) => {
			switch (optionIndex) {
			  case 1:
				return optionValue === value && availability[i];
			  case 2:
				return optionValue === value && optionValues[0][i] === currentVariant.option1 && availability[i];
			  case 3:
				return optionValue === value && optionValues[0][i] === currentVariant.option1 && optionValues[1][i] === currentVariant.option2 && availability[i];
			  default:
				return false;
			}
		  });
		  const dropdowns = this.productForm.querySelectorAll(`.dropdown-list--item[value="${value}"]`);
		  dropdowns.forEach(dropdown => {
			if (isOptionAvailable) {
			  dropdown.classList.remove('sold-out');
			  // Remove sold-out text if it exists
			  const statusText = dropdown.querySelector('.status-text');
			  if (statusText) {
				statusText.remove();
			  }
			} else {
			  dropdown.classList.add('sold-out');
			  // Add sold-out text if it doesn't exist
			  if (!dropdown.querySelector('.status-text')) {
				const soldOutText = document.createElement('span');
				soldOutText.className = 'status-text';
				soldOutText.textContent = this.soldOutString;
				dropdown.appendChild(soldOutText);
			  }
			}
		  });
		},
		close: function () {
		  this.open = false;
		}
	  },
	  beforeDestroy: function () {
		if (this.isVariantDropdown && this.productForm) {
		  this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
		}
	  }
	}));
	;// CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue?vue&type=script&lang=js&
	/* harmony default export */ const components_Dropdownvue_type_script_lang_js_ = (Dropdownvue_type_script_lang_js_);
	;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

	function normalizeComponent(
		scriptExports,
		render,
		staticRenderFns,
		functionalTemplate,
		injectStyles,
		scopeId,
		moduleIdentifier /* server only */,
		shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options =
		  typeof scriptExports === 'function' ? scriptExports.options : scriptExports

	  // render functions
	  if (render) {
		options.render = render
		options.staticRenderFns = staticRenderFns
		options._compiled = true
	  }

	  // functional template
	  if (functionalTemplate) {
		options.functional = true
	  }

	  // scopedId
	  if (scopeId) {
		options._scopeId = 'data-v-' + scopeId
	  }

	  var hook
	  if (moduleIdentifier) {
		// server build
		hook = function (context) {
		  // 2.3 injection
		  context =
			  context || // cached call
			  (this.$vnode && this.$vnode.ssrContext) || // stateful
			  (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
		  // 2.2 with runInNewContext: true
		  if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
			context = __VUE_SSR_CONTEXT__
		  }
		  // inject component styles
		  if (injectStyles) {
			injectStyles.call(this, context)
		  }
		  // register component module identifier for async chunk inferrence
		  if (context && context._registeredComponents) {
			context._registeredComponents.add(moduleIdentifier)
		  }
		}
		// used by ssr in case component is cached and beforeCreate
		// never gets called
		options._ssrRegister = hook
	  } else if (injectStyles) {
		hook = shadowMode
			? function () {
			  injectStyles.call(
				  this,
				  (options.functional ? this.parent : this).$root.$options.shadowRoot
			  )
			}
			: injectStyles
	  }

	  if (hook) {
		if (options.functional) {
		  // for template-only hot-reload because in that case the render fn doesn't
		  // go through the normalizer
		  options._injectStyles = hook
		  // register for functional component in vue file
		  var originalRender = options.render
		  options.render = function renderWithStyleInjection(h, context) {
			hook.call(context)
			return originalRender(h, context)
		  }
		} else {
		  // inject component registration as beforeCreate hook
		  var existing = options.beforeCreate
		  options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
		}
	  }

	  return {
		exports: scriptExports,
		options: options
	  }
	}

	;// CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue





	/* normalize component */
	;
	var component = normalizeComponent(
		components_Dropdownvue_type_script_lang_js_,
		render,
		staticRenderFns,
		false,
		null,
		null,
		null

	)

	/* harmony default export */ const Dropdown = (component.exports);
	;// CONCATENATED MODULE: ./src/javascripts/sections/ProductSection.js
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
	function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
	function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }














	/** @typedef {import('theme-checker/dist/shopify').Variant} Variant */
	/** @typedef {import('theme-checker/dist/shopify').Product} Product */
	/** @typedef {import('theme-checker/dist/shopify').Media} Media */

	const State = {
	  ready: 'ready',
	  soldOut: 'soldOut',
	  added: 'added',
	  unavailable: 'unavailable',
	  adding: 'adding'
	};
	const MOBILE_BREAKPOINT = Breakpoints.xs;
	let ProductForm = (_dec = vue_class_component_esm({
	  components: {
		'bulletproof-dropdown': Dropdown
	  }
	}), _dec2 = Prop({
	  required: true
	}), _dec3 = Prop({
	  required: true
	}), _dec4 = Prop({
	  required: true
	}), _dec5 = Prop({
	  required: true
	}), _dec6 = Prop({
	  required: true
	}), _dec7 = Prop({
	  required: true
	}), _dec8 = Prop({
	  required: true
	}), _dec9 = Prop({
	  required: true
	}), _dec10 = Prop({
	  required: true
	}), _dec11 = Prop({
	  required: true
	}), _dec12 = Prop({
	  required: true
	}), _dec13 = Prop({
	  required: true
	}), _dec14 = Prop({
	  required: true
	}), _dec15 = Prop({
	  required: false
	}), _dec16 = Watch('variant'), _dec17 = Watch('sendAsGift', {
	  deep: true
	}), _dec(_class = (_class2 = class ProductForm extends vue_esm {
	  constructor(...args) {
		super(...args);
		_initializerDefineProperty(this, "initialVariantId", _descriptor, this);
		_initializerDefineProperty(this, "product", _descriptor2, this);
		_initializerDefineProperty(this, "theme", _descriptor3, this);
		_initializerDefineProperty(this, "productSection", _descriptor4, this);
		_initializerDefineProperty(this, "isFeaturedProduct", _descriptor5, this);
		_initializerDefineProperty(this, "thumbnailChangesVariant", _descriptor6, this);
		_initializerDefineProperty(this, "hasThumbnails", _descriptor7, this);
		_initializerDefineProperty(this, "videoLoopEnabled", _descriptor8, this);
		_initializerDefineProperty(this, "sectionId", _descriptor9, this);
		_initializerDefineProperty(this, "cartMethod", _descriptor10, this);
		_initializerDefineProperty(this, "slidesPerView", _descriptor11, this);
		_initializerDefineProperty(this, "giftwrapProductVariantId", _descriptor12, this);
		_initializerDefineProperty(this, "locationsEnabled", _descriptor13, this);
		_initializerDefineProperty(this, "languageUrl", _descriptor14, this);
		this.option1 = '';
		this.option2 = null;
		this.option3 = null;
		this.addingToCart = void 0;
		this.afterAddToCart = void 0;
		this.mediaWrapperSpacing = void 0;
		this.activeMediaId = void 0;
		this.mediaWrapperById = void 0;
		this.showOutOfStockForm = void 0;
		this.isMobile = void 0;
		this.quantity = 1;
		this.hasErrors = void 0;
		this.giftwrapProduct = void 0;
		this.sendAsGift = void 0;
		this.mediaSlider = null;
		this.locationsModal = null;
		this.modalLink = null;
		this.Accessibility = void 0;
		this.hidePaymentButtons = () => {
		  jquery_default()('.shopify-payment-button').hide();
		};
		this.showPaymentButtons = () => {
		  jquery_default()('.shopify-payment-button').show();
		};
	  }
	  data() {
		const variant = this.product.variants.find(v => v.id === this.initialVariantId);
		let media;
		if (variant.featured_media) {
		  media = variant.featured_media;
		} else if (this.product.media && this.product.media.length > 0) {
		  media = this.product.media[0];
		}
		return {
		  option1: variant.option1,
		  option2: variant.option2,
		  option3: variant.option3,
		  addingToCart: false,
		  afterAddToCart: false,
		  mediaWrapperSpacing: '',
		  activeMediaId: media ? media.id : undefined,
		  mediaWrapperById: new Map(),
		  showOutOfStockForm: false,
		  isMobile: window.matchMedia(`only screen and (max-width: ${MOBILE_BREAKPOINT.max}px)`).matches,
		  quantity: 1,
		  hasErrors: '',
		  giftwrapProduct: false,
		  sendAsGift: false,
		  hasLocalPickup: '',
		  locationsModal: null,
		  modalLink: null,
		  Accessibility: null
		};
	  }

	  /** @returns {Variant | null} */
	  get variant() {
		return this.product.variants.find(v => v.option1 === this.option1 && v.option2 == this.option2 && v.option3 === this.option3);
	  }

	  /** @returns {boolean} */
	  get isSale() {
		return this.variant && this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price;
	  }

	  /** @return {State[keyof State]} */
	  get state() {
		if (this.addingToCart) {
		  return State.adding;
		}
		if (this.afterAddToCart) {
		  return State.added;
		}
		if (this.variant) {
		  if (this.variant.available) {
			return State.ready;
		  } else {
			return State.soldOut;
		  }
		} else {
		  return State.unavailable;
		}
	  }

	  /** @returns {boolean} */
	  get addToCartDisabled() {
		return !this.variant || !this.variant.available;
	  }

	  /** @returns {Media | undefined} */
	  get activeMedia() {
		return (this.product.media || []).find(m => m.id === this.activeMediaId);
	  }

	  /** @returns {Media | undefined} */
	  get firstOrActiveModel() {
		if (this.activeMedia && this.activeMedia.media_type === 'model') {
		  return this.activeMedia;
		}
		return (this.product.media || []).find(m => m.media_type === 'model');
	  }
	  increaseQuantity() {
		this.quantity = +this.quantity + 1;
	  }
	  decreaseQuantity() {
		this.quantity = Math.max(1, +this.quantity - 1);
	  }

	  /** @param {number} mediaId */
	  getMedia(mediaId) {
		let media = this.mediaWrapperById.get(mediaId);
		if (!media) {
		  const m = (this.product.media || []).find(m => m.id === mediaId);
		  const target = this.$refs.mediaTargets[m.position - 1];
		  media = new MediaWrapper(this.theme, this.sectionId, m, target);
		  target.addEventListener('media-play', this.onMediaPlay.bind(this));
		  target.addEventListener('media-pause', this.onMediaPause.bind(this));
		  target.addEventListener('media-load', this.onMediaLoaded.bind(this));
		  this.mediaWrapperById.set(mediaId, media);
		}
		return media;
	  }
	  async updateStoreAvailabilityContent(variantId, productTitle) {
		if (!this.locationsEnabled) return;
		const initialContent = this.$el.querySelector('#initialPickupInfo');
		const variantSectionUrl = '/variants/' + variantId + '/?section_id=store-availability';
		const response = await window.fetch(variantSectionUrl);
		const responseText = await response.text();
		let tempDomNode = document.createElement('div');
		tempDomNode.innerHTML = responseText;
		const hasPickupContent = tempDomNode.querySelector('.store-availability-information');
		const pickupHTML = tempDomNode.firstElementChild.innerHTML;
		if (hasPickupContent && initialContent.innerHTML != pickupHTML) {
		  // @ts-ignore
		  initialContent.style.display = 'none';
		  this.hasLocalPickup = pickupHTML;
		} else if (!hasPickupContent) {
		  this.hasLocalPickup = '';
		}
		this.$nextTick(() => {
		  // Write product full title.
		  let productTitleElem = this.$el.querySelector('.store-availabilities-modal__product-title');
		  if (!productTitleElem) return;
		  productTitleElem.textContent = productTitle;

		  // Modal.
		  this.locationsModal = this.$el.querySelector('.store-availabilities-modal');
		  if (!this.locationsModal) return;

		  // Event listeners.
		  this.modalLink = this.$el.querySelector('.store-availability-information__link');
		  if (this.modalLink) this.modalLink.addEventListener('click', this.openLocationsModal);
		  this.modalClose = this.$el.querySelector('.store-availabilities-modal__close');
		  if (this.modalClose) this.modalClose.addEventListener('click', this.closeLocationsModal);

		  // Move modal html out of product info as that can be sticky, causing z-index problems.
		  var parentNode = document.querySelector('#PageContainer');
		  parentNode.insertBefore(this.locationsModal, parentNode.firstChild);
		});
	  }
	  handleLocationsClickOutside(e) {
		if (!e.target.classList.contains('store-availability-information__link') && !this.locationsModal.contains(e.target)) {
		  e.preventDefault();
		  this.closeLocationsModal();
		}
	  }
	  openLocationsModal() {
		document.body.classList.add('js-drawer-location-modal-open');
		this.locationsModal.classList.add('locations-modal--is-active');
		disableBodyScroll(this.locationsModal);
		document.addEventListener('click', this.handleLocationsClickOutside);
		this.Accessibility.trapFocus({
		  container: this.locationsModal,
		  elementToFocus: this.$el.querySelector('.store-availability-information__link')
		});
	  }
	  closeLocationsModal() {
		document.body.classList.remove('js-drawer-location-modal-open');
		this.locationsModal.classList.remove('locations-modal--is-active');
		enableBodyScroll(this.locationsModal);
		document.removeEventListener('click', this.handleLocationsClickOutside);
		this.Accessibility.removeTrapFocus({
		  container: this.locationsModal,
		  elementToFocus: this.$el.querySelector('.store-availability-information__link')
		});
	  }
	  loadSlider() {
		this.mediaSlider = new swiper_esm_bundle(this.$el.querySelector('.swiper-container'), {
		  direction: 'horizontal',
		  slidesPerView: this.slidesPerView,
		  centeredSlides: this.slidesPerView > 1,
		  updateOnImagesReady: true,
		  spaceBetween: 20,
		  threshold: 10,
		  autoHeight: true,
		  pagination: {
			el: '.swiper-pagination',
			clickable: true
		  }
		});
		this.mediaSlider.on('slideChange', () => {
		  if (this.thumbnailChangesVariant) {
			const media = this.product.media[this.mediaSlider.activeIndex];
			this.changeDropdownsToMedia(media);
		  }
		  this.mediaWrapperById.forEach(m => m.pause());
		});
		this.mediaSlider.allowTouchMove = this.isFeaturedProduct || this.isMobile;
		if (this.variant.featured_media) {
		  this.slideTo(this.getMedia(this.variant.featured_media.id), true);
		}
	  }
	  unloadSlider() {
		this.mediaSlider.destroy();
		this.mediaSlider = undefined;
	  }
	  loadPhotoSwipe() {
		const leftArrowSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn"><path d="M13 5L8 10L13 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		const zoomInSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn" id="pswp__icn--zoom-in"><path d="M6.66667 9.16667H9.16667M9.16667 9.16667H11.6667M9.16667 9.16667V6.66667M9.16667 9.16667V11.6667M14.1667 14.1667L17.5 17.5M2.5 9.16667C2.5 10.9348 3.20238 12.6305 4.45262 13.8807C5.70286 15.131 7.39856 15.8333 9.16667 15.8333C10.9348 15.8333 12.6305 15.131 13.8807 13.8807C15.131 12.6305 15.8333 10.9348 15.8333 9.16667C15.8333 7.39856 15.131 5.70286 13.8807 4.45262C12.6305 3.20238 10.9348 2.5 9.16667 2.5C7.39856 2.5 5.70286 3.20238 4.45262 4.45262C3.20238 5.70286 2.5 7.39856 2.5 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		const zoomOutSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn" id="pswp__icn--zoom-out"><path d="M14.1667 14.1667L17.5 17.5M6.66667 9.16667H11.6667M2.5 9.16667C2.5 10.9348 3.20238 12.6305 4.45262 13.8807C5.70286 15.131 7.39856 15.8333 9.16667 15.8333C10.9348 15.8333 12.6305 15.131 13.8807 13.8807C15.131 12.6305 15.8333 10.9348 15.8333 9.16667C15.8333 7.39856 15.131 5.70286 13.8807 4.45262C12.6305 3.20238 10.9348 2.5 9.16667 2.5C7.39856 2.5 5.70286 3.20238 4.45262 4.45262C3.20238 5.70286 2.5 7.39856 2.5 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		const zoomSVGs = zoomInSVG + zoomOutSVG;
		const closeSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn"><path d="M5.63086 14.3692L10 10L14.3692 14.3692M14.3692 5.63086L9.99919 10L5.63086 5.63086" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		const lightbox = new PhotoSwipeLightbox({
		  mainClass: 'pswp--custom-colors',
		  gallery: '.product-images-container .swiper-container',
		  children: 'a',
		  bgOpacity: 1,
		  howAnimationDuration: 200,
		  hideAnimationDuration: 200,
		  arrowPrevSVG: leftArrowSVG,
		  arrowNextSVG: leftArrowSVG,
		  // right arrow is a flipped left arrow
		  zoomSVG: zoomSVGs,
		  // the switch between zoom-in and zoom-out icon happens with .pswp--zoomed-in class
		  closeSVG: closeSVG,
		  pswpModule: PhotoSwipe
		});
		lightbox.on('uiRegister', function () {
		  lightbox.pswp.ui.registerElement({
			name: 'bulletsIndicator',
			className: 'pswp__bullets-indicator',
			appendTo: 'wrapper',
			onInit: (el, pswp) => {
			  const bullets = [];
			  let bullet;
			  let prevIndex = -1;
			  for (let i = 0; i < pswp.getNumItems(); i++) {
				bullet = document.createElement('div');
				bullet.className = 'pswp__bullet';
				bullet.onclick = e => {
				  pswp.goTo(bullets.indexOf(e.target));
				};
				el.appendChild(bullet);
				bullets.push(bullet);
			  }
			  pswp.on('change', a => {
				if (prevIndex >= 0) {
				  bullets[prevIndex].classList.remove('pswp__bullet--active');
				}
				bullets[pswp.currIndex].classList.add('pswp__bullet--active');
				prevIndex = pswp.currIndex;
			  });
			}
		  });
		});

		// forcing slidechange with animation
		lightbox.on('beforeChange', function () {
		  // Add the class 'pswp--animated' to enable the animation
		  lightbox.template.classList.add('pswp--animated');
		});
		lightbox.on('change', () => {
		  if (!this.mediaSlider) return;
		  const {
			pswp
		  } = lightbox;
		  this.mediaSlider.slideTo(pswp.currIndex, 0);
		});
		lightbox.init();
	  }
	  get hasSlider() {
		return this.isFeaturedProduct || this.isMobile;
	  }
	  get showThumbails() {
		return !this.isFeaturedProduct && this.hasThumbnails && !this.isMobile;
	  }
	  initApps() {
		let appBlocks = document.querySelectorAll('.shopify-app-block');
		if (appBlocks.length > 0) {
		  appBlocks.forEach((element, index) => {
			let blockId = document.querySelector(`form #${element.id}`);
			if (blockId) {
			  let appContent = document.querySelector(`.shopify-app-block#${blockId.id}`);
			  let getContent = appContent.parentElement.removeChild(appContent);
			  blockId.append(getContent);
			}
		  });
		}
	  }
	  initSizeGuide() {
		const handleSizeGuideClick = e => {
		  e.preventDefault();
		  this.theme.toggleRightDrawer('page', true, {
			url: e.currentTarget.href
		  });
		};
		let sizeGuideEl = document.querySelector('#size-guide-link');
		sizeGuideEl?.addEventListener('click', handleSizeGuideClick);
	  }
	  initReviewsRatingLink() {
		const ratingLink = /** @type {HTMLElement} */this.$el.querySelector('[data-reviews-link]');
		const reviewsSection = document.querySelector('#shopify-product-reviews');
		if (!ratingLink || !reviewsSection) return;
		ratingLink.setAttribute('role', 'link');
		ratingLink.setAttribute('tabindex', '0');
		ratingLink.style.cursor = 'pointer';
		ratingLink.addEventListener('click', () => {
		  reviewsSection.scrollIntoView({
			behavior: 'smooth'
		  });
		});
		ratingLink.addEventListener('keydown', e => {
		  if (e.key === 'Enter') {
			reviewsSection.scrollIntoView({
			  behavior: 'smooth'
			});
		  }
		});
	  }
	  mounted() {
		this.initApps();
		this.initSizeGuide();
		this.initReviewsRatingLink();
		let qtyNoscript = this.$el.querySelector('.quantity-noscript');
		let jsQtyNum = this.$el.querySelector('.js-qty__num');
		if (qtyNoscript) {
		  qtyNoscript.setAttribute('name', 'no-js-quantity');
		}
		if (jsQtyNum) {
		  jsQtyNum.setAttribute('name', 'quantity');
		}
		this.$el.querySelector('#AddToCartForm').addEventListener('submit', this.onAddToCart);
		this.mediaWrapperById = new Map();
		this.Accessibility = new Accessibility();
		if (this.showThumbails || this.hasSlider) {
		  this.loadSlider();
		}
		this.loadPhotoSwipe();
		this.updateStoreAvailabilityContent(this.variant.id, this.product.title);
		this.$el.addEventListener('product-media-select', this.onMediaSelect.bind(this));
		if (this.firstOrActiveModel) {
		  // We have at least one model => load XR library so
		  // it can show/hide the button based on browser/device support
		  window.Shopify.loadFeatures([{
			name: 'shopify-xr',
			version: '1.0'
		  }]);
		  document.addEventListener('shopify_xr_launch', () => {
			// The launch of XR viewer triggers beforeload event, we need to reappear page content
			setTimeout(() => {
			  document.body.classList.remove('unloading');
			}, 100);
		  });
		}
		window.ShopifyXR = window.ShopifyXR || function () {
		  (window.ShopifyXR.q = window.ShopifyXR.q || []).push(arguments);
		};
		const models = (this.product.media || []).filter(m => m.media_type === 'model');
		if (window.ShopifyXR.addModels) {
		  window.ShopifyXR.addModels(models);
		} else {
		  window.ShopifyXR('addModels', models);
		}
		this.giftCardRecipientsFieldsForm = /** @type {HTMLElement} */this.$el.querySelector('.gift-card--recipient-form-wrapper');
		this.giftCardRecipientsFields = /** @type {NodeListOf<HTMLInputElement>} */this.giftCardRecipientsFieldsForm ? this.giftCardRecipientsFieldsForm.querySelectorAll('[name*="properties"]') : [];
	  }
	  onVariantChange() {
		if (this.variant) {
		  if (!this.variant.available) {
			this.showOutOfStockForm = false;
			this.hidePaymentButtons();
		  } else {
			this.showPaymentButtons();
		  }
		  this.setVariantUrl(this.variant);
		  this.updateStoreAvailabilityContent(this.variant.id, this.product.title);
		  const stockLevelIndicatorEl = this.$el.querySelector('stock-level-indicator');
		  if (stockLevelIndicatorEl) this.updateStockLevelIndicator(stockLevelIndicatorEl, this.variant.id);
		  if (this.variant.featured_media) {
			const mediaElement = this.$el.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`);
			this.onMediaElementSelect(mediaElement, {
			  load: true
			});
		  }

		  // Ensure the change event is fired on the form when variants changed (for Shop Pay Installments)
		  const self = this;
		  this.addToCartForm = this.$el.querySelector('#AddToCartForm');
		  this.$nextTick(() => {
			const event = new Event('change');
			self.addToCartForm.dispatchEvent(event);
		  });
		} else {
		  this.hidePaymentButtons();
		}

		// Dispatch variant:changed event for other components to listen to
		const variantChangedEvent = new CustomEvent('variant:changed', {
		  detail: {
			variant: this.variant,
			product: this.product
		  }
		});
		this.$el.dispatchEvent(variantChangedEvent);
	  }
	  onShowOutOfStockForm(e) {
		e.preventDefault();
		// When the HERE button is clicked, the target is whole text
		if (e.currentTarget.contains(e.target.closest('a'))) {
		  this.showOutOfStockForm = true;
		}
	  }
	  onMediaPlay(e) {
		if (this.mediaSlider) {
		  // Stop swiper swipe gestures, video is playing.
		  this.mediaSlider.allowTouchMove = false;

		  // There may be a difference between the poster image
		  // and the video aspect ratio. Update height.
		  this.mediaSlider.updateAutoHeight();
		}
	  }
	  onMediaPause(e) {
		if (this.mediaSlider) {
		  // Restarts swiper swipe gestures, video isn't playing.
		  this.mediaSlider.allowTouchMove = true;
		}
	  }
	  onMediaLoaded(e) {
		e.detail.parent.querySelector('.product-medias__media').addEventListener('click', this.onMediaActivate.bind(this));
	  }
	  onMediaSelect(e) {
		const element = /** @type {HTMLElement} */jquery_default()(this.$el).find('.product-single__media')[e.detail.index];
		const mediaWrapper = this.mediaWrapperById.get(parseInt(element.dataset.mediaId, 10));
		const isVideo = mediaWrapper.media.media_type === 'video' || mediaWrapper.media.media_type === 'external_video';
		const isQuickShop = this.$el.closest('#ShopNowContainer');
		this.onMediaElementSelect(element, {
		  load: e.detail.forceLoad,
		  forcePlay: e.detail.forcePlay || !this.isMobile && !isQuickShop && isVideo,
		  // Autoplay video on non-mobile and not in quick shop
		  focus: e.detail.focus
		});
	  }

	  /** @param {KeyboardEvent} e */
	  onMediaActivate(e) {
		const target = /** @type {HTMLElement} */e.target;
		const currentTarget = /** @type {HTMLElement} */e.currentTarget;
		if (e.type === 'keydown') {
		  if (e.keyCode !== 13 && e.keyCode !== 27) {
			return;
		  }
		  if (target.classList.contains('shopify-model-viewer-ui__button') || target.classList.contains('plyr__controls__item')) {
			return;
		  }
		}
		e.preventDefault();
		if (target.classList.contains('product-medias__view-in-space')) {
		  // Don't do anything on "view in your space" click, it's handled by Shopify XR library.
		  return;
		}
		if (target.tagName === 'MODEL-VIEWER' || target.classList.contains('shopify-model-viewer-ui__controls-overlay')) {
		  // Don't do anything on 3d model overlay click, it will trigger an event itself.
		  return;
		}
		const isLoaded = currentTarget.classList.contains('product-single__media--loaded');
		const isActive = currentTarget.classList.contains('product-single__media--active');
		if (this.hasThumbnails) {
		  this.onThumbnailClick(currentTarget);
		}
		if (isLoaded && isActive) {
		  // Loaded and active media will handle click internally in the component itself.
		  return;
		}
		this.onMediaElementSelect(currentTarget, {
		  load: true,
		  togglePlay: true
		});
	  }
	  onMediaElementSelect(element, options) {
		if (!element) {
		  return;
		}
		const mediaWrapper = this.getMedia(parseInt(element.dataset.mediaId, 10));
		this.activeMediaId = mediaWrapper.media.id;
		this.slideTo(mediaWrapper);

		// Pause all others
		this.mediaWrapperById.forEach(otherMediaWrapper => {
		  if (otherMediaWrapper.mediaId !== mediaWrapper.mediaId) {
			otherMediaWrapper.pause();
		  }
		});
		jquery_default()(this.$el).find('.product-single__media--selected').not(element).removeClass('product-single__media--selected');
		element.classList.add('product-single__media--selected');
		if (options.togglePlay) {
		  mediaWrapper.togglePlay();
		} else if (options.forcePlay) {
		  mediaWrapper.play();
		} else if (options.load) {
		  mediaWrapper.load();
		}
		if (options.focus) {
		  mediaWrapper.focus();
		}
	  }
	  async onAddToCart(e) {
		e.preventDefault();
		this.addingToCart = true;
		this.hasErrors = '';
		try {
		  const data = jquery_default()(this.$el.querySelector('#AddToCartForm')).serialize();
		  const $formContainer = jquery_default()(this.$el.querySelector('#AddToCartForm'));
		  let giftwrapProperty = '';
		  if (this.giftwrapProduct && this.giftwrapProductVariantId) {
			giftwrapProperty = '&properties[' + this.theme.translations.giftwrap_label + ']=' + this.theme.translations.yes;
		  }

		  // Gift wrap add to cart.
		  if (this.giftwrapProduct && this.giftwrapProductVariantId) {
			const giftData = {
			  items: [{
				id: this.giftwrapProductVariantId,
				quantity: this.quantity
			  }]
			};
			const giftResponse = await window.fetch('/cart/add.js', {
			  method: 'POST',
			  credentials: 'same-origin',
			  headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			  },
			  body: JSON.stringify(giftData)
			});
			const giftResponse1 = await giftResponse.json();
			if (!giftResponse.ok) {
			  if (giftResponse1.status == 422) {
				this.hasErrors = giftResponse1.description;
			  }
			  this.addingToCart = false;
			  return;
			}
		  }

		  // 'Actual' product add to cart.
		  const response = await window.fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
			  'Content-Type': 'application/x-www-form-urlencoded',
			  'X-Requested-With': 'XMLHttpRequest'
			},
			body: data + giftwrapProperty
		  });
		  const response1 = await response.json();
		  if (!response.ok) {
			// Handle various errors, quantity etc.
			// See: https://shopify.dev/docs/themes/ajax-api/reference/cart
			if (response1.status == 422) {
			  this.hasErrors = response1.description;
			}
			this.addingToCart = false;
			return;
		  }
		  const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
		  const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
		  if (!response2.ok) {
			// FIXME: error handling
			this.addingToCart = false;
			return;
		  }
		  const cart = await response2.json();
		  const featuredProductSubmit = this.$el.querySelector('[data-submit-type]');
		  this.addingToCart = false;
		  var cartBtn = /** @type {HTMLElement} */document.querySelector('#AddToCart');
		  var cartURL = cartBtn.dataset.cartUrl;
		  if (this.cartMethod === 'drawer' && !featuredProductSubmit) {
			this.theme.toggleRightDrawer('cart', true, {
			  cart: cart
			});
			if (this.giftCardRecipientsFieldsForm) this.giftProductFormOnAddToCart();
		  } else if (this.cartMethod === 'added' && !featuredProductSubmit) {
			this.afterAddToCart = true;
			setTimeout(() => {
			  this.afterAddToCart = false;
			}, 2000);
			this.theme.updateCartDrawer(cart);
			if (this.giftCardRecipientsFieldsForm) this.giftProductFormOnAddToCart();
		  } else if (this.cartMethod === 'page' || featuredProductSubmit) {
			window.location.href = cartURL;
		  }
		} catch (e) {
		  console.error('Unable to add to cart: ', e);
		  // FIXME error handling
		}
	  }

	  giftProductFormOnAddToCart() {
		if (!this.sendAsGift) return;
		if (!this.giftCardRecipientsFieldsForm) return;
		this.emptyGiftPropductFormFields();
		this.toggleGiftCardRecipientFormVisibility(true);
		this.sendAsGift = false;
	  }
	  emptyGiftPropductFormFields() {
		this.giftCardRecipientsFields.forEach(input => input.value = '');
	  }
	  toggleGiftCardRecipientFormVisibility(visible) {
		this.giftCardRecipientsFields.forEach(input => visible ? input.disabled = true : input.disabled = false);
		this.giftCardRecipientsFieldsForm.style.display = visible ? 'none' : 'flex';
	  }
	  onSendAsGiftChange(newVal, oldVal) {
		if (!this.giftCardRecipientsFieldsForm) return;
		this.toggleGiftCardRecipientFormVisibility(oldVal);
		this.sendAsGift = newVal;
	  }
	  onThumbnailClick(target) {
		const mediaWrapper = this.getMedia(parseInt(target.dataset.mediaId, 10));
		this.slideTo(mediaWrapper);
		this.changeDropdownsToMedia(mediaWrapper.media);
	  }
	  slideTo(mediaWrapper, skipAnimation = false) {
		if (this.mediaSlider) {
		  this.mediaSlider.slideTo(mediaWrapper.media.position - 1, this.hasSlider && !skipAnimation ? 200 : 0);
		}
	  }
	  changeDropdownsToMedia(media) {
		// select variant
		if (this.thumbnailChangesVariant) {
		  const variant = this.product.variants.find(v => v.featured_media && v.featured_media.id === media.id);
		  if (variant) {
			this.option1 = variant.option1;
			this.option2 = variant.option2;
			this.option3 = variant.option3;
			const variantChangedEvent = new CustomEvent('variant:changed', {
			  detail: {
				variant: variant,
				product: this.product
			  }
			});
			this.$el.dispatchEvent(variantChangedEvent);
		  }
		}
	  }
	  setVariantOption(value, name) {
		this[`option${name}`] = value;
	  }

	  /** @param {Variant} variant */
	  setVariantUrl(variant) {
		const hasMoreVariants = this.product.variants.length > 1;
		if (history.replaceState && !this.isFeaturedProduct && hasMoreVariants) {
		  // Change url to include variant if we're not on homepage
		  let search = [];
		  if (window.location.search.length > 1) {
			// select non-variant query params
			search = window.location.search.slice(1).split('&').filter(q => {
			  return q.indexOf('variant=') !== 0;
			});
		  }
		  // add current variant
		  search.push('variant=' + variant.id);

		  // set the url to include the variant
		  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + search.join('&');
		  window.history.replaceState({
			path: newurl
		  }, '', newurl);
		}
	  }
	  updateStockLevelIndicator(stockLevelIndicator, variantId) {
		stockLevelIndicator.setAttribute('data-flow-variant-id', variantId);
	  }
	  /** @returns {string} */
	  money(price) {
		return this.theme.formatMoney(price);
	  }
	  onWindowResizeBreakpoint({
								 breakpoint,
								 oldBreakpoint
							   }) {
		const newIsMobile = breakpoint.order <= MOBILE_BREAKPOINT.order;
		const oldWasMobile = oldBreakpoint.order <= MOBILE_BREAKPOINT.order;
		if (newIsMobile !== oldWasMobile) {
		  this.isMobile = newIsMobile;
		  if (this.mediaSlider) {
			this.mediaSlider.allowTouchMove = this.hasSlider;
		  }
		  if (!this.hasThumbnails) {
			if (this.hasSlider && !this.mediaSlider) {
			  this.loadSlider();
			} else if (!this.hasSlider && this.mediaSlider) {
			  this.unloadSlider();
			}
		  }
		}
	  }
	}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "initialVariantId", [_dec2], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "product", [_dec3], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "theme", [_dec4], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "productSection", [_dec5], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isFeaturedProduct", [_dec6], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "thumbnailChangesVariant", [_dec7], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "hasThumbnails", [_dec8], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "videoLoopEnabled", [_dec9], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "sectionId", [_dec10], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "cartMethod", [_dec11], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "slidesPerView", [_dec12], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "giftwrapProductVariantId", [_dec13], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "locationsEnabled", [_dec14], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "languageUrl", [_dec15], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), _applyDecoratedDescriptor(_class2.prototype, "onVariantChange", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "onVariantChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSendAsGiftChange", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "onSendAsGiftChange"), _class2.prototype)), _class2)) || _class);
	class ProductSection extends Section {
	  constructor(theme, _element, pageLoad, options = {}) {
		super(theme, _element, pageLoad);
		this.fixSticky = () => {
		  const productStickyElements = /** @type {NodeListOf<HTMLElement>} */this.element.querySelectorAll('.product-sticky');
		  const headerSticky = document.querySelector('.sticky-header');
		  if (productStickyElements && headerSticky) {
			productStickyElements.forEach(element => {
			  element.style.top = `${headerSticky.clientHeight}px`;
			});
		  }
		};
		this.onWindowResize = () => {
		  this.fixSticky();
		  this.loadReadmore();
		};
		this.onWindowResizeBreakpoint = ({
										   breakpoint,
										   oldBreakpoint
										 }) => {
		  if (!this.vue) {
			// Product was not selected => no vue
			return;
		  }
		  /** @type {ProductForm} */this.vue.$children[0].onWindowResizeBreakpoint({
			breakpoint,
			oldBreakpoint
		  });
		};
		this.loadReadmore = () => {
		  const readMoreEls = document.querySelectorAll('.product-description.readmore');
		  if (!readMoreEls) return;
		  let thisHeight = 100;
		  if (this.element.querySelector('.product-description_full-width')) {
			thisHeight = 150;
			if (this.theme.getWindowWidth() <= 768) {
			  thisHeight = 100;
			}
		  }
		  readMoreEls.forEach(readMoreEl => {
			if (!readMoreEl.classList.contains('rmjs-1')) {
			  this.readMore = new readmore_es6(readMoreEl, {
				speed: 100,
				collapsedHeight: thisHeight,
				moreLink: `<div class="read-more-link">
                      <div class="read-more-less--content nav-link-animated--custom">
                        <a href="#" class="animated-link--item">${this.theme.translations.read_more_html}</a>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </div>
                    </div>`,
				lessLink: `<div class="read-less-link nav-link-animated--custom">
                      <div class="read-more-less--content nav-link-animated--custom">
                        <a href="#" class="animated-link--item">${this.theme.translations.read_less_html}</a>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M5.5 12.5L10.5 7.5L15.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </div>
                    </div>`,
				beforeToggle: function (trigger, element, expanded) {
				  if (expanded) {
					const headerEl = document.querySelector('.sticky-header');
					const stickyHeaderHeight = headerEl ? headerEl.clientHeight : 0;
					jquery_default()('html, body').animate({
					  scrollTop: jquery_default()(element).offset().top - stickyHeaderHeight
					}, 100);
				  }
				  jquery_default()(element).toggleClass('closed');
				}
			  });
			}
		  });
		};
		this.loadTabs = () => {
		  jquery_default()(this.element).find('ul.tabs').each(function () {
			var active,
				content,
				links = jquery_default()(this).find('a');
			active = links.first().addClass('active');
			content = jquery_default()(active.attr('href'));
			links.not(':first').each(function () {
			  jquery_default()(jquery_default()(this).attr('href')).hide();
			});
			jquery_default()(this).find('a').click(function (e) {
			  active.removeClass('active');
			  content.hide();
			  active = jquery_default()(this);
			  content = jquery_default()(jquery_default()(this).attr('href'));
			  active.addClass('active');
			  content.fadeIn();
			  return false;
			});
		  });
		};
		this.scrollToPostedForm = () => {
		  if (jquery_default()('.out-of-stock-form .posted-successfully').length) {
			jquery_default()('html, body').animate({
			  scrollTop: jquery_default()('.form-vertical').offset().top
			}, 100);
		  }
		};
		var product_json_el = this.element.querySelector('.product-json');
		if (!product_json_el) {
		  // No product on the page - maybe just product placeholder
		  return;
		}
		this.product = JSON.parse(product_json_el.textContent);
		this.vue = new vue_esm({
		  el: this.element.querySelector('.product-form-vue'),
		  components: {
			'bulletproof-product-form': ProductForm
		  },
		  data: () => ({
			productSection: this,
			product: this.product,
			theme: this.theme,
			isFeaturedProduct: this.isFeaturedProduct,
			slidesPerView: options ? options.slidesPerView || 1 : 1
		  })
		});
		this.fixSticky();
		this.loadReadmore();
		this.loadTabs();
		this.scrollToPostedForm();
		document.addEventListener('shopify:block:select', this.loadReadmore);
		document.addEventListener('shopify:section:select', this.loadReadmore);
	  }
	  get isFeaturedProduct() {
		return false;
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/FeaturedProduct.js

	class FeaturedProduct extends ProductSection {
	  get isFeaturedProduct() {
		return true;
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/MapSection.js




	class MapSection extends Section {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   * @param {boolean} pageLoad
	   */
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.onAuthError = e => {
		  this.showError(e.detail.reason);
		};
		this.showError = message => {
		  const container = this.element.querySelector('.map-section__container');
		  container.classList.add('hide');
		  if (window.Shopify.designMode) {
			jquery_default()('<div class="map-container-error"></div>').text(message).appendTo(container.parentElement.querySelector('.map-section__overlay'));
		  }
		  container.parentElement.querySelector('.homepage-map--fallback').classList.remove('hide');
		};
		this.onLoad = maps => {
		  this.mapsApi = maps;
		  const config = {
			zoom: 14
		  };
		  let style = [];
		  try {
			const mapThemeElem = this.element.querySelector('.map-theme');
			if (mapThemeElem) {
			  style = JSON.parse(mapThemeElem.textContent);
			}
		  } catch (e) {
			console.error('Unable to parse theme style:', e);
		  }
		  const container = /** @type {HTMLElement} */this.element.querySelector('.map-section__container');
		  if (!container) {
			return;
		  }
		  this.geocoder = new maps.Geocoder();
		  this.geocoder.geocode({
			'address': this.address
		  }, (results, status) => {
			if (status === 'OK') {
			  /**
			   * @typedef {import('../window').GoogleMap} GoogleMap
			   *
			   */
			  this.map = /** @type {GoogleMap} */new maps.Map(container, {
				zoom: config.zoom,
				styles: style,
				disableDefaultUI: true,
				draggable: false,
				clickableIcons: false,
				scrollwheel: false,
				disableDoubleClickZoom: true,
				draggableCursor: 'default'
			  });
			  this.mapsApi.event.addListener(this.map, "projection_changed", () => {
				this.centerMap();
				if (this.contentBox) {
				  // Center map when content box is resized
				  // works as windiw resize observer as well since the content box has relative width

				  // @ts-ignore
				  new ResizeObserver(this.centerMap).observe(this.contentBox);
				} else {
				  // Center map when screensize is changed
				  // redundant if content box resize observer is active
				  window.addEventListener('resize', this.centerMap);
				}
			  });

			  /**
			   *
			   * @typedef {import('../window').GoogleMapsMarker} GoogleMapsMarkerType
			   */
			  this.marker = /** @type {GoogleMapsMarkerType} */new maps.Marker({
				map: this.map,
				position: results[0].geometry.location
			  });
			} else {
			  this.showError('Error looking up that address');
			}
		  });
		};
		this.offsetCenter = (offsetX, offsetY) => {
		  // offsetX is the distance you want that point to move to the right, in pixels
		  // offsetY is the distance you want that point to move upwards, in pixels
		  // offset values can be negative

		  const markerPosition = this.marker.getPosition();
		  const scale = Math.pow(2, this.map.getZoom());
		  const mapProjection = this.map.getProjection();
		  const worldCoordinateCenter = mapProjection.fromLatLngToPoint(markerPosition);
		  const pixelOffset = new this.mapsApi.Point(offsetX / scale || 0, offsetY / scale || 0);
		  const worldCoordinateNewCenter = new this.mapsApi.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
		  const newCenter = mapProjection.fromPointToLatLng(worldCoordinateNewCenter);
		  this.map.setCenter(newCenter);
		};
		this.centerMap = () => {
		  if (!this.map) return;
		  if (this.contentBox) {
			const totalContentBoxWidth = this.contentBox.offsetWidth + this.contentBoxMargin;
			const totalContentBoxHeight = this.contentBox.offsetHeight + this.contentBoxMargin;
			if (window.innerWidth > 767) {
			  if (this.contentBoxAllignment === 'left') {
				this.offsetCenter(totalContentBoxWidth / 2, 0);
			  } else {
				this.offsetCenter(-(totalContentBoxWidth / 2), 0);
			  }
			} else {
			  this.offsetCenter(0, -(totalContentBoxHeight / 2));
			}
		  } else {
			this.map.setCenter(this.marker.getPosition());
		  }
		};
		this.mapsApi = null;
		this.mapElement = /** @type {HTMLElement} */element.querySelector('.map-wrapper');
		this.contentBox = /** @type {HTMLElement} */element.querySelector('.homepage-map-content-box');
		if (this.contentBox) {
		  this.contentBoxAllignment = this.element.dataset.mapsAlignment === 'right' ? 'left' : 'right';
		  this.contentBoxMargin = parseInt(window.getComputedStyle(this.contentBox).getPropertyValue(`margin-${this.contentBoxAllignment}`));
		}
		this.apiKey = this.element.dataset.mapsApikey;
		this.address = this.element.dataset.mapsAddress;
		if (!this.apiKey || !this.address) return;
		theme.loadGoogleMapApi(this.apiKey).then(this.onLoad).catch(this.showError);
		document.body.addEventListener('google-maps-auth-failure', this.onAuthError);

		this.parallax = new Parallax_Parallax(theme, element);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/Pagination.js



	/** Pagination logic (Infinite scrolling and Load more button) */
	class Pagination_Pagination extends Component {
	  // how many pixels from bottom should next page start loading

	  // how often should the scroll position should be checked (in milliseconds)

	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   */
	  constructor(theme, element, loadedCallback1, loadedCallback2) {
		super(theme, element);
		this.PAGINATION_LOAD_OFFSET = 1200;
		this.SCROLL_DELAY = 200;
		this.PAGINATION_SELECTOR = '.pagination';
		this.COLLECTION_WRAPPER_SELECTOR = '#CollectionProductGrid';
		this.COLLECTION_MAIN_SELECTOR = '.collection-main-body-inner';
		this.COLLECTION_HEADER_SELECTOR = '.collection-main-central-header';
		this.COLLECTION_ITEM_SELECTOR = '.grid__item';
		this.COLLECTION_ITEM_EXCLUDE_SELECTOR = '.collection-central-description-block';
		this.initialize = () => {
		  if (jquery_default()('.pagination').hasClass('pagination-infinite')) {
			this.pagination_type = 'infinite-scroll';
		  } else if (jquery_default()('.pagination').hasClass('pagination--load-more')) {
			this.pagination_type = 'load-more';
			this.load_more_button();
		  }
		  this.execCallbacks();
		};
		this.execCallbacks = () => {
		  if (this.loadedCallback1) {
			this.loadedCallback1();
		  }
		  if (this.loadedCallback2) {
			this.loadedCallback2();
		  }
		};
		this.onWindowScroll = () => {
		  this.$wrapper = jquery_default()(this.COLLECTION_WRAPPER_SELECTOR);
		  if (this.pagination_type !== 'infinite-scroll') {
			return;
		  }
		  var height = this.$wrapper.position().top + this.$wrapper.height();
		  if (height - this.PAGINATION_LOAD_OFFSET < this.$doc.scrollTop() + this.$w.height()) {
			this.load_next_page();
		  }
		};
		this.check_pagination_progress = () => {
		  var next_url = jquery_default()(this.PAGINATION_SELECTOR).find('.pagination-next a').attr('href');
		  this.fully_loaded = !next_url || next_url === '#';
		};
		this.build_load_more_html = function () {
		  var totalItems = parseInt(jquery_default()('.pagination').attr('data-paginate-items'), 10);
		  var currentOffset = parseInt(jquery_default()('.pagination').attr('data-paginate-offset'), 10);
		  var pageSize = parseInt(jquery_default()('.pagination').attr('data-paginate-size'), 10);
		  var totalViewed = currentOffset + pageSize;
		  var progressPercentage = 100 * totalViewed / totalItems;
		  if (this.theme.translations.youve_viewed !== undefined) {
			var youViewed = this.theme.translations.youve_viewed.replace('{{ x }}', totalViewed).replace('{{ y }}', totalItems);
		  } else {
			youViewed = "";
		  }
		  var buttonHtml = '<div class="pagination__load-more">' + `<p class="pagination__progress-text">${youViewed}</p>` + '<div class="progress-bar"><div class="progress-bar__inner" style="width:' + progressPercentage + '%;"></div></div>' + `<button class="btn btn--large btn--load-more">${this.theme.translations.load_more}</button>` + '</div>';
		  return buttonHtml;
		};
		this.load_more_button = function () {
		  this.check_pagination_progress();

		  // Check if Load More button already on page
		  var buttonAppended = jquery_default()('.pagination .btn--load-more').length !== 0;

		  // Build Button html
		  var buttonHtml = this.build_load_more_html();

		  // If button not on page and more results are available, display button
		  if (!buttonAppended && !this.fully_loaded) {
			jquery_default()('.pagination').append(buttonHtml);
		  }

		  // If button clicked, load next page
		  jquery_default()('.btn--load-more').off('click').on('click', this.load_next_page.bind(this.$self));
		};
		this.set_loading = loading => {
		  if (loading) {
			this.loading = true;
			this.$loading_indicator.show();
			jquery_default()(this.PAGINATION_SELECTOR).hide();
		  } else {
			this.loading = false;
			this.$loading_indicator.hide();
			jquery_default()(this.PAGINATION_SELECTOR).show();
		  }
		};
		this.load_next_page = () => {
		  if (this.loading) {
			return false;
		  }
		  var next_url = jquery_default()(this.PAGINATION_SELECTOR).find('.pagination-next a').attr('href');
		  if (!next_url || next_url === '#') {
			return;
		  }
		  this.set_loading(true);
		  jquery_default().ajax({
			type: 'GET',
			url: next_url,
			dataType: "html"
		  }).then(this.page_loaded.bind(this)).always(this.set_loading.bind(this, false));

		  // let newUrlIS =  window.location.origin + next_url;
		  // history.pushState({}, null, newUrlIS);
		};
		this.scroll_position_history = () => {
		  var pathName = document.location.pathname;
		  window.onbeforeunload = function () {
			var htmlContent = document.querySelector('.collection-main-body-inner').innerHTML;
			var paginationContent = document.querySelector('.pagination').innerHTML;
			sessionStorage.setItem('pagePosition_' + pathName, htmlContent.toString());
			sessionStorage.setItem('pagePagination_' + pathName, paginationContent.toString());
		  };
		  if (performance.navigation.type == 2 && sessionStorage['pagePosition_' + pathName]) {
			var htmlContentContainer = document.querySelector('.collection-main-body-inner');
			htmlContentContainer.innerHTML = sessionStorage.getItem('pagePosition_' + pathName);
		  }
		  if (performance.navigation.type == 2 && sessionStorage['pagePagination_' + pathName]) {
			var paginationContainer = document.querySelector('.pagination');
			paginationContainer.innerHTML = sessionStorage.getItem('pagePagination_' + pathName);
		  }
		};
		this.page_loaded = data => {
		  var data_dom = jquery_default()(data);
		  var classes = /** @type {string} */jquery_default()('#grid_item_width_classes').val();
		  if (classes) {
			data_dom.find('.grid__item').removeClass('large--one-quarter medium--one-quarter small--one-whole large--one-half medium--one-half').addClass(classes);
		  }
		  this.$collection.append(data_dom.find(this.COLLECTION_HEADER_SELECTOR + ' > ' + this.COLLECTION_ITEM_SELECTOR).not(this.COLLECTION_ITEM_EXCLUDE_SELECTOR), data_dom.find(this.COLLECTION_MAIN_SELECTOR + ' > ' + this.COLLECTION_ITEM_SELECTOR));
		  jquery_default()(this.PAGINATION_SELECTOR).replaceWith(data_dom.find(this.PAGINATION_SELECTOR));

		  // If "load more" enabled, run function to conditionally render button on newly-loaded page
		  if (this.pagination_type === 'load-more') {
			this.load_more_button();
		  }
		  this.execCallbacks();
		};
		this.loadedCallback1 = loadedCallback1;
		this.loadedCallback2 = loadedCallback2;
		this.$w = jquery_default()(window);
		this.$doc = jquery_default()(document);
		this.$self = this;
		this.$collection = jquery_default()(this.COLLECTION_MAIN_SELECTOR);
		this.$wrapper = jquery_default()(this.COLLECTION_WRAPPER_SELECTOR);
		this.$loading_indicator = jquery_default()('.pagination-loading');
		this.loading = false;
		this.fully_loaded = false;
		this.scroll_timeout = null;
		this.pagination_type = null;

		// If neither "infinite scrolling" nor "load more" are enabled, end function here
		const $pagination_infinite = jquery_default()('.pagination-infinite');
		const $pagination_load_more = jquery_default()('.pagination--load-more');
		this.initialize();
		if ($pagination_infinite.length > 0 || $pagination_load_more.length > 0) {
		  this.scroll_position_history();
		}
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/CollectionSection.js





	class CollectionSection extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.initParallax = () => {
		  // collection image is outside of main div, need to call it on parent
		  this.parallax = new Parallax_Parallax(this.theme, this.element.parentNode);
		};
		this.initPagination = () => {
		  this.pagination = new Pagination_Pagination(this.theme, this.element, this.loadShopNow, this.loadQuickAdd);
		};
		this.loadShopNow = () => {
		  Array.prototype.forEach.call(this.element.querySelectorAll('.shop-now-button, .quick-add-button-variants'), el => {
			el.removeEventListener('click', this.handleShopNow);
			el.addEventListener('click', this.handleShopNow);
		  });
		  this.theme.addBadges(this.element, 1000);
		};
		this.loadQuickAdd = () => {
		  this.quickAddButtons = new QuickAdd(this.theme, this.element);
		};
		this.loadTagFilter = () => {
		  /* Product Tag Filters - Good for any number of filters on any type of collection pages */
		  var collFilters = jquery_default()('.coll-filter');
		  collFilters.on('change', function () {
			var newTags = [];
			var val = jquery_default()(this).val();
			if (val) {
			  newTags.push(val);
			}
			if (newTags.length) {
			  var query = newTags.join('+');
			  var link = jquery_default()('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
			  window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + query + '$2');
			} else {
			  window.location.href = jquery_default()('#link-to-collection').val().toString();
			}
		  });
		  jquery_default()('.collection-filter-tag-checkbox').on('change', function () {
			var filter = Array.prototype.map.call(document.querySelectorAll('input.collection-filter-tag-checkbox:checked'), function (el) {
			  return el.value;
			}).join('+');
			var link = jquery_default()('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
			window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + filter + '$2');
		  });
		};
		this.loadSortBy = () => {
		  const queryParams = {};
		  if (location.search.length) {
			for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
			  aKeyValue = aCouples[i].split('=');
			  if (aKeyValue.length > 1) {
				queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
			  }
			}
		  }
		  jquery_default()('.coll-sort-by').val('{{ collection.sort_by | default: collection.default_sort_by | escape }}');
		  jquery_default()('.coll-sort-by,.collection-sort-by-radio').on('change', function () {
			queryParams.sort_by = jquery_default()(this).val();
			location.search = jquery_default().param(queryParams).replace(/\+/g, '%20');
		  });
		};
		this.handleShopNow = e => {
		  e.preventDefault();
		  this.theme.toggleRightDrawer('shop-now', true, {
			url: e.currentTarget.href
		  });
		};
		this.isMobile = () => {
		  return window.matchMedia('(max-width: 1023px)').matches;
		};
		this.element = element;
		this.theme = theme;
		this.loadTagFilter();
		this.loadSortBy();
		this.initPagination();
		this.loadShopNow();
		this.loadQuickAdd();
		this.initParallax();
		this.theme.addBadges(this.element, 1000);
		document.addEventListener('shopify:section:load', () => {
		  this.initParallax();
		});
		document.addEventListener('paginate', this.initPagination);
		document.addEventListener('shopify:section:select', this.initParallax);
		document.addEventListener('shopify:section:deselect', this.initParallax);
		document.addEventListener('shopify:section:reorder', this.initParallax);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/CollectionListSection.js



	class CollectionListSection extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.parallax = new Parallax_Parallax(theme, element.parentNode);
		this.quickAddButtons = new QuickAdd(theme, element);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/RichText.js

	class RichText extends Section {}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Testimonials.js

	class Testimonails extends Section {}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Blog.js


	class Blog extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);

	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/TextAdverts.js


	class TextAdverts extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		const swiperContainer = this.element.querySelector('.swiper-container');
		this.swiper = new swiper_esm_bundle(swiperContainer, {
		  slidesPerView: 1,
		  watchOverflow: true,
		  autoHeight: true,
		  loop: true,
		  autoplay: {
			delay: 5000
		  },
		  speed: 1000
		});
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/VideoHero.js


	class VideoHero extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		createClickableSection(this.element);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/sections/Cart.js

	class Cart extends Section {
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.changeQuantity = e => {
		  e.preventDefault();
		  const input = e.currentTarget.closest('.js-qty').querySelector('input');
		  if (e.currentTarget.classList.contains('js-qty__adjust--minus')) {
			input.value = Math.max(1, parseInt(input.value, 10) - 1);
		  } else {
			input.value = parseInt(input.value, 10) + 1;
		  }
		};
		Array.prototype.forEach.call(this.element.querySelectorAll('.js-qty__adjust'), el => el.addEventListener('click', this.changeQuantity));
	  }
	}
	;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Video.vue?vue&type=template&id=6f2f9e95&
	var Videovue_type_template_id_6f2f9e95_render = function () {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", [
		_c(
			"div",
			{
			  class: _vm.overlay
				  ? "homepage-hero-content-overlay-wrapper homepage-video-content-overlay-wrapper-" +
				  _vm.sectionId +
				  " " +
				  (!_vm.showOverlay ? "overlay-hidden" : "")
				  : "",
			},
			[
			  _vm.showOverlay && !_vm.hero && !_vm.autoplay
				  ? _c("div", { staticClass: "video--video__static-image" })
				  : _vm._e(),
			  _vm._v(" "),
			  _vm.showOverlay && !_vm.hero && !_vm.autoplay
				  ? _c(
					  "div",
					  {
						staticClass: "video--video__text-block",
						on: {
						  click: _vm.play,
						  keyup: function ($event) {
							if (
								!$event.type.indexOf("key") &&
								_vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
							) {
							  return null
							}
							return _vm.play.apply(null, arguments)
						  },
						},
					  },
					  [_vm._m(0)]
				  )
				  : _vm._e(),
			  _vm._v(" "),
			  _c(
				  "div",
				  {
					class: {
					  "embed-container": !_vm.hero,
					  "type-youtube": _vm.videoType === "youtube" && !_vm.hero,
					},
				  },
				  [
					_c("div", { ref: "video", staticClass: "video" }, [
					  _vm.videoType === "mp4"
						  ? _c(
							  "video",
							  {
								ref: "videoMP4",
								staticClass: "hero-video-mp4",
								attrs: { playsinline: "", controls: "" },
							  },
							  [
								_c("source", {
								  attrs: { src: _vm.url, type: "video/mp4" },
								}),
							  ]
						  )
						  : _vm._e(),
					]),
				  ]
			  ),
			]
		),
	  ])
	}
	var Videovue_type_template_id_6f2f9e95_staticRenderFns = [
	  function () {
		var _vm = this
		var _h = _vm.$createElement
		var _c = _vm._self._c || _h
		return _c(
			"div",
			{ staticClass: "homepage-video-play-button", attrs: { tabindex: "0" } },
			[_c("div", { staticClass: "homepage-video-play-button-inner" })]
		)
	  },
	]
	Videovue_type_template_id_6f2f9e95_render._withStripped = true


	;// CONCATENATED MODULE: ./src/javascripts/components/Video.vue?vue&type=template&id=6f2f9e95&

	;// CONCATENATED MODULE: ./src/javascripts/global/VideoBase.js
	/**
	 * @typedef {Object} VideoParams
	 * @param {boolean} autoplay
	 * @param {boolean} mute
	 * @param {boolean} loop
	 * @param {boolean} hideControls
	 * @param {string} url
	 */

	class VideoBase {
	  constructor(theme, element) {
		this.getAutoplay = autoplay => {
		  // Autoplay if Save-Data is not set
		  if ("connection" in navigator) {
			if (navigator.connection.saveData) {
			  return false;
			}
		  }
		  // Autoplay if reduced motion is not set
		  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return false;
		  }
		  return autoplay;
		};
		this._load = async function () {};
		this.init = params => {};
		this.play = () => {};
		this.pause = () => {};
		this.theme = theme;
		this.element = element;
	  }

	  /**
	   * Get autoplay with overrides
	   *
	   * @param {boolean} autoplay User autoplay preference
	   * @return {boolean}
	   */
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/Youtube.js


	/** Get ID of a youtube video from URL
	 * @param {string} url
	 * @return {string} youtube video ID
	 */
	const youtubeGetId = url => {
	  const parts = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
	  if (parts[2] !== undefined) {
		return parts[2].split(/[^0-9a-z_-]/i)[0];
	  }
	  return url;
	};
	class Youtube extends VideoBase {
	  constructor(...args) {
		super(...args);
		this._load = () => {
		  return this.theme.loadYoutubeApi();
		};
		this.init = ({
					   autoplay,
					   hideControls,
					   url,
					   mute,
					   loop,
					   onPlay,
					   onEnd
					 }) => {
		  autoplay = this.getAutoplay(autoplay);
		  const videoId = youtubeGetId(url);
		  return new Promise(resolve => {
			this._load().then(YT => {
			  this.player = new YT.Player(this.element, {
				videoId: videoId,
				playerVars: {
				  showinfo: 0,
				  modestbranding: 1,
				  rel: 0,
				  autoplay: autoplay ? 1 : 0,
				  controls: hideControls ? 0 : 1,
				  mute: mute || autoplay ? 1 : 0,
				  videoId: videoId,
				  cc_load_policy: 0,
				  fs: 0,
				  iv_load_policy: 3,
				  playsinline: 1,
				  branding: 0,
				  origin: window.location.origin
				},
				events: {
				  onReady: event => {
					this.player = event.target;
					if (mute || autoplay) {
					  this.player.mute();
					}
					if (autoplay) {
					  // Force play just in case that the option didn't work
					  this.player.playVideo();
					}
					resolve(this.player);
				  },
				  onStateChange: event => {
					if (event.data === YT.PlayerState.PLAYING) {
					  onPlay();
					}
					if (event.data === YT.PlayerState.ENDED && loop) {
					  this.player.playVideo();
					  onEnd();
					}
				  }
				}
			  });
			});
		  });
		};
		this.play = () => {
		  this.player.playVideo();
		};
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/Vimeo.js


	/** Get ID of a vimeo video from URL
	 * @param {string} url
	 * @return {string} vimeo video ID
	 */
	function vimeoGetId(url) {
	  const regex = /(videos|video|channels|\.com)\/([\d]+)/;
	  const parts = url.match(regex);
	  const partsNum = url.split('/');

	  // Handle URLs like https://vimeo.com/413064250/6b8fd8d053
	  if (partsNum.length > 4) {
		return url;
	  } else if (parts && parts[2] !== undefined) {
		return parts[2];
	  }
	  return url;
	}
	class Vimeo extends VideoBase {
	  constructor(...args) {
		super(...args);
		this._load = () => {
		  return this.theme.loadVimeoApi();
		};
		this.init = ({
					   autoplay,
					   hideControls,
					   url,
					   mute,
					   loop,
					   onPlay,
					   onEnd
					 }) => {
		  autoplay = this.getAutoplay(autoplay);
		  const videoId = vimeoGetId(url);
		  return new Promise((resolve, reject) => {
			this._load().then(Vimeo => {
			  this.player = new Vimeo.Player(this.element, {
				id: videoId,
				autoplay: autoplay,
				controls: !hideControls,
				byline: false,
				portrait: false,
				title: false
			  });
			  this.player.ready().then(() => {
				if (mute || autoplay) {
				  this.player.setVolume(0);
				}
				if (loop) {
				  this.player.setLoop(true);
				}
				if (autoplay) {
				  this.player.play();
				}
				resolve(this.player);
			  });
			  this.player.on('play', () => {
				onPlay();
			  });
			  this.player.on('ended', () => {
				onEnd();
			  });
			});
		  });
		};
		this.play = () => {
		  this.player.play();
		};
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/MP4Video.js


/// <reference path="../window.d.ts" />

	class MP4Video extends VideoBase {
	  constructor(...args) {
		super(...args);
		this._load = () => {
		  return new Promise(resolve => {
			window.Shopify.loadFeatures([{
			  name: 'video-ui',
			  version: '1.0',
			  onLoad: function () {
				resolve(window.Shopify.Plyr);
			  }
			}]);
		  });
		};
		this.init = ({
					   autoplay,
					   hideControls,
					   url,
					   mute,
					   loop,
					   onPlay,
					   onPause,
					   onEnd
					 }) => {
		  autoplay = this.getAutoplay(autoplay);
		  return new Promise((resolve, reject) => {
			this._load().then(Plyr => {
			  this.player = new Plyr(this.element, {
				loop: {
				  active: loop
				},
				autoplay: autoplay,
				muted: mute || autoplay ? 1 : 0,
				fullscreen: {
				  enabled: false
				},
				focusOnPlay: false
			  });
			  this.player.on('ready', event => {
				this.player = event.detail.plyr;
				if (autoplay) {
				  this.player.play();
				}
				if (hideControls) {
				  this.player.toggleControls(false);
				}
				resolve();
			  });
			  this.player.on('playing', () => {
				onPlay();
			  });
			  this.player.on('pause', () => {
				onPause();
			  });
			  this.player.on('ended', () => {
				onEnd();
			  });
			});
		  });
		};
		this.play = () => {
		  this.player.play();
		};
	  }
	}
	;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-2.use!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Video.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






	/* harmony default export */ const Videovue_type_script_lang_js_ = (vue_esm.extend({
	  props: {
		theme: ThemeBase,
		hero: Boolean,
		videoType: {
		  type: String,
		  required: true,
		  validator: function (value) {
			return ['youtube', 'vimeo', 'mp4'].indexOf(value) !== -1;
		  }
		},
		url: {
		  type: String,
		  required: true
		},
		autoplay: {
		  type: Boolean,
		  required: true
		},
		loop: Boolean,
		mute: Boolean,
		hideControls: {
		  type: Boolean,
		  default: false
		},
		overlayOpacity: {
		  type: Number,
		  default: 1
		},
		sectionId: {
		  type: String,
		  default: ''
		},
		overlay: Boolean
	  },
	  data() {
		return {
		  /** @type {import('../global/VideoBase').default} */
		  player: null,
		  isPlaying: false,
		  showOverlay: true
		};
	  },
	  mounted() {
		if (this.videoType === 'youtube') {
		  this.player = new Youtube(this.$root.theme, this.$refs.video);
		} else if (this.videoType === 'vimeo') {
		  this.player = new Vimeo(this.$root.theme, this.$refs.video);
		} else if (this.videoType === 'mp4') {
		  this.player = new MP4Video(this.$root.theme, this.$refs.videoMP4);
		}
		this.player.init({
		  autoplay: this.autoplay,
		  hideControls: this.hideControls,
		  url: this.url,
		  mute: this.mute,
		  loop: this.loop,
		  onPlay: this.onPlay,
		  onPause: this.onPause,
		  onEnd: this.onEnd
		});
	  },
	  methods: {
		onPlay() {
		  this.isPlaying = true;
		},
		onPause() {
		  this.isPlaying = false;
		},
		onEnd() {
		  this.isPlaying = false;
		},
		play() {
		  this.player.play();
		  this.showOverlay = false;
		}
	  }
	}));
	;// CONCATENATED MODULE: ./src/javascripts/components/Video.vue?vue&type=script&lang=js&
	/* harmony default export */ const components_Videovue_type_script_lang_js_ = (Videovue_type_script_lang_js_);
	;// CONCATENATED MODULE: ./src/javascripts/components/Video.vue





	/* normalize component */
	;
	var Video_component = normalizeComponent(
		components_Videovue_type_script_lang_js_,
		Videovue_type_template_id_6f2f9e95_render,
		Videovue_type_template_id_6f2f9e95_staticRenderFns,
		false,
		null,
		null,
		null

	)

	/* harmony default export */ const Video = (Video_component.exports);
	;// CONCATENATED MODULE: ./src/javascripts/global/Login.js

	class Login {
	  constructor(theme, element) {
		this.showRecoverPasswordForm = () => {
		  this.$recoverPasswordForm.show();
		  this.$customerLoginForm.hide();

		  // Now + 10 minutes (in milliseconds).
		  var expiry = new Date(Date.now() + 10 * 60 * 1000);
		  localStorage.setItem('resettingPassword', JSON.stringify({
			expiry: expiry.toISOString()
		  }));
		};
		this.hideRecoverPasswordForm = () => {
		  this.$recoverPasswordForm.hide();
		  this.$customerLoginForm.show();
		};
		this._isLocalStorageSupported = () => {
		  try {
			return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
		  } catch (e) {
			return false;
		  }
		};
		this.theme = theme;
		this.element = element;
		this.$element = jquery_default()(element);
		this.$recoverPasswordForm = this.$element.find('#RecoverPasswordForm');
		this.$customerLoginForm = this.$element.find('#CustomerLoginForm');
		this.$recoverPasswordLink = this.$element.find('#RecoverPassword');
		this.$hideRecoverPasswordLink = this.$element.find('#HideRecoverPasswordLink');
		this.hasLocalStorage = this._isLocalStorageSupported();
		this.$recoverPasswordLink.on('click', evt => {
		  evt.preventDefault();
		  this.showRecoverPasswordForm();
		});
		this.$hideRecoverPasswordLink.on('click', evt => {
		  evt.preventDefault();
		  this.hideRecoverPasswordForm();
		  if (this.hasLocalStorage) {
			window.localStorage.removeItem('resettingPassword');
		  }
		});

		// Allow deep linking to recover password form
		if (window.location.hash === '#recover') {
		  this.showRecoverPasswordForm();
		}
		var isResettingPassword = null;
		if (this.hasLocalStorage) {
		  isResettingPassword = window.localStorage.getItem('resettingPassword');
		}
		if (isResettingPassword) {
		  var isError = document.querySelector('#RecoverPasswordForm .errors');
		  if (isError) {
			jquery_default()('#ResetSuccess').hide();
		  } else {
			// The password reset email has been sent. Display information.
			jquery_default()('#ResetSuccess').show();
			if (this.hasLocalStorage) {
			  window.localStorage.removeItem('resettingPassword');
			}
		  }
		}
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/RightDrawer.js
	var RightDrawer_dec, RightDrawer_dec2, RightDrawer_dec3, RightDrawer_dec4, RightDrawer_dec5, RightDrawer_dec6, RightDrawer_class, RightDrawer_class2, RightDrawer_descriptor, RightDrawer_descriptor2, RightDrawer_descriptor3;
	function RightDrawer_initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
	function RightDrawer_applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
	function RightDrawer_initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }




	/**
	 * @typedef {Object} SearchGroup
	 * @param {string} name
	 * @param {any[]} results
	 */
	let RightDrawer = (RightDrawer_dec = vue_class_component_esm({
	  template: '#bulletproof-right-drawer-template'
	}), RightDrawer_dec2 = Prop({
	  required: true
	}), RightDrawer_dec3 = Prop({
	  required: false
	}), RightDrawer_dec4 = Prop({
	  required: false
	}), RightDrawer_dec5 = Watch('giftNote'), RightDrawer_dec6 = Watch('searchQuery'), RightDrawer_dec(RightDrawer_class = (RightDrawer_class2 = class RightDrawer extends vue_esm {
	  constructor(...args) {
		super(...args);
		this.isOpen = false;
		this.type = 'cart';
		this.cart = null;
		this.lineQuantityUpdating = null;
		this.quickShopProductUrl = null;
		this.quickShopContent = '';
		this.searching = false;
		this.searchQuery = '';
		this.searchGroups = [];
		this.searchChangeTimer = null;
		this.searchSummary = '';
		this.searchHasResults = false;
		this.searchResultsNum = 0;
		this.giftNote = '';
		this.updatingGiftNote = false;
		RightDrawer_initializerDefineProperty(this, "searchUrl", RightDrawer_descriptor, this);
		RightDrawer_initializerDefineProperty(this, "isPredictive", RightDrawer_descriptor2, this);
		RightDrawer_initializerDefineProperty(this, "languageUrl", RightDrawer_descriptor3, this);
	  }
	  data() {
		return {
		  isOpen: false,
		  type: 'cart',
		  cart: null,
		  lineQuantityUpdating: null,
		  quickShopProductUrl: null,
		  quickShopContent: '',
		  searchQuery: '',
		  searchResults: [],
		  giftNote: ''
		};
	  }
	  onGiftNoteChange() {
		if (this.giftNoteChangeTimer) {
		  window.clearTimeout(this.giftNoteChangeTimer);
		}
		this.giftNoteChangeTimer = window.setTimeout(() => {
		  this.updatingGiftNote = true;
		  this.updateGiftNote();
		  this.giftNoteChangeTimer = null;
		}, 1000);
	  }
	  onSearchChange() {
		if (this.isSearchPredictive) {
		  if (this.searchQuery > '') {
			if (this.searchChangeTimer) {
			  window.clearTimeout(this.searchChangeTimer);
			}
			this.searchChangeTimer = window.setTimeout(() => {
			  this.performSearch();
			  this.searchChangeTimer = null;
			}, 250);
		  } else {
			this.searchResultsNum = 0;
			this.searchHasResults = false;
			this.searchGroups = [];
			this.searching = false;
			this.searchSummary = '';
		  }
		}
	  }

	  /** @returns {import('../ThemeBase').default} */
	  get theme() {
		// @ts-ignore
		return this.$root.theme;
	  }
	  mounted() {
		document.documentElement.addEventListener(TOGGLE_RIGHT_DRAWER_EVENT, this.handleToggle);
	  }
	  beforeDestroy() {
		document.documentElement.removeEventListener(TOGGLE_RIGHT_DRAWER_EVENT, this.handleToggle);
	  }
	  handleToggle(event) {
		const {
		  type,
		  forceOpen,
		  params
		} = event.detail;
		if (params) {
		  if (params.url) {
			const url = params.url;
			if (type === 'shop-now') {
			  if (this.quickShopProductUrl !== url) {
				this.getProductPage(url);
				this.quickShopProductId = url;
			  }
			} else if (type === 'page') {
			  this.getGenericPage(url);
			}
		  }
		  if (params.cart) {
			this.cart = params.cart;
			// Populate gift note if it exists
			if (params.cart.attributes.gift_note) {
			  this.giftNote = params.cart.attributes.gift_note;
			}
			this.theme.updateCartDrawer(params.cart);
		  }
		}
		this.toggle(type, forceOpen);
	  }
	  close() {
		document.body.classList.remove('js-drawer-open');
		document.body.classList.remove('js-drawer-open-right');
		this.isOpen = false;
	  }
	  open() {
		this.setSubtotal();
		document.body.classList.add('js-drawer-open');
		document.body.classList.add('js-drawer-open-right');
		this.isOpen = true;
		if (this.type === 'cart' && this.cart === null) {
		  this.fetchCart();
		  this.$nextTick(() => /** @type {HTMLElement} */this.$refs.drawerClose.focus());
		} else if (this.type === 'search') {
		  this.$nextTick(() => /** @type {HTMLElement} */this.$refs.searchText.focus());
		}
	  }
	  toggle(type, forceOpen = undefined) {
		if (forceOpen === true) {
		  this.type = type;
		  this.open();
		} else if (forceOpen === false) {
		  this.close();
		} else if (this.isOpen) {
		  this.close();
		} else {
		  this.type = type;
		  this.open();
		}
	  }
	  async fetchCart() {
		try {
		  const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
		  const response = await window.fetch(`${languageParam}/cart?view=compare`);
		  if (!response.ok) {
			// FIXME error handling
		  }
		  const cart = await response.json();
		  this.cart = cart;
		  // Populate gift note if it exists
		  if (cart.attributes.gift_note) {
			this.giftNote = cart.attributes.gift_note;
		  }
		  this.theme.updateCartDrawer(cart);
		} catch (e) {
		  console.error('Unable to fetch cart: ', e);
		  // FIXME error handling
		}
	  }

	  setSubtotal() {
		setTimeout(function () {
		  //Show the sum of all the line item compare at prices before the subtotal in the drawer
		  let priceNoDiscount = document.querySelectorAll('.price-no--discount');
		  let lineItemPrices = document.querySelectorAll('.has--discount');
		  let lineItemComparePrices = document.querySelectorAll('.line-item__compare-at-price');
		  let copmarePriceDiv = /** @type {HTMLElement} */document.querySelector('.line__compare_price');
		  let cartTotal = /** @type {HTMLElement} */document.querySelector('.cart__total');
		  let cartTotalAmt = 0;
		  if (cartTotal) cartTotalAmt = parseFloat(cartTotal.innerHTML);
		  let totalWithDiscount;
		  if (!lineItemComparePrices || !lineItemPrices) return;
		  if (lineItemComparePrices.length > 0 && lineItemPrices.length > 0) {
			//Get the sum of all compare at prices
			let total = 0;
			let compareSubtotal;
			for (let num = 0; num < lineItemComparePrices.length; num++) {
			  const currentPrice = /** @type {HTMLElement} */lineItemComparePrices[num];
			  total += parseFloat(currentPrice.innerText);
			  compareSubtotal = total;
			}

			//Get the sum of discount prices
			let count = 0;
			let finalPriceTotal;
			for (let amount = 0; amount < lineItemPrices.length; amount++) {
			  const currentTotalPrice = /** @type {HTMLElement} */lineItemPrices[amount];
			  count += parseFloat(currentTotalPrice.innerText);
			  finalPriceTotal = count;
			}

			//Get the sum of all line items that don't have discounts
			let price = 0;
			let totalPrice;
			for (let amt = 0; amt < priceNoDiscount.length; amt++) {
			  const currFinalPrice = /** @type {HTMLElement} */priceNoDiscount[amt];
			  price += parseFloat(currFinalPrice.innerText);
			  totalPrice = price;
			}
			if (totalPrice > 0) {
			  totalWithDiscount = compareSubtotal + totalPrice;
			} else {
			  totalWithDiscount = compareSubtotal;
			}
			if (copmarePriceDiv) {
			  copmarePriceDiv.innerHTML = this.bulletproof.formatMoney(totalWithDiscount);
			}
		  }
		}, 1500);
	  }

	  /**
	   * Fetch page
	   *
	   * @param {string} url
	   */
	  async fetchPage(url) {
		const response = await window.fetch(url);
		const parser = new DOMParser();
		const doc = parser.parseFromString(await response.text(), 'text/html');
		const pageContent = doc.querySelector('.page-main--wrapper');
		return pageContent;
	  }

	  /**
	   * Product page url
	   *
	   * @param {string} url
	   */
	  async getProductPage(url) {
		const pageContent = await this.fetchPage(url);
		const productDiv = pageContent.querySelector('[data-bulletproof-section-type="template--product"]');
		const target = /** @type {HTMLElement} */this.$refs.shopNowContent;
		target.appendChild(productDiv);
		new FeaturedProduct(this.theme, target.querySelector('[data-bulletproof-section-type="template--product"]'), {
		  slidesPerView: 2
		});

		// window.Shopify.PaymentButton does not exist until the fetched
		// product page is fully loaded
		setTimeout(() => {
		  if (window.Shopify && window.Shopify.PaymentButton) {
			window.Shopify.PaymentButton.init();
		  }
		}, 1250);
	  }

	  /**
	   * Page url
	   *
	   * @param {string} url
	   */
	  async getGenericPage(url) {
		const pageContent = await this.fetchPage(url);
		const target = /** @type {HTMLElement} */this.$refs.pageContent;
		target.appendChild(pageContent);
	  }
	  numDifference(a, b) {
		if (a > b) {
		  return a - b;
		} else {
		  return b - a;
		}
	  }
	  get isGiftwrapEnabled() {
		return this.theme.giftwrapProduct && this.theme.giftwrapEnabled;
	  }

	  /**
	   * Is a given Product object the selected giftwrap product?
	   *
	   * @param {object} item
	   */
	  isGiftwrapProduct(item) {
		if (!this.isGiftwrapEnabled) return false;
		return item.handle == this.theme.giftwrapProduct;
	  }

	  /**
	   * Remove giftwrap product when another product is removed
	   *
	   * @param {number} line 1-based index of a line
	   * @param {number} quantity new quantity
	   */
	  async updateGiftwrap(line, quantity) {
		const thisProduct = this.cart.items[line - 1];
		if (!this.isGiftwrapEnabled) return line;
		if (thisProduct.properties) {
		  if (this.theme.translations.giftwrap_label in thisProduct.properties) {
			// Find position of gift wrap item in the cart. Note this will break
			// if you ever add additional properties to the gift wrap product
			// such that it splits that product into > 1 cart line items.
			const giftwrapIndex = this.cart.items.map(e => e.handle).indexOf(this.theme.giftwrapProduct);

			// Continue only if gift wrap product is in the cart
			if (giftwrapIndex > -1) {
			  let difference = this.numDifference(thisProduct.quantity, quantity);

			  // Quantity = quantity of current gift wrap product minus the quantity
			  // of the product being removed. There could be gift wrap for other
			  // items.
			  let newGiftwrapQuantity = 0;
			  if (quantity > thisProduct.quantity) {
				newGiftwrapQuantity = this.cart.items[giftwrapIndex].quantity + difference;
			  } else if (quantity == 0) {
				// If new quantity is zero, the associated product is being removed.
				newGiftwrapQuantity = this.cart.items[giftwrapIndex].quantity - thisProduct.quantity;
			  } else {
				newGiftwrapQuantity = this.cart.items[giftwrapIndex].quantity - difference;
			  }
			  const response = await window.fetch('/cart/change.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
				  'Content-Type': 'application/json'
				},
				body: JSON.stringify({
				  'line': giftwrapIndex + 1,
				  'quantity': newGiftwrapQuantity
				})
			  });

			  // Line is always 1-based so do not go below 1.
			  if (newGiftwrapQuantity == 0 && line > 1) return line - 1;
			  return line;
			}
			return line;
		  }
		}
		return line;
	  }

	  /**
	   * Update quantity of an item in cart
	   *
	   * @param {number} line 1-based index of a line
	   * @param {number} quantity new quantity
	   */
	  async setQuantity(line, quantity) {
		this.lineQuantityUpdating = line;
		try {
		  // If item has gift wrap, change gift wrap quantity too.
		  line = await this.updateGiftwrap(line, quantity);
		  this.lineQuantityUpdating = line;
		  const response = await window.fetch('/cart/change.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify({
			  line,
			  quantity
			})
		  });
		  const cart = await response.json();
		  this.cart = cart;
		  this.lineQuantityUpdating = null;
		} catch (e) {
		  console.error('Unable to fetch cart: ', e);
		  // FIXME error handling
		}

		this.fetchCart();
	  }
	  onSearchSubmit() {
		window.location.href = this.searchPageUrlWithQuery;
		return;
	  }
	  clearSearchInput() {
		this.searchQuery = '';
		/** @type {HTMLElement} */this.$refs.searchText.focus();
	  }
	  get isSearchPredictive() {
		return this.isPredictive == 'true';
	  }
	  get searchUrlWithQuery() {
		if (this.isSearchPredictive) {
		  return `${this.searchUrl}?q=${encodeURIComponent(this.searchQuery)}&resources[limit]=3&resources[limit_scope]=each`;
		} else {
		  return `/search?q=${encodeURIComponent(this.searchQuery)}`;
		}
	  }
	  get searchPageUrlWithQuery() {
		const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
		return `${languageParam}/search?q=${encodeURIComponent(this.searchQuery)}*`;
	  }
	  async performSearch() {
		this.searching = true;
		this.searchHasResults = false;
		this.searchResultsNum = 0;
		this.searchSummary = '';
		let data;
		try {
		  const response = await fetch(`${this.searchUrlWithQuery}`);
		  if (!response.ok) {
			// FIXME handle error
		  }
		  data = await response.json();
		} catch (e) {
		  console.error("Search failed", e);
		  // We'll redirect the user to /search page when search fails (for whatever reason)
		  window.location.href = this.searchPageUrlWithQuery;
		}
		const resultGroups = new Map();

		// Loop over groups e.g. Products / Pages / Articles / Collections
		Object.keys(data.resources.results).forEach(resultType => {
		  let group = resultGroups.get(resultType);
		  let result = data.resources.results[resultType];
		  if (!group) {
			group = {
			  name: {
				'queries': this.theme.translations.suggestions,
				'articles': this.theme.translations.articles,
				'pages': this.theme.translations.pages,
				'products': this.theme.translations.products,
				'collections': this.theme.translations.collections
			  }[resultType],
			  results: []
			};
			resultGroups.set(resultType, group);
		  }

		  // Format price.
		  let resultWithPrice = result.map(item => {
			var temp = Object.assign({}, item);
			if (temp.price) {
			  temp.price = this.theme.formatMoney(temp.price);
			}
			return temp;
		  });
		  group.results = resultWithPrice;
		  if (group.results && group.results.length > 0) {
			this.searchResultsNum += result.length;
			this.searchHasResults = true;
		  }
		});
		if (!this.searchHasResults && this.searchQuery > '') {
		  this.searchSummary = this.theme.translations.no_results_html.replace('{{ terms }}', this.searchQuery);
		}
		this.searching = false;
		this.searchGroups = Array.from(resultGroups.values());
	  }
	  async updateGiftNote() {
		const response = await window.fetch('/cart/update.js', {
		  method: 'POST',
		  credentials: 'same-origin',
		  headers: {
			'Content-Type': 'application/json'
		  },
		  body: JSON.stringify({
			attributes: {
			  'gift_note': this.giftNote
			}
		  })
		});
		if (!response.ok) {
		  // FIXME error handling
		  console.log('Could not update gift note in cart drawer', response);
		}
		this.updatingGiftNote = false;
	  }
	}, (RightDrawer_descriptor = RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "searchUrl", [RightDrawer_dec2], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), RightDrawer_descriptor2 = RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "isPredictive", [RightDrawer_dec3], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), RightDrawer_descriptor3 = RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "languageUrl", [RightDrawer_dec4], {
	  configurable: true,
	  enumerable: true,
	  writable: true,
	  initializer: null
	}), RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "onGiftNoteChange", [RightDrawer_dec5], Object.getOwnPropertyDescriptor(RightDrawer_class2.prototype, "onGiftNoteChange"), RightDrawer_class2.prototype), RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "onSearchChange", [RightDrawer_dec6], Object.getOwnPropertyDescriptor(RightDrawer_class2.prototype, "onSearchChange"), RightDrawer_class2.prototype)), RightDrawer_class2)) || RightDrawer_class);
	/* harmony default export */ const global_RightDrawer = (RightDrawer);

	// CONCATENATED MODULE: ./src/javascripts/global/Badge.js
	/* Place the sale or sold out badge at the top left of preview thumbnail
* image/s, rather than the top left of the containing <div>.
*/
	class Badge extends Component {
	  constructor(theme, _element) {
		super(theme, _element);
		this.add = (element, timeout) => {
		  this.roots.push(element);
		  this.load(element, timeout);
		};
		this.onWindowResize = () => {
		  const $containers = jquery_default()(this.roots).find('.grid-view-item .grid-view-item-image');
		  const $badges = $containers.find('.badge');
		  $badges.css('opacity', 0);
		  this.calculateBadgePositions($containers);
		  $badges.css('opacity', 1);
		};
		this.load = (element, timeout = undefined) => {
		  const badge = this;
		  if (timeout === undefined) {
			timeout = 0;
		  }
		  const $containers = jquery_default()(element).find('.grid-view-item .grid-view-item-image');
		  this.calculateBadgePositions($containers);
		  if (timeout > 0) {
			setTimeout(() => {
			  this.calculateBadgePositions($containers);
			}, timeout);
		  }

		  // On hover, if the 'Enable hover effect' setting is ON we'll need to move
		  // the badge on hover as a different image will be shown.
		  if ($containers.find('.hidden').length > 0 && this.theme.getWindowWidth() >= Breakpoints.md.min) {
			$containers.each((index, el) => {
			  hoverintent_default()(el, function () {
				if (!jquery_default()(this).parent('.grid-view-item').hasClass('hovering')) {
				  // Fade in second image.
				  var self = jquery_default()(this);
				  self.parent('.grid-view-item').addClass('hovering');
				  self.find('.hidden').fadeTo(200, 1, function () {
					badge.calculateHoverBadgePositions(jquery_default()(self));
				  });
				}
			  }, function () {
				var self = jquery_default()(this);
				// Fade out second image.
				jquery_default()(this).find('.hidden').fadeTo(200, 0, function () {
				  badge.calculateBadgePositions($containers);
				});
				self.parent('.grid-view-item').removeClass('hovering');
			  }).options({
				sensitivity: 10,
				interval: 25
			  });
			});
		  }
		};
		this.calculateHoverBadgePositions = item => {
		  // If the 'Enable hover effect' setting is ON, also calculate the position
		  // of the badge on the second thumbnail.
		  if (item.find('.reveal .hidden').length) {
			/*item.find('.reveal .hidden').css('z-index', 4);*/
		  }
		};
		this.calculateBadgePositions = container => {
		  container.each((i, el) => {
			jquery_default()(el).find('*').stop(true, true);
		  });
		};
		this.roots = [];
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/RecentlyViewed.js




	function get_unique_array(array) {
	  var newArray = new Array();
	  var handleArray = new Array();
	  for (var i = 0; i < array.length; i++) {
		var handle = array[i]['handle'];
		if (handleArray.indexOf(handle) === -1) {
		  newArray.push(array[i]);
		  handleArray.push(handle);
		}
	  }
	  return newArray;
	}
	class RecentlyViewed extends Section {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   */
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.RECENTLY_VIEWED_COUNT = 10;
		this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
		this.PLACEHOLDER = 'PLACEHOLDER';
		this.loadProducts = recentlyViewed => {
		  let str = this.paramStr(this.blocksArray);
		  var promises = recentlyViewed.map(function (rv) {
			return jquery_default().get(this.productUrl.replace(this.PLACEHOLDER, rv.handle), {
			  blocks: str
			});
		  }.bind(this));
		  jquery_default().when.apply((jquery_default()), promises).then(() => {
			let allOK = true;
			promises.forEach(promise => {
			  if (promise.status === 200) {
				var container = document.createElement('div');
				container.innerHTML = promise.responseText;
				this.$content.append(container.querySelector('.main-content .grid__item').outerHTML);
				this.$content.find('.grid__item').addClass('swiper-slide');
				this.orderBlocks(container.querySelector('.grid-view-item'));
			  } else {
				console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
				allOK = false;
			  }
			});
			if (allOK) {
			  this.show();
			} else {
			  this.hideButtons();
			}
		  });
		};
		this.orderBlocks = parent => {
		  if (!this.blocksArray) return;
		  const clone = parent.cloneNode(true);
		  parent.innerHTML = '';
		  this.blocksArray.forEach(block => {
			if (!block) return;
			const blockElement = clone.querySelector(`[data-block-type=${block}]`);
			if (blockElement) {
			  parent.appendChild(blockElement);
			}
		  });
		};
		this.hideButtons = () => {
		  this.$element.find('.swiper-button--next').hide();
		  this.$element.find('.swiper-button--prev').hide();
		};
		this.show = () => {
		  const nextEl = this.element.querySelector('.swiper-button--next');
		  const prevEl = this.element.querySelector('.swiper-button--prev');
		  this.$element.fadeIn();
		  this.swiper = new swiper_esm_bundle(this.element.querySelector('.swiper-container'), {
			slidesPerView: 2,
			navigation: {
			  nextEl,
			  prevEl
			},
			breakpoints: {
			  768: {
				slidesPerView: 4
			  }
			},
			watchOverflow: true,
			autoHeight: true
		  });
		  this.loadShopNow();
		  this.quickAddButtons = new QuickAdd(this.theme, this.element);
		  this.badge = this.theme.addBadges(this.element, 1000);
		  const sectionLoadedEvent = new CustomEvent('theme:section:load');
		  document.dispatchEvent(sectionLoadedEvent);
		};
		this.loadShopNow = () => {
		  if (this.quickShopDesktopEnabled === 'true') {
			Array.prototype.forEach.call(this.element.querySelectorAll('.grid-view-item'), el => {
			  const productId = Number(el.dataset.productId);
			  const productAvailable = el.dataset.productAvailable == 'true';
			  const productVarSize = Number(el.dataset.productVariantsSize);
			  const product_url = el.dataset.productUrl;
			  const cardImageBottomWrapper = el.querySelector('.product-card-image--bottom-wrapper');

			  // Construct button for this product.
			  const a_desktop = document.createElement('a');
			  const a_mobile = document.createElement('a');
			  const wrapper = document.createElement('div');
			  wrapper.classList.add('quick-add-wrapper');
			  if (productVarSize == 1) wrapper.classList.add('is-singular');
			  if (productVarSize > 1 && productAvailable) {
				// Desktop button.
				a_desktop.classList.add('quick-add-button-variants', 'quick-add-button-variants-desktop');
				a_desktop.tabIndex = 0;
				a_desktop.href = product_url;
				a_desktop.textContent = this.theme.translations.view_options;

				// Mobile button.
				a_mobile.classList.add('quick-add-button-variants', 'quick-add-button-variants-mobile');
				if (this.quickShopMobileDisabled == 'true') a_mobile.classList.add('quick-shop-hidden');
				a_mobile.tabIndex = 0;
				a_mobile.href = product_url;
				const icon_span = document.createElement('span');
				icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
				a_mobile.appendChild(icon_span);
				[a_desktop, a_mobile].forEach(a => {
				  wrapper.appendChild(a);
				});
			  } else if (productAvailable) {
				// HTML Form. Used for the 'Add to cart' button functionality.
				const form = document.createElement('form');
				form.method = 'post';
				form.action = '/cart/add';
				form.id = 'CollectionAddToCartForm';
				form.acceptCharset = 'UTF-8';
				form.classList.add('shopify-product-form');
				form.enctype = 'multipart/form-data';
				// Hidden form inputs.
				const form_type = document.createElement('input');
				form_type.type = 'hidden';
				form_type.name = 'form_type';
				form_type.value = 'product';
				form.appendChild(form_type);
				const utf_input = document.createElement('input');
				utf_input.type = 'hidden';
				utf_input.name = 'utf8';
				utf_input.value = '✓';
				form.appendChild(utf_input);
				const prod_id = document.createElement('input');
				prod_id.type = 'hidden';
				prod_id.name = 'id';
				prod_id.value = productId.toString();
				form.appendChild(prod_id);

				// Submit button desktop.
				const btn_desktop = document.createElement('button');
				btn_desktop.classList.add('quick-add-button', 'quick-add-button-desktop');
				btn_desktop.type = 'submit';
				btn_desktop.tabIndex = 0;
				btn_desktop.textContent = this.theme.translations.addToCart;

				// Submit button mobile.
				const btn_mobile = document.createElement('button');
				btn_mobile.classList.add('quick-add-button', 'quick-add-button-mobile');
				if (this.quickShopMobileDisabled == 'true') btn_mobile.classList.add('quick-shop-hidden');
				btn_mobile.type = 'submit';
				btn_mobile.tabIndex = 0;
				const icon_span = document.createElement('span');
				icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
				btn_mobile.appendChild(icon_span);
				[btn_desktop, btn_mobile].forEach(btn => {
				  form.appendChild(btn);
				});
				wrapper.appendChild(form);
			  } else {
				// Desktop button.
				a_desktop.classList.add('sold-out-button', 'sold-out-button-desktop');
				a_desktop.href = product_url;
				a_desktop.textContent = this.theme.translations.soldOut;

				// Mobile button.
				a_mobile.classList.add('sold-out-button', 'sold-out-button-mobile');
				if (this.quickShopMobileDisabled == 'true') a_mobile.classList.add('quick-shop-hidden');
				a_mobile.href = product_url;
				const icon_span = document.createElement('span');
				icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
				a_mobile.appendChild(icon_span);
				[a_desktop, a_mobile].forEach(a => {
				  wrapper.appendChild(a);
				});
			  }
			  if (cardImageBottomWrapper) cardImageBottomWrapper.appendChild(wrapper);
			});
		  }
		  const quickAddButtons = this.element.querySelectorAll('.quick-add-button-variants');
		  quickAddButtons.forEach(button => {
			button.addEventListener('click', this.handleShopNow.bind(this));
		  });
		};
		this.handleShopNow = e => {
		  e.preventDefault();
		  this.theme.toggleRightDrawer('shop-now', true, {
			url: e.currentTarget.href
		  });
		};
		this._isLocalStorageSupported = () => {
		  try {
			return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
		  } catch (e) {
			return false;
		  }
		};
		this.paramStr = arr => {
		  var parameters = [];
		  for (var property in arr) {
			if (Object.prototype.hasOwnProperty.call(arr, property) && arr[property].length > 0) {
			  parameters.push(encodeURI(arr[property]));
			}
		  }
		  return parameters.join(',');
		};
		this.isMobile = () => {
		  return window.matchMedia('(max-width: 1023px)').matches;
		};
		this.$element = jquery_default()(element);
		this.handle = this.element.dataset.productHandle;
		this.productUrl = this.element.dataset.productUrl;
		this.blocksArray = this.element.dataset.blocks.split(',');
		this.$content = this.$element.find('#recently-viewed-products');
		this.quickShopDesktopEnabled = this.element.dataset.quickShopDesktopEnabled;
		this.quickShopMobileDisabled = this.element.dataset.quickShopMobileDisabled;
		var self = this;
		window.addEventListener('load', event => {
		  setTimeout(() => {
			if (self.swiper) {
			  self.swiper.resize.resizeHandler();
			}
		  }, 1000);
		});
		if (this.$content.hasClass('recently-viewed-loading')) {
		  return;
		}
		this.$content.empty().addClass('recently-viewed-loading');
		var recentlyViewedJSON = null;
		if (this._isLocalStorageSupported()) {
		  recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
		}
		var _recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];
		if (this.handle) {
		  var item = {
			'handle': this.handle
		  };
		  _recentlyViewed.unshift(item);
		}
		var uniqueArray = _recentlyViewed.length ? get_unique_array(_recentlyViewed) : _recentlyViewed;
		if (uniqueArray.length > this.RECENTLY_VIEWED_COUNT) {
		  uniqueArray = uniqueArray.slice(0, this.RECENTLY_VIEWED_COUNT);
		}
		if (this._isLocalStorageSupported()) {
		  localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
		}
		if (uniqueArray.length > 1 || uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle) {
		  this.loadProducts(uniqueArray.filter(item => {
			return item.handle !== this.handle;
		  }));
		} else {
		  this.$element.remove();
		}
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/InfoColumns.js


	class InfoColumns extends Section {
	  constructor(theme, _element, pageLoad) {
		super(theme, _element, pageLoad);
		this.isSlideInViewport = el => {
		  const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
		  const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
		  const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)

		  // Check if the slide is in the visible area
		  if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
			return true;
		  }
		  const absoluteSlideIndex = slideIndex + this.numberOfSlides;
		  if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
			return true;
		  }
		  return false;
		};
		this.onBlockSelect = ({
								element
							  }) => {
		  if (this.isSlideInViewport(element)) return;
		  const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
		  const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
		  this.swiper.slideTo(index, transitionDuration, false);
		};
		this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
		this.swiperContainer = this.element.querySelector('.swiper-container');
		this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
		const nextEl = this.element.querySelector('.swiper-button--next');
		const prevEl = this.element.querySelector('.swiper-button--prev');
		this.swiper = new swiper_esm_bundle(this.swiperContainer, {
		  slidesPerView: 1,
		  allowTouchMove: true,
		  navigation: {
			nextEl,
			prevEl
		  },
		  breakpoints: {
			// when window width is >= 768px
			769: {
			  slidesPerView: this.slidesPerView
			}
		  },
		  watchOverflow: true,
		  autoHeight: true,
		  loop: true,
		  pagination: {
			el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
			clickable: true
		  }
		});
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/global/SearchResults.js

	class SearchResults extends Section {
	  /**
	   * @param {import('../ThemeBase').default} theme
	   * @param {HTMLElement} element
	   */
	  constructor(theme, element, pageLoad) {
		super(theme, element, pageLoad);
		this.removeAsterisks = () => {
		  var pageTitle = document.querySelector('.page--title');
		  pageTitle.textContent = pageTitle.textContent.replace('*', '');
		  var searchInput = /** @type {HTMLInputElement} */document.querySelector('.search-bar .input-group-field');
		  searchInput.value = searchInput.value.replace('*', '');
		  var breadcrumbLast = document.querySelector('nav.breadcrumb span:last-child');
		  if (breadcrumbLast) {
			breadcrumbLast.textContent = breadcrumbLast.textContent.replace('*', '');
		  }
		};
		this.onSearchChange = e => {
		  if (this.searchInput.value.length > 0) {
			this.searchClear.style.opacity = '1';
			this.searchClear.tabIndex = 0;
		  } else {
			this.searchClear.style.opacity = '0';
			this.searchClear.tabIndex = -1;
		  }
		};
		this.clearSearch = e => {
		  if (this.searchInput) {
			this.searchInput.value = '';
			this.onSearchChange();
			this.searchInput.focus();
		  }
		};
		this.tabClearSearch = e => {
		  if (e.keyCode === 13) {
			e.preventDefault();
			this.searchInput.value = '';
			this.onSearchChange();
			this.searchInput.focus();
		  }
		};
		this.removeAsterisks();
		this.clearSearch();
		this.searchInput = /** @type {HTMLInputElement} */element.querySelector('input[type="search"]');
		this.searchInput.addEventListener('input', this.onSearchChange);
		this.searchClear = /** @type {HTMLElement} */element.querySelector('.search-drawer--clear');
		this.searchClear.addEventListener('click', this.clearSearch);
		this.searchClear.addEventListener('keydown', this.tabClearSearch);
	  }
	}
	;// CONCATENATED MODULE: ./src/javascripts/Theme.js





// import Popup from './global/Popup';
// import Newsletter from './global/Newsletter';
// import CartDrawer from './global/CartDrawer';
// import Drawer from './global/Drawer';

// import LoginPage from './pages/LoginPage';
	/**
	 * @typedef {Object} ShopifyEventDetail
	 * @property {string} sectionId
	 * @property {string} [blockId]
	 * @property {boolean} [load]
	 */

	/**
	 * @typedef {CustomEvent<ShopifyEventDetail>} ShopifyEvent
	 */

	class Theme extends ThemeBase {
	  constructor() {
		super();
		this.THROTTLE_INTERVAL = 400;
		this.SECTIONS = {
		  'header': Header,
		  'footer-main': Footer,
		  'announcement-bar': AnnouncementBar,
		  'animated-text': AnimatedText,
		  'advanced-layout--custom-html': CustomHtml,
		  'advanced-layout--hero': Hero,
		  'blog--blog-posts': BlogPosts,
		  'collage-builder': VideoHero,
		  'template--product--info-columns': InfoColumns,
		  'collection--collection-list': CollectionList,
		  'collection--featured-collection': FeaturedCollection,
		  'countdown-timer': ImageWithText,
		  'events-calendar': EventsCalendar,
		  'image--gallery': ImageGallery,
		  'image--image-with-text-overlay': ImageWithTextOverlay,
		  'image--image-with-text': ImageWithText,
		  'image--logo-list': LogoList,
		  'image--slideshow': Slideshow,
		  'newsletter--newsletter': Newsletter,
		  'password': Password,
		  'products--featured-product': FeaturedProduct,
		  'store-information--map': MapSection,
		  'template--blog': Blog,
		  'template--cart': Cart,
		  'template--collection': CollectionSection,
		  'template--collections-list': CollectionListSection,
		  'template--page-contact': MapSection,
		  'template--product': ProductSection,
		  'template--product--recently-viewed': RecentlyViewed,
		  'template--search': SearchResults,
		  'text--rich-text': RichText,
		  'text--testimonials': Testimonails,
		  'text--text-adverts': TextAdverts,
		  'video--video-hero': VideoHero,
		  'video--video': Section,
		  'featured-menu': FeaturedMenu
		};
		this.VUE_COMPONENTS = {
		  'bulletproof-dropdown': Dropdown,
		  'bulletproof-video': Video
		};
		this.loadFadeAnimation = () => {
		  document.body.classList.add('loaded');
		  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
			// Safari doesn't support beforeunload very well when using back/forward buttons.
			return;
		  }
		  window.addEventListener('beforeunload', function () {
			document.body.classList.add('unloading');
		  });
		};
		this.loadGlobal = () => {
		  const globalEl = document.querySelector('#bptheme-global');
		  if (!globalEl) {
			console.warn('Script #bptheme-global with global definitions not found');
			return;
		  }
		  let global;
		  try {
			global = JSON.parse(globalEl.textContent);
		  } catch (e) {
			console.warn('Invalid syntax in #bptheme-global', e);
			return;
		  }
		  this.translations = global.translations;
		  this.moneyFormat = global.moneyFormat;
		  this.giftwrapProduct = global.giftwrapProduct;
		  this.giftwrapEnabled = global.giftwrapEnabled;
		  vue_esm.directive('money', {
			bind: (el, binding) => {
			  el.innerHTML = this.formatMoney(binding.value);
			},
			update: (el, binding) => {
			  if (binding.oldValue !== binding.value) {
				el.innerHTML = this.formatMoney(binding.value);
			  }
			}
		  });
		  vue_esm.directive('responsive', {
			bind: (el, binding) => {
			  /* Create product thumbnail:
           *  - Remove file extension, add _1000x, and re-add extension
           *  - Create server relative link
           *  - Create responsive variant (`_{width}x` as size)
           */

			  let srcset = '';
			  if (el.width > 550) {
				srcset += binding.value.replace(/(\.[^.]*)$/, "_550x$1") + ' 550w,';
			  }
			  if (el.width > 1100) {
				srcset += binding.value.replace(/(\.[^.]*)$/, "_1100x$1") + ' 1100w,';
			  }
			  if (el.width > 1445) {
				srcset += binding.value.replace(/(\.[^.]*)$/, "_1445x$1") + ' 1445w,';
			  }
			  if (el.width > 1680) {
				srcset += binding.value.replace(/(\.[^.]*)$/, "_1680x$1") + ' 1680w,';
			  }
			  if (el.width > 2048) {
				srcset += binding.value.replace(/(\.[^.]*)$/, "_2048x$1") + ' 2048w,';
			  }

			  // Plus the original image size for good measure.
			  srcset += binding.value + ' ' + el.width + 'w';
			  const img = binding.value.replace(/(\.[^.]*)$/, "_1000x$1").replace('http:', '');
			  el.setAttribute('src', img);
			  el.setAttribute('srcset', srcset);
			  el.setAttribute('loading', 'lazy');
			  el.setAttribute('loading', 'lazy');
			}
		  });
		};
		this.loadVueComponents = element => {
		  Object.entries(this.VUE_COMPONENTS).forEach(([tagName, VueComponent]) => {
			this.loadVueComponent(element, tagName, VueComponent);
		  });
		};
		this.loadVueComponent = (element, tagName, Component) => {
		  Array.prototype.forEach.call(element.querySelectorAll(tagName), el => {
			const c = new vue_esm({
			  el: el.parentNode,
			  components: {
				[tagName]: Component
			  },
			  data: () => {
				return {
				  theme: this
				};
			  }
			});
			this.vueComponents.push(c);
		  });
		};
		this.loadSection = (element, SectionClass, pageLoad) => {
		  const c = new SectionClass(this, element, pageLoad);
		  this.sectionById.set(element.dataset.bulletproofSectionId, c);
		  const type = element.dataset.bulletproofSectionType;
		  let sections = this.sectionsByType.get(type);
		  if (!sections) {
			sections = [];
			this.sectionsByType.set(type, sections);
		  }
		  sections.push(c);
		  this.loadVueComponents(element);
		};
		this.loadSectionsByType = (type, SectionClass, pageLoad) => {
		  const selector = `[data-bulletproof-section-type="${type}"]`;
		  Array.prototype.forEach.call(document.querySelectorAll(selector), element => {
			try {
			  this.loadSection(element, SectionClass, pageLoad);
			} catch (e) {
			  console.error(`Unable to load section ${type} on element`, element, e);
			}
		  });
		};
		this.onLoadAll = () => {
		  this.load();
		  Object.entries(this.SECTIONS).forEach(([type, SectionClass]) => {
			this.loadSectionsByType(type, SectionClass, true);
		  });
		  this.showOnScroll();
		};
		this.onSectionLoad = event => {
		  // When in section preview, there is no section instance - show the section and return
		  if (window.Shopify.visualPreviewMode) {
			this.showOnScroll();
			return;
		  }
		  const {
			sectionId
		  } = event.detail;
		  const selector = `[data-bulletproof-section-id="${sectionId}"]`;
		  const element = /** @type {HTMLElement} */document.querySelector(selector);
		  if (!element) {
			console.warn(`Element with ${selector} not found, section won't be loaded`);
			return;
		  }
		  const type = element.dataset.bulletproofSectionType;
		  const SectionClass = this.SECTIONS[type];
		  if (!SectionClass) {
			console.warn(`Cannot find class with type "${type}"`);
			return;
		  }
		  // Remove 'fadeInUp' animation from the first section
		  let getAnimatedEls = document.querySelectorAll('.show-on-scroll');
		  if (getAnimatedEls.length > 0) {
			getAnimatedEls[0].classList.remove('show-on-scroll');
		  }
		  this.loadSection(element, SectionClass, false);
		  this.showOnScroll();
		};
		this.onSectionUnload = event => {
		  const element = /** @type {HTMLElement} */event.target;
		  const {
			sectionId
		  } = event.detail;
		  const section = this.sectionById.get(sectionId);
		  if (!section) {
			console.warn(`No section with id ${sectionId}, nothing will be unloaded`);
			return;
		  }
		  section.destroy({
			element
		  });
		};
		this.onSectionSelect = event => {
		  const element = /** @type {HTMLElement} */event.target;
		  const {
			sectionId,
			load
		  } = event.detail;
		  const section = this.sectionById.get(sectionId);
		  if (!section) {
			console.warn(`No section with id ${sectionId}, nothing will be selected`);
			return;
		  }
		  section.onSectionSelect({
			element,
			sectionId,
			load
		  });
		};
		this.onSectionDeselect = event => {
		  const element = /** @type {HTMLElement} */event.target;
		  const {
			sectionId
		  } = event.detail;
		  const section = this.sectionById.get(sectionId);
		  if (!section) {
			console.warn(`No section with id ${sectionId}, nothing will be deselected`);
			return;
		  }
		  section.onSectionDeselect({
			element,
			sectionId
		  });
		};
		this.onSectionReorder = event => {
		  const element = /** @type {HTMLElement} */event.target;
		  const {
			sectionId
		  } = event.detail;
		  const section = this.sectionById.get(sectionId);
		  if (!section) {
			console.warn(`No section with id ${sectionId}, nothing will be done on reorder`);
			return;
		  }
		  section.onSectionReorder({
			element,
			sectionId
		  });
		};
		this.onBlockSelect = event => {
		  const element = /** @type {HTMLElement} */event.target;
		  const {
			sectionId,
			blockId,
			load
		  } = event.detail;
		  const section = this.sectionById.get(sectionId);
		  if (!section) {
			console.warn(`No section with id ${sectionId}, block select will do nothing`);
			return;
		  }
		  section.onBlockSelect({
			element,
			sectionId,
			blockId,
			load
		  });
		};
		this.onBlockDeselect = event => {
		  const element = /** @type {HTMLElement} */event.target;
		  const {
			sectionId,
			blockId
		  } = event.detail;
		  const section = this.sectionById.get(sectionId);
		  if (!section) {
			console.warn(`No section with id ${sectionId}, block deselect will do nothing`);
			return;
		  }
		  section.onBlockDeselect({
			element,
			sectionId,
			blockId
		  });
		};
		this.onRawResize = event => {
		  const width = this.getWindowWidth();

		  // Trigger non-debounced event on all components
		  this.registeredComponents.forEach(c => c.onWindowResizeRaw({
			width
		  }));
		  this.onResize();
		};
		this.onResize = throttle(() => {
		  const width = this.getWindowWidth();
		  const oldWidth = this.previousWidth;
		  const breakpoint = this.getBreakpoint(width);
		  this.registeredComponents.forEach(c => {
			c.onWindowResize({
			  width,
			  oldWidth,
			  breakpoint
			});
			if (breakpoint !== this.breakpoint) {
			  // Breakpoint has changed, trigger the event
			  c.onWindowResizeBreakpoint({
				breakpoint,
				oldBreakpoint: this.breakpoint,
				width
			  });
			}
		  });
		  this.previousWidth = width;
		  this.breakpoint = breakpoint;
		}, this.THROTTLE_INTERVAL);
		this.onRawScroll = event => {
		  this.onScroll(event);
		};
		this.onScroll = throttle(event => {
		  this.showOnScroll();
		  this.registeredComponents.forEach(c => {
			c.onWindowScroll();
		  });
		}, this.THROTTLE_INTERVAL);
		this.showOnScroll = () => {
		  const windowHeight = jquery_default()(window).height();
		  jquery_default()('.show-on-scroll').each(function (index, section) {
			var rect = section.getBoundingClientRect();
			if (rect.bottom >= 0 && rect.top < windowHeight) {
			  jquery_default()(section).removeClass('show-on-scroll').addClass('shown-on-scroll animated fadeInUp');
			}
		  });
		};
		this.onKeyUp = e => {
		  // Close drawers when escape is pressed if they are open
		  if (e.keyCode == 27) {
			// escape key maps to keycode `27`
			this.closeDrawers();
		  }
		};
		this.handleAccordions = () => {
		  let detailsElements = document.querySelectorAll('details');

		  //@ts-ignore
		  for (let item of detailsElements) {
			item.addEventListener('click', e => {
			  const target = /** @type {HTMLElement} */e.currentTarget;
			  setTimeout(() => {
				const isExpanded = item.open ? 'true' : 'false';
				item.firstElementChild.setAttribute('aria-expanded', isExpanded);
			  }, 0);
			});
		  }
		};
		this.loadYoutubeApi = () => {
		  return new Promise((resolve, reject) => {
			if (window.YT) {
			  // We already have youtube API loaded, we're done
			  resolve(window.YT);
			} else if (!document.querySelector('#youtube_api')) {
			  // Resolve once youtube is loaded
			  this.youtubeLoadedCallbacks.push({
				resolve,
				reject
			  });
			  const embedContainers = /** @type {NodeListOf<Element>} */document.querySelectorAll('.type-youtube');
			  const videoObserverOptions = {};
			  const videoObserverCallback = (watchEntries, videoObserver) => {
				watchEntries.forEach(watchEntry => {
				  if (watchEntry.isIntersecting) {
					// Youtube API is not yet loaded, create script that loads it
					this.createScript("youtube_api", "https://www.youtube.com/player_api", true);
					embedContainers.forEach(embedContainer => {
					  videoObserver.unobserve(embedContainer);
					});
				  }
				});
			  };
			  const videoObserver = new IntersectionObserver(videoObserverCallback, videoObserverOptions);
			  if (embedContainers.length) {
				embedContainers.forEach(embedContainer => {
				  videoObserver.observe(embedContainer);
				});
			  }
			} else {
			  // Script for loading youtube API is there, but youtube is not yet loaded
			  this.youtubeLoadedCallbacks.push({
				resolve,
				reject
			  });
			}
		  });
		};
		this.onYoutubeLoaded = () => {
		  this.youtubeLoadedCallbacks.forEach(({
												 resolve
											   }) => {
			resolve(window.YT);
		  });
		  this.youtubeLoadedCallbacks.splice(0);
		};
		this.loadVimeoApi = () => {
		  return new Promise((resolve, reject) => {
			if (window.Vimeo) {
			  // Already loaded
			  resolve(window.Vimeo);
			} else if (!document.querySelector('#vimeo_api')) {
			  // Vimeo API is not yet loaded, create script that loads it
			  const script = this.createScript("vimeo_api", "https://player.vimeo.com/api/player.js");
			  script.onload = () => {
				resolve(window.Vimeo);
				this.onVimeoLoaded();
			  };
			} else {
			  this.vimeoLoadedCallbacks.push({
				resolve,
				reject
			  });
			}
		  });
		};
		this.onVimeoLoaded = () => {
		  this.vimeoLoadedCallbacks.forEach(({
											   resolve
											 }) => {
			resolve(window.Vimeo);
		  });
		  this.vimeoLoadedCallbacks.splice(0);
		};
		this.loadGoogleMapApi = apiKey => {
		  return new Promise((resolve, reject) => {
			if (window.google && window.google.maps && window.google.maps.Geocoder && window.google.maps.Map) {
			  resolve(window.google.maps);
			} else if (!document.querySelector('#google_maps_api')) {
			  const loadMaps = () => {
				// Google Maps API is not yet loaded, create script that loads it
				const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=onGoogleMapsAPIReady`;
				this.createScript('google_maps_api', url, true);
			  };

			  // Resolve once Maps API is loaded
			  this.mapsLoadedCallbacks.push({
				resolve,
				reject
			  });

			  // Google Maps API collides with Shopify payments loading Google Pay,
			  // we need to wait for payments to load before loading Maps API
			  // TODO: remove once Shopify fixes their payments code
			  let attemptsRemaining = 6;
			  const checkForPayments = () => {
				// Wait for checkout buttons to be loaded
				const checkoutWrapper = document.querySelector('[data-shopify="dynamic-checkout-cart"]');
				if (attemptsRemaining > 0 && checkoutWrapper && checkoutWrapper.children.length === 0) {
				  attemptsRemaining -= 1;
				  setTimeout(checkForPayments, 500);
				} else {
				  loadMaps();
				}
			  };
			  checkForPayments();
			} else {
			  // Script for loading maps API is there, but it is not yet loaded
			  this.mapsLoadedCallbacks.push({
				resolve,
				reject
			  });
			}
		  });
		};
		this.onGoogleMapsLoaded = () => {
		  this.mapsLoadedCallbacks.forEach(({
											  resolve
											}) => {
			resolve(window.google.maps);
		  });
		  this.mapsLoadedCallbacks.splice(0);
		};
		this.onGoogleAuthFailure = reason => {
		  this.mapsLoadedCallbacks.forEach(({
											  reject
											}) => {
			reject(reason);
		  });
		  this.mapsLoadedCallbacks.splice(0);
		  const event = new CustomEvent('google-maps-auth-failure', {
			detail: {
			  reason
			}
		  });
		  document.body.dispatchEvent(event);
		};
		this._loadCartKey = () => {
		  const cerberusKey = 'f1957945-9048-438b-bd2c-0ed182340c65';
		  return cerberusKey;
		};
		this.toggleRightDrawer = (type = 'cart', forceOpen = undefined, params = {}) => {
		  const event = new CustomEvent(TOGGLE_RIGHT_DRAWER_EVENT, {
			detail: {
			  type,
			  forceOpen,
			  params
			}
		  });
		  document.documentElement.dispatchEvent(event);
		};
		this.toggleLeftDrawer = (forceOpen = undefined) => {
		  const event = new CustomEvent(TOGGLE_LEFT_DRAWER_EVENT, {
			detail: {
			  forceOpen
			}
		  });
		  document.documentElement.dispatchEvent(event);
		};
		this.updateCartDrawer = cart => {
		  const event = new CustomEvent(CART_UPDATE_EVENT, {
			detail: {
			  cart
			}
		  });
		  document.documentElement.dispatchEvent(event);
		};
		this.createScript = (id, src, async = false) => {
		  const tag = document.createElement('script');
		  tag.id = id;
		  tag.src = src;
		  if (async) {
			tag.defer = true;
			tag.async = true;
		  }
		  const firstScriptTag = document.getElementsByTagName('script')[0];
		  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		  return tag;
		};
		this.registerComponent = component => {
		  this.registeredComponents.push(component);
		};
		this.makeVideoEmbedsResponsive = () => {
		  jquery_default()('.template-page iframe, .template-blog iframe, .template-article iframe').each(function (index, iframe) {
			var source = jquery_default()(iframe).attr("src");
			if (source.indexOf("youtube.com") >= 0 || source.indexOf("vimeo.com") >= 0 || source.indexOf("dailymotion.com") >= 0) {
			  //create container
			  var embedContainer = document.createElement('div');
			  jquery_default()(embedContainer).addClass('embed-container');

			  //clone iframe
			  var iframeClone = jquery_default()(iframe).clone();

			  //put clone in container
			  jquery_default()(embedContainer).append(iframeClone);

			  //embed clone with responsive container
			  jquery_default()(iframe).replaceWith(embedContainer);
			}
		  });
		};
		this.closeDrawers = e => {
		  this.toggleLeftDrawer(false);
		  this.toggleRightDrawer('cart', false);
		};
		this.addBadges = (root, timeout) => {
		  this.badge.add(root, timeout);
		};
		this.name = 'HITCHED';
		this.$ = (jquery_default());

		// Passive event listeners for jQuery.
		(jquery_default()).event.special.touchstart = {
		  setup: function (_, ns, handle) {
			// @ts-ignore
			this.addEventListener('touchstart', handle, {
			  passive: !ns.includes('noPreventDefault')
			});
		  }
		};
		(jquery_default()).event.special.touchmove = {
		  setup: function (_, ns, handle) {
			// @ts-ignore
			this.addEventListener('touchmove', handle, {
			  passive: !ns.includes('noPreventDefault')
			});
		  }
		};

		/** Section by it's unique ID
		 * @type {Map<string, Section>}
		 */
		this.sectionById = new Map();

		/** Array of sections by given section type
		 * @type {Map<string, Section[]>}
		 */
		this.sectionsByType = new Map();

		/** Array of registed components
		 * @type {Array<import('./Component').default>}
		 */
		this.registeredComponents = [];

		/** Array of initialized vue components
		 * @type {Array<Object>}
		 */
		this.vueComponents = [];

		/** @type {Array<{ resolve: (YoutubeApi) => void, reject: (string) => void }>} */
		this.youtubeLoadedCallbacks = [];
		/** @type {Array<{ resolve: (VimeoApi) => void, reject: (string) => void }>} */
		this.vimeoLoadedCallbacks = [];
		/** @type {Array<{ resolve: (MapsApi) => void, reject: (string) => void }>} */
		this.mapsLoadedCallbacks = [];
		this.resizeDebounceTimer = null;
		document.addEventListener('shopify:section:load', this.onSectionLoad);
		document.addEventListener('shopify:section:unload', this.onSectionUnload);
		document.addEventListener('shopify:section:select', this.onSectionSelect);
		document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
		document.addEventListener('shopify:section:reorder', this.onSectionReorder);
		document.addEventListener('shopify:block:select', this.onBlockSelect);
		document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
		document.addEventListener('DOMContentLoaded', this.onLoadAll);
		document.addEventListener('keyup', this.onKeyUp);
		window.addEventListener('resize', this.onRawResize);
		window.addEventListener('scroll', this.onRawScroll);
		this.drawerOverlay = document.querySelector('#DrawerOverlay');
		if (this.drawerOverlay) {
		  // We don't have it on password page
		  document.querySelector('#DrawerOverlay').addEventListener('click', this.closeDrawers);
		}

		// Number of attempts to load Shopify product reviews
		//this._spr_remaining_attemtps = 10;
	  }

	  /** This will be execute when whole DOM is loaded */
	  load() {
		this.loadGlobal();
		this.breakpoint = this.getBreakpoint();
		this.wow = new (wow_default())().init();
		if (!document.body.classList.contains('password-page')) {
		  // this.drawer = new Drawer(this);
		  // this.cartDrawer = this.drawer.slideouts.right ? new CartDrawer(this, this.drawer.slideouts.right.menu) : null;
		}
		this.popup = null;
		const popupEl = /** @type {HTMLElement} */document.querySelector('#popup');
		if (popupEl && window.location.pathname !== '/challenge') {
		  // Don't show popup when we're filling CAPTCHA for contact form
		  this.popup = new Popup(this, popupEl);
		}
		this.verificationPopup = null;
		const verificationEl = /** @type {HTMLElement} */document.querySelector('.verification-popup-container');
		if (verificationEl && window.location.pathname !== '/challenge') {
		  // Don't show popup when we're filling CAPTCHA for contact form
		  this.verificationPopup = new VerificationPopup(this, verificationEl);
		}

		// Newsletter form could be on contact-us page, so outside of sections
		// this.newsletter = new Newsletter(this);

		// Login page doesn't have sections, load it here
		if (document.body.classList.contains('template-customers-login')) {
		  this.login = new Login(this, document.body);
		}

		// Remove 'fadeInUp' animation from the first section
		let getAnimatedEls = document.querySelectorAll('.show-on-scroll');
		if (getAnimatedEls.length > 0) {
		  getAnimatedEls[0].classList.remove('show-on-scroll');
		}
		this.handleAccordions();
		this.loadFadeAnimation();

		// Right drawer is not part of any component
		this.loadVueComponent(document.body, 'bulletproof-right-drawer', global_RightDrawer);
		this.badge = new Badge(this, document.body);
		document.body.addEventListener('mousedown', this._usingMouse);
		document.body.addEventListener('keydown', this._usingTab);
	  }
	  _usingMouse() {
		document.body.classList.add('using-mouse');
		document.body.classList.remove('using-keyboard');
	  }
	  _usingTab(evt) {
		if (evt.key === "Tab") {
		  document.body.classList.remove('using-mouse');
		  document.body.classList.add('using-keyboard');
		}
	  }
	}

// Make the theme object instance globally available (without overriding the existing window.bulletproof)
	const theme = new Theme();
	for (const [key, value] of Object.entries(theme)) {
	  window.bulletproof[key] = value;
	}
	window.onYouTubePlayerAPIReady = () => {
	  window.bulletproof.onYoutubeLoaded();
	};
	window.onGoogleMapsAPIReady = () => {
	  window.bulletproof.onGoogleMapsLoaded();
	};
	window.gm_authFailure = function () {
	  window.bulletproof.onGoogleAuthFailure('Google Maps authentication error, API key might be invalid');
	};
  })();

   })()
;

